//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
    let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processIsTenantAvailable(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processIsTenantAvailable(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
    }));
  }

  protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = IsTenantAvailableOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<IsTenantAvailableOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resolveTenantId(body: ResolveTenantIdInput | undefined): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processResolveTenantId(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processResolveTenantId(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<number>;
        }
      } else
        return _observableThrow(response_) as any as Observable<number>;
    }));
  }

  protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<number>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  register(body: RegisterInput | undefined): Observable<RegisterOutput> {
    let url_ = this.baseUrl + "/api/services/app/Account/Register";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processRegister(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRegister(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<RegisterOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<RegisterOutput>;
    }));
  }

  protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RegisterOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<RegisterOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSendPasswordResetCode(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendPasswordResetCode(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
    let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processResetPassword(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processResetPassword(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ResetPasswordOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ResetPasswordOutput>;
    }));
  }

  protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResetPasswordOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ResetPasswordOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSendEmailActivationLink(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendEmailActivationLink(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processActivateEmail(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processActivateEmail(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processActivateEmail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  impersonateUser(body: ImpersonateUserInput | undefined): Observable<ImpersonateOutput> {
    let url_ = this.baseUrl + "/api/services/app/Account/ImpersonateUser";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processImpersonateUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processImpersonateUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ImpersonateOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
    }));
  }

  protected processImpersonateUser(response: HttpResponseBase): Observable<ImpersonateOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ImpersonateOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ImpersonateOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  impersonateTenant(body: ImpersonateTenantInput | undefined): Observable<ImpersonateOutput> {
    let url_ = this.baseUrl + "/api/services/app/Account/ImpersonateTenant";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processImpersonateTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processImpersonateTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ImpersonateOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
    }));
  }

  protected processImpersonateTenant(response: HttpResponseBase): Observable<ImpersonateOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ImpersonateOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ImpersonateOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  delegatedImpersonate(body: DelegatedImpersonateInput | undefined): Observable<ImpersonateOutput> {
    let url_ = this.baseUrl + "/api/services/app/Account/DelegatedImpersonate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelegatedImpersonate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelegatedImpersonate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ImpersonateOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
    }));
  }

  protected processDelegatedImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ImpersonateOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ImpersonateOutput>(null as any);
  }

  /**
   * @return Success
   */
  backToImpersonator(): Observable<ImpersonateOutput> {
    let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processBackToImpersonator(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processBackToImpersonator(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ImpersonateOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
    }));
  }

  protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ImpersonateOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ImpersonateOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  switchToLinkedAccount(body: SwitchToLinkedAccountInput | undefined): Observable<SwitchToLinkedAccountOutput> {
    let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSwitchToLinkedAccount(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSwitchToLinkedAccount(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwitchToLinkedAccountOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwitchToLinkedAccountOutput>;
    }));
  }

  protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwitchToLinkedAccountOutput>(null as any);
  }
}

@Injectable()
export class AgeLimitsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param maxStartAgeFilter (optional)
   * @param minStartAgeFilter (optional)
   * @param maxEndAgeFilter (optional)
   * @param minEndAgeFilter (optional)
   * @param descriptionFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, maxStartAgeFilter: number | undefined, minStartAgeFilter: number | undefined, maxEndAgeFilter: number | undefined, minEndAgeFilter: number | undefined, descriptionFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAgeLimitForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/AgeLimits/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (maxStartAgeFilter === null)
      throw new Error("The parameter 'maxStartAgeFilter' cannot be null.");
    else if (maxStartAgeFilter !== undefined)
      url_ += "MaxStartAgeFilter=" + encodeURIComponent("" + maxStartAgeFilter) + "&";
    if (minStartAgeFilter === null)
      throw new Error("The parameter 'minStartAgeFilter' cannot be null.");
    else if (minStartAgeFilter !== undefined)
      url_ += "MinStartAgeFilter=" + encodeURIComponent("" + minStartAgeFilter) + "&";
    if (maxEndAgeFilter === null)
      throw new Error("The parameter 'maxEndAgeFilter' cannot be null.");
    else if (maxEndAgeFilter !== undefined)
      url_ += "MaxEndAgeFilter=" + encodeURIComponent("" + maxEndAgeFilter) + "&";
    if (minEndAgeFilter === null)
      throw new Error("The parameter 'minEndAgeFilter' cannot be null.");
    else if (minEndAgeFilter !== undefined)
      url_ += "MinEndAgeFilter=" + encodeURIComponent("" + minEndAgeFilter) + "&";
    if (descriptionFilter === null)
      throw new Error("The parameter 'descriptionFilter' cannot be null.");
    else if (descriptionFilter !== undefined)
      url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAgeLimitForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAgeLimitForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAgeLimitForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetAgeLimitForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetAgeLimitForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getAgeLimitForView(id: number | undefined): Observable<GetAgeLimitForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/AgeLimits/GetAgeLimitForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAgeLimitForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAgeLimitForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetAgeLimitForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetAgeLimitForViewDto>;
    }));
  }

  protected processGetAgeLimitForView(response: HttpResponseBase): Observable<GetAgeLimitForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetAgeLimitForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetAgeLimitForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getAgeLimitForEdit(id: number | undefined): Observable<GetAgeLimitForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/AgeLimits/GetAgeLimitForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAgeLimitForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAgeLimitForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetAgeLimitForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetAgeLimitForEditOutput>;
    }));
  }

  protected processGetAgeLimitForEdit(response: HttpResponseBase): Observable<GetAgeLimitForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetAgeLimitForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetAgeLimitForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditAgeLimitDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/AgeLimits/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/AgeLimits/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param maxStartAgeFilter (optional)
   * @param minStartAgeFilter (optional)
   * @param maxEndAgeFilter (optional)
   * @param minEndAgeFilter (optional)
   * @param descriptionFilter (optional)
   * @return Success
   */
  getAgeLimitsToExcel(filter: string | undefined, maxStartAgeFilter: number | undefined, minStartAgeFilter: number | undefined, maxEndAgeFilter: number | undefined, minEndAgeFilter: number | undefined, descriptionFilter: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/AgeLimits/GetAgeLimitsToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (maxStartAgeFilter === null)
      throw new Error("The parameter 'maxStartAgeFilter' cannot be null.");
    else if (maxStartAgeFilter !== undefined)
      url_ += "MaxStartAgeFilter=" + encodeURIComponent("" + maxStartAgeFilter) + "&";
    if (minStartAgeFilter === null)
      throw new Error("The parameter 'minStartAgeFilter' cannot be null.");
    else if (minStartAgeFilter !== undefined)
      url_ += "MinStartAgeFilter=" + encodeURIComponent("" + minStartAgeFilter) + "&";
    if (maxEndAgeFilter === null)
      throw new Error("The parameter 'maxEndAgeFilter' cannot be null.");
    else if (maxEndAgeFilter !== undefined)
      url_ += "MaxEndAgeFilter=" + encodeURIComponent("" + maxEndAgeFilter) + "&";
    if (minEndAgeFilter === null)
      throw new Error("The parameter 'minEndAgeFilter' cannot be null.");
    else if (minEndAgeFilter !== undefined)
      url_ += "MinEndAgeFilter=" + encodeURIComponent("" + minEndAgeFilter) + "&";
    if (descriptionFilter === null)
      throw new Error("The parameter 'descriptionFilter' cannot be null.");
    else if (descriptionFilter !== undefined)
      url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAgeLimitsToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAgeLimitsToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetAgeLimitsToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }

  /**
   * @return Success
   */
  getAllAgeLimitLookupTableDropdown(): Observable<EventCalendarDetailAgeLimitLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/AgeLimits/GetAllAgeLimitLookupTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllAgeLimitLookupTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllAgeLimitLookupTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<EventCalendarDetailAgeLimitLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<EventCalendarDetailAgeLimitLookupTableDto[]>;
    }));
  }

  protected processGetAllAgeLimitLookupTableDropdown(response: HttpResponseBase): Observable<EventCalendarDetailAgeLimitLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(EventCalendarDetailAgeLimitLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<EventCalendarDetailAgeLimitLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class AuditLogServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param startDate (optional)
   * @param endDate (optional)
   * @param userName (optional)
   * @param serviceName (optional)
   * @param methodName (optional)
   * @param browserInfo (optional)
   * @param hasException (optional)
   * @param minExecutionDuration (optional)
   * @param maxExecutionDuration (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getAuditLogs(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
    let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
    if (userName === null)
      throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined)
      url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
    if (serviceName === null)
      throw new Error("The parameter 'serviceName' cannot be null.");
    else if (serviceName !== undefined)
      url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
    if (methodName === null)
      throw new Error("The parameter 'methodName' cannot be null.");
    else if (methodName !== undefined)
      url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
    if (browserInfo === null)
      throw new Error("The parameter 'browserInfo' cannot be null.");
    else if (browserInfo !== undefined)
      url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
    if (hasException === null)
      throw new Error("The parameter 'hasException' cannot be null.");
    else if (hasException !== undefined)
      url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
    if (minExecutionDuration === null)
      throw new Error("The parameter 'minExecutionDuration' cannot be null.");
    else if (minExecutionDuration !== undefined)
      url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
    if (maxExecutionDuration === null)
      throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
    else if (maxExecutionDuration !== undefined)
      url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAuditLogs(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAuditLogs(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListDto>;
    }));
  }

  protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfAuditLogListDto>(null as any);
  }

  /**
   * @param startDate (optional)
   * @param endDate (optional)
   * @param userName (optional)
   * @param serviceName (optional)
   * @param methodName (optional)
   * @param browserInfo (optional)
   * @param hasException (optional)
   * @param minExecutionDuration (optional)
   * @param maxExecutionDuration (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getAuditLogsToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
    if (userName === null)
      throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined)
      url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
    if (serviceName === null)
      throw new Error("The parameter 'serviceName' cannot be null.");
    else if (serviceName !== undefined)
      url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
    if (methodName === null)
      throw new Error("The parameter 'methodName' cannot be null.");
    else if (methodName !== undefined)
      url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
    if (browserInfo === null)
      throw new Error("The parameter 'browserInfo' cannot be null.");
    else if (browserInfo !== undefined)
      url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
    if (hasException === null)
      throw new Error("The parameter 'hasException' cannot be null.");
    else if (hasException !== undefined)
      url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
    if (minExecutionDuration === null)
      throw new Error("The parameter 'minExecutionDuration' cannot be null.");
    else if (minExecutionDuration !== undefined)
      url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
    if (maxExecutionDuration === null)
      throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
    else if (maxExecutionDuration !== undefined)
      url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAuditLogsToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAuditLogsToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }

  /**
   * @return Success
   */
  getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
    let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEntityHistoryObjectTypes(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEntityHistoryObjectTypes(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<NameValueDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<NameValueDto[]>;
    }));
  }

  protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(NameValueDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<NameValueDto[]>(null as any);
  }

  /**
   * @param startDate (optional)
   * @param endDate (optional)
   * @param userName (optional)
   * @param entityTypeFullName (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getEntityChanges(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
    let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
    if (userName === null)
      throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined)
      url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
    if (entityTypeFullName === null)
      throw new Error("The parameter 'entityTypeFullName' cannot be null.");
    else if (entityTypeFullName !== undefined)
      url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEntityChanges(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEntityChanges(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
    }));
  }

  protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfEntityChangeListDto>(null as any);
  }

  /**
   * @param entityTypeFullName (optional)
   * @param entityId (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getEntityTypeChanges(entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
    let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
    if (entityTypeFullName === null)
      throw new Error("The parameter 'entityTypeFullName' cannot be null.");
    else if (entityTypeFullName !== undefined)
      url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
    if (entityId === null)
      throw new Error("The parameter 'entityId' cannot be null.");
    else if (entityId !== undefined)
      url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEntityTypeChanges(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEntityTypeChanges(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
    }));
  }

  protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfEntityChangeListDto>(null as any);
  }

  /**
   * @param startDate (optional)
   * @param endDate (optional)
   * @param userName (optional)
   * @param entityTypeFullName (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getEntityChangesToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
    if (userName === null)
      throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined)
      url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
    if (entityTypeFullName === null)
      throw new Error("The parameter 'entityTypeFullName' cannot be null.");
    else if (entityTypeFullName !== undefined)
      url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEntityChangesToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEntityChangesToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }

  /**
   * @param entityChangeId (optional)
   * @return Success
   */
  getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
    let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
    if (entityChangeId === null)
      throw new Error("The parameter 'entityChangeId' cannot be null.");
    else if (entityChangeId !== undefined)
      url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEntityPropertyChanges(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEntityPropertyChanges(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
    }));
  }

  protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(EntityPropertyChangeDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<EntityPropertyChangeDto[]>(null as any);
  }
}

@Injectable()
export class AvailabilityStatusesServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAvailabilityStatusForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/AvailabilityStatuses/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAvailabilityStatusForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAvailabilityStatusForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAvailabilityStatusForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetAvailabilityStatusForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetAvailabilityStatusForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getAvailabilityStatusForView(id: number | undefined): Observable<GetAvailabilityStatusForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/AvailabilityStatuses/GetAvailabilityStatusForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAvailabilityStatusForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAvailabilityStatusForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetAvailabilityStatusForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetAvailabilityStatusForViewDto>;
    }));
  }

  protected processGetAvailabilityStatusForView(response: HttpResponseBase): Observable<GetAvailabilityStatusForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetAvailabilityStatusForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetAvailabilityStatusForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getAvailabilityStatusForEdit(id: number | undefined): Observable<GetAvailabilityStatusForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/AvailabilityStatuses/GetAvailabilityStatusForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAvailabilityStatusForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAvailabilityStatusForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetAvailabilityStatusForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetAvailabilityStatusForEditOutput>;
    }));
  }

  protected processGetAvailabilityStatusForEdit(response: HttpResponseBase): Observable<GetAvailabilityStatusForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetAvailabilityStatusForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetAvailabilityStatusForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditAvailabilityStatusDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/AvailabilityStatuses/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/AvailabilityStatuses/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @return Success
   */
  getAvailabilityStatusesToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/AvailabilityStatuses/GetAvailabilityStatusesToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAvailabilityStatusesToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAvailabilityStatusesToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetAvailabilityStatusesToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }
}

@Injectable()
export class BookTypesServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBookTypeForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/BookTypes/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBookTypeForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBookTypeForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBookTypeForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetBookTypeForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetBookTypeForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getBookTypeForView(id: number | undefined): Observable<GetBookTypeForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/BookTypes/GetBookTypeForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetBookTypeForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetBookTypeForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetBookTypeForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetBookTypeForViewDto>;
    }));
  }

  protected processGetBookTypeForView(response: HttpResponseBase): Observable<GetBookTypeForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetBookTypeForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetBookTypeForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getBookTypeForEdit(id: number | undefined): Observable<GetBookTypeForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/BookTypes/GetBookTypeForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetBookTypeForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetBookTypeForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetBookTypeForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetBookTypeForEditOutput>;
    }));
  }

  protected processGetBookTypeForEdit(response: HttpResponseBase): Observable<GetBookTypeForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetBookTypeForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetBookTypeForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditBookTypeDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/BookTypes/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/BookTypes/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @return Success
   */
  getBookTypesToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/BookTypes/GetBookTypesToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetBookTypesToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetBookTypesToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetBookTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }
}

@Injectable()
export class CachingServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getAllCaches(): Observable<ListResultDtoOfCacheDto> {
    let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllCaches(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllCaches(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfCacheDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfCacheDto>;
    }));
  }

  protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfCacheDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  clearCache(body: EntityDtoOfString | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processClearCache(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processClearCache(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processClearCache(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  clearAllCaches(): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processClearAllCaches(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processClearAllCaches(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class ChatServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
    let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetUserChatFriendsWithSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetUserChatFriendsWithSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
    }));
  }

  protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetUserChatFriendsWithSettingsOutput>(null as any);
  }

  /**
   * @param tenantId (optional)
   * @param userId (optional)
   * @param minMessageId (optional)
   * @return Success
   */
  getUserChatMessages(tenantId: number | undefined, userId: number | undefined, minMessageId: number | undefined): Observable<ListResultDtoOfChatMessageDto> {
    let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
    if (tenantId === null)
      throw new Error("The parameter 'tenantId' cannot be null.");
    else if (tenantId !== undefined)
      url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
    if (minMessageId === null)
      throw new Error("The parameter 'minMessageId' cannot be null.");
    else if (minMessageId !== undefined)
      url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetUserChatMessages(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetUserChatMessages(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfChatMessageDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfChatMessageDto>;
    }));
  }

  protected processGetUserChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfChatMessageDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  markAllUnreadMessagesOfUserAsRead(body: MarkAllUnreadMessagesOfUserAsReadInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processMarkAllUnreadMessagesOfUserAsRead(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class CommonLookupServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param onlyFreeItems (optional)
   * @return Success
   */
  getEditionsForCombobox(onlyFreeItems: boolean | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
    let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
    if (onlyFreeItems === null)
      throw new Error("The parameter 'onlyFreeItems' cannot be null.");
    else if (onlyFreeItems !== undefined)
      url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEditionsForCombobox(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEditionsForCombobox(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
    }));
  }

  protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfSubscribableEditionComboboxItemDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  findUsers(body: FindUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
    let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processFindUsers(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processFindUsers(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
    }));
  }

  protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfNameValueDto>(null as any);
  }

  /**
   * @return Success
   */
  getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
    let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetDefaultEditionName(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDefaultEditionName(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetDefaultEditionNameOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetDefaultEditionNameOutput>;
    }));
  }

  protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetDefaultEditionNameOutput>(null as any);
  }
}

@Injectable()
export class DashboardCustomizationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param dashboardName (optional)
   * @param application (optional)
   * @return Success
   */
  getUserDashboard(dashboardName: string | undefined, application: string | undefined): Observable<Dashboard> {
    let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetUserDashboard?";
    if (dashboardName === null)
      throw new Error("The parameter 'dashboardName' cannot be null.");
    else if (dashboardName !== undefined)
      url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
    if (application === null)
      throw new Error("The parameter 'application' cannot be null.");
    else if (application !== undefined)
      url_ += "Application=" + encodeURIComponent("" + application) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetUserDashboard(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetUserDashboard(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<Dashboard>;
        }
      } else
        return _observableThrow(response_) as any as Observable<Dashboard>;
    }));
  }

  protected processGetUserDashboard(response: HttpResponseBase): Observable<Dashboard> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = Dashboard.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<Dashboard>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  savePage(body: SavePageInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/SavePage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSavePage(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSavePage(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSavePage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  renamePage(body: RenamePageInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/RenamePage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processRenamePage(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRenamePage(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processRenamePage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addNewPage(body: AddNewPageInput | undefined): Observable<AddNewPageOutput> {
    let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddNewPage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processAddNewPage(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddNewPage(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<AddNewPageOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<AddNewPageOutput>;
    }));
  }

  protected processAddNewPage(response: HttpResponseBase): Observable<AddNewPageOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AddNewPageOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<AddNewPageOutput>(null as any);
  }

  /**
   * @param id (optional)
   * @param dashboardName (optional)
   * @param application (optional)
   * @return Success
   */
  deletePage(id: string | undefined, dashboardName: string | undefined, application: string | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/DeletePage?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    if (dashboardName === null)
      throw new Error("The parameter 'dashboardName' cannot be null.");
    else if (dashboardName !== undefined)
      url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
    if (application === null)
      throw new Error("The parameter 'application' cannot be null.");
    else if (application !== undefined)
      url_ += "Application=" + encodeURIComponent("" + application) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeletePage(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeletePage(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDeletePage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addWidget(body: AddWidgetInput | undefined): Observable<Widget> {
    let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddWidget";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processAddWidget(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddWidget(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<Widget>;
        }
      } else
        return _observableThrow(response_) as any as Observable<Widget>;
    }));
  }

  protected processAddWidget(response: HttpResponseBase): Observable<Widget> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = Widget.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<Widget>(null as any);
  }

  /**
   * @param dashboardName (optional)
   * @param application (optional)
   * @return Success
   */
  getDashboardDefinition(dashboardName: string | undefined, application: string | undefined): Observable<DashboardOutput> {
    let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetDashboardDefinition?";
    if (dashboardName === null)
      throw new Error("The parameter 'dashboardName' cannot be null.");
    else if (dashboardName !== undefined)
      url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
    if (application === null)
      throw new Error("The parameter 'application' cannot be null.");
    else if (application !== undefined)
      url_ += "Application=" + encodeURIComponent("" + application) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetDashboardDefinition(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDashboardDefinition(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DashboardOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DashboardOutput>;
    }));
  }

  protected processGetDashboardDefinition(response: HttpResponseBase): Observable<DashboardOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DashboardOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<DashboardOutput>(null as any);
  }

  /**
   * @param dashboardName (optional)
   * @param application (optional)
   * @return Success
   */
  getAllWidgetDefinitions(dashboardName: string | undefined, application: string | undefined): Observable<WidgetOutput[]> {
    let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetAllWidgetDefinitions?";
    if (dashboardName === null)
      throw new Error("The parameter 'dashboardName' cannot be null.");
    else if (dashboardName !== undefined)
      url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
    if (application === null)
      throw new Error("The parameter 'application' cannot be null.");
    else if (application !== undefined)
      url_ += "Application=" + encodeURIComponent("" + application) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllWidgetDefinitions(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllWidgetDefinitions(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<WidgetOutput[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<WidgetOutput[]>;
    }));
  }

  protected processGetAllWidgetDefinitions(response: HttpResponseBase): Observable<WidgetOutput[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(WidgetOutput.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<WidgetOutput[]>(null as any);
  }

  /**
   * @param dashboardName (optional)
   * @param application (optional)
   * @param pageId (optional)
   * @return Success
   */
  getAllAvailableWidgetDefinitionsForPage(dashboardName: string | undefined, application: string | undefined, pageId: string | undefined): Observable<WidgetOutput[]> {
    let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetAllAvailableWidgetDefinitionsForPage?";
    if (dashboardName === null)
      throw new Error("The parameter 'dashboardName' cannot be null.");
    else if (dashboardName !== undefined)
      url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
    if (application === null)
      throw new Error("The parameter 'application' cannot be null.");
    else if (application !== undefined)
      url_ += "Application=" + encodeURIComponent("" + application) + "&";
    if (pageId === null)
      throw new Error("The parameter 'pageId' cannot be null.");
    else if (pageId !== undefined)
      url_ += "PageId=" + encodeURIComponent("" + pageId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllAvailableWidgetDefinitionsForPage(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllAvailableWidgetDefinitionsForPage(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<WidgetOutput[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<WidgetOutput[]>;
    }));
  }

  protected processGetAllAvailableWidgetDefinitionsForPage(response: HttpResponseBase): Observable<WidgetOutput[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(WidgetOutput.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<WidgetOutput[]>(null as any);
  }

  /**
   * @param application (optional)
   * @return Success
   */
  getSettingName(application: string | undefined): Observable<string> {
    let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetSettingName?";
    if (application === null)
      throw new Error("The parameter 'application' cannot be null.");
    else if (application !== undefined)
      url_ += "application=" + encodeURIComponent("" + application) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetSettingName(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSettingName(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<string>;
        }
      } else
        return _observableThrow(response_) as any as Observable<string>;
    }));
  }

  protected processGetSettingName(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<string>(null as any);
  }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param date (optional)
   * @return Success
   */
  sendAndGetDate(date: DateTime | undefined): Observable<DateToStringOutput> {
    let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
    if (date === null)
      throw new Error("The parameter 'date' cannot be null.");
    else if (date !== undefined)
      url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSendAndGetDate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendAndGetDate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DateToStringOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DateToStringOutput>;
    }));
  }

  protected processSendAndGetDate(response: HttpResponseBase): Observable<DateToStringOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DateToStringOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<DateToStringOutput>(null as any);
  }

  /**
   * @param date (optional)
   * @return Success
   */
  sendAndGetDateTime(date: DateTime | undefined): Observable<DateToStringOutput> {
    let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
    if (date === null)
      throw new Error("The parameter 'date' cannot be null.");
    else if (date !== undefined)
      url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSendAndGetDateTime(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendAndGetDateTime(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DateToStringOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DateToStringOutput>;
    }));
  }

  protected processSendAndGetDateTime(response: HttpResponseBase): Observable<DateToStringOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DateToStringOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<DateToStringOutput>(null as any);
  }

  /**
   * @param startDate (optional)
   * @param endDate (optional)
   * @return Success
   */
  sendAndGetDateRange(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<DateToStringOutput> {
    let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSendAndGetDateRange(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendAndGetDateRange(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DateToStringOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DateToStringOutput>;
    }));
  }

  protected processSendAndGetDateRange(response: HttpResponseBase): Observable<DateToStringOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DateToStringOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<DateToStringOutput>(null as any);
  }

  /**
   * @param searchTerm (optional)
   * @return Success
   */
  getCountries(searchTerm: string | undefined): Observable<NameValueOfString[]> {
    let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
    if (searchTerm === null)
      throw new Error("The parameter 'searchTerm' cannot be null.");
    else if (searchTerm !== undefined)
      url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetCountries(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetCountries(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<NameValueOfString[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
    }));
  }

  protected processGetCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(NameValueOfString.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<NameValueOfString[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendAndGetSelectedCountries(body: NameValueOfString[] | undefined): Observable<NameValueOfString[]> {
    let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSendAndGetSelectedCountries(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendAndGetSelectedCountries(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<NameValueOfString[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
    }));
  }

  protected processSendAndGetSelectedCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(NameValueOfString.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<NameValueOfString[]>(null as any);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  sendAndGetValue(input: string | undefined): Observable<StringOutput> {
    let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
    if (input === null)
      throw new Error("The parameter 'input' cannot be null.");
    else if (input !== undefined)
      url_ += "input=" + encodeURIComponent("" + input) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSendAndGetValue(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendAndGetValue(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<StringOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<StringOutput>;
    }));
  }

  protected processSendAndGetValue(response: HttpResponseBase): Observable<StringOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StringOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<StringOutput>(null as any);
  }
}

@Injectable()
export class DistrictsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param provinceNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nameFilter: string | undefined, provinceNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDistrictForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/Districts/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (provinceNameFilter === null)
      throw new Error("The parameter 'provinceNameFilter' cannot be null.");
    else if (provinceNameFilter !== undefined)
      url_ += "ProvinceNameFilter=" + encodeURIComponent("" + provinceNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetDistrictForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetDistrictForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetDistrictForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetDistrictForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetDistrictForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getDistrictForView(id: number | undefined): Observable<GetDistrictForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/Districts/GetDistrictForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetDistrictForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDistrictForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetDistrictForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetDistrictForViewDto>;
    }));
  }

  protected processGetDistrictForView(response: HttpResponseBase): Observable<GetDistrictForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetDistrictForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetDistrictForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getDistrictForEdit(id: number | undefined): Observable<GetDistrictForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/Districts/GetDistrictForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetDistrictForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDistrictForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetDistrictForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetDistrictForEditOutput>;
    }));
  }

  protected processGetDistrictForEdit(response: HttpResponseBase): Observable<GetDistrictForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetDistrictForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetDistrictForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditDistrictDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Districts/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Districts/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param provinceNameFilter (optional)
   * @return Success
   */
  getDistrictsToExcel(filter: string | undefined, nameFilter: string | undefined, provinceNameFilter: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/Districts/GetDistrictsToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (provinceNameFilter === null)
      throw new Error("The parameter 'provinceNameFilter' cannot be null.");
    else if (provinceNameFilter !== undefined)
      url_ += "ProvinceNameFilter=" + encodeURIComponent("" + provinceNameFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetDistrictsToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDistrictsToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetDistrictsToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }

  /**
   * @return Success
   */
  getAllProvinceForTableDropdown(): Observable<DistrictProvinceLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/Districts/GetAllProvinceForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllProvinceForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllProvinceForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DistrictProvinceLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DistrictProvinceLookupTableDto[]>;
    }));
  }

  protected processGetAllProvinceForTableDropdown(response: HttpResponseBase): Observable<DistrictProvinceLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DistrictProvinceLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<DistrictProvinceLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class DynamicEntityPropertyServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<DynamicEntityPropertyDto> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Get?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DynamicEntityPropertyDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DynamicEntityPropertyDto>;
    }));
  }

  protected processGet(response: HttpResponseBase): Observable<DynamicEntityPropertyDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DynamicEntityPropertyDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<DynamicEntityPropertyDto>(null as any);
  }

  /**
   * @param entityFullName (optional)
   * @return Success
   */
  getAllPropertiesOfAnEntity(entityFullName: string | undefined): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAllPropertiesOfAnEntity?";
    if (entityFullName === null)
      throw new Error("The parameter 'entityFullName' cannot be null.");
    else if (entityFullName !== undefined)
      url_ += "EntityFullName=" + encodeURIComponent("" + entityFullName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllPropertiesOfAnEntity(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllPropertiesOfAnEntity(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
    }));
  }

  protected processGetAllPropertiesOfAnEntity(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfDynamicEntityPropertyDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfDynamicEntityPropertyDto>(null as any);
  }

  /**
   * @return Success
   */
  getAll(): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAll";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfDynamicEntityPropertyDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfDynamicEntityPropertyDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  add(body: DynamicEntityPropertyDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Add";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processAdd(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAdd(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processAdd(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: DynamicEntityPropertyDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getAllEntitiesHasDynamicProperty(): Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAllEntitiesHasDynamicProperty";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllEntitiesHasDynamicProperty(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllEntitiesHasDynamicProperty(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput>;
    }));
  }

  protected processGetAllEntitiesHasDynamicProperty(response: HttpResponseBase): Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput>(null as any);
  }
}

@Injectable()
export class DynamicEntityPropertyDefinitionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getAllAllowedInputTypeNames(): Observable<string[]> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyDefinition/GetAllAllowedInputTypeNames";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllAllowedInputTypeNames(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllAllowedInputTypeNames(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<string[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<string[]>;
    }));
  }

  protected processGetAllAllowedInputTypeNames(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(item);
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<string[]>(null as any);
  }

  /**
   * @return Success
   */
  getAllEntities(): Observable<string[]> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyDefinition/GetAllEntities";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllEntities(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllEntities(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<string[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<string[]>;
    }));
  }

  protected processGetAllEntities(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(item);
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<string[]>(null as any);
  }
}

@Injectable()
export class DynamicEntityPropertyValueServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<DynamicEntityPropertyValueDto> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Get?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DynamicEntityPropertyValueDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DynamicEntityPropertyValueDto>;
    }));
  }

  protected processGet(response: HttpResponseBase): Observable<DynamicEntityPropertyValueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DynamicEntityPropertyValueDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<DynamicEntityPropertyValueDto>(null as any);
  }

  /**
   * @param entityId (optional)
   * @param propertyId (optional)
   * @return Success
   */
  getAll(entityId: string | undefined, propertyId: number | undefined): Observable<ListResultDtoOfDynamicEntityPropertyValueDto> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/GetAll?";
    if (entityId === null)
      throw new Error("The parameter 'entityId' cannot be null.");
    else if (entityId !== undefined)
      url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
    if (propertyId === null)
      throw new Error("The parameter 'propertyId' cannot be null.");
    else if (propertyId !== undefined)
      url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicEntityPropertyValueDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicEntityPropertyValueDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyValueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfDynamicEntityPropertyValueDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfDynamicEntityPropertyValueDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  add(body: DynamicEntityPropertyValueDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Add";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processAdd(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAdd(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processAdd(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: DynamicEntityPropertyValueDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getAllDynamicEntityPropertyValues(entityFullName: string, entityId: string): Observable<GetAllDynamicEntityPropertyValuesOutput> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/GetAllDynamicEntityPropertyValues?";
    if (entityFullName === undefined || entityFullName === null)
      throw new Error("The parameter 'entityFullName' must be defined and cannot be null.");
    else
      url_ += "EntityFullName=" + encodeURIComponent("" + entityFullName) + "&";
    if (entityId === undefined || entityId === null)
      throw new Error("The parameter 'entityId' must be defined and cannot be null.");
    else
      url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllDynamicEntityPropertyValues(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllDynamicEntityPropertyValues(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetAllDynamicEntityPropertyValuesOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetAllDynamicEntityPropertyValuesOutput>;
    }));
  }

  protected processGetAllDynamicEntityPropertyValues(response: HttpResponseBase): Observable<GetAllDynamicEntityPropertyValuesOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetAllDynamicEntityPropertyValuesOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetAllDynamicEntityPropertyValuesOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  insertOrUpdateAllValues(body: InsertOrUpdateAllValuesInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/InsertOrUpdateAllValues";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processInsertOrUpdateAllValues(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processInsertOrUpdateAllValues(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processInsertOrUpdateAllValues(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  cleanValues(body: CleanValuesInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/CleanValues";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCleanValues(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCleanValues(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCleanValues(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class DynamicPropertyServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<DynamicPropertyDto> {
    let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Get?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DynamicPropertyDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DynamicPropertyDto>;
    }));
  }

  protected processGet(response: HttpResponseBase): Observable<DynamicPropertyDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DynamicPropertyDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<DynamicPropertyDto>(null as any);
  }

  /**
   * @return Success
   */
  getAll(): Observable<ListResultDtoOfDynamicPropertyDto> {
    let url_ = this.baseUrl + "/api/services/app/DynamicProperty/GetAll";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicPropertyDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicPropertyDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicPropertyDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfDynamicPropertyDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfDynamicPropertyDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  add(body: DynamicPropertyDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Add";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processAdd(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAdd(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processAdd(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: DynamicPropertyDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param name (optional)
   * @return Success
   */
  findAllowedInputType(name: string | undefined): Observable<IInputType> {
    let url_ = this.baseUrl + "/api/services/app/DynamicProperty/FindAllowedInputType?";
    if (name === null)
      throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processFindAllowedInputType(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processFindAllowedInputType(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<IInputType>;
        }
      } else
        return _observableThrow(response_) as any as Observable<IInputType>;
    }));
  }

  protected processFindAllowedInputType(response: HttpResponseBase): Observable<IInputType> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = IInputType.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<IInputType>(null as any);
  }
}

@Injectable()
export class DynamicPropertyValueServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<DynamicPropertyValueDto> {
    let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Get?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DynamicPropertyValueDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DynamicPropertyValueDto>;
    }));
  }

  protected processGet(response: HttpResponseBase): Observable<DynamicPropertyValueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DynamicPropertyValueDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<DynamicPropertyValueDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getAllValuesOfDynamicProperty(id: number | undefined): Observable<ListResultDtoOfDynamicPropertyValueDto> {
    let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/GetAllValuesOfDynamicProperty?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllValuesOfDynamicProperty(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllValuesOfDynamicProperty(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicPropertyValueDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicPropertyValueDto>;
    }));
  }

  protected processGetAllValuesOfDynamicProperty(response: HttpResponseBase): Observable<ListResultDtoOfDynamicPropertyValueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfDynamicPropertyValueDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfDynamicPropertyValueDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  add(body: DynamicPropertyValueDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Add";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processAdd(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAdd(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processAdd(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: DynamicPropertyValueDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class EditionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getEditions(): Observable<ListResultDtoOfEditionListDto> {
    let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEditions(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEditions(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfEditionListDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfEditionListDto>;
    }));
  }

  protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfEditionListDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEditionForEdit(id: number | undefined): Observable<GetEditionEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEditionForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEditionForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetEditionEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetEditionEditOutput>;
    }));
  }

  protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetEditionEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetEditionEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createEdition(body: CreateEditionDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateEdition(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateEdition(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateEdition(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateEdition(body: UpdateEditionDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateEdition(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateEdition(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateEdition(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteEdition(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteEdition(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteEdition(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  moveTenantsToAnotherEdition(body: MoveTenantsToAnotherEditionDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processMoveTenantsToAnotherEdition(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processMoveTenantsToAnotherEdition(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processMoveTenantsToAnotherEdition(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param selectedEditionId (optional)
   * @param addAllItem (optional)
   * @param onlyFreeItems (optional)
   * @return Success
   */
  getEditionComboboxItems(selectedEditionId: number | undefined, addAllItem: boolean | undefined, onlyFreeItems: boolean | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
    let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
    if (selectedEditionId === null)
      throw new Error("The parameter 'selectedEditionId' cannot be null.");
    else if (selectedEditionId !== undefined)
      url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
    if (addAllItem === null)
      throw new Error("The parameter 'addAllItem' cannot be null.");
    else if (addAllItem !== undefined)
      url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
    if (onlyFreeItems === null)
      throw new Error("The parameter 'onlyFreeItems' cannot be null.");
    else if (onlyFreeItems !== undefined)
      url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEditionComboboxItems(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEditionComboboxItems(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SubscribableEditionComboboxItemDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SubscribableEditionComboboxItemDto[]>;
    }));
  }

  protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(SubscribableEditionComboboxItemDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SubscribableEditionComboboxItemDto[]>(null as any);
  }

  /**
   * @param editionId (optional)
   * @return Success
   */
  getTenantCount(editionId: number | undefined): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
    if (editionId === null)
      throw new Error("The parameter 'editionId' cannot be null.");
    else if (editionId !== undefined)
      url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetTenantCount(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTenantCount(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<number>;
        }
      } else
        return _observableThrow(response_) as any as Observable<number>;
    }));
  }

  protected processGetTenantCount(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<number>(null as any);
  }
}

@Injectable()
export class EducationStatusesServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEducationStatusForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/EducationStatuses/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEducationStatusForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEducationStatusForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEducationStatusForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetEducationStatusForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetEducationStatusForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEducationStatusForView(id: number | undefined): Observable<GetEducationStatusForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/EducationStatuses/GetEducationStatusForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEducationStatusForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEducationStatusForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetEducationStatusForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetEducationStatusForViewDto>;
    }));
  }

  protected processGetEducationStatusForView(response: HttpResponseBase): Observable<GetEducationStatusForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetEducationStatusForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetEducationStatusForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEducationStatusForEdit(id: number | undefined): Observable<GetEducationStatusForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/EducationStatuses/GetEducationStatusForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEducationStatusForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEducationStatusForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetEducationStatusForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetEducationStatusForEditOutput>;
    }));
  }

  protected processGetEducationStatusForEdit(response: HttpResponseBase): Observable<GetEducationStatusForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetEducationStatusForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetEducationStatusForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditEducationStatusDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/EducationStatuses/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/EducationStatuses/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @return Success
   */
  getEducationStatusesToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/EducationStatuses/GetEducationStatusesToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEducationStatusesToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEducationStatusesToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetEducationStatusesToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }
}

@Injectable()
export class EducationTypesServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEducationTypeForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/EducationTypes/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEducationTypeForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEducationTypeForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEducationTypeForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetEducationTypeForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetEducationTypeForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEducationTypeForView(id: number | undefined): Observable<GetEducationTypeForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/EducationTypes/GetEducationTypeForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEducationTypeForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEducationTypeForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetEducationTypeForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetEducationTypeForViewDto>;
    }));
  }

  protected processGetEducationTypeForView(response: HttpResponseBase): Observable<GetEducationTypeForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetEducationTypeForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetEducationTypeForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEducationTypeForEdit(id: number | undefined): Observable<GetEducationTypeForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/EducationTypes/GetEducationTypeForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEducationTypeForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEducationTypeForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetEducationTypeForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetEducationTypeForEditOutput>;
    }));
  }

  protected processGetEducationTypeForEdit(response: HttpResponseBase): Observable<GetEducationTypeForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetEducationTypeForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetEducationTypeForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditEducationTypeDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/EducationTypes/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/EducationTypes/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @return Success
   */
  getEducationTypesToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/EducationTypes/GetEducationTypesToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEducationTypesToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEducationTypesToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetEducationTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }
}

@Injectable()
export class EventCalendarDetailsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param subjectFilter (optional)
   * @param descriptionFilter (optional)
   * @param maxStartDateFilter (optional)
   * @param minStartDateFilter (optional)
   * @param maxEndDateFilter (optional)
   * @param minEndDateFilter (optional)
   * @param isOnlineFilter (optional)
   * @param eventLocationOrUrlFilter (optional)
   * @param geoAreaFilter (optional)
   * @param ageLimitFilter (optional)
   * @param orphanEventTypeNameFilter (optional)
   * @param provinceNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, subjectFilter: string | undefined, descriptionFilter: string | undefined, maxStartDateFilter: DateTime | undefined, minStartDateFilter: DateTime | undefined, maxEndDateFilter: DateTime | undefined, minEndDateFilter: DateTime | undefined, isOnlineFilter: number | undefined, eventLocationOrUrlFilter: string | undefined, geoAreaFilter: string | undefined, ageLimitFilter: string | undefined, orphanEventTypeNameFilter: string | undefined, provinceNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEventCalendarDetailForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/EventCalendarDetails/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (subjectFilter === null)
      throw new Error("The parameter 'subjectFilter' cannot be null.");
    else if (subjectFilter !== undefined)
      url_ += "SubjectFilter=" + encodeURIComponent("" + subjectFilter) + "&";
    if (descriptionFilter === null)
      throw new Error("The parameter 'descriptionFilter' cannot be null.");
    else if (descriptionFilter !== undefined)
      url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
    if (maxStartDateFilter === null)
      throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
    else if (maxStartDateFilter !== undefined)
      url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toString() : "") + "&";
    if (minStartDateFilter === null)
      throw new Error("The parameter 'minStartDateFilter' cannot be null.");
    else if (minStartDateFilter !== undefined)
      url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toString() : "") + "&";
    if (maxEndDateFilter === null)
      throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
    else if (maxEndDateFilter !== undefined)
      url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toString() : "") + "&";
    if (minEndDateFilter === null)
      throw new Error("The parameter 'minEndDateFilter' cannot be null.");
    else if (minEndDateFilter !== undefined)
      url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toString() : "") + "&";
    if (isOnlineFilter === null)
      throw new Error("The parameter 'isOnlineFilter' cannot be null.");
    else if (isOnlineFilter !== undefined)
      url_ += "IsOnlineFilter=" + encodeURIComponent("" + isOnlineFilter) + "&";
    if (eventLocationOrUrlFilter === null)
      throw new Error("The parameter 'eventLocationOrUrlFilter' cannot be null.");
    else if (eventLocationOrUrlFilter !== undefined)
      url_ += "EventLocationOrUrlFilter=" + encodeURIComponent("" + eventLocationOrUrlFilter) + "&";
    if (geoAreaFilter === null)
      throw new Error("The parameter 'geoAreaFilter' cannot be null.");
    else if (geoAreaFilter !== undefined)
      url_ += "GeoAreaFilter=" + encodeURIComponent("" + geoAreaFilter) + "&";
    if (ageLimitFilter === null)
      throw new Error("The parameter 'ageLimitFilter' cannot be null.");
    else if (ageLimitFilter !== undefined)
      url_ += "AgeLimitFilter=" + encodeURIComponent("" + ageLimitFilter) + "&";
    if (orphanEventTypeNameFilter === null)
      throw new Error("The parameter 'orphanEventTypeNameFilter' cannot be null.");
    else if (orphanEventTypeNameFilter !== undefined)
      url_ += "OrphanEventTypeNameFilter=" + encodeURIComponent("" + orphanEventTypeNameFilter) + "&";
    if (provinceNameFilter === null)
      throw new Error("The parameter 'provinceNameFilter' cannot be null.");
    else if (provinceNameFilter !== undefined)
      url_ += "ProvinceNameFilter=" + encodeURIComponent("" + provinceNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEventCalendarDetailForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEventCalendarDetailForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEventCalendarDetailForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetEventCalendarDetailForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetEventCalendarDetailForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEventCalendarDetailForView(id: number | undefined): Observable<GetEventCalendarDetailForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/EventCalendarDetails/GetEventCalendarDetailForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEventCalendarDetailForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEventCalendarDetailForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetEventCalendarDetailForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetEventCalendarDetailForViewDto>;
    }));
  }

  protected processGetEventCalendarDetailForView(response: HttpResponseBase): Observable<GetEventCalendarDetailForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetEventCalendarDetailForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetEventCalendarDetailForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEventCalendarDetailForEdit(id: number | undefined): Observable<GetEventCalendarDetailForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/EventCalendarDetails/GetEventCalendarDetailForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEventCalendarDetailForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEventCalendarDetailForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetEventCalendarDetailForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetEventCalendarDetailForEditOutput>;
    }));
  }

  protected processGetEventCalendarDetailForEdit(response: HttpResponseBase): Observable<GetEventCalendarDetailForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetEventCalendarDetailForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetEventCalendarDetailForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditEventCalendarDetailDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/EventCalendarDetails/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/EventCalendarDetails/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param subjectFilter (optional)
   * @param descriptionFilter (optional)
   * @param maxStartDateFilter (optional)
   * @param minStartDateFilter (optional)
   * @param maxEndDateFilter (optional)
   * @param minEndDateFilter (optional)
   * @param isOnlineFilter (optional)
   * @param eventLocationOrUrlFilter (optional)
   * @param geoAreaFilter (optional)
   * @param ageLimitFilter (optional)
   * @param orphanEventTypeNameFilter (optional)
   * @param provinceNameFilter (optional)
   * @return Success
   */
  getEventCalendarDetailsToExcel(filter: string | undefined, subjectFilter: string | undefined, descriptionFilter: string | undefined, maxStartDateFilter: DateTime | undefined, minStartDateFilter: DateTime | undefined, maxEndDateFilter: DateTime | undefined, minEndDateFilter: DateTime | undefined, isOnlineFilter: number | undefined, eventLocationOrUrlFilter: string | undefined, geoAreaFilter: string | undefined, ageLimitFilter: string | undefined, orphanEventTypeNameFilter: string | undefined, provinceNameFilter: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/EventCalendarDetails/GetEventCalendarDetailsToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (subjectFilter === null)
      throw new Error("The parameter 'subjectFilter' cannot be null.");
    else if (subjectFilter !== undefined)
      url_ += "SubjectFilter=" + encodeURIComponent("" + subjectFilter) + "&";
    if (descriptionFilter === null)
      throw new Error("The parameter 'descriptionFilter' cannot be null.");
    else if (descriptionFilter !== undefined)
      url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
    if (maxStartDateFilter === null)
      throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
    else if (maxStartDateFilter !== undefined)
      url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toString() : "") + "&";
    if (minStartDateFilter === null)
      throw new Error("The parameter 'minStartDateFilter' cannot be null.");
    else if (minStartDateFilter !== undefined)
      url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toString() : "") + "&";
    if (maxEndDateFilter === null)
      throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
    else if (maxEndDateFilter !== undefined)
      url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toString() : "") + "&";
    if (minEndDateFilter === null)
      throw new Error("The parameter 'minEndDateFilter' cannot be null.");
    else if (minEndDateFilter !== undefined)
      url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toString() : "") + "&";
    if (isOnlineFilter === null)
      throw new Error("The parameter 'isOnlineFilter' cannot be null.");
    else if (isOnlineFilter !== undefined)
      url_ += "IsOnlineFilter=" + encodeURIComponent("" + isOnlineFilter) + "&";
    if (eventLocationOrUrlFilter === null)
      throw new Error("The parameter 'eventLocationOrUrlFilter' cannot be null.");
    else if (eventLocationOrUrlFilter !== undefined)
      url_ += "EventLocationOrUrlFilter=" + encodeURIComponent("" + eventLocationOrUrlFilter) + "&";
    if (geoAreaFilter === null)
      throw new Error("The parameter 'geoAreaFilter' cannot be null.");
    else if (geoAreaFilter !== undefined)
      url_ += "GeoAreaFilter=" + encodeURIComponent("" + geoAreaFilter) + "&";
    if (ageLimitFilter === null)
      throw new Error("The parameter 'ageLimitFilter' cannot be null.");
    else if (ageLimitFilter !== undefined)
      url_ += "AgeLimitFilter=" + encodeURIComponent("" + ageLimitFilter) + "&";
    if (orphanEventTypeNameFilter === null)
      throw new Error("The parameter 'orphanEventTypeNameFilter' cannot be null.");
    else if (orphanEventTypeNameFilter !== undefined)
      url_ += "OrphanEventTypeNameFilter=" + encodeURIComponent("" + orphanEventTypeNameFilter) + "&";
    if (provinceNameFilter === null)
      throw new Error("The parameter 'provinceNameFilter' cannot be null.");
    else if (provinceNameFilter !== undefined)
      url_ += "ProvinceNameFilter=" + encodeURIComponent("" + provinceNameFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEventCalendarDetailsToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEventCalendarDetailsToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetEventCalendarDetailsToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }

  /**
   * @return Success
   */
  getAllOrphanEventTypeForTableDropdown(): Observable<EventCalendarDetailOrphanEventTypeLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/EventCalendarDetails/GetAllOrphanEventTypeForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllOrphanEventTypeForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllOrphanEventTypeForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<EventCalendarDetailOrphanEventTypeLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<EventCalendarDetailOrphanEventTypeLookupTableDto[]>;
    }));
  }

  protected processGetAllOrphanEventTypeForTableDropdown(response: HttpResponseBase): Observable<EventCalendarDetailOrphanEventTypeLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(EventCalendarDetailOrphanEventTypeLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<EventCalendarDetailOrphanEventTypeLookupTableDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getAllProvinceForTableDropdown(): Observable<EventCalendarDetailProvinceLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/EventCalendarDetails/GetAllProvinceForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllProvinceForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllProvinceForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<EventCalendarDetailProvinceLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<EventCalendarDetailProvinceLookupTableDto[]>;
    }));
  }

  protected processGetAllProvinceForTableDropdown(response: HttpResponseBase): Observable<EventCalendarDetailProvinceLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(EventCalendarDetailProvinceLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<EventCalendarDetailProvinceLookupTableDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getAllRegionForTableDropdown(): Observable<EventCalendarRegionLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/EventCalendarDetails/GetAllRegionForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllRegionForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllRegionForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<EventCalendarRegionLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<EventCalendarRegionLookupTableDto[]>;
    }));
  }

  protected processGetAllRegionForTableDropdown(response: HttpResponseBase): Observable<EventCalendarRegionLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(EventCalendarRegionLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<EventCalendarRegionLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class FriendshipServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createFriendshipRequest(body: CreateFriendshipRequestInput | undefined): Observable<FriendDto> {
    let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateFriendshipRequest(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateFriendshipRequest(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FriendDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FriendDto>;
    }));
  }

  protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FriendDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FriendDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createFriendshipRequestByUserName(body: CreateFriendshipRequestByUserNameInput | undefined): Observable<FriendDto> {
    let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateFriendshipRequestByUserName(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateFriendshipRequestByUserName(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FriendDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FriendDto>;
    }));
  }

  protected processCreateFriendshipRequestByUserName(response: HttpResponseBase): Observable<FriendDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FriendDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FriendDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  blockUser(body: BlockUserInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processBlockUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processBlockUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processBlockUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  unblockUser(body: UnblockUserInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUnblockUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUnblockUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUnblockUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  acceptFriendshipRequest(body: AcceptFriendshipRequestInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processAcceptFriendshipRequest(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAcceptFriendshipRequest(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class HostDashboardServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param startDate (optional)
   * @param endDate (optional)
   * @return Success
   */
  getTopStatsData(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<TopStatsData> {
    let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTopStatsData?";
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetTopStatsData(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTopStatsData(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<TopStatsData>;
        }
      } else
        return _observableThrow(response_) as any as Observable<TopStatsData>;
    }));
  }

  protected processGetTopStatsData(response: HttpResponseBase): Observable<TopStatsData> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TopStatsData.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<TopStatsData>(null as any);
  }

  /**
   * @return Success
   */
  getRecentTenantsData(): Observable<GetRecentTenantsOutput> {
    let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetRecentTenantsData";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRecentTenantsData(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRecentTenantsData(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetRecentTenantsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetRecentTenantsOutput>;
    }));
  }

  protected processGetRecentTenantsData(response: HttpResponseBase): Observable<GetRecentTenantsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetRecentTenantsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetRecentTenantsOutput>(null as any);
  }

  /**
   * @return Success
   */
  getSubscriptionExpiringTenantsData(): Observable<GetExpiringTenantsOutput> {
    let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetSubscriptionExpiringTenantsData";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetSubscriptionExpiringTenantsData(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSubscriptionExpiringTenantsData(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetExpiringTenantsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetExpiringTenantsOutput>;
    }));
  }

  protected processGetSubscriptionExpiringTenantsData(response: HttpResponseBase): Observable<GetExpiringTenantsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetExpiringTenantsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetExpiringTenantsOutput>(null as any);
  }

  /**
   * @param startDate (optional)
   * @param endDate (optional)
   * @return Success
   */
  getIncomeStatistics(incomeStatisticsDateInterval: ChartDateInterval, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetIncomeStatisticsDataOutput> {
    let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
    if (incomeStatisticsDateInterval === undefined || incomeStatisticsDateInterval === null)
      throw new Error("The parameter 'incomeStatisticsDateInterval' must be defined and cannot be null.");
    else
      url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetIncomeStatistics(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetIncomeStatistics(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetIncomeStatisticsDataOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetIncomeStatisticsDataOutput>;
    }));
  }

  protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetIncomeStatisticsDataOutput>(null as any);
  }

  /**
   * @param startDate (optional)
   * @param endDate (optional)
   * @return Success
   */
  getEditionTenantStatistics(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetEditionTenantStatisticsOutput> {
    let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEditionTenantStatistics(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEditionTenantStatistics(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetEditionTenantStatisticsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetEditionTenantStatisticsOutput>;
    }));
  }

  protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetEditionTenantStatisticsOutput>(null as any);
  }
}

@Injectable()
export class HostSettingsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getAllSettings(): Observable<HostSettingsEditDto> {
    let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<HostSettingsEditDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<HostSettingsEditDto>;
    }));
  }

  protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = HostSettingsEditDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<HostSettingsEditDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateAllSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateAllSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSendTestEmail(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendTestEmail(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
    let url_ = this.baseUrl + "/api/services/app/HostSettings/GetEnabledSocialLoginSettings";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEnabledSocialLoginSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEnabledSocialLoginSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
    }));
  }

  protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ExternalLoginSettingsDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ExternalLoginSettingsDto>(null as any);
  }
}

@Injectable()
export class InstallServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  setup(body: InstallDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Install/Setup";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSetup(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSetup(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSetup(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getAppSettingsJson(): Observable<AppSettingsJsonDto> {
    let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAppSettingsJson(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAppSettingsJson(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<AppSettingsJsonDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<AppSettingsJsonDto>;
    }));
  }

  protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AppSettingsJsonDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<AppSettingsJsonDto>(null as any);
  }

  /**
   * @return Success
   */
  checkDatabase(): Observable<CheckDatabaseOutput> {
    let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCheckDatabase(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCheckDatabase(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<CheckDatabaseOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<CheckDatabaseOutput>;
    }));
  }

  protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CheckDatabaseOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<CheckDatabaseOutput>(null as any);
  }
}

@Injectable()
export class InvoiceServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getInvoiceInfo(id: number | undefined): Observable<InvoiceDto> {
    let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetInvoiceInfo(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetInvoiceInfo(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<InvoiceDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<InvoiceDto>;
    }));
  }

  protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = InvoiceDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<InvoiceDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createInvoice(body: CreateInvoiceDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateInvoice(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateInvoice(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class JobApplicationsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param orphanDescriptionFilter (optional)
   * @param maxJoinDateFilter (optional)
   * @param minJoinDateFilter (optional)
   * @param managerDescriptionFilter (optional)
   * @param orphanFirstNameFilter (optional)
   * @param jobStatusNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, orphanDescriptionFilter: string | undefined, maxJoinDateFilter: DateTime | undefined, minJoinDateFilter: DateTime | undefined, managerDescriptionFilter: string | undefined, orphanFirstNameFilter: string | undefined, jobStatusNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetJobApplicationForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/JobApplications/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (orphanDescriptionFilter === null)
      throw new Error("The parameter 'orphanDescriptionFilter' cannot be null.");
    else if (orphanDescriptionFilter !== undefined)
      url_ += "OrphanDescriptionFilter=" + encodeURIComponent("" + orphanDescriptionFilter) + "&";
    if (maxJoinDateFilter === null)
      throw new Error("The parameter 'maxJoinDateFilter' cannot be null.");
    else if (maxJoinDateFilter !== undefined)
      url_ += "MaxJoinDateFilter=" + encodeURIComponent(maxJoinDateFilter ? "" + maxJoinDateFilter.toString() : "") + "&";
    if (minJoinDateFilter === null)
      throw new Error("The parameter 'minJoinDateFilter' cannot be null.");
    else if (minJoinDateFilter !== undefined)
      url_ += "MinJoinDateFilter=" + encodeURIComponent(minJoinDateFilter ? "" + minJoinDateFilter.toString() : "") + "&";
    if (managerDescriptionFilter === null)
      throw new Error("The parameter 'managerDescriptionFilter' cannot be null.");
    else if (managerDescriptionFilter !== undefined)
      url_ += "ManagerDescriptionFilter=" + encodeURIComponent("" + managerDescriptionFilter) + "&";
    if (orphanFirstNameFilter === null)
      throw new Error("The parameter 'orphanFirstNameFilter' cannot be null.");
    else if (orphanFirstNameFilter !== undefined)
      url_ += "OrphanFirstNameFilter=" + encodeURIComponent("" + orphanFirstNameFilter) + "&";
    if (jobStatusNameFilter === null)
      throw new Error("The parameter 'jobStatusNameFilter' cannot be null.");
    else if (jobStatusNameFilter !== undefined)
      url_ += "JobStatusNameFilter=" + encodeURIComponent("" + jobStatusNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetJobApplicationForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetJobApplicationForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetJobApplicationForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetJobApplicationForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetJobApplicationForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getJobApplicationForEdit(id: number | undefined): Observable<GetJobApplicationForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/JobApplications/GetJobApplicationForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetJobApplicationForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetJobApplicationForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetJobApplicationForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetJobApplicationForEditOutput>;
    }));
  }

  protected processGetJobApplicationForEdit(response: HttpResponseBase): Observable<GetJobApplicationForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetJobApplicationForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetJobApplicationForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditJobApplicationDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/JobApplications/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/JobApplications/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getAllOrphanForTableDropdown(): Observable<JobApplicationOrphanLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/JobApplications/GetAllOrphanForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllOrphanForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllOrphanForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<JobApplicationOrphanLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<JobApplicationOrphanLookupTableDto[]>;
    }));
  }

  protected processGetAllOrphanForTableDropdown(response: HttpResponseBase): Observable<JobApplicationOrphanLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(JobApplicationOrphanLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<JobApplicationOrphanLookupTableDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getAllJobStatusForTableDropdown(): Observable<JobApplicationJobStatusLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/JobApplications/GetAllJobStatusForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllJobStatusForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllJobStatusForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<JobApplicationJobStatusLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<JobApplicationJobStatusLookupTableDto[]>;
    }));
  }

  protected processGetAllJobStatusForTableDropdown(response: HttpResponseBase): Observable<JobApplicationJobStatusLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(JobApplicationJobStatusLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<JobApplicationJobStatusLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class JobStatuesServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetJobStatusForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/JobStatues/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetJobStatusForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetJobStatusForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetJobStatusForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetJobStatusForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetJobStatusForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getJobStatusForView(id: number | undefined): Observable<GetJobStatusForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/JobStatues/GetJobStatusForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetJobStatusForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetJobStatusForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetJobStatusForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetJobStatusForViewDto>;
    }));
  }

  protected processGetJobStatusForView(response: HttpResponseBase): Observable<GetJobStatusForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetJobStatusForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetJobStatusForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getJobStatusForEdit(id: number | undefined): Observable<GetJobStatusForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/JobStatues/GetJobStatusForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetJobStatusForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetJobStatusForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetJobStatusForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetJobStatusForEditOutput>;
    }));
  }

  protected processGetJobStatusForEdit(response: HttpResponseBase): Observable<GetJobStatusForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetJobStatusForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetJobStatusForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditJobStatusDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/JobStatues/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/JobStatues/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @return Success
   */
  getJobStatuesToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/JobStatues/GetJobStatuesToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetJobStatuesToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetJobStatuesToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetJobStatuesToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }
}

@Injectable()
export class LanguageServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getLanguages(): Observable<GetLanguagesOutput> {
    let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetLanguages(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetLanguages(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetLanguagesOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetLanguagesOutput>;
    }));
  }

  protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetLanguagesOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetLanguagesOutput>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getLanguageForEdit(id: number | undefined): Observable<GetLanguageForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetLanguageForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetLanguageForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetLanguageForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetLanguageForEditOutput>;
    }));
  }

  protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetLanguageForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetLanguageForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrUpdateLanguage(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrUpdateLanguage(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteLanguage(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteLanguage(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteLanguage(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSetDefaultLanguage(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSetDefaultLanguage(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @param sorting (optional)
   * @param baseLanguageName (optional)
   * @param targetValueFilter (optional)
   * @param filterText (optional)
   * @return Success
   */
  getLanguageTexts(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined, sourceName: string, baseLanguageName: string | undefined, targetLanguageName: string, targetValueFilter: string | undefined, filterText: string | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
    let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (sourceName === undefined || sourceName === null)
      throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
    else
      url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
    if (baseLanguageName === null)
      throw new Error("The parameter 'baseLanguageName' cannot be null.");
    else if (baseLanguageName !== undefined)
      url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
    if (targetLanguageName === undefined || targetLanguageName === null)
      throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
    else
      url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
    if (targetValueFilter === null)
      throw new Error("The parameter 'targetValueFilter' cannot be null.");
    else if (targetValueFilter !== undefined)
      url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
    if (filterText === null)
      throw new Error("The parameter 'filterText' cannot be null.");
    else if (filterText !== undefined)
      url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetLanguageTexts(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetLanguageTexts(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
    }));
  }

  protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfLanguageTextListDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateLanguageText(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateLanguageText(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class NeighborhoodsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param districtNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nameFilter: string | undefined, districtNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetNeighborhoodForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/Neighborhoods/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (districtNameFilter === null)
      throw new Error("The parameter 'districtNameFilter' cannot be null.");
    else if (districtNameFilter !== undefined)
      url_ += "DistrictNameFilter=" + encodeURIComponent("" + districtNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetNeighborhoodForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetNeighborhoodForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetNeighborhoodForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetNeighborhoodForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetNeighborhoodForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getNeighborhoodForView(id: number | undefined): Observable<GetNeighborhoodForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/Neighborhoods/GetNeighborhoodForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetNeighborhoodForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetNeighborhoodForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetNeighborhoodForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetNeighborhoodForViewDto>;
    }));
  }

  protected processGetNeighborhoodForView(response: HttpResponseBase): Observable<GetNeighborhoodForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetNeighborhoodForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetNeighborhoodForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getNeighborhoodForEdit(id: number | undefined): Observable<GetNeighborhoodForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/Neighborhoods/GetNeighborhoodForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetNeighborhoodForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetNeighborhoodForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetNeighborhoodForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetNeighborhoodForEditOutput>;
    }));
  }

  protected processGetNeighborhoodForEdit(response: HttpResponseBase): Observable<GetNeighborhoodForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetNeighborhoodForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetNeighborhoodForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditNeighborhoodDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Neighborhoods/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Neighborhoods/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param districtNameFilter (optional)
   * @return Success
   */
  getNeighborhoodsToExcel(filter: string | undefined, nameFilter: string | undefined, districtNameFilter: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/Neighborhoods/GetNeighborhoodsToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (districtNameFilter === null)
      throw new Error("The parameter 'districtNameFilter' cannot be null.");
    else if (districtNameFilter !== undefined)
      url_ += "DistrictNameFilter=" + encodeURIComponent("" + districtNameFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetNeighborhoodsToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetNeighborhoodsToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetNeighborhoodsToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }

  /**
   * @return Success
   */
  getAllDistrictForTableDropdown(): Observable<NeighborhoodDistrictLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/Neighborhoods/GetAllDistrictForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllDistrictForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllDistrictForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<NeighborhoodDistrictLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<NeighborhoodDistrictLookupTableDto[]>;
    }));
  }

  protected processGetAllDistrictForTableDropdown(response: HttpResponseBase): Observable<NeighborhoodDistrictLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(NeighborhoodDistrictLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<NeighborhoodDistrictLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class NotificationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param state (optional)
   * @param startDate (optional)
   * @param endDate (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetNotificationsOutput> {
    let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
    if (state === null)
      throw new Error("The parameter 'state' cannot be null.");
    else if (state !== undefined)
      url_ += "State=" + encodeURIComponent("" + state) + "&";
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetUserNotifications(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetUserNotifications(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetNotificationsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetNotificationsOutput>;
    }));
  }

  protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetNotificationsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetNotificationsOutput>(null as any);
  }

  /**
   * @return Success
   */
  setAllNotificationsAsRead(): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSetAllNotificationsAsRead(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSetAllNotificationsAsRead(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  setNotificationAsRead(body: EntityDtoOfGuid | undefined): Observable<SetNotificationAsReadOutput> {
    let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSetNotificationAsRead(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSetNotificationAsRead(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SetNotificationAsReadOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SetNotificationAsReadOutput>;
    }));
  }

  protected processSetNotificationAsRead(response: HttpResponseBase): Observable<SetNotificationAsReadOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SetNotificationAsReadOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SetNotificationAsReadOutput>(null as any);
  }

  /**
   * @return Success
   */
  getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
    let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetNotificationSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetNotificationSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetNotificationSettingsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetNotificationSettingsOutput>;
    }));
  }

  protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetNotificationSettingsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetNotificationSettingsOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateNotificationSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateNotificationSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteNotification(id: string | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteNotification(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteNotification(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param state (optional)
   * @param startDate (optional)
   * @param endDate (optional)
   * @return Success
   */
  deleteAllUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications?";
    if (state === null)
      throw new Error("The parameter 'state' cannot be null.");
    else if (state !== undefined)
      url_ += "State=" + encodeURIComponent("" + state) + "&";
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteAllUserNotifications(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteAllUserNotifications(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDeleteAllUserNotifications(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class OrganizationUnitServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrganizationUnits(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrganizationUnits(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
    }));
  }

  protected processGetOrganizationUnits(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfOrganizationUnitDto>(null as any);
  }

  /**
   * @param id (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getOrganizationUnitUsers(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrganizationUnitUsers(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrganizationUnitUsers(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
    }));
  }

  protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfOrganizationUnitUserListDto>(null as any);
  }

  /**
   * @param id (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getOrganizationUnitRoles(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrganizationUnitRoles(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrganizationUnitRoles(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
    }));
  }

  protected processGetOrganizationUnitRoles(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfOrganizationUnitRoleListDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrganizationUnit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrganizationUnit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
    }));
  }

  protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrganizationUnitDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrganizationUnitDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateOrganizationUnit(body: UpdateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateOrganizationUnit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateOrganizationUnit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
    }));
  }

  protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrganizationUnitDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrganizationUnitDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processMoveOrganizationUnit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processMoveOrganizationUnit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
    }));
  }

  protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrganizationUnitDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrganizationUnitDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteOrganizationUnit(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteOrganizationUnit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteOrganizationUnit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param userId (optional)
   * @param organizationUnitId (optional)
   * @return Success
   */
  removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
    if (organizationUnitId === null)
      throw new Error("The parameter 'organizationUnitId' cannot be null.");
    else if (organizationUnitId !== undefined)
      url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processRemoveUserFromOrganizationUnit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRemoveUserFromOrganizationUnit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param roleId (optional)
   * @param organizationUnitId (optional)
   * @return Success
   */
  removeRoleFromOrganizationUnit(roleId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
    if (roleId === null)
      throw new Error("The parameter 'roleId' cannot be null.");
    else if (roleId !== undefined)
      url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
    if (organizationUnitId === null)
      throw new Error("The parameter 'organizationUnitId' cannot be null.");
    else if (organizationUnitId !== undefined)
      url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processRemoveRoleFromOrganizationUnit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRemoveRoleFromOrganizationUnit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processRemoveRoleFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processAddUsersToOrganizationUnit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddUsersToOrganizationUnit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addRolesToOrganizationUnit(body: RolesToOrganizationUnitInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processAddRolesToOrganizationUnit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddRolesToOrganizationUnit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processAddRolesToOrganizationUnit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  findUsers(body: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processFindUsers(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processFindUsers(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
    }));
  }

  protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfNameValueDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  findRoles(body: FindOrganizationUnitRolesInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processFindRoles(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processFindRoles(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
    }));
  }

  protected processFindRoles(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfNameValueDto>(null as any);
  }
}

@Injectable()
export class OrphanBookDetailsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param bookNameFilter (optional)
   * @param bookAuthorFilter (optional)
   * @param maxPageCountFilter (optional)
   * @param minPageCountFilter (optional)
   * @param maxStartDateFilter (optional)
   * @param minStartDateFilter (optional)
   * @param maxEndDateFilter (optional)
   * @param minEndDateFilter (optional)
   * @param bookTypeNameFilter (optional)
   * @param orphanFirstNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, bookNameFilter: string | undefined, bookAuthorFilter: string | undefined, maxPageCountFilter: number | undefined, minPageCountFilter: number | undefined, maxStartDateFilter: DateTime | undefined, minStartDateFilter: DateTime | undefined, maxEndDateFilter: DateTime | undefined, minEndDateFilter: DateTime | undefined, bookTypeNameFilter: string | undefined, orphanFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrphanBookDetailForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/OrphanBookDetails/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (bookNameFilter === null)
      throw new Error("The parameter 'bookNameFilter' cannot be null.");
    else if (bookNameFilter !== undefined)
      url_ += "BookNameFilter=" + encodeURIComponent("" + bookNameFilter) + "&";
    if (bookAuthorFilter === null)
      throw new Error("The parameter 'bookAuthorFilter' cannot be null.");
    else if (bookAuthorFilter !== undefined)
      url_ += "BookAuthorFilter=" + encodeURIComponent("" + bookAuthorFilter) + "&";
    if (maxPageCountFilter === null)
      throw new Error("The parameter 'maxPageCountFilter' cannot be null.");
    else if (maxPageCountFilter !== undefined)
      url_ += "MaxPageCountFilter=" + encodeURIComponent("" + maxPageCountFilter) + "&";
    if (minPageCountFilter === null)
      throw new Error("The parameter 'minPageCountFilter' cannot be null.");
    else if (minPageCountFilter !== undefined)
      url_ += "MinPageCountFilter=" + encodeURIComponent("" + minPageCountFilter) + "&";
    if (maxStartDateFilter === null)
      throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
    else if (maxStartDateFilter !== undefined)
      url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toString() : "") + "&";
    if (minStartDateFilter === null)
      throw new Error("The parameter 'minStartDateFilter' cannot be null.");
    else if (minStartDateFilter !== undefined)
      url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toString() : "") + "&";
    if (maxEndDateFilter === null)
      throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
    else if (maxEndDateFilter !== undefined)
      url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toString() : "") + "&";
    if (minEndDateFilter === null)
      throw new Error("The parameter 'minEndDateFilter' cannot be null.");
    else if (minEndDateFilter !== undefined)
      url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toString() : "") + "&";
    if (bookTypeNameFilter === null)
      throw new Error("The parameter 'bookTypeNameFilter' cannot be null.");
    else if (bookTypeNameFilter !== undefined)
      url_ += "BookTypeNameFilter=" + encodeURIComponent("" + bookTypeNameFilter) + "&";
    if (orphanFirstNameFilter === null)
      throw new Error("The parameter 'orphanFirstNameFilter' cannot be null.");
    else if (orphanFirstNameFilter !== undefined)
      url_ += "OrphanFirstNameFilter=" + encodeURIComponent("" + orphanFirstNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrphanBookDetailForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrphanBookDetailForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrphanBookDetailForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetOrphanBookDetailForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetOrphanBookDetailForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrphanBookDetailForEdit(id: number | undefined): Observable<GetOrphanBookDetailForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/OrphanBookDetails/GetOrphanBookDetailForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanBookDetailForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanBookDetailForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetOrphanBookDetailForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetOrphanBookDetailForEditOutput>;
    }));
  }

  protected processGetOrphanBookDetailForEdit(response: HttpResponseBase): Observable<GetOrphanBookDetailForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetOrphanBookDetailForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetOrphanBookDetailForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditOrphanBookDetailDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanBookDetails/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanBookDetails/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getAllBookTypeForTableDropdown(): Observable<OrphanBookDetailBookTypeLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanBookDetails/GetAllBookTypeForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllBookTypeForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllBookTypeForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanBookDetailBookTypeLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanBookDetailBookTypeLookupTableDto[]>;
    }));
  }

  protected processGetAllBookTypeForTableDropdown(response: HttpResponseBase): Observable<OrphanBookDetailBookTypeLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanBookDetailBookTypeLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanBookDetailBookTypeLookupTableDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getAllOrphanForTableDropdown(): Observable<OrphanBookDetailOrphanLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanBookDetails/GetAllOrphanForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllOrphanForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllOrphanForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanBookDetailOrphanLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanBookDetailOrphanLookupTableDto[]>;
    }));
  }

  protected processGetAllOrphanForTableDropdown(response: HttpResponseBase): Observable<OrphanBookDetailOrphanLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanBookDetailOrphanLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanBookDetailOrphanLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class OrphanClubDetailsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param maxJoinedCountFilter (optional)
   * @param minJoinedCountFilter (optional)
   * @param maxJoinedYearFilter (optional)
   * @param minJoinedYearFilter (optional)
   * @param descriptionFilter (optional)
   * @param orphanFirstNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nameFilter: string | undefined, maxJoinedCountFilter: number | undefined, minJoinedCountFilter: number | undefined, maxJoinedYearFilter: number | undefined, minJoinedYearFilter: number | undefined, descriptionFilter: string | undefined, orphanFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrphanClubDetailForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/OrphanClubDetails/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (maxJoinedCountFilter === null)
      throw new Error("The parameter 'maxJoinedCountFilter' cannot be null.");
    else if (maxJoinedCountFilter !== undefined)
      url_ += "MaxJoinedCountFilter=" + encodeURIComponent("" + maxJoinedCountFilter) + "&";
    if (minJoinedCountFilter === null)
      throw new Error("The parameter 'minJoinedCountFilter' cannot be null.");
    else if (minJoinedCountFilter !== undefined)
      url_ += "MinJoinedCountFilter=" + encodeURIComponent("" + minJoinedCountFilter) + "&";
    if (maxJoinedYearFilter === null)
      throw new Error("The parameter 'maxJoinedYearFilter' cannot be null.");
    else if (maxJoinedYearFilter !== undefined)
      url_ += "MaxJoinedYearFilter=" + encodeURIComponent("" + maxJoinedYearFilter) + "&";
    if (minJoinedYearFilter === null)
      throw new Error("The parameter 'minJoinedYearFilter' cannot be null.");
    else if (minJoinedYearFilter !== undefined)
      url_ += "MinJoinedYearFilter=" + encodeURIComponent("" + minJoinedYearFilter) + "&";
    if (descriptionFilter === null)
      throw new Error("The parameter 'descriptionFilter' cannot be null.");
    else if (descriptionFilter !== undefined)
      url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
    if (orphanFirstNameFilter === null)
      throw new Error("The parameter 'orphanFirstNameFilter' cannot be null.");
    else if (orphanFirstNameFilter !== undefined)
      url_ += "OrphanFirstNameFilter=" + encodeURIComponent("" + orphanFirstNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrphanClubDetailForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrphanClubDetailForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrphanClubDetailForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetOrphanClubDetailForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetOrphanClubDetailForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrphanClubDetailForEdit(id: number | undefined): Observable<GetOrphanClubDetailForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/OrphanClubDetails/GetOrphanClubDetailForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanClubDetailForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanClubDetailForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetOrphanClubDetailForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetOrphanClubDetailForEditOutput>;
    }));
  }

  protected processGetOrphanClubDetailForEdit(response: HttpResponseBase): Observable<GetOrphanClubDetailForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetOrphanClubDetailForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetOrphanClubDetailForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditOrphanClubDetailDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanClubDetails/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanClubDetails/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getAllOrphanForTableDropdown(): Observable<OrphanClubDetailOrphanLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanClubDetails/GetAllOrphanForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllOrphanForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllOrphanForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanClubDetailOrphanLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanClubDetailOrphanLookupTableDto[]>;
    }));
  }

  protected processGetAllOrphanForTableDropdown(response: HttpResponseBase): Observable<OrphanClubDetailOrphanLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanClubDetailOrphanLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanClubDetailOrphanLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class OrphanEducationsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param educationNameFilter (optional)
   * @param educationTimeFilter (optional)
   * @param pointValueFilter (optional)
   * @param descriptionFilter (optional)
   * @param documentNameFilter (optional)
   * @param filePathFilter (optional)
   * @param fileExtensionFilter (optional)
   * @param maxEducationDateFilter (optional)
   * @param minEducationDateFilter (optional)
   * @param orphanFirstNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, educationNameFilter: string | undefined, educationTimeFilter: string | undefined, pointValueFilter: string | undefined, descriptionFilter: string | undefined, documentNameFilter: string | undefined, filePathFilter: string | undefined, fileExtensionFilter: string | undefined, maxEducationDateFilter: DateTime | undefined, minEducationDateFilter: DateTime | undefined, orphanFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrphanEducationForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/OrphanEducations/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (educationNameFilter === null)
      throw new Error("The parameter 'educationNameFilter' cannot be null.");
    else if (educationNameFilter !== undefined)
      url_ += "EducationNameFilter=" + encodeURIComponent("" + educationNameFilter) + "&";
    if (educationTimeFilter === null)
      throw new Error("The parameter 'educationTimeFilter' cannot be null.");
    else if (educationTimeFilter !== undefined)
      url_ += "EducationTimeFilter=" + encodeURIComponent("" + educationTimeFilter) + "&";
    if (pointValueFilter === null)
      throw new Error("The parameter 'pointValueFilter' cannot be null.");
    else if (pointValueFilter !== undefined)
      url_ += "PointValueFilter=" + encodeURIComponent("" + pointValueFilter) + "&";
    if (descriptionFilter === null)
      throw new Error("The parameter 'descriptionFilter' cannot be null.");
    else if (descriptionFilter !== undefined)
      url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
    if (documentNameFilter === null)
      throw new Error("The parameter 'documentNameFilter' cannot be null.");
    else if (documentNameFilter !== undefined)
      url_ += "DocumentNameFilter=" + encodeURIComponent("" + documentNameFilter) + "&";
    if (filePathFilter === null)
      throw new Error("The parameter 'filePathFilter' cannot be null.");
    else if (filePathFilter !== undefined)
      url_ += "FilePathFilter=" + encodeURIComponent("" + filePathFilter) + "&";
    if (fileExtensionFilter === null)
      throw new Error("The parameter 'fileExtensionFilter' cannot be null.");
    else if (fileExtensionFilter !== undefined)
      url_ += "FileExtensionFilter=" + encodeURIComponent("" + fileExtensionFilter) + "&";
    if (maxEducationDateFilter === null)
      throw new Error("The parameter 'maxEducationDateFilter' cannot be null.");
    else if (maxEducationDateFilter !== undefined)
      url_ += "MaxEducationDateFilter=" + encodeURIComponent(maxEducationDateFilter ? "" + maxEducationDateFilter.toString() : "") + "&";
    if (minEducationDateFilter === null)
      throw new Error("The parameter 'minEducationDateFilter' cannot be null.");
    else if (minEducationDateFilter !== undefined)
      url_ += "MinEducationDateFilter=" + encodeURIComponent(minEducationDateFilter ? "" + minEducationDateFilter.toString() : "") + "&";
    if (orphanFirstNameFilter === null)
      throw new Error("The parameter 'orphanFirstNameFilter' cannot be null.");
    else if (orphanFirstNameFilter !== undefined)
      url_ += "OrphanFirstNameFilter=" + encodeURIComponent("" + orphanFirstNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrphanEducationForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrphanEducationForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrphanEducationForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetOrphanEducationForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetOrphanEducationForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrphanEducationForEdit(id: number | undefined): Observable<GetOrphanEducationForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/OrphanEducations/GetOrphanEducationForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanEducationForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanEducationForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetOrphanEducationForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetOrphanEducationForEditOutput>;
    }));
  }

  protected processGetOrphanEducationForEdit(response: HttpResponseBase): Observable<GetOrphanEducationForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetOrphanEducationForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetOrphanEducationForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditOrphanEducationDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanEducations/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanEducations/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getAllOrphanForTableDropdown(): Observable<OrphanEducationOrphanLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanEducations/GetAllOrphanForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllOrphanForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllOrphanForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanEducationOrphanLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanEducationOrphanLookupTableDto[]>;
    }));
  }

  protected processGetAllOrphanForTableDropdown(response: HttpResponseBase): Observable<OrphanEducationOrphanLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanEducationOrphanLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanEducationOrphanLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class OrphanEventTypesServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrphanEventTypeForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/OrphanEventTypes/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrphanEventTypeForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrphanEventTypeForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrphanEventTypeForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetOrphanEventTypeForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetOrphanEventTypeForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrphanEventTypeForView(id: number | undefined): Observable<GetOrphanEventTypeForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/OrphanEventTypes/GetOrphanEventTypeForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanEventTypeForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanEventTypeForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetOrphanEventTypeForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetOrphanEventTypeForViewDto>;
    }));
  }

  protected processGetOrphanEventTypeForView(response: HttpResponseBase): Observable<GetOrphanEventTypeForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetOrphanEventTypeForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetOrphanEventTypeForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrphanEventTypeForEdit(id: number | undefined): Observable<GetOrphanEventTypeForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/OrphanEventTypes/GetOrphanEventTypeForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanEventTypeForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanEventTypeForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetOrphanEventTypeForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetOrphanEventTypeForEditOutput>;
    }));
  }

  protected processGetOrphanEventTypeForEdit(response: HttpResponseBase): Observable<GetOrphanEventTypeForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetOrphanEventTypeForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetOrphanEventTypeForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditOrphanEventTypeDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanEventTypes/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanEventTypes/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @return Success
   */
  getOrphanEventTypesToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/OrphanEventTypes/GetOrphanEventTypesToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanEventTypesToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanEventTypesToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetOrphanEventTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }
}

@Injectable()
export class OrphanExperiencesServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param companyNameFilter (optional)
   * @param taskTypeFilter (optional)
   * @param maxOprhanWorkTypeFilter (optional)
   * @param minOprhanWorkTypeFilter (optional)
   * @param maxStartDateFilter (optional)
   * @param minStartDateFilter (optional)
   * @param maxEndDateFilter (optional)
   * @param minEndDateFilter (optional)
   * @param companySectorFilter (optional)
   * @param descriptionFilter (optional)
   * @param provinceNameFilter (optional)
   * @param orphanFirstNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, companyNameFilter: string | undefined, taskTypeFilter: number | undefined, maxOprhanWorkTypeFilter: number | undefined, minOprhanWorkTypeFilter: number | undefined, maxStartDateFilter: DateTime | undefined, minStartDateFilter: DateTime | undefined, maxEndDateFilter: DateTime | undefined, minEndDateFilter: DateTime | undefined, companySectorFilter: string | undefined, descriptionFilter: string | undefined, provinceNameFilter: string | undefined, orphanFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrphanExperienceForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/OrphanExperiences/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (companyNameFilter === null)
      throw new Error("The parameter 'companyNameFilter' cannot be null.");
    else if (companyNameFilter !== undefined)
      url_ += "CompanyNameFilter=" + encodeURIComponent("" + companyNameFilter) + "&";
    if (taskTypeFilter === null)
      throw new Error("The parameter 'taskTypeFilter' cannot be null.");
    else if (taskTypeFilter !== undefined)
      url_ += "TaskTypeFilter=" + encodeURIComponent("" + taskTypeFilter) + "&";
    if (maxOprhanWorkTypeFilter === null)
      throw new Error("The parameter 'maxOprhanWorkTypeFilter' cannot be null.");
    else if (maxOprhanWorkTypeFilter !== undefined)
      url_ += "MaxOprhanWorkTypeFilter=" + encodeURIComponent("" + maxOprhanWorkTypeFilter) + "&";
    if (minOprhanWorkTypeFilter === null)
      throw new Error("The parameter 'minOprhanWorkTypeFilter' cannot be null.");
    else if (minOprhanWorkTypeFilter !== undefined)
      url_ += "MinOprhanWorkTypeFilter=" + encodeURIComponent("" + minOprhanWorkTypeFilter) + "&";
    if (maxStartDateFilter === null)
      throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
    else if (maxStartDateFilter !== undefined)
      url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toString() : "") + "&";
    if (minStartDateFilter === null)
      throw new Error("The parameter 'minStartDateFilter' cannot be null.");
    else if (minStartDateFilter !== undefined)
      url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toString() : "") + "&";
    if (maxEndDateFilter === null)
      throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
    else if (maxEndDateFilter !== undefined)
      url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toString() : "") + "&";
    if (minEndDateFilter === null)
      throw new Error("The parameter 'minEndDateFilter' cannot be null.");
    else if (minEndDateFilter !== undefined)
      url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toString() : "") + "&";
    if (companySectorFilter === null)
      throw new Error("The parameter 'companySectorFilter' cannot be null.");
    else if (companySectorFilter !== undefined)
      url_ += "CompanySectorFilter=" + encodeURIComponent("" + companySectorFilter) + "&";
    if (descriptionFilter === null)
      throw new Error("The parameter 'descriptionFilter' cannot be null.");
    else if (descriptionFilter !== undefined)
      url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
    if (provinceNameFilter === null)
      throw new Error("The parameter 'provinceNameFilter' cannot be null.");
    else if (provinceNameFilter !== undefined)
      url_ += "ProvinceNameFilter=" + encodeURIComponent("" + provinceNameFilter) + "&";
    if (orphanFirstNameFilter === null)
      throw new Error("The parameter 'orphanFirstNameFilter' cannot be null.");
    else if (orphanFirstNameFilter !== undefined)
      url_ += "OrphanFirstNameFilter=" + encodeURIComponent("" + orphanFirstNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrphanExperienceForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrphanExperienceForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrphanExperienceForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetOrphanExperienceForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetOrphanExperienceForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrphanExperienceForEdit(id: number | undefined): Observable<GetOrphanExperienceForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/OrphanExperiences/GetOrphanExperienceForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanExperienceForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanExperienceForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetOrphanExperienceForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetOrphanExperienceForEditOutput>;
    }));
  }

  protected processGetOrphanExperienceForEdit(response: HttpResponseBase): Observable<GetOrphanExperienceForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetOrphanExperienceForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetOrphanExperienceForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditOrphanExperienceDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanExperiences/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanExperiences/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getAllProvinceForTableDropdown(): Observable<OrphanExperienceProvinceLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanExperiences/GetAllProvinceForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllProvinceForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllProvinceForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanExperienceProvinceLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanExperienceProvinceLookupTableDto[]>;
    }));
  }

  protected processGetAllProvinceForTableDropdown(response: HttpResponseBase): Observable<OrphanExperienceProvinceLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanExperienceProvinceLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanExperienceProvinceLookupTableDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getAllOrphanForTableDropdown(): Observable<OrphanExperienceOrphanLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanExperiences/GetAllOrphanForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllOrphanForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllOrphanForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanExperienceOrphanLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanExperienceOrphanLookupTableDto[]>;
    }));
  }

  protected processGetAllOrphanForTableDropdown(response: HttpResponseBase): Observable<OrphanExperienceOrphanLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanExperienceOrphanLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanExperienceOrphanLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class OrphanInterestDetailsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param orphanFirstNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nameFilter: string | undefined, orphanFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrphanInterestDetailForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/OrphanInterestDetails/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (orphanFirstNameFilter === null)
      throw new Error("The parameter 'orphanFirstNameFilter' cannot be null.");
    else if (orphanFirstNameFilter !== undefined)
      url_ += "OrphanFirstNameFilter=" + encodeURIComponent("" + orphanFirstNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrphanInterestDetailForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrphanInterestDetailForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrphanInterestDetailForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetOrphanInterestDetailForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetOrphanInterestDetailForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrphanInterestDetailForEdit(id: number | undefined): Observable<GetOrphanInterestDetailForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/OrphanInterestDetails/GetOrphanInterestDetailForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanInterestDetailForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanInterestDetailForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetOrphanInterestDetailForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetOrphanInterestDetailForEditOutput>;
    }));
  }

  protected processGetOrphanInterestDetailForEdit(response: HttpResponseBase): Observable<GetOrphanInterestDetailForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetOrphanInterestDetailForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetOrphanInterestDetailForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditOrphanInterestDetailDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanInterestDetails/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanInterestDetails/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getAllOrphanForTableDropdown(): Observable<OrphanInterestDetailOrphanLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanInterestDetails/GetAllOrphanForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllOrphanForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllOrphanForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanInterestDetailOrphanLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanInterestDetailOrphanLookupTableDto[]>;
    }));
  }

  protected processGetAllOrphanForTableDropdown(response: HttpResponseBase): Observable<OrphanInterestDetailOrphanLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanInterestDetailOrphanLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanInterestDetailOrphanLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class OrphanLanguageDetailsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param languageLevelFilter (optional)
   * @param orphanFirstNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nameFilter: string | undefined, languageLevelFilter: number | undefined, orphanFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrphanLanguageDetailForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/OrphanLanguageDetails/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (languageLevelFilter === null)
      throw new Error("The parameter 'languageLevelFilter' cannot be null.");
    else if (languageLevelFilter !== undefined)
      url_ += "LanguageLevelFilter=" + encodeURIComponent("" + languageLevelFilter) + "&";
    if (orphanFirstNameFilter === null)
      throw new Error("The parameter 'orphanFirstNameFilter' cannot be null.");
    else if (orphanFirstNameFilter !== undefined)
      url_ += "OrphanFirstNameFilter=" + encodeURIComponent("" + orphanFirstNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrphanLanguageDetailForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrphanLanguageDetailForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrphanLanguageDetailForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetOrphanLanguageDetailForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetOrphanLanguageDetailForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrphanLanguageDetailForEdit(id: number | undefined): Observable<GetOrphanLanguageDetailForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/OrphanLanguageDetails/GetOrphanLanguageDetailForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanLanguageDetailForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanLanguageDetailForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetOrphanLanguageDetailForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetOrphanLanguageDetailForEditOutput>;
    }));
  }

  protected processGetOrphanLanguageDetailForEdit(response: HttpResponseBase): Observable<GetOrphanLanguageDetailForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetOrphanLanguageDetailForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetOrphanLanguageDetailForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditOrphanLanguageDetailDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanLanguageDetails/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanLanguageDetails/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getAllOrphanForTableDropdown(): Observable<OrphanLanguageDetailOrphanLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanLanguageDetails/GetAllOrphanForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllOrphanForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllOrphanForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanLanguageDetailOrphanLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanLanguageDetailOrphanLookupTableDto[]>;
    }));
  }

  protected processGetAllOrphanForTableDropdown(response: HttpResponseBase): Observable<OrphanLanguageDetailOrphanLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanLanguageDetailOrphanLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanLanguageDetailOrphanLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class OrphanProjectDetailsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param yearFilter (optional)
   * @param nameFilter (optional)
   * @param projectStatusFilter (optional)
   * @param orphanFirstNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, yearFilter: string | undefined, nameFilter: string | undefined, projectStatusFilter: number | undefined, orphanFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrphanProjectDetailForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/OrphanProjectDetails/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (yearFilter === null)
      throw new Error("The parameter 'yearFilter' cannot be null.");
    else if (yearFilter !== undefined)
      url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (projectStatusFilter === null)
      throw new Error("The parameter 'projectStatusFilter' cannot be null.");
    else if (projectStatusFilter !== undefined)
      url_ += "ProjectStatusFilter=" + encodeURIComponent("" + projectStatusFilter) + "&";
    if (orphanFirstNameFilter === null)
      throw new Error("The parameter 'orphanFirstNameFilter' cannot be null.");
    else if (orphanFirstNameFilter !== undefined)
      url_ += "OrphanFirstNameFilter=" + encodeURIComponent("" + orphanFirstNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrphanProjectDetailForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrphanProjectDetailForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrphanProjectDetailForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetOrphanProjectDetailForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetOrphanProjectDetailForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrphanProjectDetailForEdit(id: number | undefined): Observable<GetOrphanProjectDetailForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/OrphanProjectDetails/GetOrphanProjectDetailForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanProjectDetailForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanProjectDetailForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetOrphanProjectDetailForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetOrphanProjectDetailForEditOutput>;
    }));
  }

  protected processGetOrphanProjectDetailForEdit(response: HttpResponseBase): Observable<GetOrphanProjectDetailForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetOrphanProjectDetailForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetOrphanProjectDetailForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditOrphanProjectDetailDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanProjectDetails/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanProjectDetails/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getAllOrphanForTableDropdown(): Observable<OrphanProjectDetailOrphanLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanProjectDetails/GetAllOrphanForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllOrphanForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllOrphanForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanProjectDetailOrphanLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanProjectDetailOrphanLookupTableDto[]>;
    }));
  }

  protected processGetAllOrphanForTableDropdown(response: HttpResponseBase): Observable<OrphanProjectDetailOrphanLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanProjectDetailOrphanLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanProjectDetailOrphanLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class OrphansServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nationalityFilter (optional)
   * @param mdgMuhatapNoFilter (optional)
   * @param tcNumberFilter (optional)
   * @param firstNameFilter (optional)
   * @param lastNameFilter (optional)
   * @param placeOfBirthFilter (optional)
   * @param maxDateOfBirthFilter (optional)
   * @param minDateOfBirthFilter (optional)
   * @param motherAndFatherNameFilter (optional)
   * @param addressFilter (optional)
   * @param apartmentNumberFilter (optional)
   * @param maxPostCodeFilter (optional)
   * @param minPostCodeFilter (optional)
   * @param mobileNumberFilter (optional)
   * @param homeNumberFilter (optional)
   * @param eMailFilter (optional)
   * @param maritalStatusFilter (optional)
   * @param provinceNameFilter (optional)
   * @param districtNameFilter (optional)
   * @param neighborhoodNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nationalityFilter: string | undefined, mdgMuhatapNoFilter: string | undefined, tcNumberFilter: string | undefined, firstNameFilter: string | undefined, lastNameFilter: string | undefined, placeOfBirthFilter: string | undefined, maxDateOfBirthFilter: DateTime | undefined, minDateOfBirthFilter: DateTime | undefined, motherAndFatherNameFilter: string | undefined, addressFilter: string | undefined, apartmentNumberFilter: string | undefined, maxPostCodeFilter: number | undefined, minPostCodeFilter: number | undefined, mobileNumberFilter: string | undefined, homeNumberFilter: string | undefined, eMailFilter: string | undefined, maritalStatusFilter: number | undefined, provinceNameFilter: string | undefined, districtNameFilter: string | undefined, neighborhoodNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrphanForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/Orphans/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nationalityFilter === null)
      throw new Error("The parameter 'nationalityFilter' cannot be null.");
    else if (nationalityFilter !== undefined)
      url_ += "NationalityFilter=" + encodeURIComponent("" + nationalityFilter) + "&";
    if (mdgMuhatapNoFilter === null)
      throw new Error("The parameter 'mdgMuhatapNoFilter' cannot be null.");
    else if (mdgMuhatapNoFilter !== undefined)
      url_ += "MdgMuhatapNoFilter=" + encodeURIComponent("" + mdgMuhatapNoFilter) + "&";
    if (tcNumberFilter === null)
      throw new Error("The parameter 'tcNumberFilter' cannot be null.");
    else if (tcNumberFilter !== undefined)
      url_ += "TcNumberFilter=" + encodeURIComponent("" + tcNumberFilter) + "&";
    if (firstNameFilter === null)
      throw new Error("The parameter 'firstNameFilter' cannot be null.");
    else if (firstNameFilter !== undefined)
      url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&";
    if (lastNameFilter === null)
      throw new Error("The parameter 'lastNameFilter' cannot be null.");
    else if (lastNameFilter !== undefined)
      url_ += "LastNameFilter=" + encodeURIComponent("" + lastNameFilter) + "&";
    if (placeOfBirthFilter === null)
      throw new Error("The parameter 'placeOfBirthFilter' cannot be null.");
    else if (placeOfBirthFilter !== undefined)
      url_ += "PlaceOfBirthFilter=" + encodeURIComponent("" + placeOfBirthFilter) + "&";
    if (maxDateOfBirthFilter === null)
      throw new Error("The parameter 'maxDateOfBirthFilter' cannot be null.");
    else if (maxDateOfBirthFilter !== undefined)
      url_ += "MaxDateOfBirthFilter=" + encodeURIComponent(maxDateOfBirthFilter ? "" + maxDateOfBirthFilter.toString() : "") + "&";
    if (minDateOfBirthFilter === null)
      throw new Error("The parameter 'minDateOfBirthFilter' cannot be null.");
    else if (minDateOfBirthFilter !== undefined)
      url_ += "MinDateOfBirthFilter=" + encodeURIComponent(minDateOfBirthFilter ? "" + minDateOfBirthFilter.toString() : "") + "&";
    if (motherAndFatherNameFilter === null)
      throw new Error("The parameter 'motherAndFatherNameFilter' cannot be null.");
    else if (motherAndFatherNameFilter !== undefined)
      url_ += "MotherAndFatherNameFilter=" + encodeURIComponent("" + motherAndFatherNameFilter) + "&";
    if (addressFilter === null)
      throw new Error("The parameter 'addressFilter' cannot be null.");
    else if (addressFilter !== undefined)
      url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
    if (apartmentNumberFilter === null)
      throw new Error("The parameter 'apartmentNumberFilter' cannot be null.");
    else if (apartmentNumberFilter !== undefined)
      url_ += "ApartmentNumberFilter=" + encodeURIComponent("" + apartmentNumberFilter) + "&";
    if (maxPostCodeFilter === null)
      throw new Error("The parameter 'maxPostCodeFilter' cannot be null.");
    else if (maxPostCodeFilter !== undefined)
      url_ += "MaxPostCodeFilter=" + encodeURIComponent("" + maxPostCodeFilter) + "&";
    if (minPostCodeFilter === null)
      throw new Error("The parameter 'minPostCodeFilter' cannot be null.");
    else if (minPostCodeFilter !== undefined)
      url_ += "MinPostCodeFilter=" + encodeURIComponent("" + minPostCodeFilter) + "&";
    if (mobileNumberFilter === null)
      throw new Error("The parameter 'mobileNumberFilter' cannot be null.");
    else if (mobileNumberFilter !== undefined)
      url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&";
    if (homeNumberFilter === null)
      throw new Error("The parameter 'homeNumberFilter' cannot be null.");
    else if (homeNumberFilter !== undefined)
      url_ += "HomeNumberFilter=" + encodeURIComponent("" + homeNumberFilter) + "&";
    if (eMailFilter === null)
      throw new Error("The parameter 'eMailFilter' cannot be null.");
    else if (eMailFilter !== undefined)
      url_ += "EMailFilter=" + encodeURIComponent("" + eMailFilter) + "&";
    if (maritalStatusFilter === null)
      throw new Error("The parameter 'maritalStatusFilter' cannot be null.");
    else if (maritalStatusFilter !== undefined)
      url_ += "MaritalStatusFilter=" + encodeURIComponent("" + maritalStatusFilter) + "&";
    if (provinceNameFilter === null)
      throw new Error("The parameter 'provinceNameFilter' cannot be null.");
    else if (provinceNameFilter !== undefined)
      url_ += "ProvinceNameFilter=" + encodeURIComponent("" + provinceNameFilter) + "&";
    if (districtNameFilter === null)
      throw new Error("The parameter 'districtNameFilter' cannot be null.");
    else if (districtNameFilter !== undefined)
      url_ += "DistrictNameFilter=" + encodeURIComponent("" + districtNameFilter) + "&";
    if (neighborhoodNameFilter === null)
      throw new Error("The parameter 'neighborhoodNameFilter' cannot be null.");
    else if (neighborhoodNameFilter !== undefined)
      url_ += "NeighborhoodNameFilter=" + encodeURIComponent("" + neighborhoodNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrphanForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrphanForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrphanForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetOrphanForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetOrphanForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrphanForView(id: number | undefined): Observable<GetOrphanForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/Orphans/GetOrphanForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetOrphanForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetOrphanForViewDto>;
    }));
  }

  protected processGetOrphanForView(response: HttpResponseBase): Observable<GetOrphanForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetOrphanForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetOrphanForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrphanForEdit(id: number | undefined): Observable<GetOrphanForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/Orphans/GetOrphanForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetOrphanForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetOrphanForEditOutput>;
    }));
  }

  protected processGetOrphanForEdit(response: HttpResponseBase): Observable<GetOrphanForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetOrphanForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetOrphanForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditOrphanDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Orphans/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Orphans/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param nationalityFilter (optional)
   * @param mdgMuhatapNoFilter (optional)
   * @param tcNumberFilter (optional)
   * @param firstNameFilter (optional)
   * @param lastNameFilter (optional)
   * @param placeOfBirthFilter (optional)
   * @param maxDateOfBirthFilter (optional)
   * @param minDateOfBirthFilter (optional)
   * @param motherAndFatherNameFilter (optional)
   * @param addressFilter (optional)
   * @param apartmentNumberFilter (optional)
   * @param maxPostCodeFilter (optional)
   * @param minPostCodeFilter (optional)
   * @param mobileNumberFilter (optional)
   * @param homeNumberFilter (optional)
   * @param eMailFilter (optional)
   * @param maritalStatusFilter (optional)
   * @param provinceNameFilter (optional)
   * @param districtNameFilter (optional)
   * @param neighborhoodNameFilter (optional)
   * @return Success
   */
  getOrphansToExcel(filter: string | undefined, nationalityFilter: string | undefined, mdgMuhatapNoFilter: string | undefined, tcNumberFilter: string | undefined, firstNameFilter: string | undefined, lastNameFilter: string | undefined, placeOfBirthFilter: string | undefined, maxDateOfBirthFilter: DateTime | undefined, minDateOfBirthFilter: DateTime | undefined, motherAndFatherNameFilter: string | undefined, addressFilter: string | undefined, apartmentNumberFilter: string | undefined, maxPostCodeFilter: number | undefined, minPostCodeFilter: number | undefined, mobileNumberFilter: string | undefined, homeNumberFilter: string | undefined, eMailFilter: string | undefined, maritalStatusFilter: number | undefined, provinceNameFilter: string | undefined, districtNameFilter: string | undefined, neighborhoodNameFilter: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/Orphans/GetOrphansToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nationalityFilter === null)
      throw new Error("The parameter 'nationalityFilter' cannot be null.");
    else if (nationalityFilter !== undefined)
      url_ += "NationalityFilter=" + encodeURIComponent("" + nationalityFilter) + "&";
    if (mdgMuhatapNoFilter === null)
      throw new Error("The parameter 'mdgMuhatapNoFilter' cannot be null.");
    else if (mdgMuhatapNoFilter !== undefined)
      url_ += "MdgMuhatapNoFilter=" + encodeURIComponent("" + mdgMuhatapNoFilter) + "&";
    if (tcNumberFilter === null)
      throw new Error("The parameter 'tcNumberFilter' cannot be null.");
    else if (tcNumberFilter !== undefined)
      url_ += "TcNumberFilter=" + encodeURIComponent("" + tcNumberFilter) + "&";
    if (firstNameFilter === null)
      throw new Error("The parameter 'firstNameFilter' cannot be null.");
    else if (firstNameFilter !== undefined)
      url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&";
    if (lastNameFilter === null)
      throw new Error("The parameter 'lastNameFilter' cannot be null.");
    else if (lastNameFilter !== undefined)
      url_ += "LastNameFilter=" + encodeURIComponent("" + lastNameFilter) + "&";
    if (placeOfBirthFilter === null)
      throw new Error("The parameter 'placeOfBirthFilter' cannot be null.");
    else if (placeOfBirthFilter !== undefined)
      url_ += "PlaceOfBirthFilter=" + encodeURIComponent("" + placeOfBirthFilter) + "&";
    if (maxDateOfBirthFilter === null)
      throw new Error("The parameter 'maxDateOfBirthFilter' cannot be null.");
    else if (maxDateOfBirthFilter !== undefined)
      url_ += "MaxDateOfBirthFilter=" + encodeURIComponent(maxDateOfBirthFilter ? "" + maxDateOfBirthFilter.toString() : "") + "&";
    if (minDateOfBirthFilter === null)
      throw new Error("The parameter 'minDateOfBirthFilter' cannot be null.");
    else if (minDateOfBirthFilter !== undefined)
      url_ += "MinDateOfBirthFilter=" + encodeURIComponent(minDateOfBirthFilter ? "" + minDateOfBirthFilter.toString() : "") + "&";
    if (motherAndFatherNameFilter === null)
      throw new Error("The parameter 'motherAndFatherNameFilter' cannot be null.");
    else if (motherAndFatherNameFilter !== undefined)
      url_ += "MotherAndFatherNameFilter=" + encodeURIComponent("" + motherAndFatherNameFilter) + "&";
    if (addressFilter === null)
      throw new Error("The parameter 'addressFilter' cannot be null.");
    else if (addressFilter !== undefined)
      url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
    if (apartmentNumberFilter === null)
      throw new Error("The parameter 'apartmentNumberFilter' cannot be null.");
    else if (apartmentNumberFilter !== undefined)
      url_ += "ApartmentNumberFilter=" + encodeURIComponent("" + apartmentNumberFilter) + "&";
    if (maxPostCodeFilter === null)
      throw new Error("The parameter 'maxPostCodeFilter' cannot be null.");
    else if (maxPostCodeFilter !== undefined)
      url_ += "MaxPostCodeFilter=" + encodeURIComponent("" + maxPostCodeFilter) + "&";
    if (minPostCodeFilter === null)
      throw new Error("The parameter 'minPostCodeFilter' cannot be null.");
    else if (minPostCodeFilter !== undefined)
      url_ += "MinPostCodeFilter=" + encodeURIComponent("" + minPostCodeFilter) + "&";
    if (mobileNumberFilter === null)
      throw new Error("The parameter 'mobileNumberFilter' cannot be null.");
    else if (mobileNumberFilter !== undefined)
      url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&";
    if (homeNumberFilter === null)
      throw new Error("The parameter 'homeNumberFilter' cannot be null.");
    else if (homeNumberFilter !== undefined)
      url_ += "HomeNumberFilter=" + encodeURIComponent("" + homeNumberFilter) + "&";
    if (eMailFilter === null)
      throw new Error("The parameter 'eMailFilter' cannot be null.");
    else if (eMailFilter !== undefined)
      url_ += "EMailFilter=" + encodeURIComponent("" + eMailFilter) + "&";
    if (maritalStatusFilter === null)
      throw new Error("The parameter 'maritalStatusFilter' cannot be null.");
    else if (maritalStatusFilter !== undefined)
      url_ += "MaritalStatusFilter=" + encodeURIComponent("" + maritalStatusFilter) + "&";
    if (provinceNameFilter === null)
      throw new Error("The parameter 'provinceNameFilter' cannot be null.");
    else if (provinceNameFilter !== undefined)
      url_ += "ProvinceNameFilter=" + encodeURIComponent("" + provinceNameFilter) + "&";
    if (districtNameFilter === null)
      throw new Error("The parameter 'districtNameFilter' cannot be null.");
    else if (districtNameFilter !== undefined)
      url_ += "DistrictNameFilter=" + encodeURIComponent("" + districtNameFilter) + "&";
    if (neighborhoodNameFilter === null)
      throw new Error("The parameter 'neighborhoodNameFilter' cannot be null.");
    else if (neighborhoodNameFilter !== undefined)
      url_ += "NeighborhoodNameFilter=" + encodeURIComponent("" + neighborhoodNameFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphansToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphansToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetOrphansToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }

  /**
   * @return Success
   */
  getAllProvinceForTableDropdown(): Observable<OrphanProvinceLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/Orphans/GetAllProvinceForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllProvinceForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllProvinceForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanProvinceLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanProvinceLookupTableDto[]>;
    }));
  }

  protected processGetAllProvinceForTableDropdown(response: HttpResponseBase): Observable<OrphanProvinceLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanProvinceLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanProvinceLookupTableDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getAllDistrictForTableDropdown(): Observable<OrphanDistrictLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/Orphans/GetAllDistrictForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllDistrictForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllDistrictForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanDistrictLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanDistrictLookupTableDto[]>;
    }));
  }

  protected processGetAllDistrictForTableDropdown(response: HttpResponseBase): Observable<OrphanDistrictLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanDistrictLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanDistrictLookupTableDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getAllNeighborhoodForTableDropdown(): Observable<OrphanNeighborhoodLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/Orphans/GetAllNeighborhoodForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllNeighborhoodForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllNeighborhoodForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanNeighborhoodLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanNeighborhoodLookupTableDto[]>;
    }));
  }

  protected processGetAllNeighborhoodForTableDropdown(response: HttpResponseBase): Observable<OrphanNeighborhoodLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanNeighborhoodLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanNeighborhoodLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class OrphanSchoolsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param schoolNameFilter (optional)
   * @param programNameFilter (optional)
   * @param schoolClassNameFilter (optional)
   * @param maxAvailabilityDateFilter (optional)
   * @param minAvailabilityDateFilter (optional)
   * @param provinceNameFilter (optional)
   * @param educationTypeNameFilter (optional)
   * @param availabilityStatusNameFilter (optional)
   * @param orphanFirstNameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, schoolNameFilter: string | undefined, programNameFilter: string | undefined, schoolClassNameFilter: string | undefined, maxAvailabilityDateFilter: DateTime | undefined, minAvailabilityDateFilter: DateTime | undefined, provinceNameFilter: string | undefined, educationTypeNameFilter: string | undefined, availabilityStatusNameFilter: string | undefined, orphanFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrphanSchoolForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/OrphanSchools/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (schoolNameFilter === null)
      throw new Error("The parameter 'schoolNameFilter' cannot be null.");
    else if (schoolNameFilter !== undefined)
      url_ += "SchoolNameFilter=" + encodeURIComponent("" + schoolNameFilter) + "&";
    if (programNameFilter === null)
      throw new Error("The parameter 'programNameFilter' cannot be null.");
    else if (programNameFilter !== undefined)
      url_ += "ProgramNameFilter=" + encodeURIComponent("" + programNameFilter) + "&";
    if (schoolClassNameFilter === null)
      throw new Error("The parameter 'schoolClassNameFilter' cannot be null.");
    else if (schoolClassNameFilter !== undefined)
      url_ += "SchoolClassNameFilter=" + encodeURIComponent("" + schoolClassNameFilter) + "&";
    if (maxAvailabilityDateFilter === null)
      throw new Error("The parameter 'maxAvailabilityDateFilter' cannot be null.");
    else if (maxAvailabilityDateFilter !== undefined)
      url_ += "MaxAvailabilityDateFilter=" + encodeURIComponent(maxAvailabilityDateFilter ? "" + maxAvailabilityDateFilter.toString() : "") + "&";
    if (minAvailabilityDateFilter === null)
      throw new Error("The parameter 'minAvailabilityDateFilter' cannot be null.");
    else if (minAvailabilityDateFilter !== undefined)
      url_ += "MinAvailabilityDateFilter=" + encodeURIComponent(minAvailabilityDateFilter ? "" + minAvailabilityDateFilter.toString() : "") + "&";
    if (provinceNameFilter === null)
      throw new Error("The parameter 'provinceNameFilter' cannot be null.");
    else if (provinceNameFilter !== undefined)
      url_ += "ProvinceNameFilter=" + encodeURIComponent("" + provinceNameFilter) + "&";
    if (educationTypeNameFilter === null)
      throw new Error("The parameter 'educationTypeNameFilter' cannot be null.");
    else if (educationTypeNameFilter !== undefined)
      url_ += "EducationTypeNameFilter=" + encodeURIComponent("" + educationTypeNameFilter) + "&";
    if (availabilityStatusNameFilter === null)
      throw new Error("The parameter 'availabilityStatusNameFilter' cannot be null.");
    else if (availabilityStatusNameFilter !== undefined)
      url_ += "AvailabilityStatusNameFilter=" + encodeURIComponent("" + availabilityStatusNameFilter) + "&";
    if (orphanFirstNameFilter === null)
      throw new Error("The parameter 'orphanFirstNameFilter' cannot be null.");
    else if (orphanFirstNameFilter !== undefined)
      url_ += "OrphanFirstNameFilter=" + encodeURIComponent("" + orphanFirstNameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrphanSchoolForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrphanSchoolForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrphanSchoolForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetOrphanSchoolForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetOrphanSchoolForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrphanSchoolForEdit(id: number | undefined): Observable<GetOrphanSchoolForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/OrphanSchools/GetOrphanSchoolForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOrphanSchoolForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrphanSchoolForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetOrphanSchoolForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetOrphanSchoolForEditOutput>;
    }));
  }

  protected processGetOrphanSchoolForEdit(response: HttpResponseBase): Observable<GetOrphanSchoolForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetOrphanSchoolForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetOrphanSchoolForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditOrphanSchoolDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanSchools/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrphanSchools/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getAllProvinceForTableDropdown(): Observable<OrphanSchoolProvinceLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanSchools/GetAllProvinceForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllProvinceForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllProvinceForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanSchoolProvinceLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanSchoolProvinceLookupTableDto[]>;
    }));
  }

  protected processGetAllProvinceForTableDropdown(response: HttpResponseBase): Observable<OrphanSchoolProvinceLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanSchoolProvinceLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanSchoolProvinceLookupTableDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getAllEducationTypeForTableDropdown(): Observable<OrphanSchoolEducationTypeLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanSchools/GetAllEducationTypeForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllEducationTypeForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllEducationTypeForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanSchoolEducationTypeLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanSchoolEducationTypeLookupTableDto[]>;
    }));
  }

  protected processGetAllEducationTypeForTableDropdown(response: HttpResponseBase): Observable<OrphanSchoolEducationTypeLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanSchoolEducationTypeLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanSchoolEducationTypeLookupTableDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getAllAvailabilityStatusForTableDropdown(): Observable<OrphanSchoolAvailabilityStatusLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanSchools/GetAllAvailabilityStatusForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllAvailabilityStatusForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllAvailabilityStatusForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanSchoolAvailabilityStatusLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanSchoolAvailabilityStatusLookupTableDto[]>;
    }));
  }

  protected processGetAllAvailabilityStatusForTableDropdown(response: HttpResponseBase): Observable<OrphanSchoolAvailabilityStatusLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanSchoolAvailabilityStatusLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanSchoolAvailabilityStatusLookupTableDto[]>(null as any);
  }

  /**
   * @return Success
   */
  getAllOrphanForTableDropdown(): Observable<OrphanSchoolOrphanLookupTableDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrphanSchools/GetAllOrphanForTableDropdown";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllOrphanForTableDropdown(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllOrphanForTableDropdown(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrphanSchoolOrphanLookupTableDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrphanSchoolOrphanLookupTableDto[]>;
    }));
  }

  protected processGetAllOrphanForTableDropdown(response: HttpResponseBase): Observable<OrphanSchoolOrphanLookupTableDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(OrphanSchoolOrphanLookupTableDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<OrphanSchoolOrphanLookupTableDto[]>(null as any);
  }
}

@Injectable()
export class PaymentServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param upgradeEditionId (optional)
   * @return Success
   */
  getPaymentInfo(upgradeEditionId: number | undefined): Observable<PaymentInfoDto> {
    let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
    if (upgradeEditionId === null)
      throw new Error("The parameter 'upgradeEditionId' cannot be null.");
    else if (upgradeEditionId !== undefined)
      url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetPaymentInfo(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPaymentInfo(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PaymentInfoDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PaymentInfoDto>;
    }));
  }

  protected processGetPaymentInfo(response: HttpResponseBase): Observable<PaymentInfoDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PaymentInfoDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PaymentInfoDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createPayment(body: CreatePaymentDto | undefined): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreatePayment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreatePayment(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<number>;
        }
      } else
        return _observableThrow(response_) as any as Observable<number>;
    }));
  }

  protected processCreatePayment(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<number>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  cancelPayment(body: CancelPaymentDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Payment/CancelPayment";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCancelPayment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCancelPayment(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCancelPayment(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getPaymentHistory(sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
    let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetPaymentHistory(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPaymentHistory(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfSubscriptionPaymentListDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfSubscriptionPaymentListDto>;
    }));
  }

  protected processGetPaymentHistory(response: HttpResponseBase): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfSubscriptionPaymentListDto>(null as any);
  }

  /**
   * @param recurringPaymentsEnabled (optional)
   * @return Success
   */
  getActiveGateways(recurringPaymentsEnabled: boolean | undefined): Observable<PaymentGatewayModel[]> {
    let url_ = this.baseUrl + "/api/services/app/Payment/GetActiveGateways?";
    if (recurringPaymentsEnabled === null)
      throw new Error("The parameter 'recurringPaymentsEnabled' cannot be null.");
    else if (recurringPaymentsEnabled !== undefined)
      url_ += "RecurringPaymentsEnabled=" + encodeURIComponent("" + recurringPaymentsEnabled) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetActiveGateways(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetActiveGateways(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PaymentGatewayModel[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PaymentGatewayModel[]>;
    }));
  }

  protected processGetActiveGateways(response: HttpResponseBase): Observable<PaymentGatewayModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PaymentGatewayModel.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PaymentGatewayModel[]>(null as any);
  }

  /**
   * @param paymentId (optional)
   * @return Success
   */
  getPayment(paymentId: number | undefined): Observable<SubscriptionPaymentDto> {
    let url_ = this.baseUrl + "/api/services/app/Payment/GetPayment?";
    if (paymentId === null)
      throw new Error("The parameter 'paymentId' cannot be null.");
    else if (paymentId !== undefined)
      url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetPayment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPayment(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
    }));
  }

  protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SubscriptionPaymentDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SubscriptionPaymentDto>(null as any);
  }

  /**
   * @return Success
   */
  getLastCompletedPayment(): Observable<SubscriptionPaymentDto> {
    let url_ = this.baseUrl + "/api/services/app/Payment/GetLastCompletedPayment";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetLastCompletedPayment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetLastCompletedPayment(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
    }));
  }

  protected processGetLastCompletedPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SubscriptionPaymentDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SubscriptionPaymentDto>(null as any);
  }

  /**
   * @param paymentId (optional)
   * @return Success
   */
  buyNowSucceed(paymentId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Payment/BuyNowSucceed?";
    if (paymentId === null)
      throw new Error("The parameter 'paymentId' cannot be null.");
    else if (paymentId !== undefined)
      url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processBuyNowSucceed(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processBuyNowSucceed(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processBuyNowSucceed(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param paymentId (optional)
   * @return Success
   */
  newRegistrationSucceed(paymentId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Payment/NewRegistrationSucceed?";
    if (paymentId === null)
      throw new Error("The parameter 'paymentId' cannot be null.");
    else if (paymentId !== undefined)
      url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processNewRegistrationSucceed(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processNewRegistrationSucceed(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processNewRegistrationSucceed(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param paymentId (optional)
   * @return Success
   */
  upgradeSucceed(paymentId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSucceed?";
    if (paymentId === null)
      throw new Error("The parameter 'paymentId' cannot be null.");
    else if (paymentId !== undefined)
      url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpgradeSucceed(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpgradeSucceed(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpgradeSucceed(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param paymentId (optional)
   * @return Success
   */
  extendSucceed(paymentId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Payment/ExtendSucceed?";
    if (paymentId === null)
      throw new Error("The parameter 'paymentId' cannot be null.");
    else if (paymentId !== undefined)
      url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processExtendSucceed(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processExtendSucceed(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processExtendSucceed(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param paymentId (optional)
   * @return Success
   */
  paymentFailed(paymentId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Payment/PaymentFailed?";
    if (paymentId === null)
      throw new Error("The parameter 'paymentId' cannot be null.");
    else if (paymentId !== undefined)
      url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPaymentFailed(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPaymentFailed(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processPaymentFailed(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param upgradeEditionId (optional)
   * @return Success
   */
  switchBetweenFreeEditions(upgradeEditionId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Payment/SwitchBetweenFreeEditions?";
    if (upgradeEditionId === null)
      throw new Error("The parameter 'upgradeEditionId' cannot be null.");
    else if (upgradeEditionId !== undefined)
      url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSwitchBetweenFreeEditions(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSwitchBetweenFreeEditions(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSwitchBetweenFreeEditions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param editionId (optional)
   * @return Success
   */
  upgradeSubscriptionCostsLessThenMinAmount(editionId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSubscriptionCostsLessThenMinAmount?";
    if (editionId === null)
      throw new Error("The parameter 'editionId' cannot be null.");
    else if (editionId !== undefined)
      url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpgradeSubscriptionCostsLessThenMinAmount(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpgradeSubscriptionCostsLessThenMinAmount(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpgradeSubscriptionCostsLessThenMinAmount(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  hasAnyPayment(): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/Payment/HasAnyPayment";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processHasAnyPayment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHasAnyPayment(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<boolean>;
        }
      } else
        return _observableThrow(response_) as any as Observable<boolean>;
    }));
  }

  protected processHasAnyPayment(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<boolean>(null as any);
  }
}

@Injectable()
export class PayPalPaymentServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param paymentId (optional)
   * @param paypalOrderId (optional)
   * @return Success
   */
  confirmPayment(paymentId: number | undefined, paypalOrderId: string | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/PayPalPayment/ConfirmPayment?";
    if (paymentId === null)
      throw new Error("The parameter 'paymentId' cannot be null.");
    else if (paymentId !== undefined)
      url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
    if (paypalOrderId === null)
      throw new Error("The parameter 'paypalOrderId' cannot be null.");
    else if (paypalOrderId !== undefined)
      url_ += "paypalOrderId=" + encodeURIComponent("" + paypalOrderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processConfirmPayment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processConfirmPayment(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processConfirmPayment(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getConfiguration(): Observable<PayPalConfigurationDto> {
    let url_ = this.baseUrl + "/api/services/app/PayPalPayment/GetConfiguration";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetConfiguration(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetConfiguration(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PayPalConfigurationDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PayPalConfigurationDto>;
    }));
  }

  protected processGetConfiguration(response: HttpResponseBase): Observable<PayPalConfigurationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PayPalConfigurationDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PayPalConfigurationDto>(null as any);
  }
}

@Injectable()
export class PermissionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
    let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllPermissions(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllPermissions(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
    }));
  }

  protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfFlatPermissionWithLevelDto>(null as any);
  }
}

@Injectable()
export class ProfileServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
    let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetCurrentUserProfileForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetCurrentUserProfileForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<CurrentUserProfileEditDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<CurrentUserProfileEditDto>;
    }));
  }

  protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CurrentUserProfileEditDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<CurrentUserProfileEditDto>(null as any);
  }

  /**
   * @return Success
   */
  disableGoogleAuthenticator(): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Profile/DisableGoogleAuthenticator";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDisableGoogleAuthenticator(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDisableGoogleAuthenticator(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDisableGoogleAuthenticator(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
    let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateGoogleAuthenticatorKey(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateGoogleAuthenticatorKey(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
    }));
  }

  protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<UpdateGoogleAuthenticatorKeyOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendVerificationSms(body: SendVerificationSmsInputDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSendVerificationSms(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendVerificationSms(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  verifySmsCode(body: VerifySmsCodeInputDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processVerifySmsCode(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processVerifySmsCode(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  prepareCollectedData(): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPrepareCollectedData(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPrepareCollectedData(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processPrepareCollectedData(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateCurrentUserProfile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateCurrentUserProfile(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changePassword(body: ChangePasswordInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processChangePassword(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processChangePassword(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processChangePassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateProfilePicture(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateProfilePicture(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
    let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetPasswordComplexitySetting(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPasswordComplexitySetting(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
    }));
  }

  protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetPasswordComplexitySettingOutput>(null as any);
  }

  /**
   * @return Success
   */
  getProfilePicture(): Observable<GetProfilePictureOutput> {
    let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetProfilePicture(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProfilePicture(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
    }));
  }

  protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetProfilePictureOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetProfilePictureOutput>(null as any);
  }

  /**
   * @param username (optional)
   * @return Success
   */
  getProfilePictureByUserName(username: string | undefined): Observable<GetProfilePictureOutput> {
    let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUserName?";
    if (username === null)
      throw new Error("The parameter 'username' cannot be null.");
    else if (username !== undefined)
      url_ += "username=" + encodeURIComponent("" + username) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetProfilePictureByUserName(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProfilePictureByUserName(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
    }));
  }

  protected processGetProfilePictureByUserName(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetProfilePictureOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetProfilePictureOutput>(null as any);
  }

  /**
   * @param userId (optional)
   * @param tenantId (optional)
   * @return Success
   */
  getFriendProfilePicture(userId: number | undefined, tenantId: number | undefined): Observable<GetProfilePictureOutput> {
    let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePicture?";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
    if (tenantId === null)
      throw new Error("The parameter 'tenantId' cannot be null.");
    else if (tenantId !== undefined)
      url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetFriendProfilePicture(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetFriendProfilePicture(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
    }));
  }

  protected processGetFriendProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetProfilePictureOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetProfilePictureOutput>(null as any);
  }

  /**
   * @param userId (optional)
   * @return Success
   */
  getProfilePictureByUser(userId: number | undefined): Observable<GetProfilePictureOutput> {
    let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUser?";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetProfilePictureByUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProfilePictureByUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
    }));
  }




  /**
   * @param userId (optional)
   * @return Success
   */
  getOrphanProfilePictureByUser(userId: number | undefined): Observable<GetProfilePictureOutput> {
    let url_ = this.baseUrl + "/api/services/app/Orphans/GetProfilePictureByUser?";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetProfilePictureByUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProfilePictureByUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
    }));
  }






  protected processGetProfilePictureByUser(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetProfilePictureOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetProfilePictureOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processChangeLanguage(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processChangeLanguage(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class ProvincesServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetProvinceForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/Provinces/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetProvinceForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetProvinceForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProvinceForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetProvinceForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetProvinceForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getProvinceForView(id: number | undefined): Observable<GetProvinceForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/Provinces/GetProvinceForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetProvinceForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProvinceForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetProvinceForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetProvinceForViewDto>;
    }));
  }

  protected processGetProvinceForView(response: HttpResponseBase): Observable<GetProvinceForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetProvinceForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetProvinceForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getProvinceForEdit(id: number | undefined): Observable<GetProvinceForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/Provinces/GetProvinceForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetProvinceForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProvinceForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetProvinceForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetProvinceForEditOutput>;
    }));
  }

  protected processGetProvinceForEdit(response: HttpResponseBase): Observable<GetProvinceForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetProvinceForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetProvinceForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditProvinceDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Provinces/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Provinces/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param nameFilter (optional)
   * @return Success
   */
  getProvincesToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/Provinces/GetProvincesToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (nameFilter === null)
      throw new Error("The parameter 'nameFilter' cannot be null.");
    else if (nameFilter !== undefined)
      url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetProvincesToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProvincesToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetProvincesToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }
}

@Injectable()
export class RoleServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  getRoles(body: GetRolesInput | undefined): Observable<ListResultDtoOfRoleListDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/GetRoles";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRoles(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRoles(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
    }));
  }

  protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfRoleListDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRoleForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRoleForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
    }));
  }

  protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetRoleForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetRoleForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrUpdateRole(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrUpdateRole(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteRole(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteRole(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteRole(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDeleteRole(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class SessionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
    let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetCurrentLoginInformations(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetCurrentLoginInformations(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
    }));
  }

  protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
  }

  /**
   * @return Success
   */
  updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
    let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateUserSignInToken(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateUserSignInToken(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<UpdateUserSignInTokenOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<UpdateUserSignInTokenOutput>;
    }));
  }

  protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<UpdateUserSignInTokenOutput>(null as any);
  }
}

@Injectable()
export class StripePaymentServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getConfiguration(): Observable<StripeConfigurationDto> {
    let url_ = this.baseUrl + "/api/services/app/StripePayment/GetConfiguration";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetConfiguration(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetConfiguration(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<StripeConfigurationDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<StripeConfigurationDto>;
    }));
  }

  protected processGetConfiguration(response: HttpResponseBase): Observable<StripeConfigurationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StripeConfigurationDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<StripeConfigurationDto>(null as any);
  }

  /**
   * @param stripeSessionId (optional)
   * @return Success
   */
  getPayment(stripeSessionId: string | undefined): Observable<SubscriptionPaymentDto> {
    let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPayment?";
    if (stripeSessionId === null)
      throw new Error("The parameter 'stripeSessionId' cannot be null.");
    else if (stripeSessionId !== undefined)
      url_ += "StripeSessionId=" + encodeURIComponent("" + stripeSessionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetPayment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPayment(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
    }));
  }

  protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SubscriptionPaymentDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SubscriptionPaymentDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createPaymentSession(body: StripeCreatePaymentSessionInput | undefined): Observable<string> {
    let url_ = this.baseUrl + "/api/services/app/StripePayment/CreatePaymentSession";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreatePaymentSession(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreatePaymentSession(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<string>;
        }
      } else
        return _observableThrow(response_) as any as Observable<string>;
    }));
  }

  protected processCreatePaymentSession(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<string>(null as any);
  }

  /**
   * @param paymentId (optional)
   * @return Success
   */
  getPaymentResult(paymentId: number | undefined): Observable<StripePaymentResultOutput> {
    let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPaymentResult?";
    if (paymentId === null)
      throw new Error("The parameter 'paymentId' cannot be null.");
    else if (paymentId !== undefined)
      url_ += "PaymentId=" + encodeURIComponent("" + paymentId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetPaymentResult(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPaymentResult(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<StripePaymentResultOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<StripePaymentResultOutput>;
    }));
  }

  protected processGetPaymentResult(response: HttpResponseBase): Observable<StripePaymentResultOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StripePaymentResultOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<StripePaymentResultOutput>(null as any);
  }
}

@Injectable()
export class SubscriptionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  disableRecurringPayments(): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDisableRecurringPayments(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDisableRecurringPayments(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDisableRecurringPayments(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  enableRecurringPayments(): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processEnableRecurringPayments(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processEnableRecurringPayments(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processEnableRecurringPayments(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class TenantServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param subscriptionEndDateStart (optional)
   * @param subscriptionEndDateEnd (optional)
   * @param creationDateStart (optional)
   * @param creationDateEnd (optional)
   * @param editionId (optional)
   * @param editionIdSpecified (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getTenants(filter: string | undefined, subscriptionEndDateStart: DateTime | undefined, subscriptionEndDateEnd: DateTime | undefined, creationDateStart: DateTime | undefined, creationDateEnd: DateTime | undefined, editionId: number | undefined, editionIdSpecified: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTenantListDto> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (subscriptionEndDateStart === null)
      throw new Error("The parameter 'subscriptionEndDateStart' cannot be null.");
    else if (subscriptionEndDateStart !== undefined)
      url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toString() : "") + "&";
    if (subscriptionEndDateEnd === null)
      throw new Error("The parameter 'subscriptionEndDateEnd' cannot be null.");
    else if (subscriptionEndDateEnd !== undefined)
      url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toString() : "") + "&";
    if (creationDateStart === null)
      throw new Error("The parameter 'creationDateStart' cannot be null.");
    else if (creationDateStart !== undefined)
      url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toString() : "") + "&";
    if (creationDateEnd === null)
      throw new Error("The parameter 'creationDateEnd' cannot be null.");
    else if (creationDateEnd !== undefined)
      url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toString() : "") + "&";
    if (editionId === null)
      throw new Error("The parameter 'editionId' cannot be null.");
    else if (editionId !== undefined)
      url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
    if (editionIdSpecified === null)
      throw new Error("The parameter 'editionIdSpecified' cannot be null.");
    else if (editionIdSpecified !== undefined)
      url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetTenants(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTenants(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantListDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantListDto>;
    }));
  }

  protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfTenantListDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createTenant(body: CreateTenantInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateTenant(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetTenantForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTenantForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<TenantEditDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<TenantEditDto>;
    }));
  }

  protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TenantEditDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<TenantEditDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateTenant(body: TenantEditDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteTenant(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetTenantFeaturesForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTenantFeaturesForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetTenantFeaturesEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetTenantFeaturesEditOutput>;
    }));
  }

  protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetTenantFeaturesEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateTenantFeatures(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateTenantFeatures(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processResetTenantSpecificFeatures(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processResetTenantSpecificFeatures(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUnlockTenantAdmin(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUnlockTenantAdmin(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class TenantCustomizationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param tenantId (optional)
   * @param extension (optional)
   * @return Success
   */
  getTenantLogo(skin: string, tenantId: number | undefined, extension: string | undefined): Observable<void> {
    let url_ = this.baseUrl + "/TenantCustomization/GetTenantLogo/{skin}/{tenantId}/{extension}?";
    if (skin === undefined || skin === null)
      throw new Error("The parameter 'skin' must be defined.");
    url_ = url_.replace("{skin}", encodeURIComponent("" + skin));
    if (tenantId === null)
      throw new Error("The parameter 'tenantId' cannot be null.");
    else if (tenantId !== undefined)
      url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
    if (extension === null)
      throw new Error("The parameter 'extension' cannot be null.");
    else if (extension !== undefined)
      url_ += "extension=" + encodeURIComponent("" + extension) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetTenantLogo(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTenantLogo(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processGetTenantLogo(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class TenantDashboardServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getMemberActivity(): Observable<GetMemberActivityOutput> {
    let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetMemberActivity(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetMemberActivity(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetMemberActivityOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetMemberActivityOutput>;
    }));
  }

  protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetMemberActivityOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetMemberActivityOutput>(null as any);
  }

  /**
   * @return Success
   */
  getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetDashboardDataOutput> {
    let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
    if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
      throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
    else
      url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetDashboardData(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDashboardData(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetDashboardDataOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetDashboardDataOutput>;
    }));
  }

  protected processGetDashboardData(response: HttpResponseBase): Observable<GetDashboardDataOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetDashboardDataOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetDashboardDataOutput>(null as any);
  }

  /**
   * @return Success
   */
  getTopStats(): Observable<GetTopStatsOutput> {
    let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTopStats";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetTopStats(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTopStats(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetTopStatsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetTopStatsOutput>;
    }));
  }

  protected processGetTopStats(response: HttpResponseBase): Observable<GetTopStatsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetTopStatsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetTopStatsOutput>(null as any);
  }

  /**
   * @return Success
   */
  getProfitShare(): Observable<GetProfitShareOutput> {
    let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetProfitShare";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetProfitShare(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProfitShare(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetProfitShareOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetProfitShareOutput>;
    }));
  }

  protected processGetProfitShare(response: HttpResponseBase): Observable<GetProfitShareOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetProfitShareOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetProfitShareOutput>(null as any);
  }

  /**
   * @return Success
   */
  getDailySales(): Observable<GetDailySalesOutput> {
    let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDailySales";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetDailySales(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDailySales(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetDailySalesOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetDailySalesOutput>;
    }));
  }

  protected processGetDailySales(response: HttpResponseBase): Observable<GetDailySalesOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetDailySalesOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetDailySalesOutput>(null as any);
  }

  /**
   * @return Success
   */
  getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetSalesSummaryOutput> {
    let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
    if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
      throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
    else
      url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetSalesSummary(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSalesSummary(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetSalesSummaryOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetSalesSummaryOutput>;
    }));
  }

  protected processGetSalesSummary(response: HttpResponseBase): Observable<GetSalesSummaryOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetSalesSummaryOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetSalesSummaryOutput>(null as any);
  }

  /**
   * @return Success
   */
  getRegionalStats(): Observable<GetRegionalStatsOutput> {
    let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRegionalStats(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRegionalStats(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetRegionalStatsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetRegionalStatsOutput>;
    }));
  }

  protected processGetRegionalStats(response: HttpResponseBase): Observable<GetRegionalStatsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetRegionalStatsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetRegionalStatsOutput>(null as any);
  }

  /**
   * @return Success
   */
  getGeneralStats(): Observable<GetGeneralStatsOutput> {
    let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetGeneralStats(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetGeneralStats(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetGeneralStatsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetGeneralStatsOutput>;
    }));
  }

  protected processGetGeneralStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetGeneralStatsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetGeneralStatsOutput>(null as any);
  }
}

@Injectable()
export class TenantRegistrationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  registerTenant(body: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
    let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processRegisterTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRegisterTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<RegisterTenantOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<RegisterTenantOutput>;
    }));
  }

  protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RegisterTenantOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<RegisterTenantOutput>(null as any);
  }

  /**
   * @return Success
   */
  getEditionsForSelect(): Observable<EditionsSelectOutput> {
    let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEditionsForSelect(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEditionsForSelect(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<EditionsSelectOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<EditionsSelectOutput>;
    }));
  }

  protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = EditionsSelectOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<EditionsSelectOutput>(null as any);
  }

  /**
   * @param editionId (optional)
   * @return Success
   */
  getEdition(editionId: number | undefined): Observable<EditionSelectDto> {
    let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
    if (editionId === null)
      throw new Error("The parameter 'editionId' cannot be null.");
    else if (editionId !== undefined)
      url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEdition(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEdition(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<EditionSelectDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<EditionSelectDto>;
    }));
  }

  protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = EditionSelectDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<EditionSelectDto>(null as any);
  }
}

@Injectable()
export class TenantSettingsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getAllSettings(): Observable<TenantSettingsEditDto> {
    let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<TenantSettingsEditDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<TenantSettingsEditDto>;
    }));
  }

  protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TenantSettingsEditDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<TenantSettingsEditDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateAllSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateAllSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  clearLogo(): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processClearLogo(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processClearLogo(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processClearLogo(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  clearCustomCss(): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processClearCustomCss(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processClearCustomCss(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSendTestEmail(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendTestEmail(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
    let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetEnabledSocialLoginSettings";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetEnabledSocialLoginSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEnabledSocialLoginSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
    }));
  }

  protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ExternalLoginSettingsDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ExternalLoginSettingsDto>(null as any);
  }
}

@Injectable()
export class TimingServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getTimezones(defaultTimezoneScope: SettingScopes): Observable<ListResultDtoOfNameValueDto> {
    let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
    if (defaultTimezoneScope === undefined || defaultTimezoneScope === null)
      throw new Error("The parameter 'defaultTimezoneScope' must be defined and cannot be null.");
    else
      url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetTimezones(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTimezones(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfNameValueDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfNameValueDto>;
    }));
  }

  protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfNameValueDto>(null as any);
  }

  /**
   * @param selectedTimezoneId (optional)
   * @return Success
   */
  getTimezoneComboboxItems(selectedTimezoneId: string | undefined): Observable<ComboboxItemDto[]> {
    let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
    if (selectedTimezoneId === null)
      throw new Error("The parameter 'selectedTimezoneId' cannot be null.");
    else if (selectedTimezoneId !== undefined)
      url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetTimezoneComboboxItems(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTimezoneComboboxItems(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
    }));
  }

  protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(ComboboxItemDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ComboboxItemDto[]>(null as any);
  }
}

@Injectable()
export class TokenAuthServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processAuthenticate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAuthenticate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
        }
      } else
        return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
    }));
  }

  protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AuthenticateResultModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<AuthenticateResultModel>(null as any);
  }

  /**
   * @param refreshToken (optional)
   * @return Success
   */
  refreshToken(refreshToken: string | undefined): Observable<RefreshTokenResult> {
    let url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
    if (refreshToken === null)
      throw new Error("The parameter 'refreshToken' cannot be null.");
    else if (refreshToken !== undefined)
      url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processRefreshToken(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRefreshToken(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<RefreshTokenResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
    }));
  }

  protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RefreshTokenResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<RefreshTokenResult>(null as any);
  }

  /**
   * @return Success
   */
  logOut(): Observable<void> {
    let url_ = this.baseUrl + "/api/TokenAuth/LogOut";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processLogOut(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processLogOut(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processLogOut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSendTwoFactorAuthCode(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendTwoFactorAuthCode(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param impersonationToken (optional)
   * @return Success
   */
  impersonatedAuthenticate(impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
    if (impersonationToken === null)
      throw new Error("The parameter 'impersonationToken' cannot be null.");
    else if (impersonationToken !== undefined)
      url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processImpersonatedAuthenticate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processImpersonatedAuthenticate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
    }));
  }

  protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ImpersonatedAuthenticateResultModel>(null as any);
  }

  /**
   * @param userDelegationId (optional)
   * @param impersonationToken (optional)
   * @return Success
   */
  delegatedImpersonatedAuthenticate(userDelegationId: number | undefined, impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/TokenAuth/DelegatedImpersonatedAuthenticate?";
    if (userDelegationId === null)
      throw new Error("The parameter 'userDelegationId' cannot be null.");
    else if (userDelegationId !== undefined)
      url_ += "userDelegationId=" + encodeURIComponent("" + userDelegationId) + "&";
    if (impersonationToken === null)
      throw new Error("The parameter 'impersonationToken' cannot be null.");
    else if (impersonationToken !== undefined)
      url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelegatedImpersonatedAuthenticate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelegatedImpersonatedAuthenticate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
    }));
  }

  protected processDelegatedImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ImpersonatedAuthenticateResultModel>(null as any);
  }

  /**
   * @param switchAccountToken (optional)
   * @return Success
   */
  linkedAccountAuthenticate(switchAccountToken: string | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
    if (switchAccountToken === null)
      throw new Error("The parameter 'switchAccountToken' cannot be null.");
    else if (switchAccountToken !== undefined)
      url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processLinkedAccountAuthenticate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processLinkedAccountAuthenticate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwitchedAccountAuthenticateResultModel>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwitchedAccountAuthenticateResultModel>;
    }));
  }

  protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwitchedAccountAuthenticateResultModel>(null as any);
  }

  /**
   * @return Success
   */
  getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
    let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetExternalAuthenticationProviders(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetExternalAuthenticationProviders(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
    }));
  }

  protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processExternalAuthenticate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processExternalAuthenticate(<any>response_);
        } catch (e) {
          return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
        }
      } else
        return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
    }));
  }


  protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ExternalAuthenticateResultModel.fromJS(resultData200.result);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ExternalAuthenticateResultModel>(<any>null);
  }

  /**
   * @param message (optional)
   * @param severity (optional)
   * @return Success
   */
  testNotification(message: string | undefined, severity: string | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
    if (message === null)
      throw new Error("The parameter 'message' cannot be null.");
    else if (message !== undefined)
      url_ += "message=" + encodeURIComponent("" + message) + "&";
    if (severity === null)
      throw new Error("The parameter 'severity' cannot be null.");
    else if (severity !== undefined)
      url_ += "severity=" + encodeURIComponent("" + severity) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processTestNotification(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processTestNotification(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processTestNotification(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class TwitterServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getRequestToken(): Observable<TwitterGetRequestTokenResponse> {
    let url_ = this.baseUrl + "/api/Twitter/GetRequestToken";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRequestToken(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRequestToken(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<TwitterGetRequestTokenResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<TwitterGetRequestTokenResponse>;
    }));
  }

  protected processGetRequestToken(response: HttpResponseBase): Observable<TwitterGetRequestTokenResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TwitterGetRequestTokenResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<TwitterGetRequestTokenResponse>(null as any);
  }

  /**
   * @param token (optional)
   * @param verifier (optional)
   * @return Success
   */
  getAccessToken(token: string | undefined, verifier: string | undefined): Observable<TwitterGetAccessTokenResponse> {
    let url_ = this.baseUrl + "/api/Twitter/GetAccessToken?";
    if (token === null)
      throw new Error("The parameter 'token' cannot be null.");
    else if (token !== undefined)
      url_ += "token=" + encodeURIComponent("" + token) + "&";
    if (verifier === null)
      throw new Error("The parameter 'verifier' cannot be null.");
    else if (verifier !== undefined)
      url_ += "verifier=" + encodeURIComponent("" + verifier) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAccessToken(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAccessToken(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<TwitterGetAccessTokenResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<TwitterGetAccessTokenResponse>;
    }));
  }

  protected processGetAccessToken(response: HttpResponseBase): Observable<TwitterGetAccessTokenResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TwitterGetAccessTokenResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<TwitterGetAccessTokenResponse>(null as any);
  }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
    let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetUiManagementSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetUiManagementSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ThemeSettingsDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ThemeSettingsDto[]>;
    }));
  }

  protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(ThemeSettingsDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ThemeSettingsDto[]>(null as any);
  }

  /**
   * @param themeName (optional)
   * @return Success
   */
  changeThemeWithDefaultValues(themeName: string | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
    if (themeName === null)
      throw new Error("The parameter 'themeName' cannot be null.");
    else if (themeName !== undefined)
      url_ += "themeName=" + encodeURIComponent("" + themeName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processChangeThemeWithDefaultValues(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processChangeThemeWithDefaultValues(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processChangeThemeWithDefaultValues(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateUiManagementSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateUiManagementSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateDefaultUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateDefaultUiManagementSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateDefaultUiManagementSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  useSystemDefaultSettings(): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUseSystemDefaultSettings(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUseSystemDefaultSettings(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class UserServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  getUsers(body: GetUsersInput | undefined): Observable<PagedResultDtoOfUserListDto> {
    let url_ = this.baseUrl + "/api/services/app/User/GetUsers";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetUsers(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetUsers(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
    }));
  }

  protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfUserListDto>(null as any);
  }

  /**
   * @param filter (optional)
   * @param permissions (optional)
   * @param role (optional)
   * @param onlyLockedUsers (optional)
   * @param sorting (optional)
   * @return Success
   */
  getUsersToExcel(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, onlyLockedUsers: boolean | undefined, sorting: string | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (permissions === null)
      throw new Error("The parameter 'permissions' cannot be null.");
    else if (permissions !== undefined)
      permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
    if (role === null)
      throw new Error("The parameter 'role' cannot be null.");
    else if (role !== undefined)
      url_ += "Role=" + encodeURIComponent("" + role) + "&";
    if (onlyLockedUsers === null)
      throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
    else if (onlyLockedUsers !== undefined)
      url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetUsersToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetUsersToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getUserForEdit(id: number | undefined): Observable<GetUserForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetUserForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetUserForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetUserForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetUserForEditOutput>;
    }));
  }

  protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetUserForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetUserForEditOutput>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetUserPermissionsForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetUserPermissionsForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetUserPermissionsForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetUserPermissionsForEditOutput>;
    }));
  }

  protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetUserPermissionsForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resetUserSpecificPermissions(body: EntityDtoOfInt64 | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processResetUserSpecificPermissions(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processResetUserSpecificPermissions(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateUserPermissions(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateUserPermissions(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrUpdateUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrUpdateUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteUser(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDeleteUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  unlockUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUnlockUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUnlockUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUnlockUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class UserDelegationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @param sorting (optional)
   * @return Success
   */
  getDelegatedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfUserDelegationDto> {
    let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetDelegatedUsers?";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetDelegatedUsers(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDelegatedUsers(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfUserDelegationDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserDelegationDto>;
    }));
  }

  protected processGetDelegatedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserDelegationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfUserDelegationDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfUserDelegationDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  delegateNewUser(body: CreateUserDelegationDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/UserDelegation/DelegateNewUser";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelegateNewUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelegateNewUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelegateNewUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  removeDelegation(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/UserDelegation/RemoveDelegation?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processRemoveDelegation(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRemoveDelegation(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processRemoveDelegation(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getActiveUserDelegations(): Observable<UserDelegationDto[]> {
    let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetActiveUserDelegations";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetActiveUserDelegations(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetActiveUserDelegations(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<UserDelegationDto[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<UserDelegationDto[]>;
    }));
  }

  protected processGetActiveUserDelegations(response: HttpResponseBase): Observable<UserDelegationDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(UserDelegationDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<UserDelegationDto[]>(null as any);
  }
}

@Injectable()
export class UserLinkServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  linkToUser(body: LinkToUserInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processLinkToUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processLinkToUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processLinkToUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @param sorting (optional)
   * @return Success
   */
  getLinkedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
    let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetLinkedUsers(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetLinkedUsers(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfLinkedUserDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfLinkedUserDto>;
    }));
  }

  protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfLinkedUserDto>(null as any);
  }

  /**
   * @return Success
   */
  getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
    let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRecentlyUsedLinkedUsers(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRecentlyUsedLinkedUsers(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfLinkedUserDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfLinkedUserDto>;
    }));
  }

  protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfLinkedUserDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  unlinkUser(body: UnlinkUserInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUnlinkUser(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUnlinkUser(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class UserLoginServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param startDate (optional)
   * @param endDate (optional)
   * @param result (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getUserLoginAttempts(filter: string | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, result: AbpLoginResultType | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserLoginAttemptDto> {
    let url_ = this.baseUrl + "/api/services/app/UserLogin/GetUserLoginAttempts?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
    if (result === null)
      throw new Error("The parameter 'result' cannot be null.");
    else if (result !== undefined)
      url_ += "Result=" + encodeURIComponent("" + result) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetUserLoginAttempts(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetUserLoginAttempts(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
    }));
  }

  protected processGetUserLoginAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfUserLoginAttemptDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfUserLoginAttemptDto>(null as any);
  }
}

@Injectable()
export class WebhookEventServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: string | undefined): Observable<WebhookEvent> {
    let url_ = this.baseUrl + "/api/services/app/WebhookEvent/Get?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<WebhookEvent>;
        }
      } else
        return _observableThrow(response_) as any as Observable<WebhookEvent>;
    }));
  }

  protected processGet(response: HttpResponseBase): Observable<WebhookEvent> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WebhookEvent.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<WebhookEvent>(null as any);
  }
}

@Injectable()
export class WebhookSendAttemptServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param subscriptionId (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getAllSendAttempts(subscriptionId: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfGetAllSendAttemptsOutput> {
    let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/GetAllSendAttempts?";
    if (subscriptionId === null)
      throw new Error("The parameter 'subscriptionId' cannot be null.");
    else if (subscriptionId !== undefined)
      url_ += "SubscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllSendAttempts(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllSendAttempts(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAllSendAttemptsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAllSendAttemptsOutput>;
    }));
  }

  protected processGetAllSendAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSendAttemptsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetAllSendAttemptsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetAllSendAttemptsOutput>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getAllSendAttemptsOfWebhookEvent(id: string | undefined): Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput> {
    let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/GetAllSendAttemptsOfWebhookEvent?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllSendAttemptsOfWebhookEvent(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllSendAttemptsOfWebhookEvent(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>;
    }));
  }

  protected processGetAllSendAttemptsOfWebhookEvent(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>(null as any);
  }

  /**
   * @param sendAttemptId (optional)
   * @return Success
   */
  resend(sendAttemptId: string | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/Resend?";
    if (sendAttemptId === null)
      throw new Error("The parameter 'sendAttemptId' cannot be null.");
    else if (sendAttemptId !== undefined)
      url_ += "sendAttemptId=" + encodeURIComponent("" + sendAttemptId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processResend(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processResend(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processResend(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable()
export class WebhookSubscriptionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  publishTestWebhook(): Observable<string> {
    let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/PublishTestWebhook";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPublishTestWebhook(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPublishTestWebhook(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<string>;
        }
      } else
        return _observableThrow(response_) as any as Observable<string>;
    }));
  }

  protected processPublishTestWebhook(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<string>(null as any);
  }

  /**
   * @return Success
   */
  getAllSubscriptions(): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
    let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllSubscriptions";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllSubscriptions(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllSubscriptions(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
    }));
  }

  protected processGetAllSubscriptions(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfGetAllSubscriptionsOutput>(null as any);
  }

  /**
   * @param subscriptionId (optional)
   * @return Success
   */
  getSubscription(subscriptionId: string | undefined): Observable<WebhookSubscription> {
    let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetSubscription?";
    if (subscriptionId === null)
      throw new Error("The parameter 'subscriptionId' cannot be null.");
    else if (subscriptionId !== undefined)
      url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetSubscription(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSubscription(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<WebhookSubscription>;
        }
      } else
        return _observableThrow(response_) as any as Observable<WebhookSubscription>;
    }));
  }

  protected processGetSubscription(response: HttpResponseBase): Observable<WebhookSubscription> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WebhookSubscription.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<WebhookSubscription>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addSubscription(body: WebhookSubscription | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/AddSubscription";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processAddSubscription(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddSubscription(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processAddSubscription(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateSubscription(body: WebhookSubscription | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/UpdateSubscription";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUpdateSubscription(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateSubscription(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processUpdateSubscription(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  activateWebhookSubscription(body: ActivateWebhookSubscriptionInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/ActivateWebhookSubscription";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processActivateWebhookSubscription(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processActivateWebhookSubscription(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processActivateWebhookSubscription(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param webhookName (optional)
   * @return Success
   */
  isSubscribed(webhookName: string | undefined): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/IsSubscribed?";
    if (webhookName === null)
      throw new Error("The parameter 'webhookName' cannot be null.");
    else if (webhookName !== undefined)
      url_ += "webhookName=" + encodeURIComponent("" + webhookName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processIsSubscribed(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processIsSubscribed(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<boolean>;
        }
      } else
        return _observableThrow(response_) as any as Observable<boolean>;
    }));
  }

  protected processIsSubscribed(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param webhookName (optional)
   * @return Success
   */
  getAllSubscriptionsIfFeaturesGranted(webhookName: string | undefined): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
    let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllSubscriptionsIfFeaturesGranted?";
    if (webhookName === null)
      throw new Error("The parameter 'webhookName' cannot be null.");
    else if (webhookName !== undefined)
      url_ += "webhookName=" + encodeURIComponent("" + webhookName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllSubscriptionsIfFeaturesGranted(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllSubscriptionsIfFeaturesGranted(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
    }));
  }

  protected processGetAllSubscriptionsIfFeaturesGranted(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfGetAllSubscriptionsOutput>(null as any);
  }

  /**
   * @return Success
   */
  getAllAvailableWebhooks(): Observable<ListResultDtoOfGetAllAvailableWebhooksOutput> {
    let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllAvailableWebhooks";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllAvailableWebhooks(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllAvailableWebhooks(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllAvailableWebhooksOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllAvailableWebhooksOutput>;
    }));
  }

  protected processGetAllAvailableWebhooks(response: HttpResponseBase): Observable<ListResultDtoOfGetAllAvailableWebhooksOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfGetAllAvailableWebhooksOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<ListResultDtoOfGetAllAvailableWebhooksOutput>(null as any);
  }
}

@Injectable()
export class WebLogServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
    let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetLatestWebLogs(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetLatestWebLogs(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
    }));
  }

  protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetLatestWebLogsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetLatestWebLogsOutput>(null as any);
  }

  /**
   * @return Success
   */
  downloadWebLogs(): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDownloadWebLogs(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDownloadWebLogs(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }
}

@Injectable()
export class WorkJobsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param filter (optional)
   * @param headerTextFilter (optional)
   * @param descriptionFilter (optional)
   * @param companyInfoFilter (optional)
   * @param maxStartDateFilter (optional)
   * @param minStartDateFilter (optional)
   * @param maxEndDateFilter (optional)
   * @param minEndDateFilter (optional)
   * @param maxPublishDateFilter (optional)
   * @param minPublishDateFilter (optional)
   * @param isActiveFilter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(filter: string | undefined, headerTextFilter: string | undefined, descriptionFilter: string | undefined, companyInfoFilter: string | undefined, maxStartDateFilter: DateTime | undefined, minStartDateFilter: DateTime | undefined, maxEndDateFilter: DateTime | undefined, minEndDateFilter: DateTime | undefined, maxPublishDateFilter: DateTime | undefined, minPublishDateFilter: DateTime | undefined, isActiveFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetWorkJobForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/WorkJobs/GetAll?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (headerTextFilter === null)
      throw new Error("The parameter 'headerTextFilter' cannot be null.");
    else if (headerTextFilter !== undefined)
      url_ += "HeaderTextFilter=" + encodeURIComponent("" + headerTextFilter) + "&";
    if (descriptionFilter === null)
      throw new Error("The parameter 'descriptionFilter' cannot be null.");
    else if (descriptionFilter !== undefined)
      url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
    if (companyInfoFilter === null)
      throw new Error("The parameter 'companyInfoFilter' cannot be null.");
    else if (companyInfoFilter !== undefined)
      url_ += "CompanyInfoFilter=" + encodeURIComponent("" + companyInfoFilter) + "&";
    if (maxStartDateFilter === null)
      throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
    else if (maxStartDateFilter !== undefined)
      url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toString() : "") + "&";
    if (minStartDateFilter === null)
      throw new Error("The parameter 'minStartDateFilter' cannot be null.");
    else if (minStartDateFilter !== undefined)
      url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toString() : "") + "&";
    if (maxEndDateFilter === null)
      throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
    else if (maxEndDateFilter !== undefined)
      url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toString() : "") + "&";
    if (minEndDateFilter === null)
      throw new Error("The parameter 'minEndDateFilter' cannot be null.");
    else if (minEndDateFilter !== undefined)
      url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toString() : "") + "&";
    if (maxPublishDateFilter === null)
      throw new Error("The parameter 'maxPublishDateFilter' cannot be null.");
    else if (maxPublishDateFilter !== undefined)
      url_ += "MaxPublishDateFilter=" + encodeURIComponent(maxPublishDateFilter ? "" + maxPublishDateFilter.toString() : "") + "&";
    if (minPublishDateFilter === null)
      throw new Error("The parameter 'minPublishDateFilter' cannot be null.");
    else if (minPublishDateFilter !== undefined)
      url_ += "MinPublishDateFilter=" + encodeURIComponent(minPublishDateFilter ? "" + minPublishDateFilter.toString() : "") + "&";
    if (isActiveFilter === null)
      throw new Error("The parameter 'isActiveFilter' cannot be null.");
    else if (isActiveFilter !== undefined)
      url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PagedResultDtoOfGetWorkJobForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetWorkJobForViewDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetWorkJobForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PagedResultDtoOfGetWorkJobForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<PagedResultDtoOfGetWorkJobForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getWorkJobForView(id: number | undefined): Observable<GetWorkJobForViewDto> {
    let url_ = this.baseUrl + "/api/services/app/WorkJobs/GetWorkJobForView?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetWorkJobForView(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetWorkJobForView(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetWorkJobForViewDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetWorkJobForViewDto>;
    }));
  }

  protected processGetWorkJobForView(response: HttpResponseBase): Observable<GetWorkJobForViewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetWorkJobForViewDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetWorkJobForViewDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getWorkJobForEdit(id: number | undefined): Observable<GetWorkJobForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/WorkJobs/GetWorkJobForEdit?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetWorkJobForEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetWorkJobForEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetWorkJobForEditOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetWorkJobForEditOutput>;
    }));
  }

  protected processGetWorkJobForEdit(response: HttpResponseBase): Observable<GetWorkJobForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetWorkJobForEditOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetWorkJobForEditOutput>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrEdit(body: CreateOrEditWorkJobDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/WorkJobs/CreateOrEdit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCreateOrEdit(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrEdit(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/WorkJobs/Delete?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDelete(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDelete(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param headerTextFilter (optional)
   * @param descriptionFilter (optional)
   * @param companyInfoFilter (optional)
   * @param maxStartDateFilter (optional)
   * @param minStartDateFilter (optional)
   * @param maxEndDateFilter (optional)
   * @param minEndDateFilter (optional)
   * @param maxPublishDateFilter (optional)
   * @param minPublishDateFilter (optional)
   * @param isActiveFilter (optional)
   * @return Success
   */
  getWorkJobsToExcel(filter: string | undefined, headerTextFilter: string | undefined, descriptionFilter: string | undefined, companyInfoFilter: string | undefined, maxStartDateFilter: DateTime | undefined, minStartDateFilter: DateTime | undefined, maxEndDateFilter: DateTime | undefined, minEndDateFilter: DateTime | undefined, maxPublishDateFilter: DateTime | undefined, minPublishDateFilter: DateTime | undefined, isActiveFilter: number | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/WorkJobs/GetWorkJobsToExcel?";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (headerTextFilter === null)
      throw new Error("The parameter 'headerTextFilter' cannot be null.");
    else if (headerTextFilter !== undefined)
      url_ += "HeaderTextFilter=" + encodeURIComponent("" + headerTextFilter) + "&";
    if (descriptionFilter === null)
      throw new Error("The parameter 'descriptionFilter' cannot be null.");
    else if (descriptionFilter !== undefined)
      url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
    if (companyInfoFilter === null)
      throw new Error("The parameter 'companyInfoFilter' cannot be null.");
    else if (companyInfoFilter !== undefined)
      url_ += "CompanyInfoFilter=" + encodeURIComponent("" + companyInfoFilter) + "&";
    if (maxStartDateFilter === null)
      throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
    else if (maxStartDateFilter !== undefined)
      url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toString() : "") + "&";
    if (minStartDateFilter === null)
      throw new Error("The parameter 'minStartDateFilter' cannot be null.");
    else if (minStartDateFilter !== undefined)
      url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toString() : "") + "&";
    if (maxEndDateFilter === null)
      throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
    else if (maxEndDateFilter !== undefined)
      url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toString() : "") + "&";
    if (minEndDateFilter === null)
      throw new Error("The parameter 'minEndDateFilter' cannot be null.");
    else if (minEndDateFilter !== undefined)
      url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toString() : "") + "&";
    if (maxPublishDateFilter === null)
      throw new Error("The parameter 'maxPublishDateFilter' cannot be null.");
    else if (maxPublishDateFilter !== undefined)
      url_ += "MaxPublishDateFilter=" + encodeURIComponent(maxPublishDateFilter ? "" + maxPublishDateFilter.toString() : "") + "&";
    if (minPublishDateFilter === null)
      throw new Error("The parameter 'minPublishDateFilter' cannot be null.");
    else if (minPublishDateFilter !== undefined)
      url_ += "MinPublishDateFilter=" + encodeURIComponent(minPublishDateFilter ? "" + minPublishDateFilter.toString() : "") + "&";
    if (isActiveFilter === null)
      throw new Error("The parameter 'isActiveFilter' cannot be null.");
    else if (isActiveFilter !== undefined)
      url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetWorkJobsToExcel(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetWorkJobsToExcel(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileDto>;
    }));
  }

  protected processGetWorkJobsToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FileDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<FileDto>(null as any);
  }
}

export enum AbpLoginResultType {
  Success = 1,
  InvalidUserNameOrEmailAddress = 2,
  InvalidPassword = 3,
  UserIsNotActive = 4,
  InvalidTenancyName = 5,
  TenantIsNotActive = 6,
  UserEmailIsNotConfirmed = 7,
  UnknownExternalLogin = 8,
  LockedOut = 9,
  UserPhoneNumberIsNotConfirmed = 10,
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
  userId!: number;
  tenantId!: number | undefined;

  constructor(data?: IAcceptFriendshipRequestInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.tenantId = _data["tenantId"];
    }
  }

  static fromJS(data: any): AcceptFriendshipRequestInput {
    data = typeof data === 'object' ? data : {};
    let result = new AcceptFriendshipRequestInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["tenantId"] = this.tenantId;
    return data;
  }
}

export interface IAcceptFriendshipRequestInput {
  userId: number;
  tenantId: number | undefined;
}

export class ActivateEmailInput implements IActivateEmailInput {
  userId!: number;
  confirmationCode!: string | undefined;
  c!: string | undefined;

  constructor(data?: IActivateEmailInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.confirmationCode = _data["confirmationCode"];
      this.c = _data["c"];
    }
  }

  static fromJS(data: any): ActivateEmailInput {
    data = typeof data === 'object' ? data : {};
    let result = new ActivateEmailInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["confirmationCode"] = this.confirmationCode;
    data["c"] = this.c;
    return data;
  }
}

export interface IActivateEmailInput {
  userId: number;
  confirmationCode: string | undefined;
  c: string | undefined;
}

export class ActivateWebhookSubscriptionInput implements IActivateWebhookSubscriptionInput {
  subscriptionId!: string;
  isActive!: boolean;

  constructor(data?: IActivateWebhookSubscriptionInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.subscriptionId = _data["subscriptionId"];
      this.isActive = _data["isActive"];
    }
  }

  static fromJS(data: any): ActivateWebhookSubscriptionInput {
    data = typeof data === 'object' ? data : {};
    let result = new ActivateWebhookSubscriptionInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["subscriptionId"] = this.subscriptionId;
    data["isActive"] = this.isActive;
    return data;
  }
}

export interface IActivateWebhookSubscriptionInput {
  subscriptionId: string;
  isActive: boolean;
}

export class AddNewPageInput implements IAddNewPageInput {
  dashboardName!: string | undefined;
  name!: string | undefined;
  application!: string | undefined;

  constructor(data?: IAddNewPageInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dashboardName = _data["dashboardName"];
      this.name = _data["name"];
      this.application = _data["application"];
    }
  }

  static fromJS(data: any): AddNewPageInput {
    data = typeof data === 'object' ? data : {};
    let result = new AddNewPageInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dashboardName"] = this.dashboardName;
    data["name"] = this.name;
    data["application"] = this.application;
    return data;
  }
}

export interface IAddNewPageInput {
  dashboardName: string | undefined;
  name: string | undefined;
  application: string | undefined;
}

export class AddNewPageOutput implements IAddNewPageOutput {
  pageId!: string | undefined;

  constructor(data?: IAddNewPageOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pageId = _data["pageId"];
    }
  }

  static fromJS(data: any): AddNewPageOutput {
    data = typeof data === 'object' ? data : {};
    let result = new AddNewPageOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pageId"] = this.pageId;
    return data;
  }
}

export interface IAddNewPageOutput {
  pageId: string | undefined;
}

export class AddWidgetInput implements IAddWidgetInput {
  widgetId!: string | undefined;
  pageId!: string | undefined;
  dashboardName!: string | undefined;
  width!: number;
  height!: number;
  application!: string | undefined;

  constructor(data?: IAddWidgetInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.widgetId = _data["widgetId"];
      this.pageId = _data["pageId"];
      this.dashboardName = _data["dashboardName"];
      this.width = _data["width"];
      this.height = _data["height"];
      this.application = _data["application"];
    }
  }

  static fromJS(data: any): AddWidgetInput {
    data = typeof data === 'object' ? data : {};
    let result = new AddWidgetInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["widgetId"] = this.widgetId;
    data["pageId"] = this.pageId;
    data["dashboardName"] = this.dashboardName;
    data["width"] = this.width;
    data["height"] = this.height;
    data["application"] = this.application;
    return data;
  }
}

export interface IAddWidgetInput {
  widgetId: string | undefined;
  pageId: string | undefined;
  dashboardName: string | undefined;
  width: number;
  height: number;
  application: string | undefined;
}

export class AgeLimitDto implements IAgeLimitDto {
  startAge!: number;
  endAge!: number;
  description!: string | undefined;
  id!: number;

  constructor(data?: IAgeLimitDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.startAge = _data["startAge"];
      this.endAge = _data["endAge"];
      this.description = _data["description"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AgeLimitDto {
    data = typeof data === 'object' ? data : {};
    let result = new AgeLimitDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["startAge"] = this.startAge;
    data["endAge"] = this.endAge;
    data["description"] = this.description;
    data["id"] = this.id;
    return data;
  }
}

export interface IAgeLimitDto {
  startAge: number;
  endAge: number;
  description: string | undefined;
  id: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
  version!: string | undefined;
  releaseDate!: DateTime;
  currency!: string | undefined;
  currencySign!: string | undefined;
  allowTenantsToChangeEmailSettings!: boolean;
  userDelegationIsEnabled!: boolean;
  twoFactorCodeExpireSeconds!: number;
  features!: { [key: string]: boolean; } | undefined;

  constructor(data?: IApplicationInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data["version"];
      this.releaseDate = _data["releaseDate"] ? DateTime.fromISO(_data["releaseDate"].toString()) : <any>undefined;
      this.currency = _data["currency"];
      this.currencySign = _data["currencySign"];
      this.allowTenantsToChangeEmailSettings = _data["allowTenantsToChangeEmailSettings"];
      this.userDelegationIsEnabled = _data["userDelegationIsEnabled"];
      this.twoFactorCodeExpireSeconds = _data["twoFactorCodeExpireSeconds"];
      if (_data["features"]) {
        this.features = {} as any;
        for (let key in _data["features"]) {
          if (_data["features"].hasOwnProperty(key))
            (<any>this.features)![key] = _data["features"][key];
        }
      }
    }
  }

  static fromJS(data: any): ApplicationInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["version"] = this.version;
    data["releaseDate"] = this.releaseDate ? this.releaseDate.toString() : <any>undefined;
    data["currency"] = this.currency;
    data["currencySign"] = this.currencySign;
    data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
    data["userDelegationIsEnabled"] = this.userDelegationIsEnabled;
    data["twoFactorCodeExpireSeconds"] = this.twoFactorCodeExpireSeconds;
    if (this.features) {
      data["features"] = {};
      for (let key in this.features) {
        if (this.features.hasOwnProperty(key))
          (<any>data["features"])[key] = this.features[key];
      }
    }
    return data;
  }
}

export interface IApplicationInfoDto {
  version: string | undefined;
  releaseDate: DateTime;
  currency: string | undefined;
  currencySign: string | undefined;
  allowTenantsToChangeEmailSettings: boolean;
  userDelegationIsEnabled: boolean;
  twoFactorCodeExpireSeconds: number;
  features: { [key: string]: boolean; } | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
  id!: number | undefined;
  name!: string;
  icon!: string | undefined;
  isEnabled!: boolean;

  constructor(data?: IApplicationLanguageEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.icon = _data["icon"];
      this.isEnabled = _data["isEnabled"];
    }
  }

  static fromJS(data: any): ApplicationLanguageEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationLanguageEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["icon"] = this.icon;
    data["isEnabled"] = this.isEnabled;
    return data;
  }
}

export interface IApplicationLanguageEditDto {
  id: number | undefined;
  name: string;
  icon: string | undefined;
  isEnabled: boolean;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
  tenantId!: number | undefined;
  name!: string | undefined;
  displayName!: string | undefined;
  icon!: string | undefined;
  isDisabled!: boolean;
  isDeleted!: boolean;
  deleterUserId!: number | undefined;
  deletionTime!: DateTime | undefined;
  lastModificationTime!: DateTime | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: DateTime;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IApplicationLanguageListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.icon = _data["icon"];
      this.isDisabled = _data["isDisabled"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ApplicationLanguageListDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationLanguageListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["icon"] = this.icon;
    data["isDisabled"] = this.isDisabled;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }
}

export interface IApplicationLanguageListDto {
  tenantId: number | undefined;
  name: string | undefined;
  displayName: string | undefined;
  icon: string | undefined;
  isDisabled: boolean;
  isDeleted: boolean;
  deleterUserId: number | undefined;
  deletionTime: DateTime | undefined;
  lastModificationTime: DateTime | undefined;
  lastModifierUserId: number | undefined;
  creationTime: DateTime;
  creatorUserId: number | undefined;
  id: number;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
  webSiteUrl!: string | undefined;
  serverSiteUrl!: string | undefined;
  languages!: NameValue[] | undefined;

  constructor(data?: IAppSettingsJsonDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.webSiteUrl = _data["webSiteUrl"];
      this.serverSiteUrl = _data["serverSiteUrl"];
      if (Array.isArray(_data["languages"])) {
        this.languages = [] as any;
        for (let item of _data["languages"])
          this.languages!.push(NameValue.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AppSettingsJsonDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppSettingsJsonDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["webSiteUrl"] = this.webSiteUrl;
    data["serverSiteUrl"] = this.serverSiteUrl;
    if (Array.isArray(this.languages)) {
      data["languages"] = [];
      for (let item of this.languages)
        data["languages"].push(item.toJSON());
    }
    return data;
  }
}

export interface IAppSettingsJsonDto {
  webSiteUrl: string | undefined;
  serverSiteUrl: string | undefined;
  languages: NameValue[] | undefined;
}

export class AuditLogListDto implements IAuditLogListDto {
  userId!: number | undefined;
  userName!: string | undefined;
  impersonatorTenantId!: number | undefined;
  impersonatorUserId!: number | undefined;
  serviceName!: string | undefined;
  methodName!: string | undefined;
  parameters!: string | undefined;
  executionTime!: DateTime;
  executionDuration!: number;
  clientIpAddress!: string | undefined;
  clientName!: string | undefined;
  browserInfo!: string | undefined;
  exception!: string | undefined;
  customData!: string | undefined;
  id!: number;

  constructor(data?: IAuditLogListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.userName = _data["userName"];
      this.impersonatorTenantId = _data["impersonatorTenantId"];
      this.impersonatorUserId = _data["impersonatorUserId"];
      this.serviceName = _data["serviceName"];
      this.methodName = _data["methodName"];
      this.parameters = _data["parameters"];
      this.executionTime = _data["executionTime"] ? DateTime.fromISO(_data["executionTime"].toString()) : <any>undefined;
      this.executionDuration = _data["executionDuration"];
      this.clientIpAddress = _data["clientIpAddress"];
      this.clientName = _data["clientName"];
      this.browserInfo = _data["browserInfo"];
      this.exception = _data["exception"];
      this.customData = _data["customData"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AuditLogListDto {
    data = typeof data === 'object' ? data : {};
    let result = new AuditLogListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["userName"] = this.userName;
    data["impersonatorTenantId"] = this.impersonatorTenantId;
    data["impersonatorUserId"] = this.impersonatorUserId;
    data["serviceName"] = this.serviceName;
    data["methodName"] = this.methodName;
    data["parameters"] = this.parameters;
    data["executionTime"] = this.executionTime ? this.executionTime.toString() : <any>undefined;
    data["executionDuration"] = this.executionDuration;
    data["clientIpAddress"] = this.clientIpAddress;
    data["clientName"] = this.clientName;
    data["browserInfo"] = this.browserInfo;
    data["exception"] = this.exception;
    data["customData"] = this.customData;
    data["id"] = this.id;
    return data;
  }
}

export interface IAuditLogListDto {
  userId: number | undefined;
  userName: string | undefined;
  impersonatorTenantId: number | undefined;
  impersonatorUserId: number | undefined;
  serviceName: string | undefined;
  methodName: string | undefined;
  parameters: string | undefined;
  executionTime: DateTime;
  executionDuration: number;
  clientIpAddress: string | undefined;
  clientName: string | undefined;
  browserInfo: string | undefined;
  exception: string | undefined;
  customData: string | undefined;
  id: number;
}

export class AuthenticateModel implements IAuthenticateModel {
  userNameOrEmailAddress!: string;
  password!: string;
  twoFactorVerificationCode!: string | undefined;
  rememberClient!: boolean;
  twoFactorRememberClientToken!: string | undefined;
  singleSignIn!: boolean | undefined;
  returnUrl!: string | undefined;
  captchaResponse!: string | undefined;

  constructor(data?: IAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
      this.password = _data["password"];
      this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
      this.rememberClient = _data["rememberClient"];
      this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
      this.singleSignIn = _data["singleSignIn"];
      this.returnUrl = _data["returnUrl"];
      this.captchaResponse = _data["captchaResponse"];
    }
  }

  static fromJS(data: any): AuthenticateModel {
    data = typeof data === 'object' ? data : {};
    let result = new AuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
    data["password"] = this.password;
    data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
    data["rememberClient"] = this.rememberClient;
    data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
    data["singleSignIn"] = this.singleSignIn;
    data["returnUrl"] = this.returnUrl;
    data["captchaResponse"] = this.captchaResponse;
    return data;
  }
}

export interface IAuthenticateModel {
  userNameOrEmailAddress: string;
  password: string;
  twoFactorVerificationCode: string | undefined;
  rememberClient: boolean;
  twoFactorRememberClientToken: string | undefined;
  singleSignIn: boolean | undefined;
  returnUrl: string | undefined;
  captchaResponse: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
  accessToken!: string | undefined;
  encryptedAccessToken!: string | undefined;
  expireInSeconds!: number;
  shouldResetPassword!: boolean;
  passwordResetCode!: string | undefined;
  userId!: number;
  requiresTwoFactorVerification!: boolean;
  twoFactorAuthProviders!: string[] | undefined;
  twoFactorRememberClientToken!: string | undefined;
  returnUrl!: string | undefined;
  refreshToken!: string | undefined;
  refreshTokenExpireInSeconds!: number;

  constructor(data?: IAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.encryptedAccessToken = _data["encryptedAccessToken"];
      this.expireInSeconds = _data["expireInSeconds"];
      this.shouldResetPassword = _data["shouldResetPassword"];
      this.passwordResetCode = _data["passwordResetCode"];
      this.userId = _data["userId"];
      this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
      if (Array.isArray(_data["twoFactorAuthProviders"])) {
        this.twoFactorAuthProviders = [] as any;
        for (let item of _data["twoFactorAuthProviders"])
          this.twoFactorAuthProviders!.push(item);
      }
      this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
      this.returnUrl = _data["returnUrl"];
      this.refreshToken = _data["refreshToken"];
      this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
    }
  }

  static fromJS(data: any): AuthenticateResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new AuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["accessToken"] = this.accessToken;
    data["encryptedAccessToken"] = this.encryptedAccessToken;
    data["expireInSeconds"] = this.expireInSeconds;
    data["shouldResetPassword"] = this.shouldResetPassword;
    data["passwordResetCode"] = this.passwordResetCode;
    data["userId"] = this.userId;
    data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
    if (Array.isArray(this.twoFactorAuthProviders)) {
      data["twoFactorAuthProviders"] = [];
      for (let item of this.twoFactorAuthProviders)
        data["twoFactorAuthProviders"].push(item);
    }
    data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
    data["returnUrl"] = this.returnUrl;
    data["refreshToken"] = this.refreshToken;
    data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
    return data;
  }
}

export interface IAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  shouldResetPassword: boolean;
  passwordResetCode: string | undefined;
  userId: number;
  requiresTwoFactorVerification: boolean;
  twoFactorAuthProviders: string[] | undefined;
  twoFactorRememberClientToken: string | undefined;
  returnUrl: string | undefined;
  refreshToken: string | undefined;
  refreshTokenExpireInSeconds: number;
}

export class AvailabilityStatusDto implements IAvailabilityStatusDto {
  name!: string | undefined;
  id!: number;

  constructor(data?: IAvailabilityStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AvailabilityStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new AvailabilityStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface IAvailabilityStatusDto {
  name: string | undefined;
  id: number;
}

export class BlockUserInput implements IBlockUserInput {
  userId!: number;
  tenantId!: number | undefined;

  constructor(data?: IBlockUserInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.tenantId = _data["tenantId"];
    }
  }

  static fromJS(data: any): BlockUserInput {
    data = typeof data === 'object' ? data : {};
    let result = new BlockUserInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["tenantId"] = this.tenantId;
    return data;
  }
}

export interface IBlockUserInput {
  userId: number;
  tenantId: number | undefined;
}

export class BookTypeDto implements IBookTypeDto {
  name!: string | undefined;
  id!: number;

  constructor(data?: IBookTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): BookTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new BookTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface IBookTypeDto {
  name: string | undefined;
  id: number;
}

export class CacheDto implements ICacheDto {
  name!: string | undefined;

  constructor(data?: ICacheDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): CacheDto {
    data = typeof data === 'object' ? data : {};
    let result = new CacheDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    return data;
  }
}

export interface ICacheDto {
  name: string | undefined;
}

export class CancelPaymentDto implements ICancelPaymentDto {
  paymentId!: string | undefined;
  gateway!: SubscriptionPaymentGatewayType;

  constructor(data?: ICancelPaymentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.paymentId = _data["paymentId"];
      this.gateway = _data["gateway"];
    }
  }

  static fromJS(data: any): CancelPaymentDto {
    data = typeof data === 'object' ? data : {};
    let result = new CancelPaymentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["paymentId"] = this.paymentId;
    data["gateway"] = this.gateway;
    return data;
  }
}

export interface ICancelPaymentDto {
  paymentId: string | undefined;
  gateway: SubscriptionPaymentGatewayType;
}

export class ChangePasswordInput implements IChangePasswordInput {
  currentPassword!: string;
  newPassword!: string;

  constructor(data?: IChangePasswordInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPassword = _data["currentPassword"];
      this.newPassword = _data["newPassword"];
    }
  }

  static fromJS(data: any): ChangePasswordInput {
    data = typeof data === 'object' ? data : {};
    let result = new ChangePasswordInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["currentPassword"] = this.currentPassword;
    data["newPassword"] = this.newPassword;
    return data;
  }
}

export interface IChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
  languageName!: string;

  constructor(data?: IChangeUserLanguageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.languageName = _data["languageName"];
    }
  }

  static fromJS(data: any): ChangeUserLanguageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChangeUserLanguageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["languageName"] = this.languageName;
    return data;
  }
}

export interface IChangeUserLanguageDto {
  languageName: string;
}

export enum ChartDateInterval {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
}

export class ChatMessageDto implements IChatMessageDto {
  userId!: number;
  tenantId!: number | undefined;
  targetUserId!: number;
  targetTenantId!: number | undefined;
  side!: ChatSide;
  readState!: ChatMessageReadState;
  receiverReadState!: ChatMessageReadState;
  message!: string | undefined;
  creationTime!: DateTime;
  sharedMessageId!: string | undefined;
  id!: number;

  constructor(data?: IChatMessageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.tenantId = _data["tenantId"];
      this.targetUserId = _data["targetUserId"];
      this.targetTenantId = _data["targetTenantId"];
      this.side = _data["side"];
      this.readState = _data["readState"];
      this.receiverReadState = _data["receiverReadState"];
      this.message = _data["message"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
      this.sharedMessageId = _data["sharedMessageId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ChatMessageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChatMessageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["tenantId"] = this.tenantId;
    data["targetUserId"] = this.targetUserId;
    data["targetTenantId"] = this.targetTenantId;
    data["side"] = this.side;
    data["readState"] = this.readState;
    data["receiverReadState"] = this.receiverReadState;
    data["message"] = this.message;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    data["sharedMessageId"] = this.sharedMessageId;
    data["id"] = this.id;
    return data;
  }
}

export interface IChatMessageDto {
  userId: number;
  tenantId: number | undefined;
  targetUserId: number;
  targetTenantId: number | undefined;
  side: ChatSide;
  readState: ChatMessageReadState;
  receiverReadState: ChatMessageReadState;
  message: string | undefined;
  creationTime: DateTime;
  sharedMessageId: string | undefined;
  id: number;
}

export enum ChatMessageReadState {
  Unread = 1,
  Read = 2,
}

export enum ChatSide {
  Sender = 1,
  Receiver = 2,
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
  isDatabaseExist!: boolean;

  constructor(data?: ICheckDatabaseOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isDatabaseExist = _data["isDatabaseExist"];
    }
  }

  static fromJS(data: any): CheckDatabaseOutput {
    data = typeof data === 'object' ? data : {};
    let result = new CheckDatabaseOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isDatabaseExist"] = this.isDatabaseExist;
    return data;
  }
}

export interface ICheckDatabaseOutput {
  isDatabaseExist: boolean;
}

export class CleanValuesInput implements ICleanValuesInput {
  dynamicEntityPropertyId!: number;
  entityId!: string | undefined;

  constructor(data?: ICleanValuesInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
      this.entityId = _data["entityId"];
    }
  }

  static fromJS(data: any): CleanValuesInput {
    data = typeof data === 'object' ? data : {};
    let result = new CleanValuesInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
    data["entityId"] = this.entityId;
    return data;
  }
}

export interface ICleanValuesInput {
  dynamicEntityPropertyId: number;
  entityId: string | undefined;
}

export class ComboboxItemDto implements IComboboxItemDto {
  value!: string | undefined;
  displayText!: string | undefined;
  isSelected!: boolean;

  constructor(data?: IComboboxItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"];
      this.displayText = _data["displayText"];
      this.isSelected = _data["isSelected"];
    }
  }

  static fromJS(data: any): ComboboxItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new ComboboxItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["value"] = this.value;
    data["displayText"] = this.displayText;
    data["isSelected"] = this.isSelected;
    return data;
  }
}

export interface IComboboxItemDto {
  value: string | undefined;
  displayText: string | undefined;
  isSelected: boolean;
}

export class CreateEditionDto implements ICreateEditionDto {
  edition!: EditionCreateDto;
  featureValues!: NameValueDto[];

  constructor(data?: ICreateEditionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.edition = new EditionCreateDto();
      this.featureValues = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.edition = _data["edition"] ? EditionCreateDto.fromJS(_data["edition"]) : new EditionCreateDto();
      if (Array.isArray(_data["featureValues"])) {
        this.featureValues = [] as any;
        for (let item of _data["featureValues"])
          this.featureValues!.push(NameValueDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CreateEditionDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateEditionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
    if (Array.isArray(this.featureValues)) {
      data["featureValues"] = [];
      for (let item of this.featureValues)
        data["featureValues"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICreateEditionDto {
  edition: EditionCreateDto;
  featureValues: NameValueDto[];
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
  tenancyName!: string;
  userName!: string | undefined;

  constructor(data?: ICreateFriendshipRequestByUserNameInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
      this.userName = _data["userName"];
    }
  }

  static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateFriendshipRequestByUserNameInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenancyName"] = this.tenancyName;
    data["userName"] = this.userName;
    return data;
  }
}

export interface ICreateFriendshipRequestByUserNameInput {
  tenancyName: string;
  userName: string | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
  userId!: number;
  tenantId!: number | undefined;

  constructor(data?: ICreateFriendshipRequestInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.tenantId = _data["tenantId"];
    }
  }

  static fromJS(data: any): CreateFriendshipRequestInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateFriendshipRequestInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["tenantId"] = this.tenantId;
    return data;
  }
}

export interface ICreateFriendshipRequestInput {
  userId: number;
  tenantId: number | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
  subscriptionPaymentId!: number;

  constructor(data?: ICreateInvoiceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.subscriptionPaymentId = _data["subscriptionPaymentId"];
    }
  }

  static fromJS(data: any): CreateInvoiceDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateInvoiceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["subscriptionPaymentId"] = this.subscriptionPaymentId;
    return data;
  }
}

export interface ICreateInvoiceDto {
  subscriptionPaymentId: number;
}

export class CreateOrEditAgeLimitDto implements ICreateOrEditAgeLimitDto {
  startAge!: number;
  endAge!: number;
  description!: string | undefined;
  id!: number | undefined;

  constructor(data?: ICreateOrEditAgeLimitDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.startAge = _data["startAge"];
      this.endAge = _data["endAge"];
      this.description = _data["description"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditAgeLimitDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditAgeLimitDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["startAge"] = this.startAge;
    data["endAge"] = this.endAge;
    data["description"] = this.description;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditAgeLimitDto {
  startAge: number;
  endAge: number;
  description: string | undefined;
  id: number | undefined;
}

export class CreateOrEditAvailabilityStatusDto implements ICreateOrEditAvailabilityStatusDto {
  name!: string;
  id!: number | undefined;

  constructor(data?: ICreateOrEditAvailabilityStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditAvailabilityStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditAvailabilityStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditAvailabilityStatusDto {
  name: string;
  id: number | undefined;
}

export class CreateOrEditBookTypeDto implements ICreateOrEditBookTypeDto {
  name!: string;
  id!: number | undefined;

  constructor(data?: ICreateOrEditBookTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditBookTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditBookTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditBookTypeDto {
  name: string;
  id: number | undefined;
}

export class CreateOrEditDistrictDto implements ICreateOrEditDistrictDto {
  name!: string | undefined;
  provinceId!: number;
  id!: number | undefined;

  constructor(data?: ICreateOrEditDistrictDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.provinceId = _data["provinceId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditDistrictDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditDistrictDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["provinceId"] = this.provinceId;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditDistrictDto {
  name: string | undefined;
  provinceId: number;
  id: number | undefined;
}

export class CreateOrEditEducationStatusDto implements ICreateOrEditEducationStatusDto {
  name!: string;
  id!: number | undefined;

  constructor(data?: ICreateOrEditEducationStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditEducationStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditEducationStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditEducationStatusDto {
  name: string;
  id: number | undefined;
}

export class CreateOrEditEducationTypeDto implements ICreateOrEditEducationTypeDto {
  name!: string;
  id!: number | undefined;

  constructor(data?: ICreateOrEditEducationTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditEducationTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditEducationTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditEducationTypeDto {
  name: string;
  id: number | undefined;
}

export class CreateOrEditEventCalendarDetailDto implements ICreateOrEditEventCalendarDetailDto {
  subject!: string;
  description!: string;
  startDate!: DateTime;
  endDate!: DateTime;
  isOnline!: boolean;
  eventLocationOrUrl!: string | undefined;
  orphanEventTypeId!: number;
  provinceId!: number | undefined;
  eventCalendarAgeLimits!: EventCalendarAgeLimitDto[] | undefined;
  eventCalendarRegions!: EventCalendarRegionDto[] | undefined;
  id!: number | undefined;

  constructor(data?: ICreateOrEditEventCalendarDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.subject = _data["subject"];
      this.description = _data["description"];
      this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
      this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
      this.isOnline = _data["isOnline"];
      this.eventLocationOrUrl = _data["eventLocationOrUrl"];
      this.orphanEventTypeId = _data["orphanEventTypeId"];
      this.provinceId = _data["provinceId"];
      if (Array.isArray(_data["eventCalendarAgeLimits"])) {
        this.eventCalendarAgeLimits = [] as any;
        for (let item of _data["eventCalendarAgeLimits"])
          this.eventCalendarAgeLimits!.push(EventCalendarAgeLimitDto.fromJS(item));
      }
      if (Array.isArray(_data["eventCalendarRegions"])) {
        this.eventCalendarRegions = [] as any;
        for (let item of _data["eventCalendarRegions"])
          this.eventCalendarRegions!.push(EventCalendarRegionDto.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditEventCalendarDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditEventCalendarDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["subject"] = this.subject;
    data["description"] = this.description;
    data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
    data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
    data["isOnline"] = this.isOnline;
    data["eventLocationOrUrl"] = this.eventLocationOrUrl;
    data["orphanEventTypeId"] = this.orphanEventTypeId;
    data["provinceId"] = this.provinceId;
    if (Array.isArray(this.eventCalendarAgeLimits)) {
      data["eventCalendarAgeLimits"] = [];
      for (let item of this.eventCalendarAgeLimits)
        data["eventCalendarAgeLimits"].push(item.toJSON());
    }
    if (Array.isArray(this.eventCalendarRegions)) {
      data["eventCalendarRegions"] = [];
      for (let item of this.eventCalendarRegions)
        data["eventCalendarRegions"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditEventCalendarDetailDto {
  subject: string;
  description: string;
  startDate: DateTime;
  endDate: DateTime;
  isOnline: boolean;
  eventLocationOrUrl: string | undefined;
  orphanEventTypeId: number;
  provinceId: number | undefined;
  eventCalendarAgeLimits: EventCalendarAgeLimitDto[] | undefined;
  eventCalendarRegions: EventCalendarRegionDto[] | undefined;
  id: number | undefined;
}

export class CreateOrEditJobApplicationDto implements ICreateOrEditJobApplicationDto {
  orphanDescription!: string | undefined;
  joinDate!: DateTime;
  managerDescription!: string | undefined;
  orphanId!: number;
  jobStatusId!: number | undefined;
  id!: number | undefined;

  constructor(data?: ICreateOrEditJobApplicationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanDescription = _data["orphanDescription"];
      this.joinDate = _data["joinDate"] ? DateTime.fromISO(_data["joinDate"].toString()) : <any>undefined;
      this.managerDescription = _data["managerDescription"];
      this.orphanId = _data["orphanId"];
      this.jobStatusId = _data["jobStatusId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditJobApplicationDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditJobApplicationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanDescription"] = this.orphanDescription;
    data["joinDate"] = this.joinDate ? this.joinDate.toString() : <any>undefined;
    data["managerDescription"] = this.managerDescription;
    data["orphanId"] = this.orphanId;
    data["jobStatusId"] = this.jobStatusId;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditJobApplicationDto {
  orphanDescription: string | undefined;
  joinDate: DateTime;
  managerDescription: string | undefined;
  orphanId: number;
  jobStatusId: number | undefined;
  id: number | undefined;
}

export class CreateOrEditJobStatusDto implements ICreateOrEditJobStatusDto {
  name!: string;
  id!: number | undefined;

  constructor(data?: ICreateOrEditJobStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditJobStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditJobStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditJobStatusDto {
  name: string;
  id: number | undefined;
}

export class CreateOrEditNeighborhoodDto implements ICreateOrEditNeighborhoodDto {
  name!: string;
  districtId!: number;
  id!: number | undefined;

  constructor(data?: ICreateOrEditNeighborhoodDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.districtId = _data["districtId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditNeighborhoodDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditNeighborhoodDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["districtId"] = this.districtId;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditNeighborhoodDto {
  name: string;
  districtId: number;
  id: number | undefined;
}

export class CreateOrEditOrphanBookDetailDto implements ICreateOrEditOrphanBookDetailDto {
  bookName!: string;
  bookAuthor!: string;
  pageCount!: number;
  startDate!: DateTime | undefined;
  endDate!: DateTime | undefined;
  bookTypeId!: number;
  orphanId!: number;
  id!: number | undefined;

  constructor(data?: ICreateOrEditOrphanBookDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookName = _data["bookName"];
      this.bookAuthor = _data["bookAuthor"];
      this.pageCount = _data["pageCount"];
      this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
      this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
      this.bookTypeId = _data["bookTypeId"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditOrphanBookDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditOrphanBookDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["bookName"] = this.bookName;
    data["bookAuthor"] = this.bookAuthor;
    data["pageCount"] = this.pageCount;
    data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
    data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
    data["bookTypeId"] = this.bookTypeId;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditOrphanBookDetailDto {
  bookName: string;
  bookAuthor: string;
  pageCount: number;
  startDate: DateTime | undefined;
  endDate: DateTime | undefined;
  bookTypeId: number;
  orphanId: number;
  id: number | undefined;
}

export class CreateOrEditOrphanClubDetailDto implements ICreateOrEditOrphanClubDetailDto {
  name!: string;
  joinedCount!: number | undefined;
  joinedYear!: number;
  description!: string | undefined;
  orphanId!: number;
  id!: number | undefined;

  constructor(data?: ICreateOrEditOrphanClubDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.joinedCount = _data["joinedCount"];
      this.joinedYear = _data["joinedYear"];
      this.description = _data["description"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditOrphanClubDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditOrphanClubDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["joinedCount"] = this.joinedCount;
    data["joinedYear"] = this.joinedYear;
    data["description"] = this.description;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditOrphanClubDetailDto {
  name: string;
  joinedCount: number | undefined;
  joinedYear: number;
  description: string | undefined;
  orphanId: number;
  id: number | undefined;
}

export class CreateOrEditOrphanDto implements ICreateOrEditOrphanDto {
  nationality!: string;
  mdgMuhatapNo!: string | undefined;
  tcNumber!: string | undefined;
  firstName!: string;
  lastName!: string;
  placeOfBirth!: string | undefined;
  dateOfBirth!: DateTime | undefined;
  motherAndFatherName!: string | undefined;
  address!: string | undefined;
  apartmentNumber!: string | undefined;
  postCode!: number | undefined;
  mobileNumber!: string | undefined;
  homeNumber!: string | undefined;
  eMail!: string | undefined;
  maritalStatus!: MaritalStatus;
  provinceId!: number | undefined;
  districtId!: number | undefined;
  neighborhoodId!: number | undefined;
  id!: number | undefined;

  constructor(data?: ICreateOrEditOrphanDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.nationality = _data["nationality"];
      this.mdgMuhatapNo = _data["mdgMuhatapNo"];
      this.tcNumber = _data["tcNumber"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.placeOfBirth = _data["placeOfBirth"];
      this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
      this.motherAndFatherName = _data["motherAndFatherName"];
      this.address = _data["address"];
      this.apartmentNumber = _data["apartmentNumber"];
      this.postCode = _data["postCode"];
      this.mobileNumber = _data["mobileNumber"];
      this.homeNumber = _data["homeNumber"];
      this.eMail = _data["eMail"];
      this.maritalStatus = _data["maritalStatus"];
      this.provinceId = _data["provinceId"];
      this.districtId = _data["districtId"];
      this.neighborhoodId = _data["neighborhoodId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditOrphanDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditOrphanDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["nationality"] = this.nationality;
    data["mdgMuhatapNo"] = this.mdgMuhatapNo;
    data["tcNumber"] = this.tcNumber;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["placeOfBirth"] = this.placeOfBirth;
    data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : <any>undefined;
    data["motherAndFatherName"] = this.motherAndFatherName;
    data["address"] = this.address;
    data["apartmentNumber"] = this.apartmentNumber;
    data["postCode"] = this.postCode;
    data["mobileNumber"] = this.mobileNumber;
    data["homeNumber"] = this.homeNumber;
    data["eMail"] = this.eMail;
    data["maritalStatus"] = this.maritalStatus;
    data["provinceId"] = this.provinceId;
    data["districtId"] = this.districtId;
    data["neighborhoodId"] = this.neighborhoodId;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditOrphanDto {
  nationality: string;
  mdgMuhatapNo: string | undefined;
  tcNumber: string | undefined;
  firstName: string;
  lastName: string;
  placeOfBirth: string | undefined;
  dateOfBirth: DateTime | undefined;
  motherAndFatherName: string | undefined;
  address: string | undefined;
  apartmentNumber: string | undefined;
  postCode: number | undefined;
  mobileNumber: string | undefined;
  homeNumber: string | undefined;
  eMail: string | undefined;
  maritalStatus: MaritalStatus;
  provinceId: number | undefined;
  districtId: number | undefined;
  neighborhoodId: number | undefined;
  id: number | undefined;
}

export class CreateOrEditOrphanEducationDto implements ICreateOrEditOrphanEducationDto {
  educationName!: string;
  educationTime!: string;
  pointValue!: string | undefined;
  description!: string | undefined;
  documentName!: string | undefined;
  filePath!: string | undefined;
  fileExtension!: string | undefined;
  educationDate!: DateTime;
  orphanId!: number;
  id!: number | undefined;

  constructor(data?: ICreateOrEditOrphanEducationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.educationName = _data["educationName"];
      this.educationTime = _data["educationTime"];
      this.pointValue = _data["pointValue"];
      this.description = _data["description"];
      this.documentName = _data["documentName"];
      this.filePath = _data["filePath"];
      this.fileExtension = _data["fileExtension"];
      this.educationDate = _data["educationDate"] ? DateTime.fromISO(_data["educationDate"].toString()) : <any>undefined;
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditOrphanEducationDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditOrphanEducationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["educationName"] = this.educationName;
    data["educationTime"] = this.educationTime;
    data["pointValue"] = this.pointValue;
    data["description"] = this.description;
    data["documentName"] = this.documentName;
    data["filePath"] = this.filePath;
    data["fileExtension"] = this.fileExtension;
    data["educationDate"] = this.educationDate ? this.educationDate.toString() : <any>undefined;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditOrphanEducationDto {
  educationName: string;
  educationTime: string;
  pointValue: string | undefined;
  description: string | undefined;
  documentName: string | undefined;
  filePath: string | undefined;
  fileExtension: string | undefined;
  educationDate: DateTime;
  orphanId: number;
  id: number | undefined;
}

export class CreateOrEditOrphanEventTypeDto implements ICreateOrEditOrphanEventTypeDto {
  name!: string;
  id!: number | undefined;

  constructor(data?: ICreateOrEditOrphanEventTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditOrphanEventTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditOrphanEventTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditOrphanEventTypeDto {
  name: string;
  id: number | undefined;
}

export class CreateOrEditOrphanExperienceDto implements ICreateOrEditOrphanExperienceDto {
  companyName!: string;
  taskType!: TaskType;
  oprhanWorkType!: number | undefined;
  startDate!: DateTime;
  endDate!: DateTime;
  companySector!: string | undefined;
  description!: string | undefined;
  companyProvinceId!: number | undefined;
  orphanId!: number;
  id!: number | undefined;

  constructor(data?: ICreateOrEditOrphanExperienceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data["companyName"];
      this.taskType = _data["taskType"];
      this.oprhanWorkType = _data["oprhanWorkType"];
      this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
      this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
      this.companySector = _data["companySector"];
      this.description = _data["description"];
      this.companyProvinceId = _data["companyProvinceId"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditOrphanExperienceDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditOrphanExperienceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["companyName"] = this.companyName;
    data["taskType"] = this.taskType;
    data["oprhanWorkType"] = this.oprhanWorkType;
    data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
    data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
    data["companySector"] = this.companySector;
    data["description"] = this.description;
    data["companyProvinceId"] = this.companyProvinceId;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditOrphanExperienceDto {
  companyName: string;
  taskType: TaskType;
  oprhanWorkType: number | undefined;
  startDate: DateTime;
  endDate: DateTime;
  companySector: string | undefined;
  description: string | undefined;
  companyProvinceId: number | undefined;
  orphanId: number;
  id: number | undefined;
}

export class CreateOrEditOrphanInterestDetailDto implements ICreateOrEditOrphanInterestDetailDto {
  name!: string;
  orphanId!: number;
  id!: number | undefined;

  constructor(data?: ICreateOrEditOrphanInterestDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditOrphanInterestDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditOrphanInterestDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditOrphanInterestDetailDto {
  name: string;
  orphanId: number;
  id: number | undefined;
}

export class CreateOrEditOrphanLanguageDetailDto implements ICreateOrEditOrphanLanguageDetailDto {
  name!: string;
  languageLevel!: LanguageLevel;
  orphanId!: number;
  id!: number | undefined;

  constructor(data?: ICreateOrEditOrphanLanguageDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.languageLevel = _data["languageLevel"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditOrphanLanguageDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditOrphanLanguageDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["languageLevel"] = this.languageLevel;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditOrphanLanguageDetailDto {
  name: string;
  languageLevel: LanguageLevel;
  orphanId: number;
  id: number | undefined;
}

export class CreateOrEditOrphanProjectDetailDto implements ICreateOrEditOrphanProjectDetailDto {
  year!: string;
  name!: string;
  projectStatus!: ProjectStatus;
  orphanId!: number;
  id!: number | undefined;

  constructor(data?: ICreateOrEditOrphanProjectDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.year = _data["year"];
      this.name = _data["name"];
      this.projectStatus = _data["projectStatus"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditOrphanProjectDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditOrphanProjectDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["year"] = this.year;
    data["name"] = this.name;
    data["projectStatus"] = this.projectStatus;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditOrphanProjectDetailDto {
  year: string;
  name: string;
  projectStatus: ProjectStatus;
  orphanId: number;
  id: number | undefined;
}

export class CreateOrEditOrphanSchoolDto implements ICreateOrEditOrphanSchoolDto {
  schoolName!: string;
  programName!: string | undefined;
  schoolClassName!: string | undefined;
  availabilityDate!: DateTime | undefined;
  schoolProvinceId!: number;
  educationTypeId!: number;
  availabilityStatusId!: number;
  orphanId!: number;
  id!: number | undefined;

  constructor(data?: ICreateOrEditOrphanSchoolDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.schoolName = _data["schoolName"];
      this.programName = _data["programName"];
      this.schoolClassName = _data["schoolClassName"];
      this.availabilityDate = _data["availabilityDate"] ? DateTime.fromISO(_data["availabilityDate"].toString()) : <any>undefined;
      this.schoolProvinceId = _data["schoolProvinceId"];
      this.educationTypeId = _data["educationTypeId"];
      this.availabilityStatusId = _data["availabilityStatusId"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditOrphanSchoolDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditOrphanSchoolDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["schoolName"] = this.schoolName;
    data["programName"] = this.programName;
    data["schoolClassName"] = this.schoolClassName;
    data["availabilityDate"] = this.availabilityDate ? this.availabilityDate.toString() : <any>undefined;
    data["schoolProvinceId"] = this.schoolProvinceId;
    data["educationTypeId"] = this.educationTypeId;
    data["availabilityStatusId"] = this.availabilityStatusId;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditOrphanSchoolDto {
  schoolName: string;
  programName: string | undefined;
  schoolClassName: string | undefined;
  availabilityDate: DateTime | undefined;
  schoolProvinceId: number;
  educationTypeId: number;
  availabilityStatusId: number;
  orphanId: number;
  id: number | undefined;
}

export class CreateOrEditProvinceDto implements ICreateOrEditProvinceDto {
  name!: string | undefined;
  id!: number | undefined;

  constructor(data?: ICreateOrEditProvinceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditProvinceDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditProvinceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditProvinceDto {
  name: string | undefined;
  id: number | undefined;
}

export class CreateOrEditWorkJobDto implements ICreateOrEditWorkJobDto {
  headerText!: string;
  description!: string;
  companyInfo!: string;
  startDate!: DateTime;
  endDate!: DateTime;
  publishDate!: DateTime;
  isActive!: boolean;
  id!: number | undefined;

  constructor(data?: ICreateOrEditWorkJobDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.headerText = _data["headerText"];
      this.description = _data["description"];
      this.companyInfo = _data["companyInfo"];
      this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
      this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
      this.publishDate = _data["publishDate"] ? DateTime.fromISO(_data["publishDate"].toString()) : <any>undefined;
      this.isActive = _data["isActive"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateOrEditWorkJobDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrEditWorkJobDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["headerText"] = this.headerText;
    data["description"] = this.description;
    data["companyInfo"] = this.companyInfo;
    data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
    data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
    data["publishDate"] = this.publishDate ? this.publishDate.toString() : <any>undefined;
    data["isActive"] = this.isActive;
    data["id"] = this.id;
    return data;
  }
}

export interface ICreateOrEditWorkJobDto {
  headerText: string;
  description: string;
  companyInfo: string;
  startDate: DateTime;
  endDate: DateTime;
  publishDate: DateTime;
  isActive: boolean;
  id: number | undefined;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
  parentId!: number | undefined;
  displayName!: string;

  constructor(data?: ICreateOrganizationUnitInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.parentId = _data["parentId"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): CreateOrganizationUnitInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrganizationUnitInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["parentId"] = this.parentId;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface ICreateOrganizationUnitInput {
  parentId: number | undefined;
  displayName: string;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
  language!: ApplicationLanguageEditDto;

  constructor(data?: ICreateOrUpdateLanguageInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.language = new ApplicationLanguageEditDto();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : new ApplicationLanguageEditDto();
    }
  }

  static fromJS(data: any): CreateOrUpdateLanguageInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrUpdateLanguageInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["language"] = this.language ? this.language.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICreateOrUpdateLanguageInput {
  language: ApplicationLanguageEditDto;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
  role!: RoleEditDto;
  grantedPermissionNames!: string[];

  constructor(data?: ICreateOrUpdateRoleInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.role = new RoleEditDto();
      this.grantedPermissionNames = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : new RoleEditDto();
      if (Array.isArray(_data["grantedPermissionNames"])) {
        this.grantedPermissionNames = [] as any;
        for (let item of _data["grantedPermissionNames"])
          this.grantedPermissionNames!.push(item);
      }
    }
  }

  static fromJS(data: any): CreateOrUpdateRoleInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrUpdateRoleInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["role"] = this.role ? this.role.toJSON() : <any>undefined;
    if (Array.isArray(this.grantedPermissionNames)) {
      data["grantedPermissionNames"] = [];
      for (let item of this.grantedPermissionNames)
        data["grantedPermissionNames"].push(item);
    }
    return data;
  }
}

export interface ICreateOrUpdateRoleInput {
  role: RoleEditDto;
  grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
  user!: UserEditDto;
  assignedRoleNames!: string[];
  sendActivationEmail!: boolean;
  setRandomPassword!: boolean;
  organizationUnits!: number[] | undefined;

  constructor(data?: ICreateOrUpdateUserInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.user = new UserEditDto();
      this.assignedRoleNames = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : new UserEditDto();
      if (Array.isArray(_data["assignedRoleNames"])) {
        this.assignedRoleNames = [] as any;
        for (let item of _data["assignedRoleNames"])
          this.assignedRoleNames!.push(item);
      }
      this.sendActivationEmail = _data["sendActivationEmail"];
      this.setRandomPassword = _data["setRandomPassword"];
      if (Array.isArray(_data["organizationUnits"])) {
        this.organizationUnits = [] as any;
        for (let item of _data["organizationUnits"])
          this.organizationUnits!.push(item);
      }
    }
  }

  static fromJS(data: any): CreateOrUpdateUserInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrUpdateUserInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["user"] = this.user ? this.user.toJSON() : <any>undefined;
    if (Array.isArray(this.assignedRoleNames)) {
      data["assignedRoleNames"] = [];
      for (let item of this.assignedRoleNames)
        data["assignedRoleNames"].push(item);
    }
    data["sendActivationEmail"] = this.sendActivationEmail;
    data["setRandomPassword"] = this.setRandomPassword;
    if (Array.isArray(this.organizationUnits)) {
      data["organizationUnits"] = [];
      for (let item of this.organizationUnits)
        data["organizationUnits"].push(item);
    }
    return data;
  }
}

export interface ICreateOrUpdateUserInput {
  user: UserEditDto;
  assignedRoleNames: string[];
  sendActivationEmail: boolean;
  setRandomPassword: boolean;
  organizationUnits: number[] | undefined;
}

export class CreatePaymentDto implements ICreatePaymentDto {
  editionId!: number;
  editionPaymentType!: EditionPaymentType;
  paymentPeriodType!: PaymentPeriodType;
  subscriptionPaymentGatewayType!: SubscriptionPaymentGatewayType;
  recurringPaymentEnabled!: boolean;
  successUrl!: string | undefined;
  errorUrl!: string | undefined;

  constructor(data?: ICreatePaymentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.editionId = _data["editionId"];
      this.editionPaymentType = _data["editionPaymentType"];
      this.paymentPeriodType = _data["paymentPeriodType"];
      this.subscriptionPaymentGatewayType = _data["subscriptionPaymentGatewayType"];
      this.recurringPaymentEnabled = _data["recurringPaymentEnabled"];
      this.successUrl = _data["successUrl"];
      this.errorUrl = _data["errorUrl"];
    }
  }

  static fromJS(data: any): CreatePaymentDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreatePaymentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["editionId"] = this.editionId;
    data["editionPaymentType"] = this.editionPaymentType;
    data["paymentPeriodType"] = this.paymentPeriodType;
    data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
    data["recurringPaymentEnabled"] = this.recurringPaymentEnabled;
    data["successUrl"] = this.successUrl;
    data["errorUrl"] = this.errorUrl;
    return data;
  }
}

export interface ICreatePaymentDto {
  editionId: number;
  editionPaymentType: EditionPaymentType;
  paymentPeriodType: PaymentPeriodType;
  subscriptionPaymentGatewayType: SubscriptionPaymentGatewayType;
  recurringPaymentEnabled: boolean;
  successUrl: string | undefined;
  errorUrl: string | undefined;
}

export class CreateTenantInput implements ICreateTenantInput {
  tenancyName!: string;
  name!: string;
  adminEmailAddress!: string;
  adminPassword!: string | undefined;
  connectionString!: string | undefined;
  shouldChangePasswordOnNextLogin!: boolean;
  sendActivationEmail!: boolean;
  editionId!: number | undefined;
  isActive!: boolean;
  subscriptionEndDateUtc!: DateTime | undefined;
  isInTrialPeriod!: boolean;

  constructor(data?: ICreateTenantInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
      this.name = _data["name"];
      this.adminEmailAddress = _data["adminEmailAddress"];
      this.adminPassword = _data["adminPassword"];
      this.connectionString = _data["connectionString"];
      this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
      this.sendActivationEmail = _data["sendActivationEmail"];
      this.editionId = _data["editionId"];
      this.isActive = _data["isActive"];
      this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
      this.isInTrialPeriod = _data["isInTrialPeriod"];
    }
  }

  static fromJS(data: any): CreateTenantInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateTenantInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenancyName"] = this.tenancyName;
    data["name"] = this.name;
    data["adminEmailAddress"] = this.adminEmailAddress;
    data["adminPassword"] = this.adminPassword;
    data["connectionString"] = this.connectionString;
    data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
    data["sendActivationEmail"] = this.sendActivationEmail;
    data["editionId"] = this.editionId;
    data["isActive"] = this.isActive;
    data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
    data["isInTrialPeriod"] = this.isInTrialPeriod;
    return data;
  }
}

export interface ICreateTenantInput {
  tenancyName: string;
  name: string;
  adminEmailAddress: string;
  adminPassword: string | undefined;
  connectionString: string | undefined;
  shouldChangePasswordOnNextLogin: boolean;
  sendActivationEmail: boolean;
  editionId: number | undefined;
  isActive: boolean;
  subscriptionEndDateUtc: DateTime | undefined;
  isInTrialPeriod: boolean;
}

export class CreateUserDelegationDto implements ICreateUserDelegationDto {
  targetUserId!: number;
  startTime!: DateTime;
  endTime!: DateTime;

  constructor(data?: ICreateUserDelegationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.targetUserId = _data["targetUserId"];
      this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
      this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): CreateUserDelegationDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateUserDelegationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["targetUserId"] = this.targetUserId;
    data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
    data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
    return data;
  }
}

export interface ICreateUserDelegationDto {
  targetUserId: number;
  startTime: DateTime;
  endTime: DateTime;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
  name!: string;
  surname!: string;
  userName!: string;
  emailAddress!: string;
  phoneNumber!: string | undefined;
  isPhoneNumberConfirmed!: boolean;
  timezone!: string | undefined;
  qrCodeSetupImageUrl!: string | undefined;
  isGoogleAuthenticatorEnabled!: boolean;

  constructor(data?: ICurrentUserProfileEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.userName = _data["userName"];
      this.emailAddress = _data["emailAddress"];
      this.phoneNumber = _data["phoneNumber"];
      this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
      this.timezone = _data["timezone"];
      this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
      this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
    }
  }

  static fromJS(data: any): CurrentUserProfileEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new CurrentUserProfileEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["userName"] = this.userName;
    data["emailAddress"] = this.emailAddress;
    data["phoneNumber"] = this.phoneNumber;
    data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
    data["timezone"] = this.timezone;
    data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
    data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
    return data;
  }
}

export interface ICurrentUserProfileEditDto {
  name: string;
  surname: string;
  userName: string;
  emailAddress: string;
  phoneNumber: string | undefined;
  isPhoneNumberConfirmed: boolean;
  timezone: string | undefined;
  qrCodeSetupImageUrl: string | undefined;
  isGoogleAuthenticatorEnabled: boolean;
}

export class Dashboard implements IDashboard {
  dashboardName!: string | undefined;
  pages!: Page[] | undefined;

  constructor(data?: IDashboard) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dashboardName = _data["dashboardName"];
      if (Array.isArray(_data["pages"])) {
        this.pages = [] as any;
        for (let item of _data["pages"])
          this.pages!.push(Page.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Dashboard {
    data = typeof data === 'object' ? data : {};
    let result = new Dashboard();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dashboardName"] = this.dashboardName;
    if (Array.isArray(this.pages)) {
      data["pages"] = [];
      for (let item of this.pages)
        data["pages"].push(item.toJSON());
    }
    return data;
  }
}

export interface IDashboard {
  dashboardName: string | undefined;
  pages: Page[] | undefined;
}

export class DashboardOutput implements IDashboardOutput {
  name!: string | undefined;
  widgets!: WidgetOutput[] | undefined;

  constructor(data?: IDashboardOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      if (Array.isArray(_data["widgets"])) {
        this.widgets = [] as any;
        for (let item of _data["widgets"])
          this.widgets!.push(WidgetOutput.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DashboardOutput {
    data = typeof data === 'object' ? data : {};
    let result = new DashboardOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    if (Array.isArray(this.widgets)) {
      data["widgets"] = [];
      for (let item of this.widgets)
        data["widgets"].push(item.toJSON());
    }
    return data;
  }
}

export interface IDashboardOutput {
  name: string | undefined;
  widgets: WidgetOutput[] | undefined;
}

export class DateToStringOutput implements IDateToStringOutput {
  dateString!: string | undefined;

  constructor(data?: IDateToStringOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dateString = _data["dateString"];
    }
  }

  static fromJS(data: any): DateToStringOutput {
    data = typeof data === 'object' ? data : {};
    let result = new DateToStringOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dateString"] = this.dateString;
    return data;
  }
}

export interface IDateToStringOutput {
  dateString: string | undefined;
}

export class DelegatedImpersonateInput implements IDelegatedImpersonateInput {
  userDelegationId!: number;

  constructor(data?: IDelegatedImpersonateInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userDelegationId = _data["userDelegationId"];
    }
  }

  static fromJS(data: any): DelegatedImpersonateInput {
    data = typeof data === 'object' ? data : {};
    let result = new DelegatedImpersonateInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userDelegationId"] = this.userDelegationId;
    return data;
  }
}

export interface IDelegatedImpersonateInput {
  userDelegationId: number;
}

export class DistrictDto implements IDistrictDto {
  name!: string | undefined;
  provinceId!: number;
  id!: number;

  constructor(data?: IDistrictDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.provinceId = _data["provinceId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): DistrictDto {
    data = typeof data === 'object' ? data : {};
    let result = new DistrictDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["provinceId"] = this.provinceId;
    data["id"] = this.id;
    return data;
  }
}

export interface IDistrictDto {
  name: string | undefined;
  provinceId: number;
  id: number;
}

export class DistrictProvinceLookupTableDto implements IDistrictProvinceLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IDistrictProvinceLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): DistrictProvinceLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new DistrictProvinceLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IDistrictProvinceLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class DynamicEntityPropertyDto implements IDynamicEntityPropertyDto {
  entityFullName!: string | undefined;
  dynamicPropertyName!: string | undefined;
  dynamicPropertyId!: number;
  tenantId!: number | undefined;
  id!: number;

  constructor(data?: IDynamicEntityPropertyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityFullName = _data["entityFullName"];
      this.dynamicPropertyName = _data["dynamicPropertyName"];
      this.dynamicPropertyId = _data["dynamicPropertyId"];
      this.tenantId = _data["tenantId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): DynamicEntityPropertyDto {
    data = typeof data === 'object' ? data : {};
    let result = new DynamicEntityPropertyDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["entityFullName"] = this.entityFullName;
    data["dynamicPropertyName"] = this.dynamicPropertyName;
    data["dynamicPropertyId"] = this.dynamicPropertyId;
    data["tenantId"] = this.tenantId;
    data["id"] = this.id;
    return data;
  }
}

export interface IDynamicEntityPropertyDto {
  entityFullName: string | undefined;
  dynamicPropertyName: string | undefined;
  dynamicPropertyId: number;
  tenantId: number | undefined;
  id: number;
}

export class DynamicEntityPropertyValueDto implements IDynamicEntityPropertyValueDto {
  value!: string | undefined;
  entityId!: string | undefined;
  dynamicEntityPropertyId!: number;
  id!: number;

  constructor(data?: IDynamicEntityPropertyValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"];
      this.entityId = _data["entityId"];
      this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): DynamicEntityPropertyValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new DynamicEntityPropertyValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["value"] = this.value;
    data["entityId"] = this.entityId;
    data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
    data["id"] = this.id;
    return data;
  }
}

export interface IDynamicEntityPropertyValueDto {
  value: string | undefined;
  entityId: string | undefined;
  dynamicEntityPropertyId: number;
  id: number;
}

export class DynamicPropertyDto implements IDynamicPropertyDto {
  propertyName!: string | undefined;
  displayName!: string | undefined;
  inputType!: string | undefined;
  permission!: string | undefined;
  tenantId!: number | undefined;
  id!: number;

  constructor(data?: IDynamicPropertyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.propertyName = _data["propertyName"];
      this.displayName = _data["displayName"];
      this.inputType = _data["inputType"];
      this.permission = _data["permission"];
      this.tenantId = _data["tenantId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): DynamicPropertyDto {
    data = typeof data === 'object' ? data : {};
    let result = new DynamicPropertyDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["propertyName"] = this.propertyName;
    data["displayName"] = this.displayName;
    data["inputType"] = this.inputType;
    data["permission"] = this.permission;
    data["tenantId"] = this.tenantId;
    data["id"] = this.id;
    return data;
  }
}

export interface IDynamicPropertyDto {
  propertyName: string | undefined;
  displayName: string | undefined;
  inputType: string | undefined;
  permission: string | undefined;
  tenantId: number | undefined;
  id: number;
}

export class DynamicPropertyValueDto implements IDynamicPropertyValueDto {
  value!: string | undefined;
  tenantId!: number | undefined;
  dynamicPropertyId!: number;
  id!: number;

  constructor(data?: IDynamicPropertyValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"];
      this.tenantId = _data["tenantId"];
      this.dynamicPropertyId = _data["dynamicPropertyId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): DynamicPropertyValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new DynamicPropertyValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["value"] = this.value;
    data["tenantId"] = this.tenantId;
    data["dynamicPropertyId"] = this.dynamicPropertyId;
    data["id"] = this.id;
    return data;
  }
}

export interface IDynamicPropertyValueDto {
  value: string | undefined;
  tenantId: number | undefined;
  dynamicPropertyId: number;
  id: number;
}

export class EditionCreateDto implements IEditionCreateDto {
  id!: number | undefined;
  displayName!: string;
  dailyPrice!: number | undefined;
  weeklyPrice!: number | undefined;
  monthlyPrice!: number | undefined;
  annualPrice!: number | undefined;
  trialDayCount!: number | undefined;
  waitingDayAfterExpire!: number | undefined;
  expiringEditionId!: number | undefined;

  constructor(data?: IEditionCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
      this.dailyPrice = _data["dailyPrice"];
      this.weeklyPrice = _data["weeklyPrice"];
      this.monthlyPrice = _data["monthlyPrice"];
      this.annualPrice = _data["annualPrice"];
      this.trialDayCount = _data["trialDayCount"];
      this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
      this.expiringEditionId = _data["expiringEditionId"];
    }
  }

  static fromJS(data: any): EditionCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new EditionCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    data["dailyPrice"] = this.dailyPrice;
    data["weeklyPrice"] = this.weeklyPrice;
    data["monthlyPrice"] = this.monthlyPrice;
    data["annualPrice"] = this.annualPrice;
    data["trialDayCount"] = this.trialDayCount;
    data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
    data["expiringEditionId"] = this.expiringEditionId;
    return data;
  }
}

export interface IEditionCreateDto {
  id: number | undefined;
  displayName: string;
  dailyPrice: number | undefined;
  weeklyPrice: number | undefined;
  monthlyPrice: number | undefined;
  annualPrice: number | undefined;
  trialDayCount: number | undefined;
  waitingDayAfterExpire: number | undefined;
  expiringEditionId: number | undefined;
}

export class EditionEditDto implements IEditionEditDto {
  id!: number | undefined;
  displayName!: string;
  expiringEditionId!: number | undefined;

  constructor(data?: IEditionEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
      this.expiringEditionId = _data["expiringEditionId"];
    }
  }

  static fromJS(data: any): EditionEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new EditionEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    data["expiringEditionId"] = this.expiringEditionId;
    return data;
  }
}

export interface IEditionEditDto {
  id: number | undefined;
  displayName: string;
  expiringEditionId: number | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
  displayName!: string | undefined;
  trialDayCount!: number | undefined;
  monthlyPrice!: number | undefined;
  annualPrice!: number | undefined;
  isHighestEdition!: boolean;
  isFree!: boolean;
  id!: number;

  constructor(data?: IEditionInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayName = _data["displayName"];
      this.trialDayCount = _data["trialDayCount"];
      this.monthlyPrice = _data["monthlyPrice"];
      this.annualPrice = _data["annualPrice"];
      this.isHighestEdition = _data["isHighestEdition"];
      this.isFree = _data["isFree"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EditionInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new EditionInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["displayName"] = this.displayName;
    data["trialDayCount"] = this.trialDayCount;
    data["monthlyPrice"] = this.monthlyPrice;
    data["annualPrice"] = this.annualPrice;
    data["isHighestEdition"] = this.isHighestEdition;
    data["isFree"] = this.isFree;
    data["id"] = this.id;
    return data;
  }
}

export interface IEditionInfoDto {
  displayName: string | undefined;
  trialDayCount: number | undefined;
  monthlyPrice: number | undefined;
  annualPrice: number | undefined;
  isHighestEdition: boolean;
  isFree: boolean;
  id: number;
}

export class EditionListDto implements IEditionListDto {
  name!: string | undefined;
  displayName!: string | undefined;
  dailyPrice!: number | undefined;
  weeklyPrice!: number | undefined;
  monthlyPrice!: number | undefined;
  annualPrice!: number | undefined;
  waitingDayAfterExpire!: number | undefined;
  trialDayCount!: number | undefined;
  expiringEditionDisplayName!: string | undefined;
  id!: number;

  constructor(data?: IEditionListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.dailyPrice = _data["dailyPrice"];
      this.weeklyPrice = _data["weeklyPrice"];
      this.monthlyPrice = _data["monthlyPrice"];
      this.annualPrice = _data["annualPrice"];
      this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
      this.trialDayCount = _data["trialDayCount"];
      this.expiringEditionDisplayName = _data["expiringEditionDisplayName"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EditionListDto {
    data = typeof data === 'object' ? data : {};
    let result = new EditionListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["dailyPrice"] = this.dailyPrice;
    data["weeklyPrice"] = this.weeklyPrice;
    data["monthlyPrice"] = this.monthlyPrice;
    data["annualPrice"] = this.annualPrice;
    data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
    data["trialDayCount"] = this.trialDayCount;
    data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
    data["id"] = this.id;
    return data;
  }
}

export interface IEditionListDto {
  name: string | undefined;
  displayName: string | undefined;
  dailyPrice: number | undefined;
  weeklyPrice: number | undefined;
  monthlyPrice: number | undefined;
  annualPrice: number | undefined;
  waitingDayAfterExpire: number | undefined;
  trialDayCount: number | undefined;
  expiringEditionDisplayName: string | undefined;
  id: number;
}

export enum EditionPaymentType {
  NewRegistration = 0,
  BuyNow = 1,
  Upgrade = 2,
  Extend = 3,
}

export class EditionSelectDto implements IEditionSelectDto {
  id!: number;
  name!: string | undefined;
  displayName!: string | undefined;
  expiringEditionId!: number | undefined;
  dailyPrice!: number | undefined;
  weeklyPrice!: number | undefined;
  monthlyPrice!: number | undefined;
  annualPrice!: number | undefined;
  trialDayCount!: number | undefined;
  waitingDayAfterExpire!: number | undefined;
  isFree!: boolean;
  additionalData!: AdditionalData | undefined;

  constructor(data?: IEditionSelectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.expiringEditionId = _data["expiringEditionId"];
      this.dailyPrice = _data["dailyPrice"];
      this.weeklyPrice = _data["weeklyPrice"];
      this.monthlyPrice = _data["monthlyPrice"];
      this.annualPrice = _data["annualPrice"];
      this.trialDayCount = _data["trialDayCount"];
      this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
      this.isFree = _data["isFree"];
      this.additionalData = _data["additionalData"] ? AdditionalData.fromJS(_data["additionalData"]) : <any>undefined;
    }
  }

  static fromJS(data: any): EditionSelectDto {
    data = typeof data === 'object' ? data : {};
    let result = new EditionSelectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["expiringEditionId"] = this.expiringEditionId;
    data["dailyPrice"] = this.dailyPrice;
    data["weeklyPrice"] = this.weeklyPrice;
    data["monthlyPrice"] = this.monthlyPrice;
    data["annualPrice"] = this.annualPrice;
    data["trialDayCount"] = this.trialDayCount;
    data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
    data["isFree"] = this.isFree;
    data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>undefined;
    return data;
  }
}

export interface IEditionSelectDto {
  id: number;
  name: string | undefined;
  displayName: string | undefined;
  expiringEditionId: number | undefined;
  dailyPrice: number | undefined;
  weeklyPrice: number | undefined;
  monthlyPrice: number | undefined;
  annualPrice: number | undefined;
  trialDayCount: number | undefined;
  waitingDayAfterExpire: number | undefined;
  isFree: boolean;
  additionalData: AdditionalData | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
  allFeatures!: FlatFeatureSelectDto[] | undefined;
  editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;

  constructor(data?: IEditionsSelectOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["allFeatures"])) {
        this.allFeatures = [] as any;
        for (let item of _data["allFeatures"])
          this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item));
      }
      if (Array.isArray(_data["editionsWithFeatures"])) {
        this.editionsWithFeatures = [] as any;
        for (let item of _data["editionsWithFeatures"])
          this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): EditionsSelectOutput {
    data = typeof data === 'object' ? data : {};
    let result = new EditionsSelectOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.allFeatures)) {
      data["allFeatures"] = [];
      for (let item of this.allFeatures)
        data["allFeatures"].push(item.toJSON());
    }
    if (Array.isArray(this.editionsWithFeatures)) {
      data["editionsWithFeatures"] = [];
      for (let item of this.editionsWithFeatures)
        data["editionsWithFeatures"].push(item.toJSON());
    }
    return data;
  }
}

export interface IEditionsSelectOutput {
  allFeatures: FlatFeatureSelectDto[] | undefined;
  editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
  edition!: EditionSelectDto;
  featureValues!: NameValueDto[] | undefined;

  constructor(data?: IEditionWithFeaturesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : <any>undefined;
      if (Array.isArray(_data["featureValues"])) {
        this.featureValues = [] as any;
        for (let item of _data["featureValues"])
          this.featureValues!.push(NameValueDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): EditionWithFeaturesDto {
    data = typeof data === 'object' ? data : {};
    let result = new EditionWithFeaturesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
    if (Array.isArray(this.featureValues)) {
      data["featureValues"] = [];
      for (let item of this.featureValues)
        data["featureValues"].push(item.toJSON());
    }
    return data;
  }
}

export interface IEditionWithFeaturesDto {
  edition: EditionSelectDto;
  featureValues: NameValueDto[] | undefined;
}

export class EducationStatusDto implements IEducationStatusDto {
  name!: string | undefined;
  id!: number;

  constructor(data?: IEducationStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EducationStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new EducationStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface IEducationStatusDto {
  name: string | undefined;
  id: number;
}

export class EducationTypeDto implements IEducationTypeDto {
  name!: string | undefined;
  id!: number;

  constructor(data?: IEducationTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EducationTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new EducationTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface IEducationTypeDto {
  name: string | undefined;
  id: number;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
  defaultFromAddress!: string | undefined;
  defaultFromDisplayName!: string | undefined;
  smtpHost!: string | undefined;
  smtpPort!: number;
  smtpUserName!: string | undefined;
  smtpPassword!: string | undefined;
  smtpDomain!: string | undefined;
  smtpEnableSsl!: boolean;
  smtpUseDefaultCredentials!: boolean;

  constructor(data?: IEmailSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.defaultFromAddress = _data["defaultFromAddress"];
      this.defaultFromDisplayName = _data["defaultFromDisplayName"];
      this.smtpHost = _data["smtpHost"];
      this.smtpPort = _data["smtpPort"];
      this.smtpUserName = _data["smtpUserName"];
      this.smtpPassword = _data["smtpPassword"];
      this.smtpDomain = _data["smtpDomain"];
      this.smtpEnableSsl = _data["smtpEnableSsl"];
      this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
    }
  }

  static fromJS(data: any): EmailSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new EmailSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["defaultFromAddress"] = this.defaultFromAddress;
    data["defaultFromDisplayName"] = this.defaultFromDisplayName;
    data["smtpHost"] = this.smtpHost;
    data["smtpPort"] = this.smtpPort;
    data["smtpUserName"] = this.smtpUserName;
    data["smtpPassword"] = this.smtpPassword;
    data["smtpDomain"] = this.smtpDomain;
    data["smtpEnableSsl"] = this.smtpEnableSsl;
    data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
    return data;
  }
}

export interface IEmailSettingsEditDto {
  defaultFromAddress: string | undefined;
  defaultFromDisplayName: string | undefined;
  smtpHost: string | undefined;
  smtpPort: number;
  smtpUserName: string | undefined;
  smtpPassword: string | undefined;
  smtpDomain: string | undefined;
  smtpEnableSsl: boolean;
  smtpUseDefaultCredentials: boolean;
}

export class EntityChangeListDto implements IEntityChangeListDto {
  userId!: number | undefined;
  userName!: string | undefined;
  changeTime!: DateTime;
  entityTypeFullName!: string | undefined;
  changeType!: EntityChangeType;
  readonly changeTypeName!: string | undefined;
  entityChangeSetId!: number;
  id!: number;

  constructor(data?: IEntityChangeListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.userName = _data["userName"];
      this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
      this.entityTypeFullName = _data["entityTypeFullName"];
      this.changeType = _data["changeType"];
      (<any>this).changeTypeName = _data["changeTypeName"];
      this.entityChangeSetId = _data["entityChangeSetId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EntityChangeListDto {
    data = typeof data === 'object' ? data : {};
    let result = new EntityChangeListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["userName"] = this.userName;
    data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
    data["entityTypeFullName"] = this.entityTypeFullName;
    data["changeType"] = this.changeType;
    data["changeTypeName"] = this.changeTypeName;
    data["entityChangeSetId"] = this.entityChangeSetId;
    data["id"] = this.id;
    return data;
  }
}

export interface IEntityChangeListDto {
  userId: number | undefined;
  userName: string | undefined;
  changeTime: DateTime;
  entityTypeFullName: string | undefined;
  changeType: EntityChangeType;
  changeTypeName: string | undefined;
  entityChangeSetId: number;
  id: number;
}

export enum EntityChangeType {
  Created = 0,
  Updated = 1,
  Deleted = 2,
}

export class EntityDto implements IEntityDto {
  id!: number;

  constructor(data?: IEntityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EntityDto {
    data = typeof data === 'object' ? data : {};
    let result = new EntityDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    return data;
  }
}

export interface IEntityDto {
  id: number;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
  id!: string;

  constructor(data?: IEntityDtoOfGuid) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EntityDtoOfGuid {
    data = typeof data === 'object' ? data : {};
    let result = new EntityDtoOfGuid();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    return data;
  }
}

export interface IEntityDtoOfGuid {
  id: string;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
  id!: number;

  constructor(data?: IEntityDtoOfInt64) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EntityDtoOfInt64 {
    data = typeof data === 'object' ? data : {};
    let result = new EntityDtoOfInt64();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    return data;
  }
}

export interface IEntityDtoOfInt64 {
  id: number;
}

export class EntityDtoOfString implements IEntityDtoOfString {
  id!: string | undefined;

  constructor(data?: IEntityDtoOfString) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EntityDtoOfString {
    data = typeof data === 'object' ? data : {};
    let result = new EntityDtoOfString();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    return data;
  }
}

export interface IEntityDtoOfString {
  id: string | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
  entityChangeId!: number;
  newValue!: string | undefined;
  originalValue!: string | undefined;
  propertyName!: string | undefined;
  propertyTypeFullName!: string | undefined;
  tenantId!: number | undefined;
  id!: number;

  constructor(data?: IEntityPropertyChangeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityChangeId = _data["entityChangeId"];
      this.newValue = _data["newValue"];
      this.originalValue = _data["originalValue"];
      this.propertyName = _data["propertyName"];
      this.propertyTypeFullName = _data["propertyTypeFullName"];
      this.tenantId = _data["tenantId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EntityPropertyChangeDto {
    data = typeof data === 'object' ? data : {};
    let result = new EntityPropertyChangeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["entityChangeId"] = this.entityChangeId;
    data["newValue"] = this.newValue;
    data["originalValue"] = this.originalValue;
    data["propertyName"] = this.propertyName;
    data["propertyTypeFullName"] = this.propertyTypeFullName;
    data["tenantId"] = this.tenantId;
    data["id"] = this.id;
    return data;
  }
}

export interface IEntityPropertyChangeDto {
  entityChangeId: number;
  newValue: string | undefined;
  originalValue: string | undefined;
  propertyName: string | undefined;
  propertyTypeFullName: string | undefined;
  tenantId: number | undefined;
  id: number;
}

export class EventCalendarAgeLimitDto implements IEventCalendarAgeLimitDto {
  eventCalendarDetailId!: number;
  ageLimit!: AgeLimitDto;
  ageLimitId!: number;
  id!: number;

  constructor(data?: IEventCalendarAgeLimitDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.eventCalendarDetailId = _data["eventCalendarDetailId"];
      this.ageLimit = _data["ageLimit"] ? AgeLimitDto.fromJS(_data["ageLimit"]) : <any>undefined;
      this.ageLimitId = _data["ageLimitId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EventCalendarAgeLimitDto {
    data = typeof data === 'object' ? data : {};
    let result = new EventCalendarAgeLimitDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["eventCalendarDetailId"] = this.eventCalendarDetailId;
    data["ageLimit"] = this.ageLimit ? this.ageLimit.toJSON() : <any>undefined;
    data["ageLimitId"] = this.ageLimitId;
    data["id"] = this.id;
    return data;
  }
}

export interface IEventCalendarAgeLimitDto {
  eventCalendarDetailId: number;
  ageLimit: AgeLimitDto;
  ageLimitId: number;
  id: number;
}

export class EventCalendarDetailAgeLimitLookupTableDto implements IEventCalendarDetailAgeLimitLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IEventCalendarDetailAgeLimitLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): EventCalendarDetailAgeLimitLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new EventCalendarDetailAgeLimitLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IEventCalendarDetailAgeLimitLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class EventCalendarDetailDto implements IEventCalendarDetailDto {
  subject!: string | undefined;
  description!: string | undefined;
  startDate!: DateTime;
  endDate!: DateTime;
  isOnline!: boolean;
  eventLocationOrUrl!: string | undefined;
  orphanEventTypeId!: number;
  provinceId!: number | undefined;
  eventCalendarAgeLimits!: EventCalendarAgeLimitDto[] | undefined;
  eventCalendarRegions!: EventCalendarRegionDto[] | undefined;
  id!: number;

  constructor(data?: IEventCalendarDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.subject = _data["subject"];
      this.description = _data["description"];
      this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
      this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
      this.isOnline = _data["isOnline"];
      this.eventLocationOrUrl = _data["eventLocationOrUrl"];
      this.orphanEventTypeId = _data["orphanEventTypeId"];
      this.provinceId = _data["provinceId"];
      if (Array.isArray(_data["eventCalendarAgeLimits"])) {
        this.eventCalendarAgeLimits = [] as any;
        for (let item of _data["eventCalendarAgeLimits"])
          this.eventCalendarAgeLimits!.push(EventCalendarAgeLimitDto.fromJS(item));
      }
      if (Array.isArray(_data["eventCalendarRegions"])) {
        this.eventCalendarRegions = [] as any;
        for (let item of _data["eventCalendarRegions"])
          this.eventCalendarRegions!.push(EventCalendarRegionDto.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EventCalendarDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new EventCalendarDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["subject"] = this.subject;
    data["description"] = this.description;
    data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
    data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
    data["isOnline"] = this.isOnline;
    data["eventLocationOrUrl"] = this.eventLocationOrUrl;
    data["orphanEventTypeId"] = this.orphanEventTypeId;
    data["provinceId"] = this.provinceId;
    if (Array.isArray(this.eventCalendarAgeLimits)) {
      data["eventCalendarAgeLimits"] = [];
      for (let item of this.eventCalendarAgeLimits)
        data["eventCalendarAgeLimits"].push(item.toJSON());
    }
    if (Array.isArray(this.eventCalendarRegions)) {
      data["eventCalendarRegions"] = [];
      for (let item of this.eventCalendarRegions)
        data["eventCalendarRegions"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }
}

export interface IEventCalendarDetailDto {
  subject: string | undefined;
  description: string | undefined;
  startDate: DateTime;
  endDate: DateTime;
  isOnline: boolean;
  eventLocationOrUrl: string | undefined;
  orphanEventTypeId: number;
  provinceId: number | undefined;
  eventCalendarAgeLimits: EventCalendarAgeLimitDto[] | undefined;
  eventCalendarRegions: EventCalendarRegionDto[] | undefined;
  id: number;
}

export class EventCalendarDetailOrphanEventTypeLookupTableDto implements IEventCalendarDetailOrphanEventTypeLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IEventCalendarDetailOrphanEventTypeLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): EventCalendarDetailOrphanEventTypeLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new EventCalendarDetailOrphanEventTypeLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IEventCalendarDetailOrphanEventTypeLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class EventCalendarDetailProvinceLookupTableDto implements IEventCalendarDetailProvinceLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IEventCalendarDetailProvinceLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): EventCalendarDetailProvinceLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new EventCalendarDetailProvinceLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IEventCalendarDetailProvinceLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class EventCalendarRegionDto implements IEventCalendarRegionDto {
  eventCalendarDetailId!: number;
  region!: GeoRegionTurkey;

  constructor(data?: IEventCalendarRegionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.eventCalendarDetailId = _data["eventCalendarDetailId"];
      this.region = _data["region"];
    }
  }

  static fromJS(data: any): EventCalendarRegionDto {
    data = typeof data === 'object' ? data : {};
    let result = new EventCalendarRegionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["eventCalendarDetailId"] = this.eventCalendarDetailId;
    data["region"] = this.region;
    return data;
  }
}

export interface IEventCalendarRegionDto {
  eventCalendarDetailId: number;
  region: GeoRegionTurkey;
}

export class EventCalendarRegionLookupTableDto implements IEventCalendarRegionLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IEventCalendarRegionLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): EventCalendarRegionLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new EventCalendarRegionLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IEventCalendarRegionLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class ExpiringTenant implements IExpiringTenant {
  tenantName!: string | undefined;
  remainingDayCount!: number;

  constructor(data?: IExpiringTenant) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantName = _data["tenantName"];
      this.remainingDayCount = _data["remainingDayCount"];
    }
  }

  static fromJS(data: any): ExpiringTenant {
    data = typeof data === 'object' ? data : {};
    let result = new ExpiringTenant();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantName"] = this.tenantName;
    data["remainingDayCount"] = this.remainingDayCount;
    return data;
  }
}

export interface IExpiringTenant {
  tenantName: string | undefined;
  remainingDayCount: number;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
  authProvider!: string;
  providerKey!: string;
  providerAccessCode!: string;
  returnUrl!: string | undefined;
  singleSignIn!: boolean | undefined;
  module!: string | undefined;
  fullName!: string | undefined;

  constructor(data?: IExternalAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.authProvider = _data["authProvider"];
      this.providerKey = _data["providerKey"];
      this.providerAccessCode = _data["providerAccessCode"];
      this.returnUrl = _data["returnUrl"];
      this.singleSignIn = _data["singleSignIn"];
      this.module = _data["module"];
    }
  }

  static fromJS(data: any): ExternalAuthenticateModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalAuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["authProvider"] = this.authProvider;
    data["providerKey"] = this.providerKey;
    data["providerAccessCode"] = this.providerAccessCode;
    data["returnUrl"] = this.returnUrl;
    data["singleSignIn"] = this.singleSignIn;
    data["module"] = this.module;
    return data;
  }
}

export interface IExternalAuthenticateModel {
  authProvider: string;
  providerKey: string;
  providerAccessCode: string;
  returnUrl: string | undefined;
  singleSignIn: boolean | undefined;
  module: string | undefined;
  fullName: string | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
  accessToken!: string | undefined;
  encryptedAccessToken!: string | undefined;
  expireInSeconds!: number;
  waitingForActivation!: boolean;
  returnUrl!: string | undefined;
  refreshToken!: string | undefined;
  refreshTokenExpireInSeconds!: number;
  fullName!: string | undefined;

  constructor(data?: IExternalAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.encryptedAccessToken = _data["encryptedAccessToken"];
      this.expireInSeconds = _data["expireInSeconds"];
      this.waitingForActivation = _data["waitingForActivation"];
      this.returnUrl = _data["returnUrl"];
      this.refreshToken = _data["refreshToken"];
      this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
      this.fullName = _data["fullName"];
    }
  }

  static fromJS(data: any): ExternalAuthenticateResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalAuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["accessToken"] = this.accessToken;
    data["encryptedAccessToken"] = this.encryptedAccessToken;
    data["expireInSeconds"] = this.expireInSeconds;
    data["waitingForActivation"] = this.waitingForActivation;
    data["returnUrl"] = this.returnUrl;
    data["refreshToken"] = this.refreshToken;
    data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
    return data;
  }
}

export interface IExternalAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  waitingForActivation: boolean;
  returnUrl: string | undefined;
  refreshToken: string | undefined;
  refreshTokenExpireInSeconds: number;
  fullName: string | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
  name!: string | undefined;
  clientId!: string | undefined;
  additionalParams!: { [key: string]: string; } | undefined;

  constructor(data?: IExternalLoginProviderInfoModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.clientId = _data["clientId"];
      if (_data["additionalParams"]) {
        this.additionalParams = {} as any;
        for (let key in _data["additionalParams"]) {
          if (_data["additionalParams"].hasOwnProperty(key))
            (<any>this.additionalParams)![key] = _data["additionalParams"][key];
        }
      }
    }
  }

  static fromJS(data: any): ExternalLoginProviderInfoModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalLoginProviderInfoModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["clientId"] = this.clientId;
    if (this.additionalParams) {
      data["additionalParams"] = {};
      for (let key in this.additionalParams) {
        if (this.additionalParams.hasOwnProperty(key))
          (<any>data["additionalParams"])[key] = this.additionalParams[key];
      }
    }
    return data;
  }
}

export interface IExternalLoginProviderInfoModel {
  name: string | undefined;
  clientId: string | undefined;
  additionalParams: { [key: string]: string; } | undefined;
}

export class ExternalLoginProviderSettingsEditDto implements IExternalLoginProviderSettingsEditDto {
  facebook_IsDeactivated!: boolean;
  facebook!: FacebookExternalLoginProviderSettings;
  google_IsDeactivated!: boolean;
  google!: GoogleExternalLoginProviderSettings;
  twitter_IsDeactivated!: boolean;
  twitter!: TwitterExternalLoginProviderSettings;
  microsoft_IsDeactivated!: boolean;
  microsoft!: MicrosoftExternalLoginProviderSettings;
  openIdConnect_IsDeactivated!: boolean;
  openIdConnect!: OpenIdConnectExternalLoginProviderSettings;
  openIdConnectClaimsMapping!: JsonClaimMapDto[] | undefined;
  wsFederation_IsDeactivated!: boolean;
  wsFederation!: WsFederationExternalLoginProviderSettings;
  wsFederationClaimsMapping!: JsonClaimMapDto[] | undefined;

  constructor(data?: IExternalLoginProviderSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.facebook_IsDeactivated = _data["facebook_IsDeactivated"];
      this.facebook = _data["facebook"] ? FacebookExternalLoginProviderSettings.fromJS(_data["facebook"]) : <any>undefined;
      this.google_IsDeactivated = _data["google_IsDeactivated"];
      this.google = _data["google"] ? GoogleExternalLoginProviderSettings.fromJS(_data["google"]) : <any>undefined;
      this.twitter_IsDeactivated = _data["twitter_IsDeactivated"];
      this.twitter = _data["twitter"] ? TwitterExternalLoginProviderSettings.fromJS(_data["twitter"]) : <any>undefined;
      this.microsoft_IsDeactivated = _data["microsoft_IsDeactivated"];
      this.microsoft = _data["microsoft"] ? MicrosoftExternalLoginProviderSettings.fromJS(_data["microsoft"]) : <any>undefined;
      this.openIdConnect_IsDeactivated = _data["openIdConnect_IsDeactivated"];
      this.openIdConnect = _data["openIdConnect"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["openIdConnect"]) : <any>undefined;
      if (Array.isArray(_data["openIdConnectClaimsMapping"])) {
        this.openIdConnectClaimsMapping = [] as any;
        for (let item of _data["openIdConnectClaimsMapping"])
          this.openIdConnectClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
      }
      this.wsFederation_IsDeactivated = _data["wsFederation_IsDeactivated"];
      this.wsFederation = _data["wsFederation"] ? WsFederationExternalLoginProviderSettings.fromJS(_data["wsFederation"]) : <any>undefined;
      if (Array.isArray(_data["wsFederationClaimsMapping"])) {
        this.wsFederationClaimsMapping = [] as any;
        for (let item of _data["wsFederationClaimsMapping"])
          this.wsFederationClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ExternalLoginProviderSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalLoginProviderSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["facebook_IsDeactivated"] = this.facebook_IsDeactivated;
    data["facebook"] = this.facebook ? this.facebook.toJSON() : <any>undefined;
    data["google_IsDeactivated"] = this.google_IsDeactivated;
    data["google"] = this.google ? this.google.toJSON() : <any>undefined;
    data["twitter_IsDeactivated"] = this.twitter_IsDeactivated;
    data["twitter"] = this.twitter ? this.twitter.toJSON() : <any>undefined;
    data["microsoft_IsDeactivated"] = this.microsoft_IsDeactivated;
    data["microsoft"] = this.microsoft ? this.microsoft.toJSON() : <any>undefined;
    data["openIdConnect_IsDeactivated"] = this.openIdConnect_IsDeactivated;
    data["openIdConnect"] = this.openIdConnect ? this.openIdConnect.toJSON() : <any>undefined;
    if (Array.isArray(this.openIdConnectClaimsMapping)) {
      data["openIdConnectClaimsMapping"] = [];
      for (let item of this.openIdConnectClaimsMapping)
        data["openIdConnectClaimsMapping"].push(item.toJSON());
    }
    data["wsFederation_IsDeactivated"] = this.wsFederation_IsDeactivated;
    data["wsFederation"] = this.wsFederation ? this.wsFederation.toJSON() : <any>undefined;
    if (Array.isArray(this.wsFederationClaimsMapping)) {
      data["wsFederationClaimsMapping"] = [];
      for (let item of this.wsFederationClaimsMapping)
        data["wsFederationClaimsMapping"].push(item.toJSON());
    }
    return data;
  }
}

export interface IExternalLoginProviderSettingsEditDto {
  facebook_IsDeactivated: boolean;
  facebook: FacebookExternalLoginProviderSettings;
  google_IsDeactivated: boolean;
  google: GoogleExternalLoginProviderSettings;
  twitter_IsDeactivated: boolean;
  twitter: TwitterExternalLoginProviderSettings;
  microsoft_IsDeactivated: boolean;
  microsoft: MicrosoftExternalLoginProviderSettings;
  openIdConnect_IsDeactivated: boolean;
  openIdConnect: OpenIdConnectExternalLoginProviderSettings;
  openIdConnectClaimsMapping: JsonClaimMapDto[] | undefined;
  wsFederation_IsDeactivated: boolean;
  wsFederation: WsFederationExternalLoginProviderSettings;
  wsFederationClaimsMapping: JsonClaimMapDto[] | undefined;
}

export class ExternalLoginSettingsDto implements IExternalLoginSettingsDto {
  enabledSocialLoginSettings!: string[] | undefined;

  constructor(data?: IExternalLoginSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["enabledSocialLoginSettings"])) {
        this.enabledSocialLoginSettings = [] as any;
        for (let item of _data["enabledSocialLoginSettings"])
          this.enabledSocialLoginSettings!.push(item);
      }
    }
  }

  static fromJS(data: any): ExternalLoginSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalLoginSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.enabledSocialLoginSettings)) {
      data["enabledSocialLoginSettings"] = [];
      for (let item of this.enabledSocialLoginSettings)
        data["enabledSocialLoginSettings"].push(item);
    }
    return data;
  }
}

export interface IExternalLoginSettingsDto {
  enabledSocialLoginSettings: string[] | undefined;
}

export class FacebookExternalLoginProviderSettings implements IFacebookExternalLoginProviderSettings {
  appId!: string | undefined;
  appSecret!: string | undefined;

  constructor(data?: IFacebookExternalLoginProviderSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.appId = _data["appId"];
      this.appSecret = _data["appSecret"];
    }
  }

  static fromJS(data: any): FacebookExternalLoginProviderSettings {
    data = typeof data === 'object' ? data : {};
    let result = new FacebookExternalLoginProviderSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["appId"] = this.appId;
    data["appSecret"] = this.appSecret;
    return data;
  }
}

export interface IFacebookExternalLoginProviderSettings {
  appId: string | undefined;
  appSecret: string | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
  name!: string | undefined;
  attributes!: { [key: string]: any; } | undefined;
  validator!: IValueValidator;
  itemSource!: LocalizableComboboxItemSourceDto;

  constructor(data?: IFeatureInputTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      if (_data["attributes"]) {
        this.attributes = {} as any;
        for (let key in _data["attributes"]) {
          if (_data["attributes"].hasOwnProperty(key))
            (<any>this.attributes)![key] = _data["attributes"][key];
        }
      }
      this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
      this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"]) : <any>undefined;
    }
  }

  static fromJS(data: any): FeatureInputTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new FeatureInputTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    if (this.attributes) {
      data["attributes"] = {};
      for (let key in this.attributes) {
        if (this.attributes.hasOwnProperty(key))
          (<any>data["attributes"])[key] = this.attributes[key];
      }
    }
    data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
    data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
    return data;
  }
}

export interface IFeatureInputTypeDto {
  name: string | undefined;
  attributes: { [key: string]: any; } | undefined;
  validator: IValueValidator;
  itemSource: LocalizableComboboxItemSourceDto;
}

export class FileDto implements IFileDto {
  fileName!: string;
  fileType!: string | undefined;
  fileToken!: string;

  constructor(data?: IFileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fileName = _data["fileName"];
      this.fileType = _data["fileType"];
      this.fileToken = _data["fileToken"];
    }
  }

  static fromJS(data: any): FileDto {
    data = typeof data === 'object' ? data : {};
    let result = new FileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fileName"] = this.fileName;
    data["fileType"] = this.fileType;
    data["fileToken"] = this.fileToken;
    return data;
  }
}

export interface IFileDto {
  fileName: string;
  fileType: string | undefined;
  fileToken: string;
}

export class FindOrganizationUnitRolesInput implements IFindOrganizationUnitRolesInput {
  organizationUnitId!: number;
  maxResultCount!: number;
  skipCount!: number;
  filter!: string | undefined;

  constructor(data?: IFindOrganizationUnitRolesInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.organizationUnitId = _data["organizationUnitId"];
      this.maxResultCount = _data["maxResultCount"];
      this.skipCount = _data["skipCount"];
      this.filter = _data["filter"];
    }
  }

  static fromJS(data: any): FindOrganizationUnitRolesInput {
    data = typeof data === 'object' ? data : {};
    let result = new FindOrganizationUnitRolesInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["organizationUnitId"] = this.organizationUnitId;
    data["maxResultCount"] = this.maxResultCount;
    data["skipCount"] = this.skipCount;
    data["filter"] = this.filter;
    return data;
  }
}

export interface IFindOrganizationUnitRolesInput {
  organizationUnitId: number;
  maxResultCount: number;
  skipCount: number;
  filter: string | undefined;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
  organizationUnitId!: number;
  maxResultCount!: number;
  skipCount!: number;
  filter!: string | undefined;

  constructor(data?: IFindOrganizationUnitUsersInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.organizationUnitId = _data["organizationUnitId"];
      this.maxResultCount = _data["maxResultCount"];
      this.skipCount = _data["skipCount"];
      this.filter = _data["filter"];
    }
  }

  static fromJS(data: any): FindOrganizationUnitUsersInput {
    data = typeof data === 'object' ? data : {};
    let result = new FindOrganizationUnitUsersInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["organizationUnitId"] = this.organizationUnitId;
    data["maxResultCount"] = this.maxResultCount;
    data["skipCount"] = this.skipCount;
    data["filter"] = this.filter;
    return data;
  }
}

export interface IFindOrganizationUnitUsersInput {
  organizationUnitId: number;
  maxResultCount: number;
  skipCount: number;
  filter: string | undefined;
}

export class FindUsersInput implements IFindUsersInput {
  tenantId!: number | undefined;
  excludeCurrentUser!: boolean;
  maxResultCount!: number;
  skipCount!: number;
  filter!: string | undefined;

  constructor(data?: IFindUsersInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.excludeCurrentUser = _data["excludeCurrentUser"];
      this.maxResultCount = _data["maxResultCount"];
      this.skipCount = _data["skipCount"];
      this.filter = _data["filter"];
    }
  }

  static fromJS(data: any): FindUsersInput {
    data = typeof data === 'object' ? data : {};
    let result = new FindUsersInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["excludeCurrentUser"] = this.excludeCurrentUser;
    data["maxResultCount"] = this.maxResultCount;
    data["skipCount"] = this.skipCount;
    data["filter"] = this.filter;
    return data;
  }
}

export interface IFindUsersInput {
  tenantId: number | undefined;
  excludeCurrentUser: boolean;
  maxResultCount: number;
  skipCount: number;
  filter: string | undefined;
}

export class FlatFeatureDto implements IFlatFeatureDto {
  parentName!: string | undefined;
  name!: string | undefined;
  displayName!: string | undefined;
  description!: string | undefined;
  defaultValue!: string | undefined;
  inputType!: FeatureInputTypeDto;

  constructor(data?: IFlatFeatureDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.parentName = _data["parentName"];
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.description = _data["description"];
      this.defaultValue = _data["defaultValue"];
      this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"]) : <any>undefined;
    }
  }

  static fromJS(data: any): FlatFeatureDto {
    data = typeof data === 'object' ? data : {};
    let result = new FlatFeatureDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["parentName"] = this.parentName;
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["description"] = this.description;
    data["defaultValue"] = this.defaultValue;
    data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
    return data;
  }
}

export interface IFlatFeatureDto {
  parentName: string | undefined;
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
  defaultValue: string | undefined;
  inputType: FeatureInputTypeDto;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
  parentName!: string | undefined;
  name!: string | undefined;
  displayName!: string | undefined;
  description!: string | undefined;
  defaultValue!: string | undefined;
  inputType!: IInputType;
  textHtmlColor!: string | undefined;

  constructor(data?: IFlatFeatureSelectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.parentName = _data["parentName"];
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.description = _data["description"];
      this.defaultValue = _data["defaultValue"];
      this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : <any>undefined;
      this.textHtmlColor = _data["textHtmlColor"];
    }
  }

  static fromJS(data: any): FlatFeatureSelectDto {
    data = typeof data === 'object' ? data : {};
    let result = new FlatFeatureSelectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["parentName"] = this.parentName;
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["description"] = this.description;
    data["defaultValue"] = this.defaultValue;
    data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
    data["textHtmlColor"] = this.textHtmlColor;
    return data;
  }
}

export interface IFlatFeatureSelectDto {
  parentName: string | undefined;
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
  defaultValue: string | undefined;
  inputType: IInputType;
  textHtmlColor: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
  parentName!: string | undefined;
  name!: string | undefined;
  displayName!: string | undefined;
  description!: string | undefined;
  isGrantedByDefault!: boolean;

  constructor(data?: IFlatPermissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.parentName = _data["parentName"];
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.description = _data["description"];
      this.isGrantedByDefault = _data["isGrantedByDefault"];
    }
  }

  static fromJS(data: any): FlatPermissionDto {
    data = typeof data === 'object' ? data : {};
    let result = new FlatPermissionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["parentName"] = this.parentName;
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["description"] = this.description;
    data["isGrantedByDefault"] = this.isGrantedByDefault;
    return data;
  }
}

export interface IFlatPermissionDto {
  parentName: string | undefined;
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
  isGrantedByDefault: boolean;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
  level!: number;
  parentName!: string | undefined;
  name!: string | undefined;
  displayName!: string | undefined;
  description!: string | undefined;
  isGrantedByDefault!: boolean;

  constructor(data?: IFlatPermissionWithLevelDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.level = _data["level"];
      this.parentName = _data["parentName"];
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.description = _data["description"];
      this.isGrantedByDefault = _data["isGrantedByDefault"];
    }
  }

  static fromJS(data: any): FlatPermissionWithLevelDto {
    data = typeof data === 'object' ? data : {};
    let result = new FlatPermissionWithLevelDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["level"] = this.level;
    data["parentName"] = this.parentName;
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["description"] = this.description;
    data["isGrantedByDefault"] = this.isGrantedByDefault;
    return data;
  }
}

export interface IFlatPermissionWithLevelDto {
  level: number;
  parentName: string | undefined;
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
  isGrantedByDefault: boolean;
}

export class FriendDto implements IFriendDto {
  friendUserId!: number;
  friendTenantId!: number | undefined;
  friendUserName!: string | undefined;
  friendTenancyName!: string | undefined;
  friendProfilePictureId!: string | undefined;
  unreadMessageCount!: number;
  isOnline!: boolean;
  state!: FriendshipState;

  constructor(data?: IFriendDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.friendUserId = _data["friendUserId"];
      this.friendTenantId = _data["friendTenantId"];
      this.friendUserName = _data["friendUserName"];
      this.friendTenancyName = _data["friendTenancyName"];
      this.friendProfilePictureId = _data["friendProfilePictureId"];
      this.unreadMessageCount = _data["unreadMessageCount"];
      this.isOnline = _data["isOnline"];
      this.state = _data["state"];
    }
  }

  static fromJS(data: any): FriendDto {
    data = typeof data === 'object' ? data : {};
    let result = new FriendDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["friendUserId"] = this.friendUserId;
    data["friendTenantId"] = this.friendTenantId;
    data["friendUserName"] = this.friendUserName;
    data["friendTenancyName"] = this.friendTenancyName;
    data["friendProfilePictureId"] = this.friendProfilePictureId;
    data["unreadMessageCount"] = this.unreadMessageCount;
    data["isOnline"] = this.isOnline;
    data["state"] = this.state;
    return data;
  }
}

export interface IFriendDto {
  friendUserId: number;
  friendTenantId: number | undefined;
  friendUserName: string | undefined;
  friendTenancyName: string | undefined;
  friendProfilePictureId: string | undefined;
  unreadMessageCount: number;
  isOnline: boolean;
  state: FriendshipState;
}

export enum FriendshipState {
  Accepted = 1,
  Blocked = 2,
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
  timezone!: string | undefined;
  timezoneForComparison!: string | undefined;

  constructor(data?: IGeneralSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.timezone = _data["timezone"];
      this.timezoneForComparison = _data["timezoneForComparison"];
    }
  }

  static fromJS(data: any): GeneralSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new GeneralSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["timezone"] = this.timezone;
    data["timezoneForComparison"] = this.timezoneForComparison;
    return data;
  }
}

export interface IGeneralSettingsEditDto {
  timezone: string | undefined;
  timezoneForComparison: string | undefined;
}

export enum GeoRegionTurkey {
  MarmaraRegion = 0,
  AegeanRegion = 1,
  MediterraneanRegion = 2,
  BlackSeaRegion = 3,
  InnerAnatolianRegion = 4,
  EasternAnatoliaRegion = 5,
  SoutheastAnatoliaRegion = 6,
}

export class GetAgeLimitForEditOutput implements IGetAgeLimitForEditOutput {
  ageLimit!: CreateOrEditAgeLimitDto;

  constructor(data?: IGetAgeLimitForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ageLimit = _data["ageLimit"] ? CreateOrEditAgeLimitDto.fromJS(_data["ageLimit"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetAgeLimitForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetAgeLimitForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["ageLimit"] = this.ageLimit ? this.ageLimit.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetAgeLimitForEditOutput {
  ageLimit: CreateOrEditAgeLimitDto;
}

export class GetAgeLimitForViewDto implements IGetAgeLimitForViewDto {
  ageLimit!: AgeLimitDto;

  constructor(data?: IGetAgeLimitForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ageLimit = _data["ageLimit"] ? AgeLimitDto.fromJS(_data["ageLimit"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetAgeLimitForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetAgeLimitForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["ageLimit"] = this.ageLimit ? this.ageLimit.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetAgeLimitForViewDto {
  ageLimit: AgeLimitDto;
}

export class GetAllAvailableWebhooksOutput implements IGetAllAvailableWebhooksOutput {
  name!: string | undefined;
  displayName!: string | undefined;
  description!: string | undefined;

  constructor(data?: IGetAllAvailableWebhooksOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): GetAllAvailableWebhooksOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetAllAvailableWebhooksOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["description"] = this.description;
    return data;
  }
}

export interface IGetAllAvailableWebhooksOutput {
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
}

export class GetAllDynamicEntityPropertyValuesOutput implements IGetAllDynamicEntityPropertyValuesOutput {
  items!: GetAllDynamicEntityPropertyValuesOutputItem[] | undefined;

  constructor(data?: IGetAllDynamicEntityPropertyValuesOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetAllDynamicEntityPropertyValuesOutputItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetAllDynamicEntityPropertyValuesOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetAllDynamicEntityPropertyValuesOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetAllDynamicEntityPropertyValuesOutput {
  items: GetAllDynamicEntityPropertyValuesOutputItem[] | undefined;
}

export class GetAllDynamicEntityPropertyValuesOutputItem implements IGetAllDynamicEntityPropertyValuesOutputItem {
  dynamicEntityPropertyId!: number;
  propertyName!: string | undefined;
  inputType!: IInputType;
  selectedValues!: string[] | undefined;
  allValuesInputTypeHas!: string[] | undefined;

  constructor(data?: IGetAllDynamicEntityPropertyValuesOutputItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
      this.propertyName = _data["propertyName"];
      this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : <any>undefined;
      if (Array.isArray(_data["selectedValues"])) {
        this.selectedValues = [] as any;
        for (let item of _data["selectedValues"])
          this.selectedValues!.push(item);
      }
      if (Array.isArray(_data["allValuesInputTypeHas"])) {
        this.allValuesInputTypeHas = [] as any;
        for (let item of _data["allValuesInputTypeHas"])
          this.allValuesInputTypeHas!.push(item);
      }
    }
  }

  static fromJS(data: any): GetAllDynamicEntityPropertyValuesOutputItem {
    data = typeof data === 'object' ? data : {};
    let result = new GetAllDynamicEntityPropertyValuesOutputItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
    data["propertyName"] = this.propertyName;
    data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
    if (Array.isArray(this.selectedValues)) {
      data["selectedValues"] = [];
      for (let item of this.selectedValues)
        data["selectedValues"].push(item);
    }
    if (Array.isArray(this.allValuesInputTypeHas)) {
      data["allValuesInputTypeHas"] = [];
      for (let item of this.allValuesInputTypeHas)
        data["allValuesInputTypeHas"].push(item);
    }
    return data;
  }
}

export interface IGetAllDynamicEntityPropertyValuesOutputItem {
  dynamicEntityPropertyId: number;
  propertyName: string | undefined;
  inputType: IInputType;
  selectedValues: string[] | undefined;
  allValuesInputTypeHas: string[] | undefined;
}

export class GetAllEntitiesHasDynamicPropertyOutput implements IGetAllEntitiesHasDynamicPropertyOutput {
  entityFullName!: string | undefined;

  constructor(data?: IGetAllEntitiesHasDynamicPropertyOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityFullName = _data["entityFullName"];
    }
  }

  static fromJS(data: any): GetAllEntitiesHasDynamicPropertyOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetAllEntitiesHasDynamicPropertyOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["entityFullName"] = this.entityFullName;
    return data;
  }
}

export interface IGetAllEntitiesHasDynamicPropertyOutput {
  entityFullName: string | undefined;
}

export class GetAllSendAttemptsOfWebhookEventOutput implements IGetAllSendAttemptsOfWebhookEventOutput {
  id!: string;
  webhookUri!: string | undefined;
  webhookSubscriptionId!: string;
  response!: string | undefined;
  responseStatusCode!: HttpStatusCode;
  creationTime!: DateTime;
  lastModificationTime!: DateTime | undefined;

  constructor(data?: IGetAllSendAttemptsOfWebhookEventOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.webhookUri = _data["webhookUri"];
      this.webhookSubscriptionId = _data["webhookSubscriptionId"];
      this.response = _data["response"];
      this.responseStatusCode = _data["responseStatusCode"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): GetAllSendAttemptsOfWebhookEventOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetAllSendAttemptsOfWebhookEventOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["webhookUri"] = this.webhookUri;
    data["webhookSubscriptionId"] = this.webhookSubscriptionId;
    data["response"] = this.response;
    data["responseStatusCode"] = this.responseStatusCode;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
    return data;
  }
}

export interface IGetAllSendAttemptsOfWebhookEventOutput {
  id: string;
  webhookUri: string | undefined;
  webhookSubscriptionId: string;
  response: string | undefined;
  responseStatusCode: HttpStatusCode;
  creationTime: DateTime;
  lastModificationTime: DateTime | undefined;
}

export class GetAllSendAttemptsOutput implements IGetAllSendAttemptsOutput {
  id!: string;
  webhookEventId!: string;
  webhookName!: string | undefined;
  data!: string | undefined;
  response!: string | undefined;
  responseStatusCode!: HttpStatusCode;
  creationTime!: DateTime;

  constructor(data?: IGetAllSendAttemptsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.webhookEventId = _data["webhookEventId"];
      this.webhookName = _data["webhookName"];
      this.data = _data["data"];
      this.response = _data["response"];
      this.responseStatusCode = _data["responseStatusCode"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): GetAllSendAttemptsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetAllSendAttemptsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["webhookEventId"] = this.webhookEventId;
    data["webhookName"] = this.webhookName;
    data["data"] = this.data;
    data["response"] = this.response;
    data["responseStatusCode"] = this.responseStatusCode;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    return data;
  }
}

export interface IGetAllSendAttemptsOutput {
  id: string;
  webhookEventId: string;
  webhookName: string | undefined;
  data: string | undefined;
  response: string | undefined;
  responseStatusCode: HttpStatusCode;
  creationTime: DateTime;
}

export class GetAllSubscriptionsOutput implements IGetAllSubscriptionsOutput {
  webhookUri!: string | undefined;
  isActive!: boolean;
  webhooks!: string[] | undefined;
  id!: string;

  constructor(data?: IGetAllSubscriptionsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.webhookUri = _data["webhookUri"];
      this.isActive = _data["isActive"];
      if (Array.isArray(_data["webhooks"])) {
        this.webhooks = [] as any;
        for (let item of _data["webhooks"])
          this.webhooks!.push(item);
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): GetAllSubscriptionsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetAllSubscriptionsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["webhookUri"] = this.webhookUri;
    data["isActive"] = this.isActive;
    if (Array.isArray(this.webhooks)) {
      data["webhooks"] = [];
      for (let item of this.webhooks)
        data["webhooks"].push(item);
    }
    data["id"] = this.id;
    return data;
  }
}

export interface IGetAllSubscriptionsOutput {
  webhookUri: string | undefined;
  isActive: boolean;
  webhooks: string[] | undefined;
  id: string;
}

export class GetAvailabilityStatusForEditOutput implements IGetAvailabilityStatusForEditOutput {
  availabilityStatus!: CreateOrEditAvailabilityStatusDto;

  constructor(data?: IGetAvailabilityStatusForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.availabilityStatus = _data["availabilityStatus"] ? CreateOrEditAvailabilityStatusDto.fromJS(_data["availabilityStatus"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetAvailabilityStatusForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetAvailabilityStatusForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["availabilityStatus"] = this.availabilityStatus ? this.availabilityStatus.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetAvailabilityStatusForEditOutput {
  availabilityStatus: CreateOrEditAvailabilityStatusDto;
}

export class GetAvailabilityStatusForViewDto implements IGetAvailabilityStatusForViewDto {
  availabilityStatus!: AvailabilityStatusDto;

  constructor(data?: IGetAvailabilityStatusForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.availabilityStatus = _data["availabilityStatus"] ? AvailabilityStatusDto.fromJS(_data["availabilityStatus"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetAvailabilityStatusForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetAvailabilityStatusForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["availabilityStatus"] = this.availabilityStatus ? this.availabilityStatus.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetAvailabilityStatusForViewDto {
  availabilityStatus: AvailabilityStatusDto;
}

export class GetBookTypeForEditOutput implements IGetBookTypeForEditOutput {
  bookType!: CreateOrEditBookTypeDto;

  constructor(data?: IGetBookTypeForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookType = _data["bookType"] ? CreateOrEditBookTypeDto.fromJS(_data["bookType"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetBookTypeForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetBookTypeForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["bookType"] = this.bookType ? this.bookType.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetBookTypeForEditOutput {
  bookType: CreateOrEditBookTypeDto;
}

export class GetBookTypeForViewDto implements IGetBookTypeForViewDto {
  bookType!: BookTypeDto;

  constructor(data?: IGetBookTypeForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookType = _data["bookType"] ? BookTypeDto.fromJS(_data["bookType"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetBookTypeForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetBookTypeForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["bookType"] = this.bookType ? this.bookType.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetBookTypeForViewDto {
  bookType: BookTypeDto;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
  user!: UserLoginInfoDto;
  impersonatorUser!: UserLoginInfoDto;
  tenant!: TenantLoginInfoDto;
  impersonatorTenant!: TenantLoginInfoDto;
  application!: ApplicationInfoDto;
  theme!: UiCustomizationSettingsDto;

  constructor(data?: IGetCurrentLoginInformationsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
      this.impersonatorUser = _data["impersonatorUser"] ? UserLoginInfoDto.fromJS(_data["impersonatorUser"]) : <any>undefined;
      this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
      this.impersonatorTenant = _data["impersonatorTenant"] ? TenantLoginInfoDto.fromJS(_data["impersonatorTenant"]) : <any>undefined;
      this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
      this.theme = _data["theme"] ? UiCustomizationSettingsDto.fromJS(_data["theme"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetCurrentLoginInformationsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetCurrentLoginInformationsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["user"] = this.user ? this.user.toJSON() : <any>undefined;
    data["impersonatorUser"] = this.impersonatorUser ? this.impersonatorUser.toJSON() : <any>undefined;
    data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
    data["impersonatorTenant"] = this.impersonatorTenant ? this.impersonatorTenant.toJSON() : <any>undefined;
    data["application"] = this.application ? this.application.toJSON() : <any>undefined;
    data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetCurrentLoginInformationsOutput {
  user: UserLoginInfoDto;
  impersonatorUser: UserLoginInfoDto;
  tenant: TenantLoginInfoDto;
  impersonatorTenant: TenantLoginInfoDto;
  application: ApplicationInfoDto;
  theme: UiCustomizationSettingsDto;
}

export class GetDailySalesOutput implements IGetDailySalesOutput {
  dailySales!: number[] | undefined;

  constructor(data?: IGetDailySalesOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["dailySales"])) {
        this.dailySales = [] as any;
        for (let item of _data["dailySales"])
          this.dailySales!.push(item);
      }
    }
  }

  static fromJS(data: any): GetDailySalesOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetDailySalesOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.dailySales)) {
      data["dailySales"] = [];
      for (let item of this.dailySales)
        data["dailySales"].push(item);
    }
    return data;
  }
}

export interface IGetDailySalesOutput {
  dailySales: number[] | undefined;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
  totalProfit!: number;
  newFeedbacks!: number;
  newOrders!: number;
  newUsers!: number;
  salesSummary!: SalesSummaryData[] | undefined;
  totalSales!: number;
  revenue!: number;
  expenses!: number;
  growth!: number;
  transactionPercent!: number;
  newVisitPercent!: number;
  bouncePercent!: number;
  dailySales!: number[] | undefined;
  profitShares!: number[] | undefined;

  constructor(data?: IGetDashboardDataOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalProfit = _data["totalProfit"];
      this.newFeedbacks = _data["newFeedbacks"];
      this.newOrders = _data["newOrders"];
      this.newUsers = _data["newUsers"];
      if (Array.isArray(_data["salesSummary"])) {
        this.salesSummary = [] as any;
        for (let item of _data["salesSummary"])
          this.salesSummary!.push(SalesSummaryData.fromJS(item));
      }
      this.totalSales = _data["totalSales"];
      this.revenue = _data["revenue"];
      this.expenses = _data["expenses"];
      this.growth = _data["growth"];
      this.transactionPercent = _data["transactionPercent"];
      this.newVisitPercent = _data["newVisitPercent"];
      this.bouncePercent = _data["bouncePercent"];
      if (Array.isArray(_data["dailySales"])) {
        this.dailySales = [] as any;
        for (let item of _data["dailySales"])
          this.dailySales!.push(item);
      }
      if (Array.isArray(_data["profitShares"])) {
        this.profitShares = [] as any;
        for (let item of _data["profitShares"])
          this.profitShares!.push(item);
      }
    }
  }

  static fromJS(data: any): GetDashboardDataOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetDashboardDataOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalProfit"] = this.totalProfit;
    data["newFeedbacks"] = this.newFeedbacks;
    data["newOrders"] = this.newOrders;
    data["newUsers"] = this.newUsers;
    if (Array.isArray(this.salesSummary)) {
      data["salesSummary"] = [];
      for (let item of this.salesSummary)
        data["salesSummary"].push(item.toJSON());
    }
    data["totalSales"] = this.totalSales;
    data["revenue"] = this.revenue;
    data["expenses"] = this.expenses;
    data["growth"] = this.growth;
    data["transactionPercent"] = this.transactionPercent;
    data["newVisitPercent"] = this.newVisitPercent;
    data["bouncePercent"] = this.bouncePercent;
    if (Array.isArray(this.dailySales)) {
      data["dailySales"] = [];
      for (let item of this.dailySales)
        data["dailySales"].push(item);
    }
    if (Array.isArray(this.profitShares)) {
      data["profitShares"] = [];
      for (let item of this.profitShares)
        data["profitShares"].push(item);
    }
    return data;
  }
}

export interface IGetDashboardDataOutput {
  totalProfit: number;
  newFeedbacks: number;
  newOrders: number;
  newUsers: number;
  salesSummary: SalesSummaryData[] | undefined;
  totalSales: number;
  revenue: number;
  expenses: number;
  growth: number;
  transactionPercent: number;
  newVisitPercent: number;
  bouncePercent: number;
  dailySales: number[] | undefined;
  profitShares: number[] | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
  name!: string | undefined;

  constructor(data?: IGetDefaultEditionNameOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): GetDefaultEditionNameOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetDefaultEditionNameOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    return data;
  }
}

export interface IGetDefaultEditionNameOutput {
  name: string | undefined;
}

export class GetDistrictForEditOutput implements IGetDistrictForEditOutput {
  district!: CreateOrEditDistrictDto;
  provinceName!: string | undefined;

  constructor(data?: IGetDistrictForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.district = _data["district"] ? CreateOrEditDistrictDto.fromJS(_data["district"]) : <any>undefined;
      this.provinceName = _data["provinceName"];
    }
  }

  static fromJS(data: any): GetDistrictForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetDistrictForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["district"] = this.district ? this.district.toJSON() : <any>undefined;
    data["provinceName"] = this.provinceName;
    return data;
  }
}

export interface IGetDistrictForEditOutput {
  district: CreateOrEditDistrictDto;
  provinceName: string | undefined;
}

export class GetDistrictForViewDto implements IGetDistrictForViewDto {
  district!: DistrictDto;
  provinceName!: string | undefined;

  constructor(data?: IGetDistrictForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.district = _data["district"] ? DistrictDto.fromJS(_data["district"]) : <any>undefined;
      this.provinceName = _data["provinceName"];
    }
  }

  static fromJS(data: any): GetDistrictForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetDistrictForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["district"] = this.district ? this.district.toJSON() : <any>undefined;
    data["provinceName"] = this.provinceName;
    return data;
  }
}

export interface IGetDistrictForViewDto {
  district: DistrictDto;
  provinceName: string | undefined;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
  edition!: EditionEditDto;
  featureValues!: NameValueDto[] | undefined;
  features!: FlatFeatureDto[] | undefined;

  constructor(data?: IGetEditionEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : <any>undefined;
      if (Array.isArray(_data["featureValues"])) {
        this.featureValues = [] as any;
        for (let item of _data["featureValues"])
          this.featureValues!.push(NameValueDto.fromJS(item));
      }
      if (Array.isArray(_data["features"])) {
        this.features = [] as any;
        for (let item of _data["features"])
          this.features!.push(FlatFeatureDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetEditionEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetEditionEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
    if (Array.isArray(this.featureValues)) {
      data["featureValues"] = [];
      for (let item of this.featureValues)
        data["featureValues"].push(item.toJSON());
    }
    if (Array.isArray(this.features)) {
      data["features"] = [];
      for (let item of this.features)
        data["features"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetEditionEditOutput {
  edition: EditionEditDto;
  featureValues: NameValueDto[] | undefined;
  features: FlatFeatureDto[] | undefined;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
  editionStatistics!: TenantEdition[] | undefined;

  constructor(data?: IGetEditionTenantStatisticsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["editionStatistics"])) {
        this.editionStatistics = [] as any;
        for (let item of _data["editionStatistics"])
          this.editionStatistics!.push(TenantEdition.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetEditionTenantStatisticsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetEditionTenantStatisticsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.editionStatistics)) {
      data["editionStatistics"] = [];
      for (let item of this.editionStatistics)
        data["editionStatistics"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetEditionTenantStatisticsOutput {
  editionStatistics: TenantEdition[] | undefined;
}

export class GetEducationStatusForEditOutput implements IGetEducationStatusForEditOutput {
  educationStatus!: CreateOrEditEducationStatusDto;

  constructor(data?: IGetEducationStatusForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.educationStatus = _data["educationStatus"] ? CreateOrEditEducationStatusDto.fromJS(_data["educationStatus"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetEducationStatusForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetEducationStatusForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["educationStatus"] = this.educationStatus ? this.educationStatus.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetEducationStatusForEditOutput {
  educationStatus: CreateOrEditEducationStatusDto;
}

export class GetEducationStatusForViewDto implements IGetEducationStatusForViewDto {
  educationStatus!: EducationStatusDto;

  constructor(data?: IGetEducationStatusForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.educationStatus = _data["educationStatus"] ? EducationStatusDto.fromJS(_data["educationStatus"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetEducationStatusForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetEducationStatusForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["educationStatus"] = this.educationStatus ? this.educationStatus.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetEducationStatusForViewDto {
  educationStatus: EducationStatusDto;
}

export class GetEducationTypeForEditOutput implements IGetEducationTypeForEditOutput {
  educationType!: CreateOrEditEducationTypeDto;

  constructor(data?: IGetEducationTypeForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.educationType = _data["educationType"] ? CreateOrEditEducationTypeDto.fromJS(_data["educationType"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetEducationTypeForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetEducationTypeForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["educationType"] = this.educationType ? this.educationType.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetEducationTypeForEditOutput {
  educationType: CreateOrEditEducationTypeDto;
}

export class GetEducationTypeForViewDto implements IGetEducationTypeForViewDto {
  educationType!: EducationTypeDto;

  constructor(data?: IGetEducationTypeForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.educationType = _data["educationType"] ? EducationTypeDto.fromJS(_data["educationType"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetEducationTypeForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetEducationTypeForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["educationType"] = this.educationType ? this.educationType.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetEducationTypeForViewDto {
  educationType: EducationTypeDto;
}

export class GetEventCalendarDetailForEditOutput implements IGetEventCalendarDetailForEditOutput {
  eventCalendarDetail!: CreateOrEditEventCalendarDetailDto;
  orphanEventTypeName!: string | undefined;
  provinceName!: string | undefined;

  constructor(data?: IGetEventCalendarDetailForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.eventCalendarDetail = _data["eventCalendarDetail"] ? CreateOrEditEventCalendarDetailDto.fromJS(_data["eventCalendarDetail"]) : <any>undefined;
      this.orphanEventTypeName = _data["orphanEventTypeName"];
      this.provinceName = _data["provinceName"];
    }
  }

  static fromJS(data: any): GetEventCalendarDetailForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetEventCalendarDetailForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["eventCalendarDetail"] = this.eventCalendarDetail ? this.eventCalendarDetail.toJSON() : <any>undefined;
    data["orphanEventTypeName"] = this.orphanEventTypeName;
    data["provinceName"] = this.provinceName;
    return data;
  }
}

export interface IGetEventCalendarDetailForEditOutput {
  eventCalendarDetail: CreateOrEditEventCalendarDetailDto;
  orphanEventTypeName: string | undefined;
  provinceName: string | undefined;
}

export class GetEventCalendarDetailForViewDto implements IGetEventCalendarDetailForViewDto {
  eventCalendarDetail!: EventCalendarDetailDto;
  orphanEventTypeName!: string | undefined;
  provinceName!: string | undefined;

  constructor(data?: IGetEventCalendarDetailForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.eventCalendarDetail = _data["eventCalendarDetail"] ? EventCalendarDetailDto.fromJS(_data["eventCalendarDetail"]) : <any>undefined;
      this.orphanEventTypeName = _data["orphanEventTypeName"];
      this.provinceName = _data["provinceName"];
    }
  }

  static fromJS(data: any): GetEventCalendarDetailForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetEventCalendarDetailForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["eventCalendarDetail"] = this.eventCalendarDetail ? this.eventCalendarDetail.toJSON() : <any>undefined;
    data["orphanEventTypeName"] = this.orphanEventTypeName;
    data["provinceName"] = this.provinceName;
    return data;
  }
}

export interface IGetEventCalendarDetailForViewDto {
  eventCalendarDetail: EventCalendarDetailDto;
  orphanEventTypeName: string | undefined;
  provinceName: string | undefined;
}

export class GetExpiringTenantsOutput implements IGetExpiringTenantsOutput {
  expiringTenants!: ExpiringTenant[] | undefined;
  subscriptionEndAlertDayCount!: number;
  maxExpiringTenantsShownCount!: number;
  subscriptionEndDateStart!: DateTime;
  subscriptionEndDateEnd!: DateTime;

  constructor(data?: IGetExpiringTenantsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["expiringTenants"])) {
        this.expiringTenants = [] as any;
        for (let item of _data["expiringTenants"])
          this.expiringTenants!.push(ExpiringTenant.fromJS(item));
      }
      this.subscriptionEndAlertDayCount = _data["subscriptionEndAlertDayCount"];
      this.maxExpiringTenantsShownCount = _data["maxExpiringTenantsShownCount"];
      this.subscriptionEndDateStart = _data["subscriptionEndDateStart"] ? DateTime.fromISO(_data["subscriptionEndDateStart"].toString()) : <any>undefined;
      this.subscriptionEndDateEnd = _data["subscriptionEndDateEnd"] ? DateTime.fromISO(_data["subscriptionEndDateEnd"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): GetExpiringTenantsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetExpiringTenantsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.expiringTenants)) {
      data["expiringTenants"] = [];
      for (let item of this.expiringTenants)
        data["expiringTenants"].push(item.toJSON());
    }
    data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
    data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
    data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toString() : <any>undefined;
    data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toString() : <any>undefined;
    return data;
  }
}

export interface IGetExpiringTenantsOutput {
  expiringTenants: ExpiringTenant[] | undefined;
  subscriptionEndAlertDayCount: number;
  maxExpiringTenantsShownCount: number;
  subscriptionEndDateStart: DateTime;
  subscriptionEndDateEnd: DateTime;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
  transactionPercent!: number;
  newVisitPercent!: number;
  bouncePercent!: number;

  constructor(data?: IGetGeneralStatsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transactionPercent = _data["transactionPercent"];
      this.newVisitPercent = _data["newVisitPercent"];
      this.bouncePercent = _data["bouncePercent"];
    }
  }

  static fromJS(data: any): GetGeneralStatsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetGeneralStatsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["transactionPercent"] = this.transactionPercent;
    data["newVisitPercent"] = this.newVisitPercent;
    data["bouncePercent"] = this.bouncePercent;
    return data;
  }
}

export interface IGetGeneralStatsOutput {
  transactionPercent: number;
  newVisitPercent: number;
  bouncePercent: number;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
  incomeStatistics!: IncomeStastistic[] | undefined;

  constructor(data?: IGetIncomeStatisticsDataOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["incomeStatistics"])) {
        this.incomeStatistics = [] as any;
        for (let item of _data["incomeStatistics"])
          this.incomeStatistics!.push(IncomeStastistic.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetIncomeStatisticsDataOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetIncomeStatisticsDataOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.incomeStatistics)) {
      data["incomeStatistics"] = [];
      for (let item of this.incomeStatistics)
        data["incomeStatistics"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetIncomeStatisticsDataOutput {
  incomeStatistics: IncomeStastistic[] | undefined;
}

export class GetJobApplicationForEditOutput implements IGetJobApplicationForEditOutput {
  jobApplication!: CreateOrEditJobApplicationDto;
  orphanFirstName!: string | undefined;
  jobStatusName!: string | undefined;

  constructor(data?: IGetJobApplicationForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobApplication = _data["jobApplication"] ? CreateOrEditJobApplicationDto.fromJS(_data["jobApplication"]) : <any>undefined;
      this.orphanFirstName = _data["orphanFirstName"];
      this.jobStatusName = _data["jobStatusName"];
    }
  }

  static fromJS(data: any): GetJobApplicationForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetJobApplicationForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobApplication"] = this.jobApplication ? this.jobApplication.toJSON() : <any>undefined;
    data["orphanFirstName"] = this.orphanFirstName;
    data["jobStatusName"] = this.jobStatusName;
    return data;
  }
}

export interface IGetJobApplicationForEditOutput {
  jobApplication: CreateOrEditJobApplicationDto;
  orphanFirstName: string | undefined;
  jobStatusName: string | undefined;
}

export class GetJobApplicationForViewDto implements IGetJobApplicationForViewDto {
  jobApplication!: JobApplicationDto;
  orphanFirstName!: string | undefined;
  jobStatusName!: string | undefined;

  constructor(data?: IGetJobApplicationForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobApplication = _data["jobApplication"] ? JobApplicationDto.fromJS(_data["jobApplication"]) : <any>undefined;
      this.orphanFirstName = _data["orphanFirstName"];
      this.jobStatusName = _data["jobStatusName"];
    }
  }

  static fromJS(data: any): GetJobApplicationForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetJobApplicationForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobApplication"] = this.jobApplication ? this.jobApplication.toJSON() : <any>undefined;
    data["orphanFirstName"] = this.orphanFirstName;
    data["jobStatusName"] = this.jobStatusName;
    return data;
  }
}

export interface IGetJobApplicationForViewDto {
  jobApplication: JobApplicationDto;
  orphanFirstName: string | undefined;
  jobStatusName: string | undefined;
}

export class GetJobStatusForEditOutput implements IGetJobStatusForEditOutput {
  jobStatus!: CreateOrEditJobStatusDto;

  constructor(data?: IGetJobStatusForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobStatus = _data["jobStatus"] ? CreateOrEditJobStatusDto.fromJS(_data["jobStatus"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetJobStatusForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetJobStatusForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobStatus"] = this.jobStatus ? this.jobStatus.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetJobStatusForEditOutput {
  jobStatus: CreateOrEditJobStatusDto;
}

export class GetJobStatusForViewDto implements IGetJobStatusForViewDto {
  jobStatus!: JobStatusDto;

  constructor(data?: IGetJobStatusForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobStatus = _data["jobStatus"] ? JobStatusDto.fromJS(_data["jobStatus"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetJobStatusForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetJobStatusForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobStatus"] = this.jobStatus ? this.jobStatus.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetJobStatusForViewDto {
  jobStatus: JobStatusDto;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
  language!: ApplicationLanguageEditDto;
  languageNames!: ComboboxItemDto[] | undefined;
  flags!: ComboboxItemDto[] | undefined;

  constructor(data?: IGetLanguageForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : <any>undefined;
      if (Array.isArray(_data["languageNames"])) {
        this.languageNames = [] as any;
        for (let item of _data["languageNames"])
          this.languageNames!.push(ComboboxItemDto.fromJS(item));
      }
      if (Array.isArray(_data["flags"])) {
        this.flags = [] as any;
        for (let item of _data["flags"])
          this.flags!.push(ComboboxItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetLanguageForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetLanguageForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["language"] = this.language ? this.language.toJSON() : <any>undefined;
    if (Array.isArray(this.languageNames)) {
      data["languageNames"] = [];
      for (let item of this.languageNames)
        data["languageNames"].push(item.toJSON());
    }
    if (Array.isArray(this.flags)) {
      data["flags"] = [];
      for (let item of this.flags)
        data["flags"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetLanguageForEditOutput {
  language: ApplicationLanguageEditDto;
  languageNames: ComboboxItemDto[] | undefined;
  flags: ComboboxItemDto[] | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
  defaultLanguageName!: string | undefined;
  items!: ApplicationLanguageListDto[] | undefined;

  constructor(data?: IGetLanguagesOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.defaultLanguageName = _data["defaultLanguageName"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(ApplicationLanguageListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetLanguagesOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetLanguagesOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["defaultLanguageName"] = this.defaultLanguageName;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetLanguagesOutput {
  defaultLanguageName: string | undefined;
  items: ApplicationLanguageListDto[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
  latestWebLogLines!: string[] | undefined;

  constructor(data?: IGetLatestWebLogsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["latestWebLogLines"])) {
        this.latestWebLogLines = [] as any;
        for (let item of _data["latestWebLogLines"])
          this.latestWebLogLines!.push(item);
      }
    }
  }

  static fromJS(data: any): GetLatestWebLogsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetLatestWebLogsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.latestWebLogLines)) {
      data["latestWebLogLines"] = [];
      for (let item of this.latestWebLogLines)
        data["latestWebLogLines"].push(item);
    }
    return data;
  }
}

export interface IGetLatestWebLogsOutput {
  latestWebLogLines: string[] | undefined;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
  memberActivities!: MemberActivity[] | undefined;

  constructor(data?: IGetMemberActivityOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["memberActivities"])) {
        this.memberActivities = [] as any;
        for (let item of _data["memberActivities"])
          this.memberActivities!.push(MemberActivity.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetMemberActivityOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetMemberActivityOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.memberActivities)) {
      data["memberActivities"] = [];
      for (let item of this.memberActivities)
        data["memberActivities"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetMemberActivityOutput {
  memberActivities: MemberActivity[] | undefined;
}

export class GetNeighborhoodForEditOutput implements IGetNeighborhoodForEditOutput {
  neighborhood!: CreateOrEditNeighborhoodDto;
  districtName!: string | undefined;

  constructor(data?: IGetNeighborhoodForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.neighborhood = _data["neighborhood"] ? CreateOrEditNeighborhoodDto.fromJS(_data["neighborhood"]) : <any>undefined;
      this.districtName = _data["districtName"];
    }
  }

  static fromJS(data: any): GetNeighborhoodForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetNeighborhoodForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["neighborhood"] = this.neighborhood ? this.neighborhood.toJSON() : <any>undefined;
    data["districtName"] = this.districtName;
    return data;
  }
}

export interface IGetNeighborhoodForEditOutput {
  neighborhood: CreateOrEditNeighborhoodDto;
  districtName: string | undefined;
}

export class GetNeighborhoodForViewDto implements IGetNeighborhoodForViewDto {
  neighborhood!: NeighborhoodDto;
  districtName!: string | undefined;

  constructor(data?: IGetNeighborhoodForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.neighborhood = _data["neighborhood"] ? NeighborhoodDto.fromJS(_data["neighborhood"]) : <any>undefined;
      this.districtName = _data["districtName"];
    }
  }

  static fromJS(data: any): GetNeighborhoodForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetNeighborhoodForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["neighborhood"] = this.neighborhood ? this.neighborhood.toJSON() : <any>undefined;
    data["districtName"] = this.districtName;
    return data;
  }
}

export interface IGetNeighborhoodForViewDto {
  neighborhood: NeighborhoodDto;
  districtName: string | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
  receiveNotifications!: boolean;
  notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

  constructor(data?: IGetNotificationSettingsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.receiveNotifications = _data["receiveNotifications"];
      if (Array.isArray(_data["notifications"])) {
        this.notifications = [] as any;
        for (let item of _data["notifications"])
          this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetNotificationSettingsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetNotificationSettingsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["receiveNotifications"] = this.receiveNotifications;
    if (Array.isArray(this.notifications)) {
      data["notifications"] = [];
      for (let item of this.notifications)
        data["notifications"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetNotificationSettingsOutput {
  receiveNotifications: boolean;
  notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
  unreadCount!: number;
  totalCount!: number;
  items!: UserNotification[] | undefined;

  constructor(data?: IGetNotificationsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.unreadCount = _data["unreadCount"];
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(UserNotification.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetNotificationsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetNotificationsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["unreadCount"] = this.unreadCount;
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetNotificationsOutput {
  unreadCount: number;
  totalCount: number;
  items: UserNotification[] | undefined;
}

export class GetOrphanBookDetailForEditOutput implements IGetOrphanBookDetailForEditOutput {
  orphanBookDetail!: CreateOrEditOrphanBookDetailDto;
  bookTypeName!: string | undefined;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanBookDetailForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanBookDetail = _data["orphanBookDetail"] ? CreateOrEditOrphanBookDetailDto.fromJS(_data["orphanBookDetail"]) : <any>undefined;
      this.bookTypeName = _data["bookTypeName"];
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanBookDetailForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanBookDetailForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanBookDetail"] = this.orphanBookDetail ? this.orphanBookDetail.toJSON() : <any>undefined;
    data["bookTypeName"] = this.bookTypeName;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanBookDetailForEditOutput {
  orphanBookDetail: CreateOrEditOrphanBookDetailDto;
  bookTypeName: string | undefined;
  orphanFirstName: string | undefined;
}

export class GetOrphanBookDetailForViewDto implements IGetOrphanBookDetailForViewDto {
  orphanBookDetail!: OrphanBookDetailDto;
  bookTypeName!: string | undefined;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanBookDetailForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanBookDetail = _data["orphanBookDetail"] ? OrphanBookDetailDto.fromJS(_data["orphanBookDetail"]) : <any>undefined;
      this.bookTypeName = _data["bookTypeName"];
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanBookDetailForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanBookDetailForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanBookDetail"] = this.orphanBookDetail ? this.orphanBookDetail.toJSON() : <any>undefined;
    data["bookTypeName"] = this.bookTypeName;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanBookDetailForViewDto {
  orphanBookDetail: OrphanBookDetailDto;
  bookTypeName: string | undefined;
  orphanFirstName: string | undefined;
}

export class GetOrphanClubDetailForEditOutput implements IGetOrphanClubDetailForEditOutput {
  orphanClubDetail!: CreateOrEditOrphanClubDetailDto;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanClubDetailForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanClubDetail = _data["orphanClubDetail"] ? CreateOrEditOrphanClubDetailDto.fromJS(_data["orphanClubDetail"]) : <any>undefined;
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanClubDetailForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanClubDetailForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanClubDetail"] = this.orphanClubDetail ? this.orphanClubDetail.toJSON() : <any>undefined;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanClubDetailForEditOutput {
  orphanClubDetail: CreateOrEditOrphanClubDetailDto;
  orphanFirstName: string | undefined;
}

export class GetOrphanClubDetailForViewDto implements IGetOrphanClubDetailForViewDto {
  orphanClubDetail!: OrphanClubDetailDto;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanClubDetailForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanClubDetail = _data["orphanClubDetail"] ? OrphanClubDetailDto.fromJS(_data["orphanClubDetail"]) : <any>undefined;
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanClubDetailForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanClubDetailForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanClubDetail"] = this.orphanClubDetail ? this.orphanClubDetail.toJSON() : <any>undefined;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanClubDetailForViewDto {
  orphanClubDetail: OrphanClubDetailDto;
  orphanFirstName: string | undefined;
}

export class GetOrphanEducationForEditOutput implements IGetOrphanEducationForEditOutput {
  orphanEducation!: CreateOrEditOrphanEducationDto;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanEducationForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanEducation = _data["orphanEducation"] ? CreateOrEditOrphanEducationDto.fromJS(_data["orphanEducation"]) : <any>undefined;
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanEducationForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanEducationForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanEducation"] = this.orphanEducation ? this.orphanEducation.toJSON() : <any>undefined;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanEducationForEditOutput {
  orphanEducation: CreateOrEditOrphanEducationDto;
  orphanFirstName: string | undefined;
}

export class GetOrphanEducationForViewDto implements IGetOrphanEducationForViewDto {
  orphanEducation!: OrphanEducationDto;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanEducationForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanEducation = _data["orphanEducation"] ? OrphanEducationDto.fromJS(_data["orphanEducation"]) : <any>undefined;
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanEducationForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanEducationForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanEducation"] = this.orphanEducation ? this.orphanEducation.toJSON() : <any>undefined;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanEducationForViewDto {
  orphanEducation: OrphanEducationDto;
  orphanFirstName: string | undefined;
}

export class GetOrphanEventTypeForEditOutput implements IGetOrphanEventTypeForEditOutput {
  orphanEventType!: CreateOrEditOrphanEventTypeDto;

  constructor(data?: IGetOrphanEventTypeForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanEventType = _data["orphanEventType"] ? CreateOrEditOrphanEventTypeDto.fromJS(_data["orphanEventType"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetOrphanEventTypeForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanEventTypeForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanEventType"] = this.orphanEventType ? this.orphanEventType.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetOrphanEventTypeForEditOutput {
  orphanEventType: CreateOrEditOrphanEventTypeDto;
}

export class GetOrphanEventTypeForViewDto implements IGetOrphanEventTypeForViewDto {
  orphanEventType!: OrphanEventTypeDto;

  constructor(data?: IGetOrphanEventTypeForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanEventType = _data["orphanEventType"] ? OrphanEventTypeDto.fromJS(_data["orphanEventType"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetOrphanEventTypeForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanEventTypeForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanEventType"] = this.orphanEventType ? this.orphanEventType.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetOrphanEventTypeForViewDto {
  orphanEventType: OrphanEventTypeDto;
}

export class GetOrphanExperienceForEditOutput implements IGetOrphanExperienceForEditOutput {
  orphanExperience!: CreateOrEditOrphanExperienceDto;
  provinceName!: string | undefined;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanExperienceForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanExperience = _data["orphanExperience"] ? CreateOrEditOrphanExperienceDto.fromJS(_data["orphanExperience"]) : <any>undefined;
      this.provinceName = _data["provinceName"];
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanExperienceForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanExperienceForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanExperience"] = this.orphanExperience ? this.orphanExperience.toJSON() : <any>undefined;
    data["provinceName"] = this.provinceName;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanExperienceForEditOutput {
  orphanExperience: CreateOrEditOrphanExperienceDto;
  provinceName: string | undefined;
  orphanFirstName: string | undefined;
}

export class GetOrphanExperienceForViewDto implements IGetOrphanExperienceForViewDto {
  orphanExperience!: OrphanExperienceDto;
  provinceName!: string | undefined;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanExperienceForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanExperience = _data["orphanExperience"] ? OrphanExperienceDto.fromJS(_data["orphanExperience"]) : <any>undefined;
      this.provinceName = _data["provinceName"];
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanExperienceForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanExperienceForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanExperience"] = this.orphanExperience ? this.orphanExperience.toJSON() : <any>undefined;
    data["provinceName"] = this.provinceName;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanExperienceForViewDto {
  orphanExperience: OrphanExperienceDto;
  provinceName: string | undefined;
  orphanFirstName: string | undefined;
}

export class GetOrphanForEditOutput implements IGetOrphanForEditOutput {
  orphan!: CreateOrEditOrphanDto;
  provinceName!: string | undefined;
  districtName!: string | undefined;
  neighborhoodName!: string | undefined;

  constructor(data?: IGetOrphanForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphan = _data["orphan"] ? CreateOrEditOrphanDto.fromJS(_data["orphan"]) : <any>undefined;
      this.provinceName = _data["provinceName"];
      this.districtName = _data["districtName"];
      this.neighborhoodName = _data["neighborhoodName"];
    }
  }

  static fromJS(data: any): GetOrphanForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphan"] = this.orphan ? this.orphan.toJSON() : <any>undefined;
    data["provinceName"] = this.provinceName;
    data["districtName"] = this.districtName;
    data["neighborhoodName"] = this.neighborhoodName;
    return data;
  }
}

export interface IGetOrphanForEditOutput {
  orphan: CreateOrEditOrphanDto;
  provinceName: string | undefined;
  districtName: string | undefined;
  neighborhoodName: string | undefined;
}

export class GetOrphanForViewDto implements IGetOrphanForViewDto {
  orphan!: OrphanDto;
  provinceName!: string | undefined;
  districtName!: string | undefined;
  neighborhoodName!: string | undefined;

  constructor(data?: IGetOrphanForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphan = _data["orphan"] ? OrphanDto.fromJS(_data["orphan"]) : <any>undefined;
      this.provinceName = _data["provinceName"];
      this.districtName = _data["districtName"];
      this.neighborhoodName = _data["neighborhoodName"];
    }
  }

  static fromJS(data: any): GetOrphanForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphan"] = this.orphan ? this.orphan.toJSON() : <any>undefined;
    data["provinceName"] = this.provinceName;
    data["districtName"] = this.districtName;
    data["neighborhoodName"] = this.neighborhoodName;
    return data;
  }
}

export interface IGetOrphanForViewDto {
  orphan: OrphanDto;
  provinceName: string | undefined;
  districtName: string | undefined;
  neighborhoodName: string | undefined;
}

export class GetOrphanInterestDetailForEditOutput implements IGetOrphanInterestDetailForEditOutput {
  orphanInterestDetail!: CreateOrEditOrphanInterestDetailDto;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanInterestDetailForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanInterestDetail = _data["orphanInterestDetail"] ? CreateOrEditOrphanInterestDetailDto.fromJS(_data["orphanInterestDetail"]) : <any>undefined;
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanInterestDetailForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanInterestDetailForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanInterestDetail"] = this.orphanInterestDetail ? this.orphanInterestDetail.toJSON() : <any>undefined;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanInterestDetailForEditOutput {
  orphanInterestDetail: CreateOrEditOrphanInterestDetailDto;
  orphanFirstName: string | undefined;
}

export class GetOrphanInterestDetailForViewDto implements IGetOrphanInterestDetailForViewDto {
  orphanInterestDetail!: OrphanInterestDetailDto;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanInterestDetailForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanInterestDetail = _data["orphanInterestDetail"] ? OrphanInterestDetailDto.fromJS(_data["orphanInterestDetail"]) : <any>undefined;
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanInterestDetailForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanInterestDetailForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanInterestDetail"] = this.orphanInterestDetail ? this.orphanInterestDetail.toJSON() : <any>undefined;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanInterestDetailForViewDto {
  orphanInterestDetail: OrphanInterestDetailDto;
  orphanFirstName: string | undefined;
}

export class GetOrphanLanguageDetailForEditOutput implements IGetOrphanLanguageDetailForEditOutput {
  orphanLanguageDetail!: CreateOrEditOrphanLanguageDetailDto;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanLanguageDetailForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanLanguageDetail = _data["orphanLanguageDetail"] ? CreateOrEditOrphanLanguageDetailDto.fromJS(_data["orphanLanguageDetail"]) : <any>undefined;
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanLanguageDetailForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanLanguageDetailForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanLanguageDetail"] = this.orphanLanguageDetail ? this.orphanLanguageDetail.toJSON() : <any>undefined;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanLanguageDetailForEditOutput {
  orphanLanguageDetail: CreateOrEditOrphanLanguageDetailDto;
  orphanFirstName: string | undefined;
}

export class GetOrphanLanguageDetailForViewDto implements IGetOrphanLanguageDetailForViewDto {
  orphanLanguageDetail!: OrphanLanguageDetailDto;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanLanguageDetailForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanLanguageDetail = _data["orphanLanguageDetail"] ? OrphanLanguageDetailDto.fromJS(_data["orphanLanguageDetail"]) : <any>undefined;
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanLanguageDetailForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanLanguageDetailForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanLanguageDetail"] = this.orphanLanguageDetail ? this.orphanLanguageDetail.toJSON() : <any>undefined;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanLanguageDetailForViewDto {
  orphanLanguageDetail: OrphanLanguageDetailDto;
  orphanFirstName: string | undefined;
}

export class GetOrphanProjectDetailForEditOutput implements IGetOrphanProjectDetailForEditOutput {
  orphanProjectDetail!: CreateOrEditOrphanProjectDetailDto;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanProjectDetailForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanProjectDetail = _data["orphanProjectDetail"] ? CreateOrEditOrphanProjectDetailDto.fromJS(_data["orphanProjectDetail"]) : <any>undefined;
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanProjectDetailForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanProjectDetailForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanProjectDetail"] = this.orphanProjectDetail ? this.orphanProjectDetail.toJSON() : <any>undefined;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanProjectDetailForEditOutput {
  orphanProjectDetail: CreateOrEditOrphanProjectDetailDto;
  orphanFirstName: string | undefined;
}

export class GetOrphanProjectDetailForViewDto implements IGetOrphanProjectDetailForViewDto {
  orphanProjectDetail!: OrphanProjectDetailDto;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanProjectDetailForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanProjectDetail = _data["orphanProjectDetail"] ? OrphanProjectDetailDto.fromJS(_data["orphanProjectDetail"]) : <any>undefined;
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanProjectDetailForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanProjectDetailForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanProjectDetail"] = this.orphanProjectDetail ? this.orphanProjectDetail.toJSON() : <any>undefined;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanProjectDetailForViewDto {
  orphanProjectDetail: OrphanProjectDetailDto;
  orphanFirstName: string | undefined;
}

export class GetOrphanSchoolForEditOutput implements IGetOrphanSchoolForEditOutput {
  orphanSchool!: CreateOrEditOrphanSchoolDto;
  provinceName!: string | undefined;
  educationTypeName!: string | undefined;
  availabilityStatusName!: string | undefined;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanSchoolForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanSchool = _data["orphanSchool"] ? CreateOrEditOrphanSchoolDto.fromJS(_data["orphanSchool"]) : <any>undefined;
      this.provinceName = _data["provinceName"];
      this.educationTypeName = _data["educationTypeName"];
      this.availabilityStatusName = _data["availabilityStatusName"];
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanSchoolForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanSchoolForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanSchool"] = this.orphanSchool ? this.orphanSchool.toJSON() : <any>undefined;
    data["provinceName"] = this.provinceName;
    data["educationTypeName"] = this.educationTypeName;
    data["availabilityStatusName"] = this.availabilityStatusName;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanSchoolForEditOutput {
  orphanSchool: CreateOrEditOrphanSchoolDto;
  provinceName: string | undefined;
  educationTypeName: string | undefined;
  availabilityStatusName: string | undefined;
  orphanFirstName: string | undefined;
}

export class GetOrphanSchoolForViewDto implements IGetOrphanSchoolForViewDto {
  orphanSchool!: OrphanSchoolDto;
  provinceName!: string | undefined;
  educationTypeName!: string | undefined;
  availabilityStatusName!: string | undefined;
  orphanFirstName!: string | undefined;

  constructor(data?: IGetOrphanSchoolForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanSchool = _data["orphanSchool"] ? OrphanSchoolDto.fromJS(_data["orphanSchool"]) : <any>undefined;
      this.provinceName = _data["provinceName"];
      this.educationTypeName = _data["educationTypeName"];
      this.availabilityStatusName = _data["availabilityStatusName"];
      this.orphanFirstName = _data["orphanFirstName"];
    }
  }

  static fromJS(data: any): GetOrphanSchoolForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrphanSchoolForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanSchool"] = this.orphanSchool ? this.orphanSchool.toJSON() : <any>undefined;
    data["provinceName"] = this.provinceName;
    data["educationTypeName"] = this.educationTypeName;
    data["availabilityStatusName"] = this.availabilityStatusName;
    data["orphanFirstName"] = this.orphanFirstName;
    return data;
  }
}

export interface IGetOrphanSchoolForViewDto {
  orphanSchool: OrphanSchoolDto;
  provinceName: string | undefined;
  educationTypeName: string | undefined;
  availabilityStatusName: string | undefined;
  orphanFirstName: string | undefined;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
  setting!: PasswordComplexitySetting;

  constructor(data?: IGetPasswordComplexitySettingOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.setting = _data["setting"] ? PasswordComplexitySetting.fromJS(_data["setting"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetPasswordComplexitySettingOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetPasswordComplexitySettingOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetPasswordComplexitySettingOutput {
  setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
  profilePicture!: string | undefined;

  constructor(data?: IGetProfilePictureOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profilePicture = _data["profilePicture"];
    }
  }

  static fromJS(data: any): GetProfilePictureOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetProfilePictureOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profilePicture"] = this.profilePicture;
    return data;
  }
}

export interface IGetProfilePictureOutput {
  profilePicture: string | undefined;
}

export class GetProfitShareOutput implements IGetProfitShareOutput {
  profitShares!: number[] | undefined;

  constructor(data?: IGetProfitShareOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["profitShares"])) {
        this.profitShares = [] as any;
        for (let item of _data["profitShares"])
          this.profitShares!.push(item);
      }
    }
  }

  static fromJS(data: any): GetProfitShareOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetProfitShareOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.profitShares)) {
      data["profitShares"] = [];
      for (let item of this.profitShares)
        data["profitShares"].push(item);
    }
    return data;
  }
}

export interface IGetProfitShareOutput {
  profitShares: number[] | undefined;
}

export class GetProvinceForEditOutput implements IGetProvinceForEditOutput {
  province!: CreateOrEditProvinceDto;

  constructor(data?: IGetProvinceForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.province = _data["province"] ? CreateOrEditProvinceDto.fromJS(_data["province"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetProvinceForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetProvinceForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["province"] = this.province ? this.province.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetProvinceForEditOutput {
  province: CreateOrEditProvinceDto;
}

export class GetProvinceForViewDto implements IGetProvinceForViewDto {
  province!: ProvinceDto;

  constructor(data?: IGetProvinceForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.province = _data["province"] ? ProvinceDto.fromJS(_data["province"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetProvinceForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetProvinceForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["province"] = this.province ? this.province.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetProvinceForViewDto {
  province: ProvinceDto;
}

export class GetRecentTenantsOutput implements IGetRecentTenantsOutput {
  recentTenantsDayCount!: number;
  maxRecentTenantsShownCount!: number;
  tenantCreationStartDate!: DateTime;
  recentTenants!: RecentTenant[] | undefined;

  constructor(data?: IGetRecentTenantsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.recentTenantsDayCount = _data["recentTenantsDayCount"];
      this.maxRecentTenantsShownCount = _data["maxRecentTenantsShownCount"];
      this.tenantCreationStartDate = _data["tenantCreationStartDate"] ? DateTime.fromISO(_data["tenantCreationStartDate"].toString()) : <any>undefined;
      if (Array.isArray(_data["recentTenants"])) {
        this.recentTenants = [] as any;
        for (let item of _data["recentTenants"])
          this.recentTenants!.push(RecentTenant.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetRecentTenantsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecentTenantsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["recentTenantsDayCount"] = this.recentTenantsDayCount;
    data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
    data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toString() : <any>undefined;
    if (Array.isArray(this.recentTenants)) {
      data["recentTenants"] = [];
      for (let item of this.recentTenants)
        data["recentTenants"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetRecentTenantsOutput {
  recentTenantsDayCount: number;
  maxRecentTenantsShownCount: number;
  tenantCreationStartDate: DateTime;
  recentTenants: RecentTenant[] | undefined;
}

export class GetRegionalStatsOutput implements IGetRegionalStatsOutput {
  stats!: RegionalStatCountry[] | undefined;

  constructor(data?: IGetRegionalStatsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["stats"])) {
        this.stats = [] as any;
        for (let item of _data["stats"])
          this.stats!.push(RegionalStatCountry.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetRegionalStatsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegionalStatsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.stats)) {
      data["stats"] = [];
      for (let item of this.stats)
        data["stats"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetRegionalStatsOutput {
  stats: RegionalStatCountry[] | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
  role!: RoleEditDto;
  permissions!: FlatPermissionDto[] | undefined;
  grantedPermissionNames!: string[] | undefined;

  constructor(data?: IGetRoleForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
      if (Array.isArray(_data["permissions"])) {
        this.permissions = [] as any;
        for (let item of _data["permissions"])
          this.permissions!.push(FlatPermissionDto.fromJS(item));
      }
      if (Array.isArray(_data["grantedPermissionNames"])) {
        this.grantedPermissionNames = [] as any;
        for (let item of _data["grantedPermissionNames"])
          this.grantedPermissionNames!.push(item);
      }
    }
  }

  static fromJS(data: any): GetRoleForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetRoleForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["role"] = this.role ? this.role.toJSON() : <any>undefined;
    if (Array.isArray(this.permissions)) {
      data["permissions"] = [];
      for (let item of this.permissions)
        data["permissions"].push(item.toJSON());
    }
    if (Array.isArray(this.grantedPermissionNames)) {
      data["grantedPermissionNames"] = [];
      for (let item of this.grantedPermissionNames)
        data["grantedPermissionNames"].push(item);
    }
    return data;
  }
}

export interface IGetRoleForEditOutput {
  role: RoleEditDto;
  permissions: FlatPermissionDto[] | undefined;
  grantedPermissionNames: string[] | undefined;
}

export class GetRolesInput implements IGetRolesInput {
  permissions!: string[] | undefined;

  constructor(data?: IGetRolesInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["permissions"])) {
        this.permissions = [] as any;
        for (let item of _data["permissions"])
          this.permissions!.push(item);
      }
    }
  }

  static fromJS(data: any): GetRolesInput {
    data = typeof data === 'object' ? data : {};
    let result = new GetRolesInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.permissions)) {
      data["permissions"] = [];
      for (let item of this.permissions)
        data["permissions"].push(item);
    }
    return data;
  }
}

export interface IGetRolesInput {
  permissions: string[] | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
  totalSales!: number;
  revenue!: number;
  expenses!: number;
  growth!: number;
  salesSummary!: SalesSummaryData[] | undefined;

  constructor(data?: IGetSalesSummaryOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalSales = _data["totalSales"];
      this.revenue = _data["revenue"];
      this.expenses = _data["expenses"];
      this.growth = _data["growth"];
      if (Array.isArray(_data["salesSummary"])) {
        this.salesSummary = [] as any;
        for (let item of _data["salesSummary"])
          this.salesSummary!.push(SalesSummaryData.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetSalesSummaryOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetSalesSummaryOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalSales"] = this.totalSales;
    data["revenue"] = this.revenue;
    data["expenses"] = this.expenses;
    data["growth"] = this.growth;
    if (Array.isArray(this.salesSummary)) {
      data["salesSummary"] = [];
      for (let item of this.salesSummary)
        data["salesSummary"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetSalesSummaryOutput {
  totalSales: number;
  revenue: number;
  expenses: number;
  growth: number;
  salesSummary: SalesSummaryData[] | undefined;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
  featureValues!: NameValueDto[] | undefined;
  features!: FlatFeatureDto[] | undefined;

  constructor(data?: IGetTenantFeaturesEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["featureValues"])) {
        this.featureValues = [] as any;
        for (let item of _data["featureValues"])
          this.featureValues!.push(NameValueDto.fromJS(item));
      }
      if (Array.isArray(_data["features"])) {
        this.features = [] as any;
        for (let item of _data["features"])
          this.features!.push(FlatFeatureDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetTenantFeaturesEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetTenantFeaturesEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.featureValues)) {
      data["featureValues"] = [];
      for (let item of this.featureValues)
        data["featureValues"].push(item.toJSON());
    }
    if (Array.isArray(this.features)) {
      data["features"] = [];
      for (let item of this.features)
        data["features"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetTenantFeaturesEditOutput {
  featureValues: NameValueDto[] | undefined;
  features: FlatFeatureDto[] | undefined;
}

export class GetTopStatsOutput implements IGetTopStatsOutput {
  totalProfit!: number;
  newFeedbacks!: number;
  newOrders!: number;
  newUsers!: number;

  constructor(data?: IGetTopStatsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalProfit = _data["totalProfit"];
      this.newFeedbacks = _data["newFeedbacks"];
      this.newOrders = _data["newOrders"];
      this.newUsers = _data["newUsers"];
    }
  }

  static fromJS(data: any): GetTopStatsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetTopStatsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalProfit"] = this.totalProfit;
    data["newFeedbacks"] = this.newFeedbacks;
    data["newOrders"] = this.newOrders;
    data["newUsers"] = this.newUsers;
    return data;
  }
}

export interface IGetTopStatsOutput {
  totalProfit: number;
  newFeedbacks: number;
  newOrders: number;
  newUsers: number;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
  serverTime!: DateTime;
  friends!: FriendDto[] | undefined;

  constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serverTime = _data["serverTime"] ? DateTime.fromISO(_data["serverTime"].toString()) : <any>undefined;
      if (Array.isArray(_data["friends"])) {
        this.friends = [] as any;
        for (let item of _data["friends"])
          this.friends!.push(FriendDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetUserChatFriendsWithSettingsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["serverTime"] = this.serverTime ? this.serverTime.toString() : <any>undefined;
    if (Array.isArray(this.friends)) {
      data["friends"] = [];
      for (let item of this.friends)
        data["friends"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetUserChatFriendsWithSettingsOutput {
  serverTime: DateTime;
  friends: FriendDto[] | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
  profilePictureId!: string | undefined;
  user!: UserEditDto;
  roles!: UserRoleDto[] | undefined;
  allOrganizationUnits!: OrganizationUnitDto[] | undefined;
  memberedOrganizationUnits!: string[] | undefined;

  constructor(data?: IGetUserForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profilePictureId = _data["profilePictureId"];
      this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
      if (Array.isArray(_data["roles"])) {
        this.roles = [] as any;
        for (let item of _data["roles"])
          this.roles!.push(UserRoleDto.fromJS(item));
      }
      if (Array.isArray(_data["allOrganizationUnits"])) {
        this.allOrganizationUnits = [] as any;
        for (let item of _data["allOrganizationUnits"])
          this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
      }
      if (Array.isArray(_data["memberedOrganizationUnits"])) {
        this.memberedOrganizationUnits = [] as any;
        for (let item of _data["memberedOrganizationUnits"])
          this.memberedOrganizationUnits!.push(item);
      }
    }
  }

  static fromJS(data: any): GetUserForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetUserForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profilePictureId"] = this.profilePictureId;
    data["user"] = this.user ? this.user.toJSON() : <any>undefined;
    if (Array.isArray(this.roles)) {
      data["roles"] = [];
      for (let item of this.roles)
        data["roles"].push(item.toJSON());
    }
    if (Array.isArray(this.allOrganizationUnits)) {
      data["allOrganizationUnits"] = [];
      for (let item of this.allOrganizationUnits)
        data["allOrganizationUnits"].push(item.toJSON());
    }
    if (Array.isArray(this.memberedOrganizationUnits)) {
      data["memberedOrganizationUnits"] = [];
      for (let item of this.memberedOrganizationUnits)
        data["memberedOrganizationUnits"].push(item);
    }
    return data;
  }
}

export interface IGetUserForEditOutput {
  profilePictureId: string | undefined;
  user: UserEditDto;
  roles: UserRoleDto[] | undefined;
  allOrganizationUnits: OrganizationUnitDto[] | undefined;
  memberedOrganizationUnits: string[] | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
  permissions!: FlatPermissionDto[] | undefined;
  grantedPermissionNames!: string[] | undefined;

  constructor(data?: IGetUserPermissionsForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["permissions"])) {
        this.permissions = [] as any;
        for (let item of _data["permissions"])
          this.permissions!.push(FlatPermissionDto.fromJS(item));
      }
      if (Array.isArray(_data["grantedPermissionNames"])) {
        this.grantedPermissionNames = [] as any;
        for (let item of _data["grantedPermissionNames"])
          this.grantedPermissionNames!.push(item);
      }
    }
  }

  static fromJS(data: any): GetUserPermissionsForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetUserPermissionsForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.permissions)) {
      data["permissions"] = [];
      for (let item of this.permissions)
        data["permissions"].push(item.toJSON());
    }
    if (Array.isArray(this.grantedPermissionNames)) {
      data["grantedPermissionNames"] = [];
      for (let item of this.grantedPermissionNames)
        data["grantedPermissionNames"].push(item);
    }
    return data;
  }
}

export interface IGetUserPermissionsForEditOutput {
  permissions: FlatPermissionDto[] | undefined;
  grantedPermissionNames: string[] | undefined;
}

export class GetUsersInput implements IGetUsersInput {
  filter!: string | undefined;
  permissions!: string[] | undefined;
  role!: number | undefined;
  onlyLockedUsers!: boolean;
  sorting!: string | undefined;
  maxResultCount!: number;
  skipCount!: number;

  constructor(data?: IGetUsersInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.filter = _data["filter"];
      if (Array.isArray(_data["permissions"])) {
        this.permissions = [] as any;
        for (let item of _data["permissions"])
          this.permissions!.push(item);
      }
      this.role = _data["role"];
      this.onlyLockedUsers = _data["onlyLockedUsers"];
      this.sorting = _data["sorting"];
      this.maxResultCount = _data["maxResultCount"];
      this.skipCount = _data["skipCount"];
    }
  }

  static fromJS(data: any): GetUsersInput {
    data = typeof data === 'object' ? data : {};
    let result = new GetUsersInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["filter"] = this.filter;
    if (Array.isArray(this.permissions)) {
      data["permissions"] = [];
      for (let item of this.permissions)
        data["permissions"].push(item);
    }
    data["role"] = this.role;
    data["onlyLockedUsers"] = this.onlyLockedUsers;
    data["sorting"] = this.sorting;
    data["maxResultCount"] = this.maxResultCount;
    data["skipCount"] = this.skipCount;
    return data;
  }
}

export interface IGetUsersInput {
  filter: string | undefined;
  permissions: string[] | undefined;
  role: number | undefined;
  onlyLockedUsers: boolean;
  sorting: string | undefined;
  maxResultCount: number;
  skipCount: number;
}

export class GetWorkJobForEditOutput implements IGetWorkJobForEditOutput {
  workJob!: CreateOrEditWorkJobDto;

  constructor(data?: IGetWorkJobForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.workJob = _data["workJob"] ? CreateOrEditWorkJobDto.fromJS(_data["workJob"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetWorkJobForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetWorkJobForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["workJob"] = this.workJob ? this.workJob.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetWorkJobForEditOutput {
  workJob: CreateOrEditWorkJobDto;
}

export class GetWorkJobForViewDto implements IGetWorkJobForViewDto {
  workJob!: WorkJobDto;

  constructor(data?: IGetWorkJobForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.workJob = _data["workJob"] ? WorkJobDto.fromJS(_data["workJob"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetWorkJobForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetWorkJobForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["workJob"] = this.workJob ? this.workJob.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetWorkJobForViewDto {
  workJob: WorkJobDto;
}

export class GoogleExternalLoginProviderSettings implements IGoogleExternalLoginProviderSettings {
  clientId!: string | undefined;
  clientSecret!: string | undefined;
  userInfoEndpoint!: string | undefined;

  constructor(data?: IGoogleExternalLoginProviderSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data["clientId"];
      this.clientSecret = _data["clientSecret"];
      this.userInfoEndpoint = _data["userInfoEndpoint"];
    }
  }

  static fromJS(data: any): GoogleExternalLoginProviderSettings {
    data = typeof data === 'object' ? data : {};
    let result = new GoogleExternalLoginProviderSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["clientId"] = this.clientId;
    data["clientSecret"] = this.clientSecret;
    data["userInfoEndpoint"] = this.userInfoEndpoint;
    return data;
  }
}

export interface IGoogleExternalLoginProviderSettings {
  clientId: string | undefined;
  clientSecret: string | undefined;
  userInfoEndpoint: string | undefined;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
  legalName!: string | undefined;
  address!: string | undefined;

  constructor(data?: IHostBillingSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.legalName = _data["legalName"];
      this.address = _data["address"];
    }
  }

  static fromJS(data: any): HostBillingSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new HostBillingSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["legalName"] = this.legalName;
    data["address"] = this.address;
    return data;
  }
}

export interface IHostBillingSettingsEditDto {
  legalName: string | undefined;
  address: string | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
  general!: GeneralSettingsEditDto;
  userManagement!: HostUserManagementSettingsEditDto;
  email!: EmailSettingsEditDto;
  tenantManagement!: TenantManagementSettingsEditDto;
  security!: SecuritySettingsEditDto;
  billing!: HostBillingSettingsEditDto;
  otherSettings!: OtherSettingsEditDto;
  externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

  constructor(data?: IHostSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.general = new GeneralSettingsEditDto();
      this.userManagement = new HostUserManagementSettingsEditDto();
      this.email = new EmailSettingsEditDto();
      this.tenantManagement = new TenantManagementSettingsEditDto();
      this.security = new SecuritySettingsEditDto();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : new GeneralSettingsEditDto();
      this.userManagement = _data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new HostUserManagementSettingsEditDto();
      this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"]) : new EmailSettingsEditDto();
      this.tenantManagement = _data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(_data["tenantManagement"]) : new TenantManagementSettingsEditDto();
      this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
      this.billing = _data["billing"] ? HostBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
      this.otherSettings = _data["otherSettings"] ? OtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
      this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
    }
  }

  static fromJS(data: any): HostSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new HostSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["general"] = this.general ? this.general.toJSON() : <any>undefined;
    data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
    data["email"] = this.email ? this.email.toJSON() : <any>undefined;
    data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
    data["security"] = this.security ? this.security.toJSON() : <any>undefined;
    data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
    data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
    data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
    return data;
  }
}

export interface IHostSettingsEditDto {
  general: GeneralSettingsEditDto;
  userManagement: HostUserManagementSettingsEditDto;
  email: EmailSettingsEditDto;
  tenantManagement: TenantManagementSettingsEditDto;
  security: SecuritySettingsEditDto;
  billing: HostBillingSettingsEditDto;
  otherSettings: OtherSettingsEditDto;
  externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
  isEmailConfirmationRequiredForLogin!: boolean;
  smsVerificationEnabled!: boolean;
  isCookieConsentEnabled!: boolean;
  isQuickThemeSelectEnabled!: boolean;
  useCaptchaOnLogin!: boolean;
  allowUsingGravatarProfilePicture!: boolean;
  sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;
  userPasswordSettings!: UserPasswordSettingsEditDto;

  constructor(data?: IHostUserManagementSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
      this.smsVerificationEnabled = _data["smsVerificationEnabled"];
      this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
      this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
      this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
      this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
      this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
      this.userPasswordSettings = _data["userPasswordSettings"] ? UserPasswordSettingsEditDto.fromJS(_data["userPasswordSettings"]) : <any>undefined;
    }
  }

  static fromJS(data: any): HostUserManagementSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new HostUserManagementSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
    data["smsVerificationEnabled"] = this.smsVerificationEnabled;
    data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
    data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
    data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
    data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
    data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
    data["userPasswordSettings"] = this.userPasswordSettings ? this.userPasswordSettings.toJSON() : <any>undefined;
    return data;
  }
}

export interface IHostUserManagementSettingsEditDto {
  isEmailConfirmationRequiredForLogin: boolean;
  smsVerificationEnabled: boolean;
  isCookieConsentEnabled: boolean;
  isQuickThemeSelectEnabled: boolean;
  useCaptchaOnLogin: boolean;
  allowUsingGravatarProfilePicture: boolean;
  sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
  userPasswordSettings: UserPasswordSettingsEditDto;
}

export enum HttpStatusCode {
  Continue = 100,
  SwitchingProtocols = 101,
  Processing = 102,
  EarlyHints = 103,
  OK = 200,
  Created = 201,
  Accepted = 202,
  NonAuthoritativeInformation = 203,
  NoContent = 204,
  ResetContent = 205,
  PartialContent = 206,
  MultiStatus = 207,
  AlreadyReported = 208,
  IMUsed = 226,
  MultipleChoices = 300,
  Ambiguous = 301,
  MovedPermanently = 302,
  Moved = 303,
  Found = 304,
  Redirect = 305,
  SeeOther = 306,
  RedirectMethod = 307,
  NotModified = 308,
  UseProxy = 400,
  Unused = 401,
  TemporaryRedirect = 402,
  RedirectKeepVerb = 403,
  PermanentRedirect = 404,
  BadRequest = 405,
  Unauthorized = 406,
  PaymentRequired = 407,
  Forbidden = 408,
  NotFound = 409,
  MethodNotAllowed = 410,
  NotAcceptable = 411,
  ProxyAuthenticationRequired = 412,
  RequestTimeout = 413,
  Conflict = 414,
  Gone = 415,
  LengthRequired = 416,
  PreconditionFailed = 417,
  RequestEntityTooLarge = 421,
  RequestUriTooLong = 422,
  UnsupportedMediaType = 423,
  RequestedRangeNotSatisfiable = 424,
  ExpectationFailed = 426,
  MisdirectedRequest = 428,
  UnprocessableEntity = 429,
  Locked = 431,
  FailedDependency = 451,
  UpgradeRequired = 500,
  PreconditionRequired = 501,
  TooManyRequests = 502,
  RequestHeaderFieldsTooLarge = 503,
  UnavailableForLegalReasons = 504,
  InternalServerError = 505,
  NotImplemented = 506,
  BadGateway = 507,
  ServiceUnavailable = 508,
  GatewayTimeout = 510,
  HttpVersionNotSupported = 511,
}

export class IInputType implements IIInputType {
  readonly name!: string | undefined;
  readonly attributes!: { [key: string]: any; } | undefined;
  validator!: IValueValidator;

  constructor(data?: IIInputType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).name = _data["name"];
      if (_data["attributes"]) {
        (<any>this).attributes = {} as any;
        for (let key in _data["attributes"]) {
          if (_data["attributes"].hasOwnProperty(key))
            (<any>(<any>this).attributes)![key] = _data["attributes"][key];
        }
      }
      this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
    }
  }

  static fromJS(data: any): IInputType {
    data = typeof data === 'object' ? data : {};
    let result = new IInputType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    if (this.attributes) {
      data["attributes"] = {};
      for (let key in this.attributes) {
        if (this.attributes.hasOwnProperty(key))
          (<any>data["attributes"])[key] = this.attributes[key];
      }
    }
    data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
    return data;
  }
}

export interface IIInputType {
  name: string | undefined;
  attributes: { [key: string]: any; } | undefined;
  validator: IValueValidator;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
  accessToken!: string | undefined;
  encryptedAccessToken!: string | undefined;
  expireInSeconds!: number;

  constructor(data?: IImpersonatedAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.encryptedAccessToken = _data["encryptedAccessToken"];
      this.expireInSeconds = _data["expireInSeconds"];
    }
  }

  static fromJS(data: any): ImpersonatedAuthenticateResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new ImpersonatedAuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["accessToken"] = this.accessToken;
    data["encryptedAccessToken"] = this.encryptedAccessToken;
    data["expireInSeconds"] = this.expireInSeconds;
    return data;
  }
}

export interface IImpersonatedAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
  impersonationToken!: string | undefined;
  tenancyName!: string | undefined;

  constructor(data?: IImpersonateOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.impersonationToken = _data["impersonationToken"];
      this.tenancyName = _data["tenancyName"];
    }
  }

  static fromJS(data: any): ImpersonateOutput {
    data = typeof data === 'object' ? data : {};
    let result = new ImpersonateOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["impersonationToken"] = this.impersonationToken;
    data["tenancyName"] = this.tenancyName;
    return data;
  }
}

export interface IImpersonateOutput {
  impersonationToken: string | undefined;
  tenancyName: string | undefined;
}

export class ImpersonateTenantInput implements IImpersonateTenantInput {
  tenantId!: number | undefined;
  userId!: number;

  constructor(data?: IImpersonateTenantInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.userId = _data["userId"];
    }
  }

  static fromJS(data: any): ImpersonateTenantInput {
    data = typeof data === 'object' ? data : {};
    let result = new ImpersonateTenantInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["userId"] = this.userId;
    return data;
  }
}

export interface IImpersonateTenantInput {
  tenantId: number | undefined;
  userId: number;
}

export class ImpersonateUserInput implements IImpersonateUserInput {
  tenantId!: number | undefined;
  userId!: number;

  constructor(data?: IImpersonateUserInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.userId = _data["userId"];
    }
  }

  static fromJS(data: any): ImpersonateUserInput {
    data = typeof data === 'object' ? data : {};
    let result = new ImpersonateUserInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["userId"] = this.userId;
    return data;
  }
}

export interface IImpersonateUserInput {
  tenantId: number | undefined;
  userId: number;
}

export class IncomeStastistic implements IIncomeStastistic {
  label!: string | undefined;
  date!: DateTime;
  amount!: number;

  constructor(data?: IIncomeStastistic) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.label = _data["label"];
      this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
      this.amount = _data["amount"];
    }
  }

  static fromJS(data: any): IncomeStastistic {
    data = typeof data === 'object' ? data : {};
    let result = new IncomeStastistic();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["label"] = this.label;
    data["date"] = this.date ? this.date.toString() : <any>undefined;
    data["amount"] = this.amount;
    return data;
  }
}

export interface IIncomeStastistic {
  label: string | undefined;
  date: DateTime;
  amount: number;
}

export class InsertOrUpdateAllValuesInput implements IInsertOrUpdateAllValuesInput {
  items!: InsertOrUpdateAllValuesInputItem[] | undefined;

  constructor(data?: IInsertOrUpdateAllValuesInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(InsertOrUpdateAllValuesInputItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): InsertOrUpdateAllValuesInput {
    data = typeof data === 'object' ? data : {};
    let result = new InsertOrUpdateAllValuesInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IInsertOrUpdateAllValuesInput {
  items: InsertOrUpdateAllValuesInputItem[] | undefined;
}

export class InsertOrUpdateAllValuesInputItem implements IInsertOrUpdateAllValuesInputItem {
  entityId!: string | undefined;
  dynamicEntityPropertyId!: number;
  values!: string[] | undefined;

  constructor(data?: IInsertOrUpdateAllValuesInputItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityId = _data["entityId"];
      this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
      if (Array.isArray(_data["values"])) {
        this.values = [] as any;
        for (let item of _data["values"])
          this.values!.push(item);
      }
    }
  }

  static fromJS(data: any): InsertOrUpdateAllValuesInputItem {
    data = typeof data === 'object' ? data : {};
    let result = new InsertOrUpdateAllValuesInputItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["entityId"] = this.entityId;
    data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
    if (Array.isArray(this.values)) {
      data["values"] = [];
      for (let item of this.values)
        data["values"].push(item);
    }
    return data;
  }
}

export interface IInsertOrUpdateAllValuesInputItem {
  entityId: string | undefined;
  dynamicEntityPropertyId: number;
  values: string[] | undefined;
}

export class InstallDto implements IInstallDto {
  connectionString!: string;
  adminPassword!: string;
  webSiteUrl!: string;
  serverUrl!: string | undefined;
  defaultLanguage!: string;
  smtpSettings!: EmailSettingsEditDto;
  billInfo!: HostBillingSettingsEditDto;

  constructor(data?: IInstallDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.connectionString = _data["connectionString"];
      this.adminPassword = _data["adminPassword"];
      this.webSiteUrl = _data["webSiteUrl"];
      this.serverUrl = _data["serverUrl"];
      this.defaultLanguage = _data["defaultLanguage"];
      this.smtpSettings = _data["smtpSettings"] ? EmailSettingsEditDto.fromJS(_data["smtpSettings"]) : <any>undefined;
      this.billInfo = _data["billInfo"] ? HostBillingSettingsEditDto.fromJS(_data["billInfo"]) : <any>undefined;
    }
  }

  static fromJS(data: any): InstallDto {
    data = typeof data === 'object' ? data : {};
    let result = new InstallDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["connectionString"] = this.connectionString;
    data["adminPassword"] = this.adminPassword;
    data["webSiteUrl"] = this.webSiteUrl;
    data["serverUrl"] = this.serverUrl;
    data["defaultLanguage"] = this.defaultLanguage;
    data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
    data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
    return data;
  }
}

export interface IInstallDto {
  connectionString: string;
  adminPassword: string;
  webSiteUrl: string;
  serverUrl: string | undefined;
  defaultLanguage: string;
  smtpSettings: EmailSettingsEditDto;
  billInfo: HostBillingSettingsEditDto;
}

export class InvoiceDto implements IInvoiceDto {
  amount!: number;
  editionDisplayName!: string | undefined;
  invoiceNo!: string | undefined;
  invoiceDate!: DateTime;
  tenantLegalName!: string | undefined;
  tenantAddress!: string[] | undefined;
  tenantTaxNo!: string | undefined;
  hostLegalName!: string | undefined;
  hostAddress!: string[] | undefined;

  constructor(data?: IInvoiceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.amount = _data["amount"];
      this.editionDisplayName = _data["editionDisplayName"];
      this.invoiceNo = _data["invoiceNo"];
      this.invoiceDate = _data["invoiceDate"] ? DateTime.fromISO(_data["invoiceDate"].toString()) : <any>undefined;
      this.tenantLegalName = _data["tenantLegalName"];
      if (Array.isArray(_data["tenantAddress"])) {
        this.tenantAddress = [] as any;
        for (let item of _data["tenantAddress"])
          this.tenantAddress!.push(item);
      }
      this.tenantTaxNo = _data["tenantTaxNo"];
      this.hostLegalName = _data["hostLegalName"];
      if (Array.isArray(_data["hostAddress"])) {
        this.hostAddress = [] as any;
        for (let item of _data["hostAddress"])
          this.hostAddress!.push(item);
      }
    }
  }

  static fromJS(data: any): InvoiceDto {
    data = typeof data === 'object' ? data : {};
    let result = new InvoiceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["amount"] = this.amount;
    data["editionDisplayName"] = this.editionDisplayName;
    data["invoiceNo"] = this.invoiceNo;
    data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toString() : <any>undefined;
    data["tenantLegalName"] = this.tenantLegalName;
    if (Array.isArray(this.tenantAddress)) {
      data["tenantAddress"] = [];
      for (let item of this.tenantAddress)
        data["tenantAddress"].push(item);
    }
    data["tenantTaxNo"] = this.tenantTaxNo;
    data["hostLegalName"] = this.hostLegalName;
    if (Array.isArray(this.hostAddress)) {
      data["hostAddress"] = [];
      for (let item of this.hostAddress)
        data["hostAddress"].push(item);
    }
    return data;
  }
}

export interface IInvoiceDto {
  amount: number;
  editionDisplayName: string | undefined;
  invoiceNo: string | undefined;
  invoiceDate: DateTime;
  tenantLegalName: string | undefined;
  tenantAddress: string[] | undefined;
  tenantTaxNo: string | undefined;
  hostLegalName: string | undefined;
  hostAddress: string[] | undefined;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
  tenancyName!: string;

  constructor(data?: IIsTenantAvailableInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
    }
  }

  static fromJS(data: any): IsTenantAvailableInput {
    data = typeof data === 'object' ? data : {};
    let result = new IsTenantAvailableInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenancyName"] = this.tenancyName;
    return data;
  }
}

export interface IIsTenantAvailableInput {
  tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
  state!: TenantAvailabilityState;
  tenantId!: number | undefined;
  serverRootAddress!: string | undefined;

  constructor(data?: IIsTenantAvailableOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.state = _data["state"];
      this.tenantId = _data["tenantId"];
      this.serverRootAddress = _data["serverRootAddress"];
    }
  }

  static fromJS(data: any): IsTenantAvailableOutput {
    data = typeof data === 'object' ? data : {};
    let result = new IsTenantAvailableOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["state"] = this.state;
    data["tenantId"] = this.tenantId;
    data["serverRootAddress"] = this.serverRootAddress;
    return data;
  }
}

export interface IIsTenantAvailableOutput {
  state: TenantAvailabilityState;
  tenantId: number | undefined;
  serverRootAddress: string | undefined;
}

export class IValueValidator implements IIValueValidator {
  readonly name!: string | undefined;
  readonly attributes!: { [key: string]: any; } | undefined;

  constructor(data?: IIValueValidator) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).name = _data["name"];
      if (_data["attributes"]) {
        (<any>this).attributes = {} as any;
        for (let key in _data["attributes"]) {
          if (_data["attributes"].hasOwnProperty(key))
            (<any>(<any>this).attributes)![key] = _data["attributes"][key];
        }
      }
    }
  }

  static fromJS(data: any): IValueValidator {
    data = typeof data === 'object' ? data : {};
    let result = new IValueValidator();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    if (this.attributes) {
      data["attributes"] = {};
      for (let key in this.attributes) {
        if (this.attributes.hasOwnProperty(key))
          (<any>data["attributes"])[key] = this.attributes[key];
      }
    }
    return data;
  }
}

export interface IIValueValidator {
  name: string | undefined;
  attributes: { [key: string]: any; } | undefined;
}

export class JobApplicationDto implements IJobApplicationDto {
  orphanDescription!: string | undefined;
  joinDate!: DateTime;
  managerDescription!: string | undefined;
  orphanId!: number;
  jobStatusId!: number | undefined;
  id!: number;

  constructor(data?: IJobApplicationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orphanDescription = _data["orphanDescription"];
      this.joinDate = _data["joinDate"] ? DateTime.fromISO(_data["joinDate"].toString()) : <any>undefined;
      this.managerDescription = _data["managerDescription"];
      this.orphanId = _data["orphanId"];
      this.jobStatusId = _data["jobStatusId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): JobApplicationDto {
    data = typeof data === 'object' ? data : {};
    let result = new JobApplicationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orphanDescription"] = this.orphanDescription;
    data["joinDate"] = this.joinDate ? this.joinDate.toString() : <any>undefined;
    data["managerDescription"] = this.managerDescription;
    data["orphanId"] = this.orphanId;
    data["jobStatusId"] = this.jobStatusId;
    data["id"] = this.id;
    return data;
  }
}

export interface IJobApplicationDto {
  orphanDescription: string | undefined;
  joinDate: DateTime;
  managerDescription: string | undefined;
  orphanId: number;
  jobStatusId: number | undefined;
  id: number;
}

export class JobApplicationJobStatusLookupTableDto implements IJobApplicationJobStatusLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IJobApplicationJobStatusLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): JobApplicationJobStatusLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new JobApplicationJobStatusLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IJobApplicationJobStatusLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class JobApplicationOrphanLookupTableDto implements IJobApplicationOrphanLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IJobApplicationOrphanLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): JobApplicationOrphanLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new JobApplicationOrphanLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IJobApplicationOrphanLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class JobStatusDto implements IJobStatusDto {
  name!: string | undefined;
  id!: number;

  constructor(data?: IJobStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): JobStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new JobStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface IJobStatusDto {
  name: string | undefined;
  id: number;
}

export class JsonClaimMapDto implements IJsonClaimMapDto {
  claim!: string | undefined;
  key!: string | undefined;

  constructor(data?: IJsonClaimMapDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.claim = _data["claim"];
      this.key = _data["key"];
    }
  }

  static fromJS(data: any): JsonClaimMapDto {
    data = typeof data === 'object' ? data : {};
    let result = new JsonClaimMapDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["claim"] = this.claim;
    data["key"] = this.key;
    return data;
  }
}

export interface IJsonClaimMapDto {
  claim: string | undefined;
  key: string | undefined;
}

export enum LanguageLevel {
  Good = 0,
  Middle = 1,
  Bad = 2,
}

export class LanguageTextListDto implements ILanguageTextListDto {
  key!: string | undefined;
  baseValue!: string | undefined;
  targetValue!: string | undefined;

  constructor(data?: ILanguageTextListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data["key"];
      this.baseValue = _data["baseValue"];
      this.targetValue = _data["targetValue"];
    }
  }

  static fromJS(data: any): LanguageTextListDto {
    data = typeof data === 'object' ? data : {};
    let result = new LanguageTextListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["key"] = this.key;
    data["baseValue"] = this.baseValue;
    data["targetValue"] = this.targetValue;
    return data;
  }
}

export interface ILanguageTextListDto {
  key: string | undefined;
  baseValue: string | undefined;
  targetValue: string | undefined;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
  isModuleEnabled!: boolean;
  isEnabled!: boolean;
  domain!: string | undefined;
  userName!: string | undefined;
  password!: string | undefined;

  constructor(data?: ILdapSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isModuleEnabled = _data["isModuleEnabled"];
      this.isEnabled = _data["isEnabled"];
      this.domain = _data["domain"];
      this.userName = _data["userName"];
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): LdapSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new LdapSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isModuleEnabled"] = this.isModuleEnabled;
    data["isEnabled"] = this.isEnabled;
    data["domain"] = this.domain;
    data["userName"] = this.userName;
    data["password"] = this.password;
    return data;
  }
}

export interface ILdapSettingsEditDto {
  isModuleEnabled: boolean;
  isEnabled: boolean;
  domain: string | undefined;
  userName: string | undefined;
  password: string | undefined;
}

export class LinkedUserDto implements ILinkedUserDto {
  tenantId!: number | undefined;
  tenancyName!: string | undefined;
  username!: string | undefined;
  id!: number;

  constructor(data?: ILinkedUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.tenancyName = _data["tenancyName"];
      this.username = _data["username"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): LinkedUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new LinkedUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["tenancyName"] = this.tenancyName;
    data["username"] = this.username;
    data["id"] = this.id;
    return data;
  }
}

export interface ILinkedUserDto {
  tenantId: number | undefined;
  tenancyName: string | undefined;
  username: string | undefined;
  id: number;
}

export class LinkToUserInput implements ILinkToUserInput {
  tenancyName!: string | undefined;
  usernameOrEmailAddress!: string;
  password!: string;

  constructor(data?: ILinkToUserInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
      this.usernameOrEmailAddress = _data["usernameOrEmailAddress"];
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): LinkToUserInput {
    data = typeof data === 'object' ? data : {};
    let result = new LinkToUserInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenancyName"] = this.tenancyName;
    data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
    data["password"] = this.password;
    return data;
  }
}

export interface ILinkToUserInput {
  tenancyName: string | undefined;
  usernameOrEmailAddress: string;
  password: string;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
  items!: CacheDto[] | undefined;

  constructor(data?: IListResultDtoOfCacheDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(CacheDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfCacheDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfCacheDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfCacheDto {
  items: CacheDto[] | undefined;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
  items!: ChatMessageDto[] | undefined;

  constructor(data?: IListResultDtoOfChatMessageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(ChatMessageDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfChatMessageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfChatMessageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfChatMessageDto {
  items: ChatMessageDto[] | undefined;
}

export class ListResultDtoOfDynamicEntityPropertyDto implements IListResultDtoOfDynamicEntityPropertyDto {
  items!: DynamicEntityPropertyDto[] | undefined;

  constructor(data?: IListResultDtoOfDynamicEntityPropertyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(DynamicEntityPropertyDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfDynamicEntityPropertyDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfDynamicEntityPropertyDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfDynamicEntityPropertyDto {
  items: DynamicEntityPropertyDto[] | undefined;
}

export class ListResultDtoOfDynamicEntityPropertyValueDto implements IListResultDtoOfDynamicEntityPropertyValueDto {
  items!: DynamicEntityPropertyValueDto[] | undefined;

  constructor(data?: IListResultDtoOfDynamicEntityPropertyValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(DynamicEntityPropertyValueDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfDynamicEntityPropertyValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfDynamicEntityPropertyValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfDynamicEntityPropertyValueDto {
  items: DynamicEntityPropertyValueDto[] | undefined;
}

export class ListResultDtoOfDynamicPropertyDto implements IListResultDtoOfDynamicPropertyDto {
  items!: DynamicPropertyDto[] | undefined;

  constructor(data?: IListResultDtoOfDynamicPropertyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(DynamicPropertyDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfDynamicPropertyDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfDynamicPropertyDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfDynamicPropertyDto {
  items: DynamicPropertyDto[] | undefined;
}

export class ListResultDtoOfDynamicPropertyValueDto implements IListResultDtoOfDynamicPropertyValueDto {
  items!: DynamicPropertyValueDto[] | undefined;

  constructor(data?: IListResultDtoOfDynamicPropertyValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(DynamicPropertyValueDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfDynamicPropertyValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfDynamicPropertyValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfDynamicPropertyValueDto {
  items: DynamicPropertyValueDto[] | undefined;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
  items!: EditionListDto[] | undefined;

  constructor(data?: IListResultDtoOfEditionListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(EditionListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfEditionListDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfEditionListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfEditionListDto {
  items: EditionListDto[] | undefined;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
  items!: FlatPermissionWithLevelDto[] | undefined;

  constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfFlatPermissionWithLevelDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
  items: FlatPermissionWithLevelDto[] | undefined;
}

export class ListResultDtoOfGetAllAvailableWebhooksOutput implements IListResultDtoOfGetAllAvailableWebhooksOutput {
  items!: GetAllAvailableWebhooksOutput[] | undefined;

  constructor(data?: IListResultDtoOfGetAllAvailableWebhooksOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetAllAvailableWebhooksOutput.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfGetAllAvailableWebhooksOutput {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfGetAllAvailableWebhooksOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfGetAllAvailableWebhooksOutput {
  items: GetAllAvailableWebhooksOutput[] | undefined;
}

export class ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput implements IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
  items!: GetAllEntitiesHasDynamicPropertyOutput[] | undefined;

  constructor(data?: IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetAllEntitiesHasDynamicPropertyOutput.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
  items: GetAllEntitiesHasDynamicPropertyOutput[] | undefined;
}

export class ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput implements IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
  items!: GetAllSendAttemptsOfWebhookEventOutput[] | undefined;

  constructor(data?: IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetAllSendAttemptsOfWebhookEventOutput.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
  items: GetAllSendAttemptsOfWebhookEventOutput[] | undefined;
}

export class ListResultDtoOfGetAllSubscriptionsOutput implements IListResultDtoOfGetAllSubscriptionsOutput {
  items!: GetAllSubscriptionsOutput[] | undefined;

  constructor(data?: IListResultDtoOfGetAllSubscriptionsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetAllSubscriptionsOutput.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfGetAllSubscriptionsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfGetAllSubscriptionsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfGetAllSubscriptionsOutput {
  items: GetAllSubscriptionsOutput[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
  items!: LinkedUserDto[] | undefined;

  constructor(data?: IListResultDtoOfLinkedUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(LinkedUserDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfLinkedUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfLinkedUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfLinkedUserDto {
  items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
  items!: NameValueDto[] | undefined;

  constructor(data?: IListResultDtoOfNameValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(NameValueDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfNameValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfNameValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfNameValueDto {
  items: NameValueDto[] | undefined;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
  items!: OrganizationUnitDto[] | undefined;

  constructor(data?: IListResultDtoOfOrganizationUnitDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(OrganizationUnitDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfOrganizationUnitDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfOrganizationUnitDto {
  items: OrganizationUnitDto[] | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
  items!: RoleListDto[] | undefined;

  constructor(data?: IListResultDtoOfRoleListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(RoleListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfRoleListDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfRoleListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfRoleListDto {
  items: RoleListDto[] | undefined;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
  items!: SubscribableEditionComboboxItemDto[] | undefined;

  constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
  items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
  value!: string | undefined;
  displayText!: string | undefined;

  constructor(data?: ILocalizableComboboxItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"];
      this.displayText = _data["displayText"];
    }
  }

  static fromJS(data: any): LocalizableComboboxItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new LocalizableComboboxItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["value"] = this.value;
    data["displayText"] = this.displayText;
    return data;
  }
}

export interface ILocalizableComboboxItemDto {
  value: string | undefined;
  displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
  items!: LocalizableComboboxItemDto[] | undefined;

  constructor(data?: ILocalizableComboboxItemSourceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(LocalizableComboboxItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): LocalizableComboboxItemSourceDto {
    data = typeof data === 'object' ? data : {};
    let result = new LocalizableComboboxItemSourceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface ILocalizableComboboxItemSourceDto {
  items: LocalizableComboboxItemDto[] | undefined;
}

export enum MaritalStatus {
  Married = 0,
  Single = 1,
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
  tenantId!: number | undefined;
  userId!: number;

  constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.userId = _data["userId"];
    }
  }

  static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
    data = typeof data === 'object' ? data : {};
    let result = new MarkAllUnreadMessagesOfUserAsReadInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["userId"] = this.userId;
    return data;
  }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
  tenantId: number | undefined;
  userId: number;
}

export class MemberActivity implements IMemberActivity {
  name!: string | undefined;
  earnings!: string | undefined;
  cases!: number;
  closed!: number;
  rate!: string | undefined;

  constructor(data?: IMemberActivity) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.earnings = _data["earnings"];
      this.cases = _data["cases"];
      this.closed = _data["closed"];
      this.rate = _data["rate"];
    }
  }

  static fromJS(data: any): MemberActivity {
    data = typeof data === 'object' ? data : {};
    let result = new MemberActivity();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["earnings"] = this.earnings;
    data["cases"] = this.cases;
    data["closed"] = this.closed;
    data["rate"] = this.rate;
    return data;
  }
}

export interface IMemberActivity {
  name: string | undefined;
  earnings: string | undefined;
  cases: number;
  closed: number;
  rate: string | undefined;
}

export class MicrosoftExternalLoginProviderSettings implements IMicrosoftExternalLoginProviderSettings {
  clientId!: string | undefined;
  clientSecret!: string | undefined;

  constructor(data?: IMicrosoftExternalLoginProviderSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data["clientId"];
      this.clientSecret = _data["clientSecret"];
    }
  }

  static fromJS(data: any): MicrosoftExternalLoginProviderSettings {
    data = typeof data === 'object' ? data : {};
    let result = new MicrosoftExternalLoginProviderSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["clientId"] = this.clientId;
    data["clientSecret"] = this.clientSecret;
    return data;
  }
}

export interface IMicrosoftExternalLoginProviderSettings {
  clientId: string | undefined;
  clientSecret: string | undefined;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
  id!: number;
  newParentId!: number | undefined;

  constructor(data?: IMoveOrganizationUnitInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.newParentId = _data["newParentId"];
    }
  }

  static fromJS(data: any): MoveOrganizationUnitInput {
    data = typeof data === 'object' ? data : {};
    let result = new MoveOrganizationUnitInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["newParentId"] = this.newParentId;
    return data;
  }
}

export interface IMoveOrganizationUnitInput {
  id: number;
  newParentId: number | undefined;
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
  sourceEditionId!: number;
  targetEditionId!: number;

  constructor(data?: IMoveTenantsToAnotherEditionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sourceEditionId = _data["sourceEditionId"];
      this.targetEditionId = _data["targetEditionId"];
    }
  }

  static fromJS(data: any): MoveTenantsToAnotherEditionDto {
    data = typeof data === 'object' ? data : {};
    let result = new MoveTenantsToAnotherEditionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["sourceEditionId"] = this.sourceEditionId;
    data["targetEditionId"] = this.targetEditionId;
    return data;
  }
}

export interface IMoveTenantsToAnotherEditionDto {
  sourceEditionId: number;
  targetEditionId: number;
}

export class NameValue implements INameValue {
  name!: string | undefined;
  value!: string | undefined;

  constructor(data?: INameValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): NameValue {
    data = typeof data === 'object' ? data : {};
    let result = new NameValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["value"] = this.value;
    return data;
  }
}

export interface INameValue {
  name: string | undefined;
  value: string | undefined;
}

export class NameValueDto implements INameValueDto {
  name!: string | undefined;
  value!: string | undefined;

  constructor(data?: INameValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): NameValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new NameValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["value"] = this.value;
    return data;
  }
}

export interface INameValueDto {
  name: string | undefined;
  value: string | undefined;
}

export class NameValueOfString implements INameValueOfString {
  name!: string | undefined;
  value!: string | undefined;

  constructor(data?: INameValueOfString) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): NameValueOfString {
    data = typeof data === 'object' ? data : {};
    let result = new NameValueOfString();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["value"] = this.value;
    return data;
  }
}

export interface INameValueOfString {
  name: string | undefined;
  value: string | undefined;
}

export class NeighborhoodDistrictLookupTableDto implements INeighborhoodDistrictLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: INeighborhoodDistrictLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): NeighborhoodDistrictLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new NeighborhoodDistrictLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface INeighborhoodDistrictLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class NeighborhoodDto implements INeighborhoodDto {
  name!: string | undefined;
  districtId!: number;
  id!: number;

  constructor(data?: INeighborhoodDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.districtId = _data["districtId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): NeighborhoodDto {
    data = typeof data === 'object' ? data : {};
    let result = new NeighborhoodDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["districtId"] = this.districtId;
    data["id"] = this.id;
    return data;
  }
}

export interface INeighborhoodDto {
  name: string | undefined;
  districtId: number;
  id: number;
}

export class NotificationData implements INotificationData {
  readonly type!: string | undefined;
  properties!: { [key: string]: any; } | undefined;

  constructor(data?: INotificationData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).type = _data["type"];
      if (_data["properties"]) {
        this.properties = {} as any;
        for (let key in _data["properties"]) {
          if (_data["properties"].hasOwnProperty(key))
            (<any>this.properties)![key] = _data["properties"][key];
        }
      }
    }
  }

  static fromJS(data: any): NotificationData {
    data = typeof data === 'object' ? data : {};
    let result = new NotificationData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["type"] = this.type;
    if (this.properties) {
      data["properties"] = {};
      for (let key in this.properties) {
        if (this.properties.hasOwnProperty(key))
          (<any>data["properties"])[key] = this.properties[key];
      }
    }
    return data;
  }
}

export interface INotificationData {
  type: string | undefined;
  properties: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
  Info = 0,
  Success = 1,
  Warn = 2,
  Error = 3,
  Fatal = 4,
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
  name!: string;
  isSubscribed!: boolean;

  constructor(data?: INotificationSubscriptionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.isSubscribed = _data["isSubscribed"];
    }
  }

  static fromJS(data: any): NotificationSubscriptionDto {
    data = typeof data === 'object' ? data : {};
    let result = new NotificationSubscriptionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["isSubscribed"] = this.isSubscribed;
    return data;
  }
}

export interface INotificationSubscriptionDto {
  name: string;
  isSubscribed: boolean;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
  displayName!: string | undefined;
  description!: string | undefined;
  name!: string;
  isSubscribed!: boolean;

  constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayName = _data["displayName"];
      this.description = _data["description"];
      this.name = _data["name"];
      this.isSubscribed = _data["isSubscribed"];
    }
  }

  static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
    data = typeof data === 'object' ? data : {};
    let result = new NotificationSubscriptionWithDisplayNameDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["displayName"] = this.displayName;
    data["description"] = this.description;
    data["name"] = this.name;
    data["isSubscribed"] = this.isSubscribed;
    return data;
  }
}

export interface INotificationSubscriptionWithDisplayNameDto {
  displayName: string | undefined;
  description: string | undefined;
  name: string;
  isSubscribed: boolean;
}

export class OpenIdConnectExternalLoginProviderSettings implements IOpenIdConnectExternalLoginProviderSettings {
  clientId!: string | undefined;
  clientSecret!: string | undefined;
  authority!: string | undefined;
  loginUrl!: string | undefined;
  validateIssuer!: boolean;

  constructor(data?: IOpenIdConnectExternalLoginProviderSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data["clientId"];
      this.clientSecret = _data["clientSecret"];
      this.authority = _data["authority"];
      this.loginUrl = _data["loginUrl"];
      this.validateIssuer = _data["validateIssuer"];
    }
  }

  static fromJS(data: any): OpenIdConnectExternalLoginProviderSettings {
    data = typeof data === 'object' ? data : {};
    let result = new OpenIdConnectExternalLoginProviderSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["clientId"] = this.clientId;
    data["clientSecret"] = this.clientSecret;
    data["authority"] = this.authority;
    data["loginUrl"] = this.loginUrl;
    data["validateIssuer"] = this.validateIssuer;
    return data;
  }
}

export interface IOpenIdConnectExternalLoginProviderSettings {
  clientId: string | undefined;
  clientSecret: string | undefined;
  authority: string | undefined;
  loginUrl: string | undefined;
  validateIssuer: boolean;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
  parentId!: number | undefined;
  code!: string | undefined;
  displayName!: string | undefined;
  memberCount!: number;
  roleCount!: number;
  lastModificationTime!: DateTime | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: DateTime;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IOrganizationUnitDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.parentId = _data["parentId"];
      this.code = _data["code"];
      this.displayName = _data["displayName"];
      this.memberCount = _data["memberCount"];
      this.roleCount = _data["roleCount"];
      this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrganizationUnitDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationUnitDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["parentId"] = this.parentId;
    data["code"] = this.code;
    data["displayName"] = this.displayName;
    data["memberCount"] = this.memberCount;
    data["roleCount"] = this.roleCount;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrganizationUnitDto {
  parentId: number | undefined;
  code: string | undefined;
  displayName: string | undefined;
  memberCount: number;
  roleCount: number;
  lastModificationTime: DateTime | undefined;
  lastModifierUserId: number | undefined;
  creationTime: DateTime;
  creatorUserId: number | undefined;
  id: number;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
  displayName!: string | undefined;
  name!: string | undefined;
  addedTime!: DateTime;
  id!: number;

  constructor(data?: IOrganizationUnitRoleListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayName = _data["displayName"];
      this.name = _data["name"];
      this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrganizationUnitRoleListDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationUnitRoleListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["displayName"] = this.displayName;
    data["name"] = this.name;
    data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrganizationUnitRoleListDto {
  displayName: string | undefined;
  name: string | undefined;
  addedTime: DateTime;
  id: number;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
  name!: string | undefined;
  surname!: string | undefined;
  userName!: string | undefined;
  emailAddress!: string | undefined;
  profilePictureId!: string | undefined;
  addedTime!: DateTime;
  id!: number;

  constructor(data?: IOrganizationUnitUserListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.userName = _data["userName"];
      this.emailAddress = _data["emailAddress"];
      this.profilePictureId = _data["profilePictureId"];
      this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrganizationUnitUserListDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationUnitUserListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["userName"] = this.userName;
    data["emailAddress"] = this.emailAddress;
    data["profilePictureId"] = this.profilePictureId;
    data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrganizationUnitUserListDto {
  name: string | undefined;
  surname: string | undefined;
  userName: string | undefined;
  emailAddress: string | undefined;
  profilePictureId: string | undefined;
  addedTime: DateTime;
  id: number;
}

export class OrphanBookDetailBookTypeLookupTableDto implements IOrphanBookDetailBookTypeLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanBookDetailBookTypeLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanBookDetailBookTypeLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanBookDetailBookTypeLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanBookDetailBookTypeLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanBookDetailDto implements IOrphanBookDetailDto {
  bookName!: string | undefined;
  bookAuthor!: string | undefined;
  pageCount!: number;
  startDate!: DateTime | undefined;
  endDate!: DateTime | undefined;
  bookTypeId!: number;
  orphanId!: number;
  id!: number;

  constructor(data?: IOrphanBookDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookName = _data["bookName"];
      this.bookAuthor = _data["bookAuthor"];
      this.pageCount = _data["pageCount"];
      this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
      this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
      this.bookTypeId = _data["bookTypeId"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrphanBookDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanBookDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["bookName"] = this.bookName;
    data["bookAuthor"] = this.bookAuthor;
    data["pageCount"] = this.pageCount;
    data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
    data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
    data["bookTypeId"] = this.bookTypeId;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrphanBookDetailDto {
  bookName: string | undefined;
  bookAuthor: string | undefined;
  pageCount: number;
  startDate: DateTime | undefined;
  endDate: DateTime | undefined;
  bookTypeId: number;
  orphanId: number;
  id: number;
}

export class OrphanBookDetailOrphanLookupTableDto implements IOrphanBookDetailOrphanLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanBookDetailOrphanLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanBookDetailOrphanLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanBookDetailOrphanLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanBookDetailOrphanLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanClubDetailDto implements IOrphanClubDetailDto {
  name!: string | undefined;
  joinedCount!: number | undefined;
  joinedYear!: number;
  description!: string | undefined;
  orphanId!: number;
  id!: number;

  constructor(data?: IOrphanClubDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.joinedCount = _data["joinedCount"];
      this.joinedYear = _data["joinedYear"];
      this.description = _data["description"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrphanClubDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanClubDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["joinedCount"] = this.joinedCount;
    data["joinedYear"] = this.joinedYear;
    data["description"] = this.description;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrphanClubDetailDto {
  name: string | undefined;
  joinedCount: number | undefined;
  joinedYear: number;
  description: string | undefined;
  orphanId: number;
  id: number;
}

export class OrphanClubDetailOrphanLookupTableDto implements IOrphanClubDetailOrphanLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanClubDetailOrphanLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanClubDetailOrphanLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanClubDetailOrphanLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanClubDetailOrphanLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanDistrictLookupTableDto implements IOrphanDistrictLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanDistrictLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanDistrictLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanDistrictLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanDistrictLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanDto implements IOrphanDto {
  nationality!: string | undefined;
  mdgMuhatapNo!: string | undefined;
  tcNumber!: string | undefined;
  firstName!: string | undefined;
  lastName!: string | undefined;
  placeOfBirth!: string | undefined;
  dateOfBirth!: DateTime | undefined;
  motherAndFatherName!: string | undefined;
  address!: string | undefined;
  apartmentNumber!: string | undefined;
  postCode!: number | undefined;
  mobileNumber!: string | undefined;
  homeNumber!: string | undefined;
  eMail!: string | undefined;
  maritalStatus!: MaritalStatus;
  provinceId!: number | undefined;
  districtId!: number | undefined;
  neighborhoodId!: number | undefined;
  id!: number;

  constructor(data?: IOrphanDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.nationality = _data["nationality"];
      this.mdgMuhatapNo = _data["mdgMuhatapNo"];
      this.tcNumber = _data["tcNumber"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.placeOfBirth = _data["placeOfBirth"];
      this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
      this.motherAndFatherName = _data["motherAndFatherName"];
      this.address = _data["address"];
      this.apartmentNumber = _data["apartmentNumber"];
      this.postCode = _data["postCode"];
      this.mobileNumber = _data["mobileNumber"];
      this.homeNumber = _data["homeNumber"];
      this.eMail = _data["eMail"];
      this.maritalStatus = _data["maritalStatus"];
      this.provinceId = _data["provinceId"];
      this.districtId = _data["districtId"];
      this.neighborhoodId = _data["neighborhoodId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrphanDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["nationality"] = this.nationality;
    data["mdgMuhatapNo"] = this.mdgMuhatapNo;
    data["tcNumber"] = this.tcNumber;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["placeOfBirth"] = this.placeOfBirth;
    data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : <any>undefined;
    data["motherAndFatherName"] = this.motherAndFatherName;
    data["address"] = this.address;
    data["apartmentNumber"] = this.apartmentNumber;
    data["postCode"] = this.postCode;
    data["mobileNumber"] = this.mobileNumber;
    data["homeNumber"] = this.homeNumber;
    data["eMail"] = this.eMail;
    data["maritalStatus"] = this.maritalStatus;
    data["provinceId"] = this.provinceId;
    data["districtId"] = this.districtId;
    data["neighborhoodId"] = this.neighborhoodId;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrphanDto {
  nationality: string | undefined;
  mdgMuhatapNo: string | undefined;
  tcNumber: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  placeOfBirth: string | undefined;
  dateOfBirth: DateTime | undefined;
  motherAndFatherName: string | undefined;
  address: string | undefined;
  apartmentNumber: string | undefined;
  postCode: number | undefined;
  mobileNumber: string | undefined;
  homeNumber: string | undefined;
  eMail: string | undefined;
  maritalStatus: MaritalStatus;
  provinceId: number | undefined;
  districtId: number | undefined;
  neighborhoodId: number | undefined;
  id: number;
}

export class OrphanEducationDto implements IOrphanEducationDto {
  educationName!: string | undefined;
  educationTime!: string | undefined;
  pointValue!: string | undefined;
  description!: string | undefined;
  documentName!: string | undefined;
  filePath!: string | undefined;
  fileExtension!: string | undefined;
  educationDate!: DateTime;
  orphanId!: number;
  id!: number;

  constructor(data?: IOrphanEducationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.educationName = _data["educationName"];
      this.educationTime = _data["educationTime"];
      this.pointValue = _data["pointValue"];
      this.description = _data["description"];
      this.documentName = _data["documentName"];
      this.filePath = _data["filePath"];
      this.fileExtension = _data["fileExtension"];
      this.educationDate = _data["educationDate"] ? DateTime.fromISO(_data["educationDate"].toString()) : <any>undefined;
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrphanEducationDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanEducationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["educationName"] = this.educationName;
    data["educationTime"] = this.educationTime;
    data["pointValue"] = this.pointValue;
    data["description"] = this.description;
    data["documentName"] = this.documentName;
    data["filePath"] = this.filePath;
    data["fileExtension"] = this.fileExtension;
    data["educationDate"] = this.educationDate ? this.educationDate.toString() : <any>undefined;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrphanEducationDto {
  educationName: string | undefined;
  educationTime: string | undefined;
  pointValue: string | undefined;
  description: string | undefined;
  documentName: string | undefined;
  filePath: string | undefined;
  fileExtension: string | undefined;
  educationDate: DateTime;
  orphanId: number;
  id: number;
}

export class OrphanEducationOrphanLookupTableDto implements IOrphanEducationOrphanLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanEducationOrphanLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanEducationOrphanLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanEducationOrphanLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanEducationOrphanLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanEventTypeDto implements IOrphanEventTypeDto {
  name!: string | undefined;
  id!: number;

  constructor(data?: IOrphanEventTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrphanEventTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanEventTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrphanEventTypeDto {
  name: string | undefined;
  id: number;
}

export class OrphanExperienceDto implements IOrphanExperienceDto {
  companyName!: string | undefined;
  taskType!: TaskType;
  oprhanWorkType!: number | undefined;
  startDate!: DateTime;
  endDate!: DateTime;
  companySector!: string | undefined;
  description!: string | undefined;
  companyProvinceId!: number | undefined;
  orphanId!: number;
  id!: number;

  constructor(data?: IOrphanExperienceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data["companyName"];
      this.taskType = _data["taskType"];
      this.oprhanWorkType = _data["oprhanWorkType"];
      this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
      this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
      this.companySector = _data["companySector"];
      this.description = _data["description"];
      this.companyProvinceId = _data["companyProvinceId"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrphanExperienceDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanExperienceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["companyName"] = this.companyName;
    data["taskType"] = this.taskType;
    data["oprhanWorkType"] = this.oprhanWorkType;
    data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
    data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
    data["companySector"] = this.companySector;
    data["description"] = this.description;
    data["companyProvinceId"] = this.companyProvinceId;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrphanExperienceDto {
  companyName: string | undefined;
  taskType: TaskType;
  oprhanWorkType: number | undefined;
  startDate: DateTime;
  endDate: DateTime;
  companySector: string | undefined;
  description: string | undefined;
  companyProvinceId: number | undefined;
  orphanId: number;
  id: number;
}

export class OrphanExperienceOrphanLookupTableDto implements IOrphanExperienceOrphanLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanExperienceOrphanLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanExperienceOrphanLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanExperienceOrphanLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanExperienceOrphanLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanExperienceProvinceLookupTableDto implements IOrphanExperienceProvinceLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanExperienceProvinceLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanExperienceProvinceLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanExperienceProvinceLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanExperienceProvinceLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanInterestDetailDto implements IOrphanInterestDetailDto {
  name!: string | undefined;
  orphanId!: number;
  id!: number;

  constructor(data?: IOrphanInterestDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrphanInterestDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanInterestDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrphanInterestDetailDto {
  name: string | undefined;
  orphanId: number;
  id: number;
}

export class OrphanInterestDetailOrphanLookupTableDto implements IOrphanInterestDetailOrphanLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanInterestDetailOrphanLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanInterestDetailOrphanLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanInterestDetailOrphanLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanInterestDetailOrphanLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanLanguageDetailDto implements IOrphanLanguageDetailDto {
  name!: string | undefined;
  languageLevel!: LanguageLevel;
  orphanId!: number;
  id!: number;

  constructor(data?: IOrphanLanguageDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.languageLevel = _data["languageLevel"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrphanLanguageDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanLanguageDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["languageLevel"] = this.languageLevel;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrphanLanguageDetailDto {
  name: string | undefined;
  languageLevel: LanguageLevel;
  orphanId: number;
  id: number;
}

export class OrphanLanguageDetailOrphanLookupTableDto implements IOrphanLanguageDetailOrphanLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanLanguageDetailOrphanLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanLanguageDetailOrphanLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanLanguageDetailOrphanLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanLanguageDetailOrphanLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanNeighborhoodLookupTableDto implements IOrphanNeighborhoodLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanNeighborhoodLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanNeighborhoodLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanNeighborhoodLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanNeighborhoodLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanProjectDetailDto implements IOrphanProjectDetailDto {
  year!: string | undefined;
  name!: string | undefined;
  projectStatus!: ProjectStatus;
  orphanId!: number;
  id!: number;

  constructor(data?: IOrphanProjectDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.year = _data["year"];
      this.name = _data["name"];
      this.projectStatus = _data["projectStatus"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrphanProjectDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanProjectDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["year"] = this.year;
    data["name"] = this.name;
    data["projectStatus"] = this.projectStatus;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrphanProjectDetailDto {
  year: string | undefined;
  name: string | undefined;
  projectStatus: ProjectStatus;
  orphanId: number;
  id: number;
}

export class OrphanProjectDetailOrphanLookupTableDto implements IOrphanProjectDetailOrphanLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanProjectDetailOrphanLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanProjectDetailOrphanLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanProjectDetailOrphanLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanProjectDetailOrphanLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanProvinceLookupTableDto implements IOrphanProvinceLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanProvinceLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanProvinceLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanProvinceLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanProvinceLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanSchoolAvailabilityStatusLookupTableDto implements IOrphanSchoolAvailabilityStatusLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanSchoolAvailabilityStatusLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanSchoolAvailabilityStatusLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanSchoolAvailabilityStatusLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanSchoolAvailabilityStatusLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanSchoolDto implements IOrphanSchoolDto {
  schoolName!: string | undefined;
  programName!: string | undefined;
  schoolClassName!: string | undefined;
  availabilityDate!: DateTime | undefined;
  schoolProvinceId!: number;
  educationTypeId!: number;
  availabilityStatusId!: number;
  orphanId!: number;
  id!: number;

  constructor(data?: IOrphanSchoolDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.schoolName = _data["schoolName"];
      this.programName = _data["programName"];
      this.schoolClassName = _data["schoolClassName"];
      this.availabilityDate = _data["availabilityDate"] ? DateTime.fromISO(_data["availabilityDate"].toString()) : <any>undefined;
      this.schoolProvinceId = _data["schoolProvinceId"];
      this.educationTypeId = _data["educationTypeId"];
      this.availabilityStatusId = _data["availabilityStatusId"];
      this.orphanId = _data["orphanId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrphanSchoolDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanSchoolDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["schoolName"] = this.schoolName;
    data["programName"] = this.programName;
    data["schoolClassName"] = this.schoolClassName;
    data["availabilityDate"] = this.availabilityDate ? this.availabilityDate.toString() : <any>undefined;
    data["schoolProvinceId"] = this.schoolProvinceId;
    data["educationTypeId"] = this.educationTypeId;
    data["availabilityStatusId"] = this.availabilityStatusId;
    data["orphanId"] = this.orphanId;
    data["id"] = this.id;
    return data;
  }
}

export interface IOrphanSchoolDto {
  schoolName: string | undefined;
  programName: string | undefined;
  schoolClassName: string | undefined;
  availabilityDate: DateTime | undefined;
  schoolProvinceId: number;
  educationTypeId: number;
  availabilityStatusId: number;
  orphanId: number;
  id: number;
}

export class OrphanSchoolEducationTypeLookupTableDto implements IOrphanSchoolEducationTypeLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanSchoolEducationTypeLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanSchoolEducationTypeLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanSchoolEducationTypeLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanSchoolEducationTypeLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanSchoolOrphanLookupTableDto implements IOrphanSchoolOrphanLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanSchoolOrphanLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanSchoolOrphanLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanSchoolOrphanLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanSchoolOrphanLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OrphanSchoolProvinceLookupTableDto implements IOrphanSchoolProvinceLookupTableDto {
  id!: number;
  displayName!: string | undefined;

  constructor(data?: IOrphanSchoolProvinceLookupTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OrphanSchoolProvinceLookupTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrphanSchoolProvinceLookupTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOrphanSchoolProvinceLookupTableDto {
  id: number;
  displayName: string | undefined;
}

export class OtherSettingsEditDto implements IOtherSettingsEditDto {
  isQuickThemeSelectEnabled!: boolean;

  constructor(data?: IOtherSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
    }
  }

  static fromJS(data: any): OtherSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new OtherSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
    return data;
  }
}

export interface IOtherSettingsEditDto {
  isQuickThemeSelectEnabled: boolean;
}

export class Page implements IPage {
  id!: string | undefined;
  name!: string | undefined;
  widgets!: Widget[] | undefined;

  constructor(data?: IPage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      if (Array.isArray(_data["widgets"])) {
        this.widgets = [] as any;
        for (let item of _data["widgets"])
          this.widgets!.push(Widget.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Page {
    data = typeof data === 'object' ? data : {};
    let result = new Page();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    if (Array.isArray(this.widgets)) {
      data["widgets"] = [];
      for (let item of this.widgets)
        data["widgets"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPage {
  id: string | undefined;
  name: string | undefined;
  widgets: Widget[] | undefined;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
  totalCount!: number;
  items!: AuditLogListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfAuditLogListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(AuditLogListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfAuditLogListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfAuditLogListDto {
  totalCount: number;
  items: AuditLogListDto[] | undefined;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
  totalCount!: number;
  items!: EntityChangeListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(EntityChangeListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfEntityChangeListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfEntityChangeListDto {
  totalCount: number;
  items: EntityChangeListDto[] | undefined;
}

export class PagedResultDtoOfGetAgeLimitForViewDto implements IPagedResultDtoOfGetAgeLimitForViewDto {
  totalCount!: number;
  items!: GetAgeLimitForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetAgeLimitForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetAgeLimitForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetAgeLimitForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetAgeLimitForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetAgeLimitForViewDto {
  totalCount: number;
  items: GetAgeLimitForViewDto[] | undefined;
}

export class PagedResultDtoOfGetAllSendAttemptsOutput implements IPagedResultDtoOfGetAllSendAttemptsOutput {
  totalCount!: number;
  items!: GetAllSendAttemptsOutput[] | undefined;

  constructor(data?: IPagedResultDtoOfGetAllSendAttemptsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetAllSendAttemptsOutput.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetAllSendAttemptsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetAllSendAttemptsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetAllSendAttemptsOutput {
  totalCount: number;
  items: GetAllSendAttemptsOutput[] | undefined;
}

export class PagedResultDtoOfGetAvailabilityStatusForViewDto implements IPagedResultDtoOfGetAvailabilityStatusForViewDto {
  totalCount!: number;
  items!: GetAvailabilityStatusForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetAvailabilityStatusForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetAvailabilityStatusForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetAvailabilityStatusForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetAvailabilityStatusForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetAvailabilityStatusForViewDto {
  totalCount: number;
  items: GetAvailabilityStatusForViewDto[] | undefined;
}

export class PagedResultDtoOfGetBookTypeForViewDto implements IPagedResultDtoOfGetBookTypeForViewDto {
  totalCount!: number;
  items!: GetBookTypeForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetBookTypeForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetBookTypeForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetBookTypeForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetBookTypeForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetBookTypeForViewDto {
  totalCount: number;
  items: GetBookTypeForViewDto[] | undefined;
}

export class PagedResultDtoOfGetDistrictForViewDto implements IPagedResultDtoOfGetDistrictForViewDto {
  totalCount!: number;
  items!: GetDistrictForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetDistrictForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetDistrictForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetDistrictForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetDistrictForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetDistrictForViewDto {
  totalCount: number;
  items: GetDistrictForViewDto[] | undefined;
}

export class PagedResultDtoOfGetEducationStatusForViewDto implements IPagedResultDtoOfGetEducationStatusForViewDto {
  totalCount!: number;
  items!: GetEducationStatusForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetEducationStatusForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetEducationStatusForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetEducationStatusForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetEducationStatusForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetEducationStatusForViewDto {
  totalCount: number;
  items: GetEducationStatusForViewDto[] | undefined;
}

export class PagedResultDtoOfGetEducationTypeForViewDto implements IPagedResultDtoOfGetEducationTypeForViewDto {
  totalCount!: number;
  items!: GetEducationTypeForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetEducationTypeForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetEducationTypeForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetEducationTypeForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetEducationTypeForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetEducationTypeForViewDto {
  totalCount: number;
  items: GetEducationTypeForViewDto[] | undefined;
}

export class PagedResultDtoOfGetEventCalendarDetailForViewDto implements IPagedResultDtoOfGetEventCalendarDetailForViewDto {
  totalCount!: number;
  items!: GetEventCalendarDetailForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetEventCalendarDetailForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetEventCalendarDetailForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetEventCalendarDetailForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetEventCalendarDetailForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetEventCalendarDetailForViewDto {
  totalCount: number;
  items: GetEventCalendarDetailForViewDto[] | undefined;
}

export class PagedResultDtoOfGetJobApplicationForViewDto implements IPagedResultDtoOfGetJobApplicationForViewDto {
  totalCount!: number;
  items!: GetJobApplicationForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetJobApplicationForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetJobApplicationForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetJobApplicationForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetJobApplicationForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetJobApplicationForViewDto {
  totalCount: number;
  items: GetJobApplicationForViewDto[] | undefined;
}

export class PagedResultDtoOfGetJobStatusForViewDto implements IPagedResultDtoOfGetJobStatusForViewDto {
  totalCount!: number;
  items!: GetJobStatusForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetJobStatusForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetJobStatusForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetJobStatusForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetJobStatusForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetJobStatusForViewDto {
  totalCount: number;
  items: GetJobStatusForViewDto[] | undefined;
}

export class PagedResultDtoOfGetNeighborhoodForViewDto implements IPagedResultDtoOfGetNeighborhoodForViewDto {
  totalCount!: number;
  items!: GetNeighborhoodForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetNeighborhoodForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetNeighborhoodForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetNeighborhoodForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetNeighborhoodForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetNeighborhoodForViewDto {
  totalCount: number;
  items: GetNeighborhoodForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrphanBookDetailForViewDto implements IPagedResultDtoOfGetOrphanBookDetailForViewDto {
  totalCount!: number;
  items!: GetOrphanBookDetailForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetOrphanBookDetailForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetOrphanBookDetailForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetOrphanBookDetailForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetOrphanBookDetailForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetOrphanBookDetailForViewDto {
  totalCount: number;
  items: GetOrphanBookDetailForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrphanClubDetailForViewDto implements IPagedResultDtoOfGetOrphanClubDetailForViewDto {
  totalCount!: number;
  items!: GetOrphanClubDetailForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetOrphanClubDetailForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetOrphanClubDetailForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetOrphanClubDetailForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetOrphanClubDetailForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetOrphanClubDetailForViewDto {
  totalCount: number;
  items: GetOrphanClubDetailForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrphanEducationForViewDto implements IPagedResultDtoOfGetOrphanEducationForViewDto {
  totalCount!: number;
  items!: GetOrphanEducationForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetOrphanEducationForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetOrphanEducationForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetOrphanEducationForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetOrphanEducationForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetOrphanEducationForViewDto {
  totalCount: number;
  items: GetOrphanEducationForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrphanEventTypeForViewDto implements IPagedResultDtoOfGetOrphanEventTypeForViewDto {
  totalCount!: number;
  items!: GetOrphanEventTypeForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetOrphanEventTypeForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetOrphanEventTypeForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetOrphanEventTypeForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetOrphanEventTypeForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetOrphanEventTypeForViewDto {
  totalCount: number;
  items: GetOrphanEventTypeForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrphanExperienceForViewDto implements IPagedResultDtoOfGetOrphanExperienceForViewDto {
  totalCount!: number;
  items!: GetOrphanExperienceForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetOrphanExperienceForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetOrphanExperienceForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetOrphanExperienceForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetOrphanExperienceForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetOrphanExperienceForViewDto {
  totalCount: number;
  items: GetOrphanExperienceForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrphanForViewDto implements IPagedResultDtoOfGetOrphanForViewDto {
  totalCount!: number;
  items!: GetOrphanForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetOrphanForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetOrphanForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetOrphanForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetOrphanForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetOrphanForViewDto {
  totalCount: number;
  items: GetOrphanForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrphanInterestDetailForViewDto implements IPagedResultDtoOfGetOrphanInterestDetailForViewDto {
  totalCount!: number;
  items!: GetOrphanInterestDetailForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetOrphanInterestDetailForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetOrphanInterestDetailForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetOrphanInterestDetailForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetOrphanInterestDetailForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetOrphanInterestDetailForViewDto {
  totalCount: number;
  items: GetOrphanInterestDetailForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrphanLanguageDetailForViewDto implements IPagedResultDtoOfGetOrphanLanguageDetailForViewDto {
  totalCount!: number;
  items!: GetOrphanLanguageDetailForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetOrphanLanguageDetailForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetOrphanLanguageDetailForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetOrphanLanguageDetailForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetOrphanLanguageDetailForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetOrphanLanguageDetailForViewDto {
  totalCount: number;
  items: GetOrphanLanguageDetailForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrphanProjectDetailForViewDto implements IPagedResultDtoOfGetOrphanProjectDetailForViewDto {
  totalCount!: number;
  items!: GetOrphanProjectDetailForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetOrphanProjectDetailForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetOrphanProjectDetailForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetOrphanProjectDetailForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetOrphanProjectDetailForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetOrphanProjectDetailForViewDto {
  totalCount: number;
  items: GetOrphanProjectDetailForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrphanSchoolForViewDto implements IPagedResultDtoOfGetOrphanSchoolForViewDto {
  totalCount!: number;
  items!: GetOrphanSchoolForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetOrphanSchoolForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetOrphanSchoolForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetOrphanSchoolForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetOrphanSchoolForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetOrphanSchoolForViewDto {
  totalCount: number;
  items: GetOrphanSchoolForViewDto[] | undefined;
}

export class PagedResultDtoOfGetProvinceForViewDto implements IPagedResultDtoOfGetProvinceForViewDto {
  totalCount!: number;
  items!: GetProvinceForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetProvinceForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetProvinceForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetProvinceForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetProvinceForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetProvinceForViewDto {
  totalCount: number;
  items: GetProvinceForViewDto[] | undefined;
}

export class PagedResultDtoOfGetWorkJobForViewDto implements IPagedResultDtoOfGetWorkJobForViewDto {
  totalCount!: number;
  items!: GetWorkJobForViewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetWorkJobForViewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(GetWorkJobForViewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetWorkJobForViewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetWorkJobForViewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetWorkJobForViewDto {
  totalCount: number;
  items: GetWorkJobForViewDto[] | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
  totalCount!: number;
  items!: LanguageTextListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(LanguageTextListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfLanguageTextListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfLanguageTextListDto {
  totalCount: number;
  items: LanguageTextListDto[] | undefined;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
  totalCount!: number;
  items!: LinkedUserDto[] | undefined;

  constructor(data?: IPagedResultDtoOfLinkedUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(LinkedUserDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfLinkedUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfLinkedUserDto {
  totalCount: number;
  items: LinkedUserDto[] | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
  totalCount!: number;
  items!: NameValueDto[] | undefined;

  constructor(data?: IPagedResultDtoOfNameValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(NameValueDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfNameValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfNameValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfNameValueDto {
  totalCount: number;
  items: NameValueDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
  totalCount!: number;
  items!: OrganizationUnitRoleListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(OrganizationUnitRoleListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
  totalCount: number;
  items: OrganizationUnitRoleListDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
  totalCount!: number;
  items!: OrganizationUnitUserListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(OrganizationUnitUserListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfOrganizationUnitUserListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
  totalCount: number;
  items: OrganizationUnitUserListDto[] | undefined;
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
  totalCount!: number;
  items!: SubscriptionPaymentListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(SubscriptionPaymentListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfSubscriptionPaymentListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
  totalCount: number;
  items: SubscriptionPaymentListDto[] | undefined;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
  totalCount!: number;
  items!: TenantListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfTenantListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(TenantListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfTenantListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfTenantListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfTenantListDto {
  totalCount: number;
  items: TenantListDto[] | undefined;
}

export class PagedResultDtoOfUserDelegationDto implements IPagedResultDtoOfUserDelegationDto {
  totalCount!: number;
  items!: UserDelegationDto[] | undefined;

  constructor(data?: IPagedResultDtoOfUserDelegationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(UserDelegationDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfUserDelegationDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfUserDelegationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfUserDelegationDto {
  totalCount: number;
  items: UserDelegationDto[] | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
  totalCount!: number;
  items!: UserListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfUserListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(UserListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfUserListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfUserListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfUserListDto {
  totalCount: number;
  items: UserListDto[] | undefined;
}

export class PagedResultDtoOfUserLoginAttemptDto implements IPagedResultDtoOfUserLoginAttemptDto {
  totalCount!: number;
  items!: UserLoginAttemptDto[] | undefined;

  constructor(data?: IPagedResultDtoOfUserLoginAttemptDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(UserLoginAttemptDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfUserLoginAttemptDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfUserLoginAttemptDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfUserLoginAttemptDto {
  totalCount: number;
  items: UserLoginAttemptDto[] | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
  requireDigit!: boolean;
  requireLowercase!: boolean;
  requireNonAlphanumeric!: boolean;
  requireUppercase!: boolean;
  requiredLength!: number;

  constructor(data?: IPasswordComplexitySetting) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.requireDigit = _data["requireDigit"];
      this.requireLowercase = _data["requireLowercase"];
      this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
      this.requireUppercase = _data["requireUppercase"];
      this.requiredLength = _data["requiredLength"];
    }
  }

  static fromJS(data: any): PasswordComplexitySetting {
    data = typeof data === 'object' ? data : {};
    let result = new PasswordComplexitySetting();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["requireDigit"] = this.requireDigit;
    data["requireLowercase"] = this.requireLowercase;
    data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
    data["requireUppercase"] = this.requireUppercase;
    data["requiredLength"] = this.requiredLength;
    return data;
  }
}

export interface IPasswordComplexitySetting {
  requireDigit: boolean;
  requireLowercase: boolean;
  requireNonAlphanumeric: boolean;
  requireUppercase: boolean;
  requiredLength: number;
}

export class PaymentGatewayModel implements IPaymentGatewayModel {
  gatewayType!: SubscriptionPaymentGatewayType;
  supportsRecurringPayments!: boolean;

  constructor(data?: IPaymentGatewayModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.gatewayType = _data["gatewayType"];
      this.supportsRecurringPayments = _data["supportsRecurringPayments"];
    }
  }

  static fromJS(data: any): PaymentGatewayModel {
    data = typeof data === 'object' ? data : {};
    let result = new PaymentGatewayModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["gatewayType"] = this.gatewayType;
    data["supportsRecurringPayments"] = this.supportsRecurringPayments;
    return data;
  }
}

export interface IPaymentGatewayModel {
  gatewayType: SubscriptionPaymentGatewayType;
  supportsRecurringPayments: boolean;
}

export class PaymentInfoDto implements IPaymentInfoDto {
  edition!: EditionSelectDto;
  additionalPrice!: number;

  constructor(data?: IPaymentInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : <any>undefined;
      this.additionalPrice = _data["additionalPrice"];
    }
  }

  static fromJS(data: any): PaymentInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaymentInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
    data["additionalPrice"] = this.additionalPrice;
    return data;
  }
}

export interface IPaymentInfoDto {
  edition: EditionSelectDto;
  additionalPrice: number;
}

export enum PaymentPeriodType {
  Daily = 1,
  Weekly = 7,
  Monthly = 30,
  Annual = 365,
}

export class PayPalConfigurationDto implements IPayPalConfigurationDto {
  clientId!: string | undefined;
  demoUsername!: string | undefined;
  demoPassword!: string | undefined;
  disabledFundings!: string[] | undefined;

  constructor(data?: IPayPalConfigurationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data["clientId"];
      this.demoUsername = _data["demoUsername"];
      this.demoPassword = _data["demoPassword"];
      if (Array.isArray(_data["disabledFundings"])) {
        this.disabledFundings = [] as any;
        for (let item of _data["disabledFundings"])
          this.disabledFundings!.push(item);
      }
    }
  }

  static fromJS(data: any): PayPalConfigurationDto {
    data = typeof data === 'object' ? data : {};
    let result = new PayPalConfigurationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["clientId"] = this.clientId;
    data["demoUsername"] = this.demoUsername;
    data["demoPassword"] = this.demoPassword;
    if (Array.isArray(this.disabledFundings)) {
      data["disabledFundings"] = [];
      for (let item of this.disabledFundings)
        data["disabledFundings"].push(item);
    }
    return data;
  }
}

export interface IPayPalConfigurationDto {
  clientId: string | undefined;
  demoUsername: string | undefined;
  demoPassword: string | undefined;
  disabledFundings: string[] | undefined;
}

export enum ProjectStatus {
  Completed = 0,
  UnCompleted = 1,
  Continues = 2,
}

export class ProvinceDto implements IProvinceDto {
  name!: string | undefined;
  id!: number;

  constructor(data?: IProvinceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProvinceDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProvinceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface IProvinceDto {
  name: string | undefined;
  id: number;
}

export class RecentTenant implements IRecentTenant {
  id!: number;
  name!: string | undefined;
  creationTime!: DateTime;

  constructor(data?: IRecentTenant) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): RecentTenant {
    data = typeof data === 'object' ? data : {};
    let result = new RecentTenant();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    return data;
  }
}

export interface IRecentTenant {
  id: number;
  name: string | undefined;
  creationTime: DateTime;
}

export class RefreshTokenResult implements IRefreshTokenResult {
  accessToken!: string | undefined;
  encryptedAccessToken!: string | undefined;
  expireInSeconds!: number;

  constructor(data?: IRefreshTokenResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.encryptedAccessToken = _data["encryptedAccessToken"];
      this.expireInSeconds = _data["expireInSeconds"];
    }
  }

  static fromJS(data: any): RefreshTokenResult {
    data = typeof data === 'object' ? data : {};
    let result = new RefreshTokenResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["accessToken"] = this.accessToken;
    data["encryptedAccessToken"] = this.encryptedAccessToken;
    data["expireInSeconds"] = this.expireInSeconds;
    return data;
  }
}

export interface IRefreshTokenResult {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
}

export class RegionalStatCountry implements IRegionalStatCountry {
  countryName!: string | undefined;
  sales!: number;
  change!: number[] | undefined;
  averagePrice!: number;
  totalPrice!: number;

  constructor(data?: IRegionalStatCountry) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.countryName = _data["countryName"];
      this.sales = _data["sales"];
      if (Array.isArray(_data["change"])) {
        this.change = [] as any;
        for (let item of _data["change"])
          this.change!.push(item);
      }
      this.averagePrice = _data["averagePrice"];
      this.totalPrice = _data["totalPrice"];
    }
  }

  static fromJS(data: any): RegionalStatCountry {
    data = typeof data === 'object' ? data : {};
    let result = new RegionalStatCountry();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["countryName"] = this.countryName;
    data["sales"] = this.sales;
    if (Array.isArray(this.change)) {
      data["change"] = [];
      for (let item of this.change)
        data["change"].push(item);
    }
    data["averagePrice"] = this.averagePrice;
    data["totalPrice"] = this.totalPrice;
    return data;
  }
}

export interface IRegionalStatCountry {
  countryName: string | undefined;
  sales: number;
  change: number[] | undefined;
  averagePrice: number;
  totalPrice: number;
}

export class RegisterInput implements IRegisterInput {
  name!: string;
  surname!: string;
  userName!: string;
  emailAddress!: string;
  password!: string;
  captchaResponse!: string | undefined;

  constructor(data?: IRegisterInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.userName = _data["userName"];
      this.emailAddress = _data["emailAddress"];
      this.password = _data["password"];
      this.captchaResponse = _data["captchaResponse"];
    }
  }

  static fromJS(data: any): RegisterInput {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["userName"] = this.userName;
    data["emailAddress"] = this.emailAddress;
    data["password"] = this.password;
    data["captchaResponse"] = this.captchaResponse;
    return data;
  }
}

export interface IRegisterInput {
  name: string;
  surname: string;
  userName: string;
  emailAddress: string;
  password: string;
  captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
  canLogin!: boolean;

  constructor(data?: IRegisterOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.canLogin = _data["canLogin"];
    }
  }

  static fromJS(data: any): RegisterOutput {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["canLogin"] = this.canLogin;
    return data;
  }
}

export interface IRegisterOutput {
  canLogin: boolean;
}

export class RegisterTenantInput implements IRegisterTenantInput {
  tenancyName!: string;
  name!: string;
  adminEmailAddress!: string;
  adminPassword!: string | undefined;
  captchaResponse!: string | undefined;
  subscriptionStartType!: SubscriptionStartType;
  editionId!: number | undefined;

  constructor(data?: IRegisterTenantInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
      this.name = _data["name"];
      this.adminEmailAddress = _data["adminEmailAddress"];
      this.adminPassword = _data["adminPassword"];
      this.captchaResponse = _data["captchaResponse"];
      this.subscriptionStartType = _data["subscriptionStartType"];
      this.editionId = _data["editionId"];
    }
  }

  static fromJS(data: any): RegisterTenantInput {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterTenantInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenancyName"] = this.tenancyName;
    data["name"] = this.name;
    data["adminEmailAddress"] = this.adminEmailAddress;
    data["adminPassword"] = this.adminPassword;
    data["captchaResponse"] = this.captchaResponse;
    data["subscriptionStartType"] = this.subscriptionStartType;
    data["editionId"] = this.editionId;
    return data;
  }
}

export interface IRegisterTenantInput {
  tenancyName: string;
  name: string;
  adminEmailAddress: string;
  adminPassword: string | undefined;
  captchaResponse: string | undefined;
  subscriptionStartType: SubscriptionStartType;
  editionId: number | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
  tenantId!: number;
  tenancyName!: string | undefined;
  name!: string | undefined;
  userName!: string | undefined;
  emailAddress!: string | undefined;
  isTenantActive!: boolean;
  isActive!: boolean;
  isEmailConfirmationRequired!: boolean;

  constructor(data?: IRegisterTenantOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.tenancyName = _data["tenancyName"];
      this.name = _data["name"];
      this.userName = _data["userName"];
      this.emailAddress = _data["emailAddress"];
      this.isTenantActive = _data["isTenantActive"];
      this.isActive = _data["isActive"];
      this.isEmailConfirmationRequired = _data["isEmailConfirmationRequired"];
    }
  }

  static fromJS(data: any): RegisterTenantOutput {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterTenantOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["tenancyName"] = this.tenancyName;
    data["name"] = this.name;
    data["userName"] = this.userName;
    data["emailAddress"] = this.emailAddress;
    data["isTenantActive"] = this.isTenantActive;
    data["isActive"] = this.isActive;
    data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
    return data;
  }
}

export interface IRegisterTenantOutput {
  tenantId: number;
  tenancyName: string | undefined;
  name: string | undefined;
  userName: string | undefined;
  emailAddress: string | undefined;
  isTenantActive: boolean;
  isActive: boolean;
  isEmailConfirmationRequired: boolean;
}

export class RenamePageInput implements IRenamePageInput {
  dashboardName!: string | undefined;
  id!: string | undefined;
  name!: string | undefined;
  application!: string | undefined;

  constructor(data?: IRenamePageInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dashboardName = _data["dashboardName"];
      this.id = _data["id"];
      this.name = _data["name"];
      this.application = _data["application"];
    }
  }

  static fromJS(data: any): RenamePageInput {
    data = typeof data === 'object' ? data : {};
    let result = new RenamePageInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dashboardName"] = this.dashboardName;
    data["id"] = this.id;
    data["name"] = this.name;
    data["application"] = this.application;
    return data;
  }
}

export interface IRenamePageInput {
  dashboardName: string | undefined;
  id: string | undefined;
  name: string | undefined;
  application: string | undefined;
}

export class ResetPasswordInput implements IResetPasswordInput {
  userId!: number;
  resetCode!: string | undefined;
  password!: string | undefined;
  returnUrl!: string | undefined;
  singleSignIn!: string | undefined;
  c!: string | undefined;

  constructor(data?: IResetPasswordInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.resetCode = _data["resetCode"];
      this.password = _data["password"];
      this.returnUrl = _data["returnUrl"];
      this.singleSignIn = _data["singleSignIn"];
      this.c = _data["c"];
    }
  }

  static fromJS(data: any): ResetPasswordInput {
    data = typeof data === 'object' ? data : {};
    let result = new ResetPasswordInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["resetCode"] = this.resetCode;
    data["password"] = this.password;
    data["returnUrl"] = this.returnUrl;
    data["singleSignIn"] = this.singleSignIn;
    data["c"] = this.c;
    return data;
  }
}

export interface IResetPasswordInput {
  userId: number;
  resetCode: string | undefined;
  password: string | undefined;
  returnUrl: string | undefined;
  singleSignIn: string | undefined;
  c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
  canLogin!: boolean;
  userName!: string | undefined;

  constructor(data?: IResetPasswordOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.canLogin = _data["canLogin"];
      this.userName = _data["userName"];
    }
  }

  static fromJS(data: any): ResetPasswordOutput {
    data = typeof data === 'object' ? data : {};
    let result = new ResetPasswordOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["canLogin"] = this.canLogin;
    data["userName"] = this.userName;
    return data;
  }
}

export interface IResetPasswordOutput {
  canLogin: boolean;
  userName: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
  c!: string | undefined;

  constructor(data?: IResolveTenantIdInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.c = _data["c"];
    }
  }

  static fromJS(data: any): ResolveTenantIdInput {
    data = typeof data === 'object' ? data : {};
    let result = new ResolveTenantIdInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["c"] = this.c;
    return data;
  }
}

export interface IResolveTenantIdInput {
  c: string | undefined;
}

export class RoleEditDto implements IRoleEditDto {
  id!: number | undefined;
  displayName!: string;
  isDefault!: boolean;

  constructor(data?: IRoleEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
      this.isDefault = _data["isDefault"];
    }
  }

  static fromJS(data: any): RoleEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new RoleEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    data["isDefault"] = this.isDefault;
    return data;
  }
}

export interface IRoleEditDto {
  id: number | undefined;
  displayName: string;
  isDefault: boolean;
}

export class RoleListDto implements IRoleListDto {
  name!: string | undefined;
  displayName!: string | undefined;
  isStatic!: boolean;
  isDefault!: boolean;
  creationTime!: DateTime;
  id!: number;

  constructor(data?: IRoleListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.isStatic = _data["isStatic"];
      this.isDefault = _data["isDefault"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): RoleListDto {
    data = typeof data === 'object' ? data : {};
    let result = new RoleListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["isStatic"] = this.isStatic;
    data["isDefault"] = this.isDefault;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IRoleListDto {
  name: string | undefined;
  displayName: string | undefined;
  isStatic: boolean;
  isDefault: boolean;
  creationTime: DateTime;
  id: number;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
  roleIds!: number[] | undefined;
  organizationUnitId!: number;

  constructor(data?: IRolesToOrganizationUnitInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["roleIds"])) {
        this.roleIds = [] as any;
        for (let item of _data["roleIds"])
          this.roleIds!.push(item);
      }
      this.organizationUnitId = _data["organizationUnitId"];
    }
  }

  static fromJS(data: any): RolesToOrganizationUnitInput {
    data = typeof data === 'object' ? data : {};
    let result = new RolesToOrganizationUnitInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.roleIds)) {
      data["roleIds"] = [];
      for (let item of this.roleIds)
        data["roleIds"].push(item);
    }
    data["organizationUnitId"] = this.organizationUnitId;
    return data;
  }
}

export interface IRolesToOrganizationUnitInput {
  roleIds: number[] | undefined;
  organizationUnitId: number;
}

export class SalesSummaryData implements ISalesSummaryData {
  period!: string | undefined;
  sales!: number;
  profit!: number;

  constructor(data?: ISalesSummaryData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.period = _data["period"];
      this.sales = _data["sales"];
      this.profit = _data["profit"];
    }
  }

  static fromJS(data: any): SalesSummaryData {
    data = typeof data === 'object' ? data : {};
    let result = new SalesSummaryData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["period"] = this.period;
    data["sales"] = this.sales;
    data["profit"] = this.profit;
    return data;
  }
}

export interface ISalesSummaryData {
  period: string | undefined;
  sales: number;
  profit: number;
}

export enum SalesSummaryDatePeriod {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
}

export class SavePageInput implements ISavePageInput {
  dashboardName!: string | undefined;
  application!: string | undefined;
  pages!: Page[] | undefined;

  constructor(data?: ISavePageInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dashboardName = _data["dashboardName"];
      this.application = _data["application"];
      if (Array.isArray(_data["pages"])) {
        this.pages = [] as any;
        for (let item of _data["pages"])
          this.pages!.push(Page.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SavePageInput {
    data = typeof data === 'object' ? data : {};
    let result = new SavePageInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dashboardName"] = this.dashboardName;
    data["application"] = this.application;
    if (Array.isArray(this.pages)) {
      data["pages"] = [];
      for (let item of this.pages)
        data["pages"].push(item.toJSON());
    }
    return data;
  }
}

export interface ISavePageInput {
  dashboardName: string | undefined;
  application: string | undefined;
  pages: Page[] | undefined;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
  allowOneConcurrentLoginPerUser!: boolean;
  useDefaultPasswordComplexitySettings!: boolean;
  passwordComplexity!: PasswordComplexitySetting;
  defaultPasswordComplexity!: PasswordComplexitySetting;
  userLockOut!: UserLockOutSettingsEditDto;
  twoFactorLogin!: TwoFactorLoginSettingsEditDto;

  constructor(data?: ISecuritySettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.allowOneConcurrentLoginPerUser = _data["allowOneConcurrentLoginPerUser"];
      this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
      this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"]) : <any>undefined;
      this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"]) : <any>undefined;
      this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"]) : <any>undefined;
      this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"]) : <any>undefined;
    }
  }

  static fromJS(data: any): SecuritySettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new SecuritySettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
    data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
    data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
    data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
    data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
    data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
    return data;
  }
}

export interface ISecuritySettingsEditDto {
  allowOneConcurrentLoginPerUser: boolean;
  useDefaultPasswordComplexitySettings: boolean;
  passwordComplexity: PasswordComplexitySetting;
  defaultPasswordComplexity: PasswordComplexitySetting;
  userLockOut: UserLockOutSettingsEditDto;
  twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
  emailAddress!: string;

  constructor(data?: ISendEmailActivationLinkInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data["emailAddress"];
    }
  }

  static fromJS(data: any): SendEmailActivationLinkInput {
    data = typeof data === 'object' ? data : {};
    let result = new SendEmailActivationLinkInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["emailAddress"] = this.emailAddress;
    return data;
  }
}

export interface ISendEmailActivationLinkInput {
  emailAddress: string;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
  emailAddress!: string;

  constructor(data?: ISendPasswordResetCodeInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data["emailAddress"];
    }
  }

  static fromJS(data: any): SendPasswordResetCodeInput {
    data = typeof data === 'object' ? data : {};
    let result = new SendPasswordResetCodeInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["emailAddress"] = this.emailAddress;
    return data;
  }
}

export interface ISendPasswordResetCodeInput {
  emailAddress: string;
}

export class SendTestEmailInput implements ISendTestEmailInput {
  emailAddress!: string;

  constructor(data?: ISendTestEmailInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data["emailAddress"];
    }
  }

  static fromJS(data: any): SendTestEmailInput {
    data = typeof data === 'object' ? data : {};
    let result = new SendTestEmailInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["emailAddress"] = this.emailAddress;
    return data;
  }
}

export interface ISendTestEmailInput {
  emailAddress: string;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
  userId!: number;
  provider!: string;

  constructor(data?: ISendTwoFactorAuthCodeModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.provider = _data["provider"];
    }
  }

  static fromJS(data: any): SendTwoFactorAuthCodeModel {
    data = typeof data === 'object' ? data : {};
    let result = new SendTwoFactorAuthCodeModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["provider"] = this.provider;
    return data;
  }
}

export interface ISendTwoFactorAuthCodeModel {
  userId: number;
  provider: string;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
  phoneNumber!: string | undefined;

  constructor(data?: ISendVerificationSmsInputDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.phoneNumber = _data["phoneNumber"];
    }
  }

  static fromJS(data: any): SendVerificationSmsInputDto {
    data = typeof data === 'object' ? data : {};
    let result = new SendVerificationSmsInputDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["phoneNumber"] = this.phoneNumber;
    return data;
  }
}

export interface ISendVerificationSmsInputDto {
  phoneNumber: string | undefined;
}

export class SessionTimeOutSettingsEditDto implements ISessionTimeOutSettingsEditDto {
  isEnabled!: boolean;
  timeOutSecond!: number;
  showTimeOutNotificationSecond!: number;
  showLockScreenWhenTimedOut!: boolean;

  constructor(data?: ISessionTimeOutSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isEnabled = _data["isEnabled"];
      this.timeOutSecond = _data["timeOutSecond"];
      this.showTimeOutNotificationSecond = _data["showTimeOutNotificationSecond"];
      this.showLockScreenWhenTimedOut = _data["showLockScreenWhenTimedOut"];
    }
  }

  static fromJS(data: any): SessionTimeOutSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new SessionTimeOutSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isEnabled"] = this.isEnabled;
    data["timeOutSecond"] = this.timeOutSecond;
    data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
    data["showLockScreenWhenTimedOut"] = this.showLockScreenWhenTimedOut;
    return data;
  }
}

export interface ISessionTimeOutSettingsEditDto {
  isEnabled: boolean;
  timeOutSecond: number;
  showTimeOutNotificationSecond: number;
  showLockScreenWhenTimedOut: boolean;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
  name!: string;

  constructor(data?: ISetDefaultLanguageInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): SetDefaultLanguageInput {
    data = typeof data === 'object' ? data : {};
    let result = new SetDefaultLanguageInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    return data;
  }
}

export interface ISetDefaultLanguageInput {
  name: string;
}

export class SetNotificationAsReadOutput implements ISetNotificationAsReadOutput {
  success!: boolean;

  constructor(data?: ISetNotificationAsReadOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.success = _data["success"];
    }
  }

  static fromJS(data: any): SetNotificationAsReadOutput {
    data = typeof data === 'object' ? data : {};
    let result = new SetNotificationAsReadOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["success"] = this.success;
    return data;
  }
}

export interface ISetNotificationAsReadOutput {
  success: boolean;
}

export enum SettingScopes {
  Application = 1,
  Tenant = 2,
  User = 4,
  All = 7,
}

export class StringOutput implements IStringOutput {
  output!: string | undefined;

  constructor(data?: IStringOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.output = _data["output"];
    }
  }

  static fromJS(data: any): StringOutput {
    data = typeof data === 'object' ? data : {};
    let result = new StringOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["output"] = this.output;
    return data;
  }
}

export interface IStringOutput {
  output: string | undefined;
}

export class StripeConfigurationDto implements IStripeConfigurationDto {
  publishableKey!: string | undefined;

  constructor(data?: IStripeConfigurationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.publishableKey = _data["publishableKey"];
    }
  }

  static fromJS(data: any): StripeConfigurationDto {
    data = typeof data === 'object' ? data : {};
    let result = new StripeConfigurationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["publishableKey"] = this.publishableKey;
    return data;
  }
}

export interface IStripeConfigurationDto {
  publishableKey: string | undefined;
}

export class StripeCreatePaymentSessionInput implements IStripeCreatePaymentSessionInput {
  paymentId!: number;
  successUrl!: string | undefined;
  cancelUrl!: string | undefined;

  constructor(data?: IStripeCreatePaymentSessionInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.paymentId = _data["paymentId"];
      this.successUrl = _data["successUrl"];
      this.cancelUrl = _data["cancelUrl"];
    }
  }

  static fromJS(data: any): StripeCreatePaymentSessionInput {
    data = typeof data === 'object' ? data : {};
    let result = new StripeCreatePaymentSessionInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["paymentId"] = this.paymentId;
    data["successUrl"] = this.successUrl;
    data["cancelUrl"] = this.cancelUrl;
    return data;
  }
}

export interface IStripeCreatePaymentSessionInput {
  paymentId: number;
  successUrl: string | undefined;
  cancelUrl: string | undefined;
}

export class StripePaymentResultOutput implements IStripePaymentResultOutput {
  paymentDone!: boolean;

  constructor(data?: IStripePaymentResultOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.paymentDone = _data["paymentDone"];
    }
  }

  static fromJS(data: any): StripePaymentResultOutput {
    data = typeof data === 'object' ? data : {};
    let result = new StripePaymentResultOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["paymentDone"] = this.paymentDone;
    return data;
  }
}

export interface IStripePaymentResultOutput {
  paymentDone: boolean;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
  isFree!: boolean | undefined;
  value!: string | undefined;
  displayText!: string | undefined;
  isSelected!: boolean;

  constructor(data?: ISubscribableEditionComboboxItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isFree = _data["isFree"];
      this.value = _data["value"];
      this.displayText = _data["displayText"];
      this.isSelected = _data["isSelected"];
    }
  }

  static fromJS(data: any): SubscribableEditionComboboxItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new SubscribableEditionComboboxItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isFree"] = this.isFree;
    data["value"] = this.value;
    data["displayText"] = this.displayText;
    data["isSelected"] = this.isSelected;
    return data;
  }
}

export interface ISubscribableEditionComboboxItemDto {
  isFree: boolean | undefined;
  value: string | undefined;
  displayText: string | undefined;
  isSelected: boolean;
}

export class SubscriptionPaymentDto implements ISubscriptionPaymentDto {
  description!: string | undefined;
  gateway!: SubscriptionPaymentGatewayType;
  amount!: number;
  editionId!: number;
  tenantId!: number;
  dayCount!: number;
  paymentPeriodType!: PaymentPeriodType;
  paymentId!: string | undefined;
  payerId!: string | undefined;
  editionDisplayName!: string | undefined;
  invoiceNo!: number;
  status!: SubscriptionPaymentStatus;
  isRecurring!: boolean;
  externalPaymentId!: string | undefined;
  successUrl!: string | undefined;
  errorUrl!: string | undefined;
  editionPaymentType!: EditionPaymentType;
  id!: number;

  constructor(data?: ISubscriptionPaymentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.description = _data["description"];
      this.gateway = _data["gateway"];
      this.amount = _data["amount"];
      this.editionId = _data["editionId"];
      this.tenantId = _data["tenantId"];
      this.dayCount = _data["dayCount"];
      this.paymentPeriodType = _data["paymentPeriodType"];
      this.paymentId = _data["paymentId"];
      this.payerId = _data["payerId"];
      this.editionDisplayName = _data["editionDisplayName"];
      this.invoiceNo = _data["invoiceNo"];
      this.status = _data["status"];
      this.isRecurring = _data["isRecurring"];
      this.externalPaymentId = _data["externalPaymentId"];
      this.successUrl = _data["successUrl"];
      this.errorUrl = _data["errorUrl"];
      this.editionPaymentType = _data["editionPaymentType"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): SubscriptionPaymentDto {
    data = typeof data === 'object' ? data : {};
    let result = new SubscriptionPaymentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["description"] = this.description;
    data["gateway"] = this.gateway;
    data["amount"] = this.amount;
    data["editionId"] = this.editionId;
    data["tenantId"] = this.tenantId;
    data["dayCount"] = this.dayCount;
    data["paymentPeriodType"] = this.paymentPeriodType;
    data["paymentId"] = this.paymentId;
    data["payerId"] = this.payerId;
    data["editionDisplayName"] = this.editionDisplayName;
    data["invoiceNo"] = this.invoiceNo;
    data["status"] = this.status;
    data["isRecurring"] = this.isRecurring;
    data["externalPaymentId"] = this.externalPaymentId;
    data["successUrl"] = this.successUrl;
    data["errorUrl"] = this.errorUrl;
    data["editionPaymentType"] = this.editionPaymentType;
    data["id"] = this.id;
    return data;
  }
}

export interface ISubscriptionPaymentDto {
  description: string | undefined;
  gateway: SubscriptionPaymentGatewayType;
  amount: number;
  editionId: number;
  tenantId: number;
  dayCount: number;
  paymentPeriodType: PaymentPeriodType;
  paymentId: string | undefined;
  payerId: string | undefined;
  editionDisplayName: string | undefined;
  invoiceNo: number;
  status: SubscriptionPaymentStatus;
  isRecurring: boolean;
  externalPaymentId: string | undefined;
  successUrl: string | undefined;
  errorUrl: string | undefined;
  editionPaymentType: EditionPaymentType;
  id: number;
}

export enum SubscriptionPaymentGatewayType {
  Paypal = 1,
  Stripe = 2,
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
  gateway!: string | undefined;
  amount!: number;
  editionId!: number;
  dayCount!: number;
  paymentPeriodType!: string | undefined;
  externalPaymentId!: string | undefined;
  payerId!: string | undefined;
  status!: string | undefined;
  editionDisplayName!: string | undefined;
  tenantId!: number;
  invoiceNo!: string | undefined;
  lastModificationTime!: DateTime | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: DateTime;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: ISubscriptionPaymentListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.gateway = _data["gateway"];
      this.amount = _data["amount"];
      this.editionId = _data["editionId"];
      this.dayCount = _data["dayCount"];
      this.paymentPeriodType = _data["paymentPeriodType"];
      this.externalPaymentId = _data["externalPaymentId"];
      this.payerId = _data["payerId"];
      this.status = _data["status"];
      this.editionDisplayName = _data["editionDisplayName"];
      this.tenantId = _data["tenantId"];
      this.invoiceNo = _data["invoiceNo"];
      this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): SubscriptionPaymentListDto {
    data = typeof data === 'object' ? data : {};
    let result = new SubscriptionPaymentListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["gateway"] = this.gateway;
    data["amount"] = this.amount;
    data["editionId"] = this.editionId;
    data["dayCount"] = this.dayCount;
    data["paymentPeriodType"] = this.paymentPeriodType;
    data["externalPaymentId"] = this.externalPaymentId;
    data["payerId"] = this.payerId;
    data["status"] = this.status;
    data["editionDisplayName"] = this.editionDisplayName;
    data["tenantId"] = this.tenantId;
    data["invoiceNo"] = this.invoiceNo;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }
}

export interface ISubscriptionPaymentListDto {
  gateway: string | undefined;
  amount: number;
  editionId: number;
  dayCount: number;
  paymentPeriodType: string | undefined;
  externalPaymentId: string | undefined;
  payerId: string | undefined;
  status: string | undefined;
  editionDisplayName: string | undefined;
  tenantId: number;
  invoiceNo: string | undefined;
  lastModificationTime: DateTime | undefined;
  lastModifierUserId: number | undefined;
  creationTime: DateTime;
  creatorUserId: number | undefined;
  id: number;
}

export enum SubscriptionPaymentStatus {
  NotPaid = 1,
  Paid = 2,
  Failed = 3,
  Cancelled = 4,
  Completed = 5,
}

export enum SubscriptionPaymentType {
  Manual = 0,
  RecurringAutomatic = 1,
  RecurringManual = 2,
}

export enum SubscriptionStartType {
  Free = 1,
  Trial = 2,
  Paid = 3,
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
  accessToken!: string | undefined;
  encryptedAccessToken!: string | undefined;
  expireInSeconds!: number;

  constructor(data?: ISwitchedAccountAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.encryptedAccessToken = _data["encryptedAccessToken"];
      this.expireInSeconds = _data["expireInSeconds"];
    }
  }

  static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new SwitchedAccountAuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["accessToken"] = this.accessToken;
    data["encryptedAccessToken"] = this.encryptedAccessToken;
    data["expireInSeconds"] = this.expireInSeconds;
    return data;
  }
}

export interface ISwitchedAccountAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
  targetTenantId!: number | undefined;
  targetUserId!: number;

  constructor(data?: ISwitchToLinkedAccountInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.targetTenantId = _data["targetTenantId"];
      this.targetUserId = _data["targetUserId"];
    }
  }

  static fromJS(data: any): SwitchToLinkedAccountInput {
    data = typeof data === 'object' ? data : {};
    let result = new SwitchToLinkedAccountInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["targetTenantId"] = this.targetTenantId;
    data["targetUserId"] = this.targetUserId;
    return data;
  }
}

export interface ISwitchToLinkedAccountInput {
  targetTenantId: number | undefined;
  targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
  switchAccountToken!: string | undefined;
  tenancyName!: string | undefined;

  constructor(data?: ISwitchToLinkedAccountOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.switchAccountToken = _data["switchAccountToken"];
      this.tenancyName = _data["tenancyName"];
    }
  }

  static fromJS(data: any): SwitchToLinkedAccountOutput {
    data = typeof data === 'object' ? data : {};
    let result = new SwitchToLinkedAccountOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["switchAccountToken"] = this.switchAccountToken;
    data["tenancyName"] = this.tenancyName;
    return data;
  }
}

export interface ISwitchToLinkedAccountOutput {
  switchAccountToken: string | undefined;
  tenancyName: string | undefined;
}

export enum TaskType {
  Work = 0,
  Application = 1,
  MeetingOrVisit = 2,
}

export enum TenantAvailabilityState {
  Available = 1,
  InActive = 2,
  NotFound = 3,
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
  legalName!: string | undefined;
  address!: string | undefined;
  taxVatNo!: string | undefined;

  constructor(data?: ITenantBillingSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.legalName = _data["legalName"];
      this.address = _data["address"];
      this.taxVatNo = _data["taxVatNo"];
    }
  }

  static fromJS(data: any): TenantBillingSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantBillingSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["legalName"] = this.legalName;
    data["address"] = this.address;
    data["taxVatNo"] = this.taxVatNo;
    return data;
  }
}

export interface ITenantBillingSettingsEditDto {
  legalName: string | undefined;
  address: string | undefined;
  taxVatNo: string | undefined;
}

export class TenantEditDto implements ITenantEditDto {
  tenancyName!: string;
  name!: string;
  connectionString!: string | undefined;
  editionId!: number | undefined;
  isActive!: boolean;
  subscriptionEndDateUtc!: DateTime | undefined;
  isInTrialPeriod!: boolean;
  id!: number;

  constructor(data?: ITenantEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
      this.name = _data["name"];
      this.connectionString = _data["connectionString"];
      this.editionId = _data["editionId"];
      this.isActive = _data["isActive"];
      this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
      this.isInTrialPeriod = _data["isInTrialPeriod"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TenantEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenancyName"] = this.tenancyName;
    data["name"] = this.name;
    data["connectionString"] = this.connectionString;
    data["editionId"] = this.editionId;
    data["isActive"] = this.isActive;
    data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
    data["isInTrialPeriod"] = this.isInTrialPeriod;
    data["id"] = this.id;
    return data;
  }
}

export interface ITenantEditDto {
  tenancyName: string;
  name: string;
  connectionString: string | undefined;
  editionId: number | undefined;
  isActive: boolean;
  subscriptionEndDateUtc: DateTime | undefined;
  isInTrialPeriod: boolean;
  id: number;
}

export class TenantEdition implements ITenantEdition {
  label!: string | undefined;
  value!: number;

  constructor(data?: ITenantEdition) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.label = _data["label"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): TenantEdition {
    data = typeof data === 'object' ? data : {};
    let result = new TenantEdition();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["label"] = this.label;
    data["value"] = this.value;
    return data;
  }
}

export interface ITenantEdition {
  label: string | undefined;
  value: number;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
  useHostDefaultEmailSettings!: boolean;
  defaultFromAddress!: string | undefined;
  defaultFromDisplayName!: string | undefined;
  smtpHost!: string | undefined;
  smtpPort!: number;
  smtpUserName!: string | undefined;
  smtpPassword!: string | undefined;
  smtpDomain!: string | undefined;
  smtpEnableSsl!: boolean;
  smtpUseDefaultCredentials!: boolean;

  constructor(data?: ITenantEmailSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.useHostDefaultEmailSettings = _data["useHostDefaultEmailSettings"];
      this.defaultFromAddress = _data["defaultFromAddress"];
      this.defaultFromDisplayName = _data["defaultFromDisplayName"];
      this.smtpHost = _data["smtpHost"];
      this.smtpPort = _data["smtpPort"];
      this.smtpUserName = _data["smtpUserName"];
      this.smtpPassword = _data["smtpPassword"];
      this.smtpDomain = _data["smtpDomain"];
      this.smtpEnableSsl = _data["smtpEnableSsl"];
      this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
    }
  }

  static fromJS(data: any): TenantEmailSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantEmailSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
    data["defaultFromAddress"] = this.defaultFromAddress;
    data["defaultFromDisplayName"] = this.defaultFromDisplayName;
    data["smtpHost"] = this.smtpHost;
    data["smtpPort"] = this.smtpPort;
    data["smtpUserName"] = this.smtpUserName;
    data["smtpPassword"] = this.smtpPassword;
    data["smtpDomain"] = this.smtpDomain;
    data["smtpEnableSsl"] = this.smtpEnableSsl;
    data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
    return data;
  }
}

export interface ITenantEmailSettingsEditDto {
  useHostDefaultEmailSettings: boolean;
  defaultFromAddress: string | undefined;
  defaultFromDisplayName: string | undefined;
  smtpHost: string | undefined;
  smtpPort: number;
  smtpUserName: string | undefined;
  smtpPassword: string | undefined;
  smtpDomain: string | undefined;
  smtpEnableSsl: boolean;
  smtpUseDefaultCredentials: boolean;
}

export class TenantListDto implements ITenantListDto {
  tenancyName!: string | undefined;
  name!: string | undefined;
  editionDisplayName!: string | undefined;
  connectionString!: string | undefined;
  isActive!: boolean;
  creationTime!: DateTime;
  subscriptionEndDateUtc!: DateTime | undefined;
  editionId!: number | undefined;
  isInTrialPeriod!: boolean;
  id!: number;

  constructor(data?: ITenantListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
      this.name = _data["name"];
      this.editionDisplayName = _data["editionDisplayName"];
      this.connectionString = _data["connectionString"];
      this.isActive = _data["isActive"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
      this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
      this.editionId = _data["editionId"];
      this.isInTrialPeriod = _data["isInTrialPeriod"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TenantListDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenancyName"] = this.tenancyName;
    data["name"] = this.name;
    data["editionDisplayName"] = this.editionDisplayName;
    data["connectionString"] = this.connectionString;
    data["isActive"] = this.isActive;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
    data["editionId"] = this.editionId;
    data["isInTrialPeriod"] = this.isInTrialPeriod;
    data["id"] = this.id;
    return data;
  }
}

export interface ITenantListDto {
  tenancyName: string | undefined;
  name: string | undefined;
  editionDisplayName: string | undefined;
  connectionString: string | undefined;
  isActive: boolean;
  creationTime: DateTime;
  subscriptionEndDateUtc: DateTime | undefined;
  editionId: number | undefined;
  isInTrialPeriod: boolean;
  id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
  tenancyName!: string | undefined;
  name!: string | undefined;
  logoId!: string | undefined;
  logoFileType!: string | undefined;
  customCssId!: string | undefined;
  subscriptionEndDateUtc!: DateTime | undefined;
  isInTrialPeriod!: boolean;
  subscriptionPaymentType!: SubscriptionPaymentType;
  edition!: EditionInfoDto;
  featureValues!: NameValueDto[] | undefined;
  creationTime!: DateTime;
  paymentPeriodType!: PaymentPeriodType;
  subscriptionDateString!: string | undefined;
  creationTimeString!: string | undefined;
  id!: number;

  constructor(data?: ITenantLoginInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
      this.name = _data["name"];
      this.logoId = _data["logoId"];
      this.logoFileType = _data["logoFileType"];
      this.customCssId = _data["customCssId"];
      this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
      this.isInTrialPeriod = _data["isInTrialPeriod"];
      this.subscriptionPaymentType = _data["subscriptionPaymentType"];
      this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : <any>undefined;
      if (Array.isArray(_data["featureValues"])) {
        this.featureValues = [] as any;
        for (let item of _data["featureValues"])
          this.featureValues!.push(NameValueDto.fromJS(item));
      }
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
      this.paymentPeriodType = _data["paymentPeriodType"];
      this.subscriptionDateString = _data["subscriptionDateString"];
      this.creationTimeString = _data["creationTimeString"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TenantLoginInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantLoginInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenancyName"] = this.tenancyName;
    data["name"] = this.name;
    data["logoId"] = this.logoId;
    data["logoFileType"] = this.logoFileType;
    data["customCssId"] = this.customCssId;
    data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
    data["isInTrialPeriod"] = this.isInTrialPeriod;
    data["subscriptionPaymentType"] = this.subscriptionPaymentType;
    data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
    if (Array.isArray(this.featureValues)) {
      data["featureValues"] = [];
      for (let item of this.featureValues)
        data["featureValues"].push(item.toJSON());
    }
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    data["paymentPeriodType"] = this.paymentPeriodType;
    data["subscriptionDateString"] = this.subscriptionDateString;
    data["creationTimeString"] = this.creationTimeString;
    data["id"] = this.id;
    return data;
  }
}

export interface ITenantLoginInfoDto {
  tenancyName: string | undefined;
  name: string | undefined;
  logoId: string | undefined;
  logoFileType: string | undefined;
  customCssId: string | undefined;
  subscriptionEndDateUtc: DateTime | undefined;
  isInTrialPeriod: boolean;
  subscriptionPaymentType: SubscriptionPaymentType;
  edition: EditionInfoDto;
  featureValues: NameValueDto[] | undefined;
  creationTime: DateTime;
  paymentPeriodType: PaymentPeriodType;
  subscriptionDateString: string | undefined;
  creationTimeString: string | undefined;
  id: number;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
  allowSelfRegistration!: boolean;
  isNewRegisteredTenantActiveByDefault!: boolean;
  useCaptchaOnRegistration!: boolean;
  defaultEditionId!: number | undefined;

  constructor(data?: ITenantManagementSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.allowSelfRegistration = _data["allowSelfRegistration"];
      this.isNewRegisteredTenantActiveByDefault = _data["isNewRegisteredTenantActiveByDefault"];
      this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
      this.defaultEditionId = _data["defaultEditionId"];
    }
  }

  static fromJS(data: any): TenantManagementSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantManagementSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["allowSelfRegistration"] = this.allowSelfRegistration;
    data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
    data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
    data["defaultEditionId"] = this.defaultEditionId;
    return data;
  }
}

export interface ITenantManagementSettingsEditDto {
  allowSelfRegistration: boolean;
  isNewRegisteredTenantActiveByDefault: boolean;
  useCaptchaOnRegistration: boolean;
  defaultEditionId: number | undefined;
}

export class TenantNotification implements ITenantNotification {
  tenantId!: number | undefined;
  notificationName!: string | undefined;
  data!: NotificationData;
  entityType!: string | undefined;
  entityTypeName!: string | undefined;
  entityId!: any | undefined;
  severity!: NotificationSeverity;
  creationTime!: DateTime;
  id!: string;

  constructor(data?: ITenantNotification) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.notificationName = _data["notificationName"];
      this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
      this.entityType = _data["entityType"];
      this.entityTypeName = _data["entityTypeName"];
      this.entityId = _data["entityId"];
      this.severity = _data["severity"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TenantNotification {
    data = typeof data === 'object' ? data : {};
    let result = new TenantNotification();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["notificationName"] = this.notificationName;
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    data["entityType"] = this.entityType;
    data["entityTypeName"] = this.entityTypeName;
    data["entityId"] = this.entityId;
    data["severity"] = this.severity;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface ITenantNotification {
  tenantId: number | undefined;
  notificationName: string | undefined;
  data: NotificationData;
  entityType: string | undefined;
  entityTypeName: string | undefined;
  entityId: any | undefined;
  severity: NotificationSeverity;
  creationTime: DateTime;
  id: string;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
  isQuickThemeSelectEnabled!: boolean;

  constructor(data?: ITenantOtherSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
    }
  }

  static fromJS(data: any): TenantOtherSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantOtherSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
    return data;
  }
}

export interface ITenantOtherSettingsEditDto {
  isQuickThemeSelectEnabled: boolean;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
  general!: GeneralSettingsEditDto;
  userManagement!: TenantUserManagementSettingsEditDto;
  email!: TenantEmailSettingsEditDto;
  ldap!: LdapSettingsEditDto;
  security!: SecuritySettingsEditDto;
  billing!: TenantBillingSettingsEditDto;
  otherSettings!: TenantOtherSettingsEditDto;
  externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

  constructor(data?: ITenantSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.userManagement = new TenantUserManagementSettingsEditDto();
      this.security = new SecuritySettingsEditDto();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : <any>undefined;
      this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new TenantUserManagementSettingsEditDto();
      this.email = _data["email"] ? TenantEmailSettingsEditDto.fromJS(_data["email"]) : <any>undefined;
      this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"]) : <any>undefined;
      this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
      this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
      this.otherSettings = _data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
      this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
    }
  }

  static fromJS(data: any): TenantSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["general"] = this.general ? this.general.toJSON() : <any>undefined;
    data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
    data["email"] = this.email ? this.email.toJSON() : <any>undefined;
    data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
    data["security"] = this.security ? this.security.toJSON() : <any>undefined;
    data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
    data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
    data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
    return data;
  }
}

export interface ITenantSettingsEditDto {
  general: GeneralSettingsEditDto;
  userManagement: TenantUserManagementSettingsEditDto;
  email: TenantEmailSettingsEditDto;
  ldap: LdapSettingsEditDto;
  security: SecuritySettingsEditDto;
  billing: TenantBillingSettingsEditDto;
  otherSettings: TenantOtherSettingsEditDto;
  externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
  allowSelfRegistration!: boolean;
  isNewRegisteredUserActiveByDefault!: boolean;
  isEmailConfirmationRequiredForLogin!: boolean;
  useCaptchaOnRegistration!: boolean;
  useCaptchaOnLogin!: boolean;
  isCookieConsentEnabled!: boolean;
  isQuickThemeSelectEnabled!: boolean;
  allowUsingGravatarProfilePicture!: boolean;
  sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

  constructor(data?: ITenantUserManagementSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.allowSelfRegistration = _data["allowSelfRegistration"];
      this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
      this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
      this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
      this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
      this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
      this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
      this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
      this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
    }
  }

  static fromJS(data: any): TenantUserManagementSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantUserManagementSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["allowSelfRegistration"] = this.allowSelfRegistration;
    data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
    data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
    data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
    data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
    data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
    data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
    data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
    data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
    return data;
  }
}

export interface ITenantUserManagementSettingsEditDto {
  allowSelfRegistration: boolean;
  isNewRegisteredUserActiveByDefault: boolean;
  isEmailConfirmationRequiredForLogin: boolean;
  useCaptchaOnRegistration: boolean;
  useCaptchaOnLogin: boolean;
  isCookieConsentEnabled: boolean;
  isQuickThemeSelectEnabled: boolean;
  allowUsingGravatarProfilePicture: boolean;
  sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
  fixedFooter!: boolean;

  constructor(data?: IThemeFooterSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fixedFooter = _data["fixedFooter"];
    }
  }

  static fromJS(data: any): ThemeFooterSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ThemeFooterSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fixedFooter"] = this.fixedFooter;
    return data;
  }
}

export interface IThemeFooterSettingsDto {
  fixedFooter: boolean;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
  readonly desktopFixedHeader!: boolean;
  readonly mobileFixedHeader!: boolean;
  minimizeDesktopHeaderType!: string | undefined;

  constructor(data?: IThemeHeaderSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).desktopFixedHeader = _data["desktopFixedHeader"];
      (<any>this).mobileFixedHeader = _data["mobileFixedHeader"];
      this.minimizeDesktopHeaderType = _data["minimizeDesktopHeaderType"];
    }
  }

  static fromJS(data: any): ThemeHeaderSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ThemeHeaderSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["desktopFixedHeader"] = this.desktopFixedHeader;
    data["mobileFixedHeader"] = this.mobileFixedHeader;
    data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
    return data;
  }
}

export interface IThemeHeaderSettingsDto {
  desktopFixedHeader: boolean;
  mobileFixedHeader: boolean;
  minimizeDesktopHeaderType: string | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
  layoutType!: string | undefined;
  darkMode!: boolean;

  constructor(data?: IThemeLayoutSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.layoutType = _data["layoutType"];
      this.darkMode = _data["darkMode"];
    }
  }

  static fromJS(data: any): ThemeLayoutSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ThemeLayoutSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["layoutType"] = this.layoutType;
    data["darkMode"] = this.darkMode;
    return data;
  }
}

export interface IThemeLayoutSettingsDto {
  layoutType: string | undefined;
  darkMode: boolean;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
  position!: string | undefined;
  asideSkin!: string | undefined;
  fixedAside!: boolean;
  allowAsideMinimizing!: boolean;
  defaultMinimizedAside!: boolean;
  submenuToggle!: string | undefined;
  searchActive!: boolean;
  enableSecondary!: boolean;
  hoverableAside!: boolean;

  constructor(data?: IThemeMenuSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.position = _data["position"];
      this.asideSkin = _data["asideSkin"];
      this.fixedAside = _data["fixedAside"];
      this.allowAsideMinimizing = _data["allowAsideMinimizing"];
      this.defaultMinimizedAside = _data["defaultMinimizedAside"];
      this.submenuToggle = _data["submenuToggle"];
      this.searchActive = _data["searchActive"];
      this.enableSecondary = _data["enableSecondary"];
      this.hoverableAside = _data["hoverableAside"];
    }
  }

  static fromJS(data: any): ThemeMenuSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ThemeMenuSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["position"] = this.position;
    data["asideSkin"] = this.asideSkin;
    data["fixedAside"] = this.fixedAside;
    data["allowAsideMinimizing"] = this.allowAsideMinimizing;
    data["defaultMinimizedAside"] = this.defaultMinimizedAside;
    data["submenuToggle"] = this.submenuToggle;
    data["searchActive"] = this.searchActive;
    data["enableSecondary"] = this.enableSecondary;
    data["hoverableAside"] = this.hoverableAside;
    return data;
  }
}

export interface IThemeMenuSettingsDto {
  position: string | undefined;
  asideSkin: string | undefined;
  fixedAside: boolean;
  allowAsideMinimizing: boolean;
  defaultMinimizedAside: boolean;
  submenuToggle: string | undefined;
  searchActive: boolean;
  enableSecondary: boolean;
  hoverableAside: boolean;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
  theme!: string | undefined;
  layout!: ThemeLayoutSettingsDto;
  header!: ThemeHeaderSettingsDto;
  subHeader!: ThemeSubHeaderSettingsDto;
  menu!: ThemeMenuSettingsDto;
  footer!: ThemeFooterSettingsDto;

  constructor(data?: IThemeSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.theme = _data["theme"];
      this.layout = _data["layout"] ? ThemeLayoutSettingsDto.fromJS(_data["layout"]) : <any>undefined;
      this.header = _data["header"] ? ThemeHeaderSettingsDto.fromJS(_data["header"]) : <any>undefined;
      this.subHeader = _data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(_data["subHeader"]) : <any>undefined;
      this.menu = _data["menu"] ? ThemeMenuSettingsDto.fromJS(_data["menu"]) : <any>undefined;
      this.footer = _data["footer"] ? ThemeFooterSettingsDto.fromJS(_data["footer"]) : <any>undefined;
    }
  }

  static fromJS(data: any): ThemeSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ThemeSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["theme"] = this.theme;
    data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
    data["header"] = this.header ? this.header.toJSON() : <any>undefined;
    data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : <any>undefined;
    data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
    data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
    return data;
  }
}

export interface IThemeSettingsDto {
  theme: string | undefined;
  layout: ThemeLayoutSettingsDto;
  header: ThemeHeaderSettingsDto;
  subHeader: ThemeSubHeaderSettingsDto;
  menu: ThemeMenuSettingsDto;
  footer: ThemeFooterSettingsDto;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
  fixedSubHeader!: boolean;
  subheaderStyle!: string | undefined;
  subheaderSize!: number;
  titleStyle!: string | undefined;
  containerStyle!: string | undefined;
  subContainerStyle!: string | undefined;

  constructor(data?: IThemeSubHeaderSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fixedSubHeader = _data["fixedSubHeader"];
      this.subheaderStyle = _data["subheaderStyle"];
      this.subheaderSize = _data["subheaderSize"];
      this.titleStyle = _data["titleStyle"];
      this.containerStyle = _data["containerStyle"];
      this.subContainerStyle = _data["subContainerStyle"];
    }
  }

  static fromJS(data: any): ThemeSubHeaderSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ThemeSubHeaderSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fixedSubHeader"] = this.fixedSubHeader;
    data["subheaderStyle"] = this.subheaderStyle;
    data["subheaderSize"] = this.subheaderSize;
    data["titleStyle"] = this.titleStyle;
    data["containerStyle"] = this.containerStyle;
    data["subContainerStyle"] = this.subContainerStyle;
    return data;
  }
}

export interface IThemeSubHeaderSettingsDto {
  fixedSubHeader: boolean;
  subheaderStyle: string | undefined;
  subheaderSize: number;
  titleStyle: string | undefined;
  containerStyle: string | undefined;
  subContainerStyle: string | undefined;
}

export class TopStatsData implements ITopStatsData {
  newTenantsCount!: number;
  newSubscriptionAmount!: number;
  dashboardPlaceholder1!: number;
  dashboardPlaceholder2!: number;

  constructor(data?: ITopStatsData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.newTenantsCount = _data["newTenantsCount"];
      this.newSubscriptionAmount = _data["newSubscriptionAmount"];
      this.dashboardPlaceholder1 = _data["dashboardPlaceholder1"];
      this.dashboardPlaceholder2 = _data["dashboardPlaceholder2"];
    }
  }

  static fromJS(data: any): TopStatsData {
    data = typeof data === 'object' ? data : {};
    let result = new TopStatsData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["newTenantsCount"] = this.newTenantsCount;
    data["newSubscriptionAmount"] = this.newSubscriptionAmount;
    data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
    data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
    return data;
  }
}

export interface ITopStatsData {
  newTenantsCount: number;
  newSubscriptionAmount: number;
  dashboardPlaceholder1: number;
  dashboardPlaceholder2: number;
}

export class TwitterExternalLoginProviderSettings implements ITwitterExternalLoginProviderSettings {
  consumerKey!: string | undefined;
  consumerSecret!: string | undefined;

  constructor(data?: ITwitterExternalLoginProviderSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.consumerKey = _data["consumerKey"];
      this.consumerSecret = _data["consumerSecret"];
    }
  }

  static fromJS(data: any): TwitterExternalLoginProviderSettings {
    data = typeof data === 'object' ? data : {};
    let result = new TwitterExternalLoginProviderSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["consumerKey"] = this.consumerKey;
    data["consumerSecret"] = this.consumerSecret;
    return data;
  }
}

export interface ITwitterExternalLoginProviderSettings {
  consumerKey: string | undefined;
  consumerSecret: string | undefined;
}

export class TwitterGetAccessTokenResponse implements ITwitterGetAccessTokenResponse {
  accessToken!: string | undefined;
  accessTokenSecret!: string | undefined;
  userId!: string | undefined;
  userName!: string | undefined;

  constructor(data?: ITwitterGetAccessTokenResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.accessTokenSecret = _data["accessTokenSecret"];
      this.userId = _data["userId"];
      this.userName = _data["userName"];
    }
  }

  static fromJS(data: any): TwitterGetAccessTokenResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TwitterGetAccessTokenResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["accessToken"] = this.accessToken;
    data["accessTokenSecret"] = this.accessTokenSecret;
    data["userId"] = this.userId;
    data["userName"] = this.userName;
    return data;
  }
}

export interface ITwitterGetAccessTokenResponse {
  accessToken: string | undefined;
  accessTokenSecret: string | undefined;
  userId: string | undefined;
  userName: string | undefined;
}

export class TwitterGetRequestTokenResponse implements ITwitterGetRequestTokenResponse {
  token!: string | undefined;
  secret!: string | undefined;
  confirmed!: boolean;
  redirectUrl!: string | undefined;

  constructor(data?: ITwitterGetRequestTokenResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data["token"];
      this.secret = _data["secret"];
      this.confirmed = _data["confirmed"];
      this.redirectUrl = _data["redirectUrl"];
    }
  }

  static fromJS(data: any): TwitterGetRequestTokenResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TwitterGetRequestTokenResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["token"] = this.token;
    data["secret"] = this.secret;
    data["confirmed"] = this.confirmed;
    data["redirectUrl"] = this.redirectUrl;
    return data;
  }
}

export interface ITwitterGetRequestTokenResponse {
  token: string | undefined;
  secret: string | undefined;
  confirmed: boolean;
  redirectUrl: string | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
  isEnabledForApplication!: boolean;
  isEnabled!: boolean;
  isEmailProviderEnabled!: boolean;
  isSmsProviderEnabled!: boolean;
  isRememberBrowserEnabled!: boolean;
  isGoogleAuthenticatorEnabled!: boolean;

  constructor(data?: ITwoFactorLoginSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isEnabledForApplication = _data["isEnabledForApplication"];
      this.isEnabled = _data["isEnabled"];
      this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
      this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
      this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
      this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
    }
  }

  static fromJS(data: any): TwoFactorLoginSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new TwoFactorLoginSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isEnabledForApplication"] = this.isEnabledForApplication;
    data["isEnabled"] = this.isEnabled;
    data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
    data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
    data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
    data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
    return data;
  }
}

export interface ITwoFactorLoginSettingsEditDto {
  isEnabledForApplication: boolean;
  isEnabled: boolean;
  isEmailProviderEnabled: boolean;
  isSmsProviderEnabled: boolean;
  isRememberBrowserEnabled: boolean;
  isGoogleAuthenticatorEnabled: boolean;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
  baseSettings!: ThemeSettingsDto;
  isLeftMenuUsed!: boolean;
  isTopMenuUsed!: boolean;
  isTabMenuUsed!: boolean;
  allowMenuScroll!: boolean;

  constructor(data?: IUiCustomizationSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.baseSettings = _data["baseSettings"] ? ThemeSettingsDto.fromJS(_data["baseSettings"]) : <any>undefined;
      this.isLeftMenuUsed = _data["isLeftMenuUsed"];
      this.isTopMenuUsed = _data["isTopMenuUsed"];
      this.isTabMenuUsed = _data["isTabMenuUsed"];
      this.allowMenuScroll = _data["allowMenuScroll"];
    }
  }

  static fromJS(data: any): UiCustomizationSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new UiCustomizationSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
    data["isLeftMenuUsed"] = this.isLeftMenuUsed;
    data["isTopMenuUsed"] = this.isTopMenuUsed;
    data["isTabMenuUsed"] = this.isTabMenuUsed;
    data["allowMenuScroll"] = this.allowMenuScroll;
    return data;
  }
}

export interface IUiCustomizationSettingsDto {
  baseSettings: ThemeSettingsDto;
  isLeftMenuUsed: boolean;
  isTopMenuUsed: boolean;
  isTabMenuUsed: boolean;
  allowMenuScroll: boolean;
}

export class UnblockUserInput implements IUnblockUserInput {
  userId!: number;
  tenantId!: number | undefined;

  constructor(data?: IUnblockUserInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.tenantId = _data["tenantId"];
    }
  }

  static fromJS(data: any): UnblockUserInput {
    data = typeof data === 'object' ? data : {};
    let result = new UnblockUserInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["tenantId"] = this.tenantId;
    return data;
  }
}

export interface IUnblockUserInput {
  userId: number;
  tenantId: number | undefined;
}

export class UnlinkUserInput implements IUnlinkUserInput {
  tenantId!: number | undefined;
  userId!: number;

  constructor(data?: IUnlinkUserInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.userId = _data["userId"];
    }
  }

  static fromJS(data: any): UnlinkUserInput {
    data = typeof data === 'object' ? data : {};
    let result = new UnlinkUserInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["userId"] = this.userId;
    return data;
  }
}

export interface IUnlinkUserInput {
  tenantId: number | undefined;
  userId: number;
}

export class UpdateEditionDto implements IUpdateEditionDto {
  edition!: EditionEditDto;
  featureValues!: NameValueDto[];

  constructor(data?: IUpdateEditionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.edition = new EditionEditDto();
      this.featureValues = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : new EditionEditDto();
      if (Array.isArray(_data["featureValues"])) {
        this.featureValues = [] as any;
        for (let item of _data["featureValues"])
          this.featureValues!.push(NameValueDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdateEditionDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateEditionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
    if (Array.isArray(this.featureValues)) {
      data["featureValues"] = [];
      for (let item of this.featureValues)
        data["featureValues"].push(item.toJSON());
    }
    return data;
  }
}

export interface IUpdateEditionDto {
  edition: EditionEditDto;
  featureValues: NameValueDto[];
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
  qrCodeSetupImageUrl!: string | undefined;

  constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
    }
  }

  static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateGoogleAuthenticatorKeyOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
    return data;
  }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
  qrCodeSetupImageUrl: string | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
  languageName!: string;
  sourceName!: string;
  key!: string;
  value!: string;

  constructor(data?: IUpdateLanguageTextInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.languageName = _data["languageName"];
      this.sourceName = _data["sourceName"];
      this.key = _data["key"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): UpdateLanguageTextInput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateLanguageTextInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["languageName"] = this.languageName;
    data["sourceName"] = this.sourceName;
    data["key"] = this.key;
    data["value"] = this.value;
    return data;
  }
}

export interface IUpdateLanguageTextInput {
  languageName: string;
  sourceName: string;
  key: string;
  value: string;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
  receiveNotifications!: boolean;
  notifications!: NotificationSubscriptionDto[] | undefined;

  constructor(data?: IUpdateNotificationSettingsInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.receiveNotifications = _data["receiveNotifications"];
      if (Array.isArray(_data["notifications"])) {
        this.notifications = [] as any;
        for (let item of _data["notifications"])
          this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdateNotificationSettingsInput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateNotificationSettingsInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["receiveNotifications"] = this.receiveNotifications;
    if (Array.isArray(this.notifications)) {
      data["notifications"] = [];
      for (let item of this.notifications)
        data["notifications"].push(item.toJSON());
    }
    return data;
  }
}

export interface IUpdateNotificationSettingsInput {
  receiveNotifications: boolean;
  notifications: NotificationSubscriptionDto[] | undefined;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
  id!: number;
  displayName!: string;

  constructor(data?: IUpdateOrganizationUnitInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): UpdateOrganizationUnitInput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateOrganizationUnitInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IUpdateOrganizationUnitInput {
  id: number;
  displayName: string;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
  fileToken!: string | undefined;
  x!: number;
  y!: number;
  width!: number;
  height!: number;
  useGravatarProfilePicture!: boolean;

  constructor(data?: IUpdateProfilePictureInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fileToken = _data["fileToken"];
      this.x = _data["x"];
      this.y = _data["y"];
      this.width = _data["width"];
      this.height = _data["height"];
      this.useGravatarProfilePicture = _data["useGravatarProfilePicture"];
    }
  }

  static fromJS(data: any): UpdateProfilePictureInput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateProfilePictureInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fileToken"] = this.fileToken;
    data["x"] = this.x;
    data["y"] = this.y;
    data["width"] = this.width;
    data["height"] = this.height;
    data["useGravatarProfilePicture"] = this.useGravatarProfilePicture;
    return data;
  }
}

export interface IUpdateProfilePictureInput {
  fileToken: string | undefined;
  x: number;
  y: number;
  width: number;
  height: number;
  useGravatarProfilePicture: boolean;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
  id!: number;
  featureValues!: NameValueDto[];

  constructor(data?: IUpdateTenantFeaturesInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.featureValues = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      if (Array.isArray(_data["featureValues"])) {
        this.featureValues = [] as any;
        for (let item of _data["featureValues"])
          this.featureValues!.push(NameValueDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdateTenantFeaturesInput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateTenantFeaturesInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    if (Array.isArray(this.featureValues)) {
      data["featureValues"] = [];
      for (let item of this.featureValues)
        data["featureValues"].push(item.toJSON());
    }
    return data;
  }
}

export interface IUpdateTenantFeaturesInput {
  id: number;
  featureValues: NameValueDto[];
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
  id!: number;
  grantedPermissionNames!: string[];

  constructor(data?: IUpdateUserPermissionsInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.grantedPermissionNames = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      if (Array.isArray(_data["grantedPermissionNames"])) {
        this.grantedPermissionNames = [] as any;
        for (let item of _data["grantedPermissionNames"])
          this.grantedPermissionNames!.push(item);
      }
    }
  }

  static fromJS(data: any): UpdateUserPermissionsInput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateUserPermissionsInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    if (Array.isArray(this.grantedPermissionNames)) {
      data["grantedPermissionNames"] = [];
      for (let item of this.grantedPermissionNames)
        data["grantedPermissionNames"].push(item);
    }
    return data;
  }
}

export interface IUpdateUserPermissionsInput {
  id: number;
  grantedPermissionNames: string[];
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
  signInToken!: string | undefined;
  encodedUserId!: string | undefined;
  encodedTenantId!: string | undefined;

  constructor(data?: IUpdateUserSignInTokenOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.signInToken = _data["signInToken"];
      this.encodedUserId = _data["encodedUserId"];
      this.encodedTenantId = _data["encodedTenantId"];
    }
  }

  static fromJS(data: any): UpdateUserSignInTokenOutput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateUserSignInTokenOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["signInToken"] = this.signInToken;
    data["encodedUserId"] = this.encodedUserId;
    data["encodedTenantId"] = this.encodedTenantId;
    return data;
  }
}

export interface IUpdateUserSignInTokenOutput {
  signInToken: string | undefined;
  encodedUserId: string | undefined;
  encodedTenantId: string | undefined;
}

export class UserDelegationDto implements IUserDelegationDto {
  username!: string | undefined;
  startTime!: DateTime;
  endTime!: DateTime;
  id!: number;

  constructor(data?: IUserDelegationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.username = _data["username"];
      this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
      this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): UserDelegationDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserDelegationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["username"] = this.username;
    data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
    data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IUserDelegationDto {
  username: string | undefined;
  startTime: DateTime;
  endTime: DateTime;
  id: number;
}

export class UserEditDto implements IUserEditDto {
  id!: number | undefined;
  name!: string;
  surname!: string;
  userName!: string;
  emailAddress!: string;
  phoneNumber!: string | undefined;
  password!: string | undefined;
  isActive!: boolean;
  shouldChangePasswordOnNextLogin!: boolean;
  isTwoFactorEnabled!: boolean;
  isLockoutEnabled!: boolean;
  dateBirth!: DateTime;
  lifeCity!: string;

  constructor(data?: IUserEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.userName = _data["userName"];
      this.emailAddress = _data["emailAddress"];
      this.phoneNumber = _data["phoneNumber"];
      this.password = _data["password"];
      this.isActive = _data["isActive"];
      this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
      this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
      this.isLockoutEnabled = _data["isLockoutEnabled"];
      this.dateBirth = _data["dateBirth"];
      this.lifeCity = _data["lifeCity"];
    }
  }

  static fromJS(data: any): UserEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["userName"] = this.userName;
    data["emailAddress"] = this.emailAddress;
    data["phoneNumber"] = this.phoneNumber;
    data["password"] = this.password;
    data["isActive"] = this.isActive;
    data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
    data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
    data["isLockoutEnabled"] = this.isLockoutEnabled;
    return data;
  }
}

export interface IUserEditDto {
  id: number | undefined;
  name: string;
  surname: string;
  userName: string;
  emailAddress: string;
  phoneNumber: string | undefined;
  password: string | undefined;
  isActive: boolean;
  shouldChangePasswordOnNextLogin: boolean;
  isTwoFactorEnabled: boolean;
  isLockoutEnabled: boolean;
}

export class UserListDto implements IUserListDto {
  name!: string | undefined;
  surname!: string | undefined;
  userName!: string | undefined;
  emailAddress!: string | undefined;
  phoneNumber!: string | undefined;
  profilePictureId!: string | undefined;
  isEmailConfirmed!: boolean;
  roles!: UserListRoleDto[] | undefined;
  isActive!: boolean;
  creationTime!: DateTime;
  id!: number;

  constructor(data?: IUserListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.userName = _data["userName"];
      this.emailAddress = _data["emailAddress"];
      this.phoneNumber = _data["phoneNumber"];
      this.profilePictureId = _data["profilePictureId"];
      this.isEmailConfirmed = _data["isEmailConfirmed"];
      if (Array.isArray(_data["roles"])) {
        this.roles = [] as any;
        for (let item of _data["roles"])
          this.roles!.push(UserListRoleDto.fromJS(item));
      }
      this.isActive = _data["isActive"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): UserListDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["userName"] = this.userName;
    data["emailAddress"] = this.emailAddress;
    data["phoneNumber"] = this.phoneNumber;
    data["profilePictureId"] = this.profilePictureId;
    data["isEmailConfirmed"] = this.isEmailConfirmed;
    if (Array.isArray(this.roles)) {
      data["roles"] = [];
      for (let item of this.roles)
        data["roles"].push(item.toJSON());
    }
    data["isActive"] = this.isActive;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IUserListDto {
  name: string | undefined;
  surname: string | undefined;
  userName: string | undefined;
  emailAddress: string | undefined;
  phoneNumber: string | undefined;
  profilePictureId: string | undefined;
  isEmailConfirmed: boolean;
  roles: UserListRoleDto[] | undefined;
  isActive: boolean;
  creationTime: DateTime;
  id: number;
}

export class UserListRoleDto implements IUserListRoleDto {
  roleId!: number;
  roleName!: string | undefined;

  constructor(data?: IUserListRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.roleId = _data["roleId"];
      this.roleName = _data["roleName"];
    }
  }

  static fromJS(data: any): UserListRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserListRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["roleId"] = this.roleId;
    data["roleName"] = this.roleName;
    return data;
  }
}

export interface IUserListRoleDto {
  roleId: number;
  roleName: string | undefined;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
  isEnabled!: boolean;
  maxFailedAccessAttemptsBeforeLockout!: number;
  defaultAccountLockoutSeconds!: number;

  constructor(data?: IUserLockOutSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isEnabled = _data["isEnabled"];
      this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
      this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
    }
  }

  static fromJS(data: any): UserLockOutSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserLockOutSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isEnabled"] = this.isEnabled;
    data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
    data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
    return data;
  }
}

export interface IUserLockOutSettingsEditDto {
  isEnabled: boolean;
  maxFailedAccessAttemptsBeforeLockout: number;
  defaultAccountLockoutSeconds: number;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
  tenancyName!: string | undefined;
  userNameOrEmail!: string | undefined;
  clientIpAddress!: string | undefined;
  clientName!: string | undefined;
  browserInfo!: string | undefined;
  result!: string | undefined;
  creationTime!: DateTime;

  constructor(data?: IUserLoginAttemptDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
      this.userNameOrEmail = _data["userNameOrEmail"];
      this.clientIpAddress = _data["clientIpAddress"];
      this.clientName = _data["clientName"];
      this.browserInfo = _data["browserInfo"];
      this.result = _data["result"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): UserLoginAttemptDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserLoginAttemptDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenancyName"] = this.tenancyName;
    data["userNameOrEmail"] = this.userNameOrEmail;
    data["clientIpAddress"] = this.clientIpAddress;
    data["clientName"] = this.clientName;
    data["browserInfo"] = this.browserInfo;
    data["result"] = this.result;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    return data;
  }
}

export interface IUserLoginAttemptDto {
  tenancyName: string | undefined;
  userNameOrEmail: string | undefined;
  clientIpAddress: string | undefined;
  clientName: string | undefined;
  browserInfo: string | undefined;
  result: string | undefined;
  creationTime: DateTime;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
  name!: string | undefined;
  surname!: string | undefined;
  userName!: string | undefined;
  emailAddress!: string | undefined;
  profilePictureId!: string | undefined;
  id!: number;

  constructor(data?: IUserLoginInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.userName = _data["userName"];
      this.emailAddress = _data["emailAddress"];
      this.profilePictureId = _data["profilePictureId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): UserLoginInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserLoginInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["userName"] = this.userName;
    data["emailAddress"] = this.emailAddress;
    data["profilePictureId"] = this.profilePictureId;
    data["id"] = this.id;
    return data;
  }
}

export interface IUserLoginInfoDto {
  name: string | undefined;
  surname: string | undefined;
  userName: string | undefined;
  emailAddress: string | undefined;
  profilePictureId: string | undefined;
  id: number;
}

export class UserNotification implements IUserNotification {
  tenantId!: number | undefined;
  userId!: number;
  state!: UserNotificationState;
  notification!: TenantNotification;
  id!: string;

  constructor(data?: IUserNotification) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.userId = _data["userId"];
      this.state = _data["state"];
      this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): UserNotification {
    data = typeof data === 'object' ? data : {};
    let result = new UserNotification();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["userId"] = this.userId;
    data["state"] = this.state;
    data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IUserNotification {
  tenantId: number | undefined;
  userId: number;
  state: UserNotificationState;
  notification: TenantNotification;
  id: string;
}

export enum UserNotificationState {
  Unread = 0,
  Read = 1,
}

export class UserPasswordSettingsEditDto implements IUserPasswordSettingsEditDto {
  enableCheckingLastXPasswordWhenPasswordChange!: boolean;
  checkingLastXPasswordCount!: number;
  enablePasswordExpiration!: boolean;
  passwordExpirationDayCount!: number;

  constructor(data?: IUserPasswordSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.enableCheckingLastXPasswordWhenPasswordChange = _data["enableCheckingLastXPasswordWhenPasswordChange"];
      this.checkingLastXPasswordCount = _data["checkingLastXPasswordCount"];
      this.enablePasswordExpiration = _data["enablePasswordExpiration"];
      this.passwordExpirationDayCount = _data["passwordExpirationDayCount"];
    }
  }

  static fromJS(data: any): UserPasswordSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserPasswordSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["enableCheckingLastXPasswordWhenPasswordChange"] = this.enableCheckingLastXPasswordWhenPasswordChange;
    data["checkingLastXPasswordCount"] = this.checkingLastXPasswordCount;
    data["enablePasswordExpiration"] = this.enablePasswordExpiration;
    data["passwordExpirationDayCount"] = this.passwordExpirationDayCount;
    return data;
  }
}

export interface IUserPasswordSettingsEditDto {
  enableCheckingLastXPasswordWhenPasswordChange: boolean;
  checkingLastXPasswordCount: number;
  enablePasswordExpiration: boolean;
  passwordExpirationDayCount: number;
}

export class UserRoleDto implements IUserRoleDto {
  roleId!: number;
  roleName!: string | undefined;
  roleDisplayName!: string | undefined;
  isAssigned!: boolean;
  inheritedFromOrganizationUnit!: boolean;

  constructor(data?: IUserRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.roleId = _data["roleId"];
      this.roleName = _data["roleName"];
      this.roleDisplayName = _data["roleDisplayName"];
      this.isAssigned = _data["isAssigned"];
      this.inheritedFromOrganizationUnit = _data["inheritedFromOrganizationUnit"];
    }
  }

  static fromJS(data: any): UserRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["roleId"] = this.roleId;
    data["roleName"] = this.roleName;
    data["roleDisplayName"] = this.roleDisplayName;
    data["isAssigned"] = this.isAssigned;
    data["inheritedFromOrganizationUnit"] = this.inheritedFromOrganizationUnit;
    return data;
  }
}

export interface IUserRoleDto {
  roleId: number;
  roleName: string | undefined;
  roleDisplayName: string | undefined;
  isAssigned: boolean;
  inheritedFromOrganizationUnit: boolean;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
  userIds!: number[] | undefined;
  organizationUnitId!: number;

  constructor(data?: IUsersToOrganizationUnitInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["userIds"])) {
        this.userIds = [] as any;
        for (let item of _data["userIds"])
          this.userIds!.push(item);
      }
      this.organizationUnitId = _data["organizationUnitId"];
    }
  }

  static fromJS(data: any): UsersToOrganizationUnitInput {
    data = typeof data === 'object' ? data : {};
    let result = new UsersToOrganizationUnitInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.userIds)) {
      data["userIds"] = [];
      for (let item of this.userIds)
        data["userIds"].push(item);
    }
    data["organizationUnitId"] = this.organizationUnitId;
    return data;
  }
}

export interface IUsersToOrganizationUnitInput {
  userIds: number[] | undefined;
  organizationUnitId: number;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
  code!: string | undefined;
  phoneNumber!: string | undefined;

  constructor(data?: IVerifySmsCodeInputDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.phoneNumber = _data["phoneNumber"];
    }
  }

  static fromJS(data: any): VerifySmsCodeInputDto {
    data = typeof data === 'object' ? data : {};
    let result = new VerifySmsCodeInputDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["code"] = this.code;
    data["phoneNumber"] = this.phoneNumber;
    return data;
  }
}

export interface IVerifySmsCodeInputDto {
  code: string | undefined;
  phoneNumber: string | undefined;
}

export class WebhookEvent implements IWebhookEvent {
  webhookName!: string;
  data!: string | undefined;
  creationTime!: DateTime;
  tenantId!: number | undefined;
  isDeleted!: boolean;
  deletionTime!: DateTime | undefined;
  id!: string;

  constructor(data?: IWebhookEvent) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.webhookName = _data["webhookName"];
      this.data = _data["data"];
      this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.isDeleted = _data["isDeleted"];
      this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): WebhookEvent {
    data = typeof data === 'object' ? data : {};
    let result = new WebhookEvent();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["webhookName"] = this.webhookName;
    data["data"] = this.data;
    data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["isDeleted"] = this.isDeleted;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IWebhookEvent {
  webhookName: string;
  data: string | undefined;
  creationTime: DateTime;
  tenantId: number | undefined;
  isDeleted: boolean;
  deletionTime: DateTime | undefined;
  id: string;
}

export class WebhookSubscription implements IWebhookSubscription {
  tenantId!: number | undefined;
  webhookUri!: string | undefined;
  secret!: string | undefined;
  isActive!: boolean;
  webhooks!: string[] | undefined;
  headers!: { [key: string]: string; } | undefined;
  id!: string;

  constructor(data?: IWebhookSubscription) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.webhookUri = _data["webhookUri"];
      this.secret = _data["secret"];
      this.isActive = _data["isActive"];
      if (Array.isArray(_data["webhooks"])) {
        this.webhooks = [] as any;
        for (let item of _data["webhooks"])
          this.webhooks!.push(item);
      }
      if (_data["headers"]) {
        this.headers = {} as any;
        for (let key in _data["headers"]) {
          if (_data["headers"].hasOwnProperty(key))
            (<any>this.headers)![key] = _data["headers"][key];
        }
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): WebhookSubscription {
    data = typeof data === 'object' ? data : {};
    let result = new WebhookSubscription();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["webhookUri"] = this.webhookUri;
    data["secret"] = this.secret;
    data["isActive"] = this.isActive;
    if (Array.isArray(this.webhooks)) {
      data["webhooks"] = [];
      for (let item of this.webhooks)
        data["webhooks"].push(item);
    }
    if (this.headers) {
      data["headers"] = {};
      for (let key in this.headers) {
        if (this.headers.hasOwnProperty(key))
          (<any>data["headers"])[key] = this.headers[key];
      }
    }
    data["id"] = this.id;
    return data;
  }
}

export interface IWebhookSubscription {
  tenantId: number | undefined;
  webhookUri: string | undefined;
  secret: string | undefined;
  isActive: boolean;
  webhooks: string[] | undefined;
  headers: { [key: string]: string; } | undefined;
  id: string;
}

export class Widget implements IWidget {
  widgetId!: string | undefined;
  height!: number;
  width!: number;
  positionX!: number;
  positionY!: number;

  constructor(data?: IWidget) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.widgetId = _data["widgetId"];
      this.height = _data["height"];
      this.width = _data["width"];
      this.positionX = _data["positionX"];
      this.positionY = _data["positionY"];
    }
  }

  static fromJS(data: any): Widget {
    data = typeof data === 'object' ? data : {};
    let result = new Widget();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["widgetId"] = this.widgetId;
    data["height"] = this.height;
    data["width"] = this.width;
    data["positionX"] = this.positionX;
    data["positionY"] = this.positionY;
    return data;
  }
}

export interface IWidget {
  widgetId: string | undefined;
  height: number;
  width: number;
  positionX: number;
  positionY: number;
}

export class WidgetFilterOutput implements IWidgetFilterOutput {
  id!: string | undefined;
  name!: string | undefined;

  constructor(data?: IWidgetFilterOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): WidgetFilterOutput {
    data = typeof data === 'object' ? data : {};
    let result = new WidgetFilterOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface IWidgetFilterOutput {
  id: string | undefined;
  name: string | undefined;
}

export class WidgetOutput implements IWidgetOutput {
  id!: string | undefined;
  name!: string | undefined;
  description!: string | undefined;
  filters!: WidgetFilterOutput[] | undefined;

  constructor(data?: IWidgetOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      if (Array.isArray(_data["filters"])) {
        this.filters = [] as any;
        for (let item of _data["filters"])
          this.filters!.push(WidgetFilterOutput.fromJS(item));
      }
    }
  }

  static fromJS(data: any): WidgetOutput {
    data = typeof data === 'object' ? data : {};
    let result = new WidgetOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    if (Array.isArray(this.filters)) {
      data["filters"] = [];
      for (let item of this.filters)
        data["filters"].push(item.toJSON());
    }
    return data;
  }
}

export interface IWidgetOutput {
  id: string | undefined;
  name: string | undefined;
  description: string | undefined;
  filters: WidgetFilterOutput[] | undefined;
}

export class WorkJobDto implements IWorkJobDto {
  headerText!: string | undefined;
  description!: string | undefined;
  companyInfo!: string | undefined;
  startDate!: DateTime;
  endDate!: DateTime;
  publishDate!: DateTime;
  isActive!: boolean;
  id!: number;

  constructor(data?: IWorkJobDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.headerText = _data["headerText"];
      this.description = _data["description"];
      this.companyInfo = _data["companyInfo"];
      this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
      this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
      this.publishDate = _data["publishDate"] ? DateTime.fromISO(_data["publishDate"].toString()) : <any>undefined;
      this.isActive = _data["isActive"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): WorkJobDto {
    data = typeof data === 'object' ? data : {};
    let result = new WorkJobDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["headerText"] = this.headerText;
    data["description"] = this.description;
    data["companyInfo"] = this.companyInfo;
    data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
    data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
    data["publishDate"] = this.publishDate ? this.publishDate.toString() : <any>undefined;
    data["isActive"] = this.isActive;
    data["id"] = this.id;
    return data;
  }
}

export interface IWorkJobDto {
  headerText: string | undefined;
  description: string | undefined;
  companyInfo: string | undefined;
  startDate: DateTime;
  endDate: DateTime;
  publishDate: DateTime;
  isActive: boolean;
  id: number;
}

export class WsFederationExternalLoginProviderSettings implements IWsFederationExternalLoginProviderSettings {
  clientId!: string | undefined;
  tenant!: string | undefined;
  metaDataAddress!: string | undefined;
  wtrealm!: string | undefined;
  authority!: string | undefined;

  constructor(data?: IWsFederationExternalLoginProviderSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data["clientId"];
      this.tenant = _data["tenant"];
      this.metaDataAddress = _data["metaDataAddress"];
      this.wtrealm = _data["wtrealm"];
      this.authority = _data["authority"];
    }
  }

  static fromJS(data: any): WsFederationExternalLoginProviderSettings {
    data = typeof data === 'object' ? data : {};
    let result = new WsFederationExternalLoginProviderSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["clientId"] = this.clientId;
    data["tenant"] = this.tenant;
    data["metaDataAddress"] = this.metaDataAddress;
    data["wtrealm"] = this.wtrealm;
    data["authority"] = this.authority;
    return data;
  }
}

export interface IWsFederationExternalLoginProviderSettings {
  clientId: string | undefined;
  tenant: string | undefined;
  metaDataAddress: string | undefined;
  wtrealm: string | undefined;
  authority: string | undefined;
}

export class AdditionalData implements IAdditionalData {
  paypal!: { [key: string]: string; };
  stripe!: { [key: string]: string; };

  constructor(data?: IAdditionalData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["Paypal"]) {
        this.paypal = {} as any;
        for (let key in _data["Paypal"]) {
          if (_data["Paypal"].hasOwnProperty(key))
            (<any>this.paypal)![key] = _data["Paypal"][key];
        }
      }
      if (_data["Stripe"]) {
        this.stripe = {} as any;
        for (let key in _data["Stripe"]) {
          if (_data["Stripe"].hasOwnProperty(key))
            (<any>this.stripe)![key] = _data["Stripe"][key];
        }
      }
    }
  }

  static fromJS(data: any): AdditionalData {
    data = typeof data === 'object' ? data : {};
    let result = new AdditionalData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.paypal) {
      data["Paypal"] = {};
      for (let key in this.paypal) {
        if (this.paypal.hasOwnProperty(key))
          (<any>data["Paypal"])[key] = this.paypal[key];
      }
    }
    if (this.stripe) {
      data["Stripe"] = {};
      for (let key in this.stripe) {
        if (this.stripe.hasOwnProperty(key))
          (<any>data["Stripe"])[key] = this.stripe[key];
      }
    }
    return data;
  }
}

export interface IAdditionalData {
  paypal: { [key: string]: string; };
  stripe: { [key: string]: string; };
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
